angular.module("cesium.translations", []).config(["$translateProvider", function($translateProvider) {
$translateProvider.translations("en-GB", {
  "COMMON": {
    "APP_NAME": "Cesium",
    "APP_VERSION": "v{{version}}",
    "APP_BUILD": "build {{build}}",
    "PUBKEY": "Public key",
    "MEMBER": "Member",
    "BLOCK" : "Block",
    "BTN_OK": "OK",
    "BTN_YES": "Yes",
    "BTN_NO": "No",
    "BTN_SEND": "Send",
    "BTN_SEND_MONEY": "Transfer money",
    "BTN_SEND_MONEY_SHORT": "Transfer",
    "BTN_SAVE": "Save",
    "BTN_YES_SAVE": "Yes, Save",
    "BTN_YES_CONTINUE": "Yes, Continue",
    "BTN_SHOW": "Show",
    "BTN_SHOW_PUBKEY": "Show key",
    "BTN_RELATIVE_UNIT": "Display amounts in UD?",
    "BTN_BACK": "Back",
    "BTN_NEXT": "Next",
    "BTN_IMPORT": "Import",
    "BTN_CANCEL": "Cancel",
    "BTN_CLOSE": "Close",
    "BTN_LATER": "Later",
    "BTN_LOGIN": "Sign In",
    "BTN_LOGOUT": "Logout",
    "BTN_ADD_ACCOUNT": "New Account",
    "BTN_SHARE": "Share",
    "BTN_EDIT": "Edit",
    "BTN_DELETE": "Delete",
    "BTN_ADD": "Add",
    "BTN_SEARCH": "Search",
    "BTN_REFRESH": "Refresh",
    "BTN_RETRY": "Retry",
    "BTN_START": "Start",
    "BTN_CONTINUE": "Continue",
    "BTN_CREATE": "Create",
    "BTN_UNDERSTOOD": "I understand",
    "BTN_OPTIONS": "Options",
    "BTN_HELP_TOUR": "Features tour",
    "BTN_HELP_TOUR_SCREEN": "Discover this screen",
    "BTN_DOWNLOAD": "Download",
    "BTN_DOWNLOAD_ACCOUNT_STATEMENT": "Download account statement",
    "BTN_MODIFY": "Modify",
    "CHOOSE_FILE": "Drag your file<br/>or click to select",
    "DAYS": "days",
    "NO_ACCOUNT_QUESTION": "Not a member yet? Register now!",
    "SEARCH_NO_RESULT": "No result found",
    "LOADING": "Loading...",
    "LOADING_WAIT": "Loading...<br/><small>(Waiting for node availability)</small>",
    "SEARCHING": "Searching...",
    "FROM": "From",
    "TO": "To",
    "COPY": "Copy",
    "LANGUAGE": "Language",
    "UNIVERSAL_DIVIDEND": "Universal dividend",
    "UD": "UD",
    "DATE_PATTERN": "DD/MM/YYYY HH:mm",
    "DATE_FILE_PATTERN": "YYYY-MM-DD",
    "DATE_SHORT_PATTERN": "DD/MM/YY",
    "DATE_MONTH_YEAR_PATTERN": "MM/YYYY",
    "EMPTY_PARENTHESIS": "(empty)",
    "UID": "Pseudonym",
    "ENABLE": "Enabled",
    "DISABLE": "Disabled",
    "RESULTS_LIST": "Results:",
    "RESULTS_COUNT": "{{count}} results",
    "EXECUTION_TIME": "executed in {{duration|formatDurationMs}}",
    "SHOW_VALUES": "Display values openly?",
    "POPOVER_ACTIONS_TITLE": "Options",
    "POPOVER_FILTER_TITLE": "Filters",
    "SHOW_MORE": "Show more",
    "SHOW_MORE_COUNT": "(current limit at {{limit}})",
    "POPOVER_SHARE": {
      "TITLE": "Share",
      "SHARE_ON_TWITTER": "Share on Twitter",
      "SHARE_ON_FACEBOOK": "Share on Facebook",
      "SHARE_ON_DIASPORA": "Share on Diaspora*",
      "SHARE_ON_GOOGLEPLUS": "Share on Google+"
    },
    "FILE": {
      "DATE" : "Date:",
      "TYPE" : "Type:",
      "SIZE": "Size:",
      "VALIDATING": "Validating..."
    }
  },
  "SYSTEM": {
    "PICTURE_CHOOSE_TYPE": "Choose source:",
    "BTN_PICTURE_GALLERY": "Gallery",
    "BTN_PICTURE_CAMERA": "<b>Camera</b>"
  },
  "MENU": {
    "HOME": "Home",
    "WOT": "Registry",
    "CURRENCY": "Currency",
    "ACCOUNT": "My Account",
    "WALLETS": "My wallets",
    "SETTINGS": "Settings",
    "NETWORK": "Network",
    "TRANSACTIONS": "My transactions"
  },
  "ABOUT": {
    "TITLE": "About",
    "LICENSE": "<b>Free/libre software</b> (License GNU AGPLv3).",
    "LATEST_RELEASE": "There is a <b>newer version</ b> of {{'COMMON.APP_NAME' | translate}} (<b>v{{version}}</b>)",
    "PLEASE_UPDATE": "Please update {{'COMMON.APP_NAME' | translate}} (latest version: <b>v{{version}}</b>)",
    "CODE": "Source code:",
    "OFFICIAL_WEB_SITE": "Official web site:",
    "DEVELOPERS": "Developers:",
    "FORUM": "Forum:",
    "PLEASE_REPORT_ISSUE": "Please report any issue to us!",
    "REPORT_ISSUE": "Report an issue",
    "BTN_OPEN_DEV_WINDOW": "Open the debug window"
  },
  "HOME": {
    "TITLE": "Cesium",
    "WELCOME": "Welcome to the Cesium application!",
    "WELCOME_READONLY": "Welcome to Cesium <span class='badge badge-balanced'>Monit</span> !",
    "MESSAGE": "Receive and send libre currency {{currency|abbreviate}}",
    "MESSAGE_READONLY": "Real-time monitoring of libre currency {{currency|abbreviate}}",
    "BTN_CURRENCY": "Explore currency {{currency|abbreviate}}",
    "BTN_ABOUT": "about",
    "BTN_HELP": "Help",
    "BTN_NETWORK": "Network status",
    "FREE_SOFTWARE": "Free software",
    "FORK_ME": "Fork me!",
    "SHOW_LICENSE": "Show license",
    "REPORT_ISSUE": "Report an issue",
    "NOT_YOUR_ACCOUNT_QUESTION" : "You do not own the account <b><i class=\"ion-key\"></i> {{pubkey|formatPubkey}}</b>?",
    "BTN_CHANGE_ACCOUNT": "Disconnect this account",
    "CONNECTION_ERROR": "Peer <b>{{server}}</b> unreachable or invalid address.<br/><br/>Check your Internet connection, or change node <a class=\"positive\" ng-click=\"doQuickFix('settings')\">in the settings</a>.",
    "SHOW_ALL_FEED": "Show all",
    "READ_MORE": "Read more",
    "FEED_SOURCE": "Source"
  },
  "SETTINGS": {
    "TITLE": "Settings",
    "DISPLAY_DIVIDER": "Display",
    "STORAGE_DIVIDER": "Storage",
    "NETWORK_SETTINGS": "Network",
    "PEER": "Duniter peer address",
    "PEER_SHORT": "Peer address",
    "PEER_CHANGED_TEMPORARY": "Address used temporarily",
    "PERSIST_CACHE": "Keep navigation data (experimental)",
    "PERSIST_CACHE_HELP": "Allows faster navigation, locally retaining the data received, for use from one session to another.",
    "USE_LOCAL_STORAGE": "Enable local storage",
    "USE_LOCAL_STORAGE_HELP": "Allows you to save your settings",
    "WALLETS_SETTINGS": "My wallets",
    "USE_WALLETS_ENCRYPTION": "Secure the list",
    "USE_WALLETS_ENCRYPTION_HELP": "Enables you to encrypt the list of your wallets. Authentication required to access it.",
    "ENABLE_HELPTIP": "Enable contextual help tips",
    "DISABLE_HELPTIP": "Disable contextual help tips",
    "ENABLE_UI_EFFECTS": "Enable visual effects",
    "HISTORY_SETTINGS": "Account operations",
    "DISPLAY_UD_HISTORY": "Display produced dividends?",
    "TX_HISTORY_AUTO_REFRESH": "Enable automatic refresh?",
    "TX_HISTORY_AUTO_REFRESH_HELP": "Updates the list of operations to each new block.",
    "AUTHENTICATION_SETTINGS": "Authentication",
    "KEEP_AUTH": "Expiration of authentication",
    "KEEP_AUTH_SHORT": "Expiration",
    "KEEP_AUTH_HELP": "Define when authentication is cleared from memory.",
    "KEEP_AUTH_OPTION": {
      "NEVER": "After each operation",
      "SECONDS": "After {{value}}s of inactivity",
      "MINUTE": "After {{value}}min of inactivity",
      "MINUTES": "After {{value}}min of inactivity",
      "HOUR": "After {{value}}h of inactivity",
      "ALWAYS": "At the end of the session"
    },
    "KEYRING_FILE": "Keyring file",
    "KEYRING_FILE_HELP": "Allow auto-connect at startup, or to authenticate (only if \"Expiration of authentication\" is \"at the end of the session\"",
    "REMEMBER_ME": "Remember me ?",
    "REMEMBER_ME_HELP": "Allows to remain identified from one session to another, keeping the public key locally.",
    "PLUGINS_SETTINGS": "Extensions",
    "BTN_RESET": "Restore default values",
    "EXPERT_MODE": "Enable expert mode",
    "EXPERT_MODE_HELP": "Allow to see more details",
    "BLOCK_VALIDITY_WINDOW": "Block uncertainty time",
    "BLOCK_VALIDITY_WINDOW_SHORT": "Time of uncertainty",
    "BLOCK_VALIDITY_WINDOW_HELP": "Time to wait before considering an information is validated",
    "BLOCK_VALIDITY_OPTION": {
      "NONE": "No delay",
      "N": "{{time | formatDuration}} ({{count}} blocks)"
    },
    "POPUP_PEER": {
      "TITLE" : "Duniter peer",
      "HOST" : "Address",
      "HOST_HELP": "Address: server:port",
      "USE_SSL" : "Secured?",
      "USE_SSL_HELP" : "(SSL Encryption)",
      "BTN_SHOW_LIST" : "Peer's list"
    }
  },
  "BLOCKCHAIN": {
    "HASH": "Hash: {{hash}}",
    "VIEW": {
      "HEADER_TITLE": "Block #{{number}}-{{hash|formatHash}}",
      "TITLE_CURRENT": "Current block",
      "TITLE": "Block #{{number|formatInteger}}",
      "COMPUTED_BY": "Computed by",
      "SHOW_RAW": "Show raw data",
      "TECHNICAL_DIVIDER": "Technical informations",
      "VERSION": "Format version",
      "HASH": "Computed hash",
      "UNIVERSAL_DIVIDEND_HELP": "Money co-produced by each of the {{membersCount}} members",
      "EMPTY": "Aucune donnée dans ce bloc",
      "POW_MIN": "Minimal difficulty",
      "POW_MIN_HELP": "Difficulty imposed in calculating hash",
      "DATA_DIVIDER": "Data",
      "IDENTITIES_COUNT": "New identities",
      "JOINERS_COUNT": "Joiners",
      "ACTIVES_COUNT": "Renewals",
      "ACTIVES_COUNT_HELP": "Members having renewed their membership",
      "LEAVERS_COUNT": "Leavers",
      "LEAVERS_COUNT_HELP": "Members that now refused certification",
      "EXCLUDED_COUNT": "Excluded members",
      "EXCLUDED_COUNT_HELP": "Old members, excluded because missing membreship renewal or certifications",
      "REVOKED_COUNT": "Revoked identities",
      "REVOKED_COUNT_HELP": "These accounts may no longer be member",
      "TX_COUNT": "Transactions",
      "CERT_COUNT": "Certifications",
      "TX_TO_HIMSELF": "Change",
      "TX_OUTPUT_UNLOCK_CONDITIONS": "Unlock conditions",
      "TX_OUTPUT_OPERATOR": {
        "AND": "and",
        "OR": "or"
      },
      "TX_OUTPUT_FUNCTION": {
        "SIG": "<b>Sign</b> of the public key",
        "XHX": "<b>Password</b>, including SHA256 =",
        "CSV": "Blocked during",
        "CLTV": "Bloqué until"
      }
    },
    "LOOKUP": {
      "TITLE": "Blocks",
      "NO_BLOCK": "No bloc",
      "LAST_BLOCKS": "Last blocks:",
      "BTN_COMPACT": "Compact"
    }
  },
  "CURRENCY": {
    "VIEW": {
      "TITLE": "Currency",
      "TAB_CURRENCY": "Currency",
      "TAB_WOT": "Web of trust",
      "TAB_NETWORK": "Network",
      "TAB_BLOCKS": "Blocks",
      "CURRENCY_SHORT_DESCRIPTION": "{{currency|capitalize}} is a <b>libre money</b>, started {{firstBlockTime | formatFromNow}}. It currently counts <b>{{N}} members </b>, who produce and collect a <a ng-click=\"showHelpModal('ud')\">Universal Dividend</a> (DU), each {{dt | formatPeriod}}.",
      "NETWORK_RULES_DIVIDER": "Network rules",
      "CURRENCY_NAME": "Currency name",
      "MEMBERS": "Members count",
      "MEMBERS_VARIATION": "Variation since {{duration|formatDuration}} (since last UD)",
      "MONEY_DIVIDER": "Money",
      "MASS": "Monetary mass",
      "SHARE": "Money share",
      "UD": "Universal Dividend",
      "C_ACTUAL": "Current growth",
      "MEDIAN_TIME": "Current blockchain time",
      "POW_MIN": "Common difficulty",
      "MONEY_RULES_DIVIDER": "Rules of currency",
      "C_RULE": "Theoretical growth target",
      "UD_RULE": "Universal dividend (formula)",
      "DT_REEVAL": "Period between two re-evaluation of the UD",
      "REEVAL_SYMBOL": "reeval",
      "DT_REEVAL_VALUE": "Every <b>{{dtReeval|formatDuration}}</b> ({{dtReeval/86400}} {{'COMMON.DAYS'|translate}})",
      "UD_REEVAL_TIME0": "Date of first reevaluation of the UD",
      "SIG_QTY_RULE": "Required number of certifications to become a member",
      "SIG_STOCK": "Maximum number of certifications sent by a member",
      "SIG_PERIOD": "Minimum delay between 2 certifications sent by one and the same issuer.",
      "SIG_WINDOW": "Maximum delay before a certification will be treated",
      "SIG_VALIDITY": "Lifetime of a certification that has been treated",
      "MS_WINDOW": "Maximum delay before a pending membership will be treated",
      "MS_VALIDITY": "Lifetime of a membership that has been treated",
      "STEP_MAX": "Maximum distance between a newcomer and each referring members.",
      "WOT_RULES_DIVIDER": "Rules for web of trust",
      "SENTRIES": "Required number of certifications (given <b>and</b> received) to become a referring member",
      "SENTRIES_FORMULA": "Required number of certifications to become a referring member (formula)",
      "XPERCENT":"Minimum percent of referring member to reach to match the distance rule",
      "AVG_GEN_TIME": "The average time between 2 blocks",
      "CURRENT": "current",
      "MATH_CEILING": "CEILING",
      "DISPLAY_ALL_RULES": "Display all rules?",
      "BTN_SHOW_LICENSE": "Show license",
      "WOT_DIVIDER": "Web of trust"
    },
    "LICENSE": {
      "TITLE": "Currency license",
      "BTN_DOWNLOAD": "Download file",
      "NO_LICENSE_FILE": "License file not found."
    }
  },
  "NETWORK": {
    "VIEW": {
      "MEDIAN_TIME": "Blockchain time",
      "LOADING_PEERS": "Loading peers...",
      "NODE_ADDRESS": "Address:",
      "SOFTWARE": "Software:",
      "WARN_PRE_RELEASE": "Pre-release (latest stable: <b>{{version}}</b>)",
      "WARN_NEW_RELEASE": "Version <b>{{version}}</b> available",
      "WS2PID": "Identifier:",
      "PRIVATE_ACCESS": "Private access",
      "POW_PREFIX": "Proof of work prefix:",
      "ENDPOINTS": {
        "BMAS": "Secure endpoint (SSL)",
        "BMATOR": "TOR endpoint",
        "WS2P": "WS2P endpoint",
        "ES_USER_API": "Cesium+ data node"
      }
    },
    "INFO": {
      "ONLY_SSL_PEERS": "Non-SSL nodes have a degraded display because Cesium works in HTTPS mode."
    }
  },
  "PEER": {
    "PEERS": "Peers",
    "SIGNED_ON_BLOCK": "Signed on block",
    "MIRROR": "mirror",
    "MIRRORS": "Mirrors",
    "MIRROR_PEERS": "Mirror peers",
    "PEER_LIST" : "Peer's list",
    "MEMBERS" : "Members",
    "MEMBER_PEERS" : "Member peers",
    "ALL_PEERS" : "All peers",
    "DIFFICULTY" : "Difficulty",
    "API" : "API",
    "CURRENT_BLOCK" : "Block #",
    "POPOVER_FILTER_TITLE": "Filter",
    "OFFLINE": "Offline",
    "OFFLINE_PEERS": "Offline peers",
    "BTN_SHOW_PEER": "Show peer",
    "VIEW": {
      "TITLE": "Peer",
      "OWNER": "Owned by ",
      "SHOW_RAW_PEERING": "See peering document",
      "SHOW_RAW_CURRENT_BLOCK": "See current block (raw format)",
      "LAST_BLOCKS": "Last blocks",
      "KNOWN_PEERS": "Known peers :",
      "GENERAL_DIVIDER": "General information",
      "ERROR": {
        "LOADING_TOR_NODE_ERROR": "Could not get peer data, using the TOR network.",
        "LOADING_NODE_ERROR": "Could not get peer data"
      }
    }
  },
  "WOT": {
    "SEARCH_HELP": "Search (member or public key)",
    "SEARCH_INIT_PHASE_WARNING": "During the pre-registration phase, the search for pending registrations <b>may be long</b>. Please wait ...",
    "REGISTERED_SINCE": "Registered on",
    "REGISTERED_SINCE_BLOCK": "Registered since block #",
    "NO_CERTIFICATION": "No validated certification",
    "NO_GIVEN_CERTIFICATION": "No given certification",
    "NOT_MEMBER_PARENTHESIS": "(non-member)",
    "IDENTITY_REVOKED_PARENTHESIS": "(identity revoked)",
    "MEMBER_PENDING_REVOCATION_PARENTHESIS": "(being revoked)",
    "EXPIRE_IN": "Expires",
    "NOT_WRITTEN_EXPIRE_IN": "Deadline<br/>treatment",
    "EXPIRED": "Expired",
    "PSEUDO": "Pseudonym",
    "SIGNED_ON_BLOCK": "Emitted on block #{{block}}",
    "WRITTEN_ON_BLOCK": "Written on block #{{block}}",
    "GENERAL_DIVIDER": "General information",
    "NOT_MEMBER_ACCOUNT": "Non-member account",
    "NOT_MEMBER_ACCOUNT_HELP": "This is a simple wallet, with no pending membership application.",
    "TECHNICAL_DIVIDER": "Technical data",
    "BTN_CERTIFY": "Certify",
    "BTN_YES_CERTIFY": "Yes, certify",
    "BTN_SELECT_AND_CERTIFY": "New certification",
    "ACCOUNT_OPERATIONS": "Account operations",
    "VIEW": {
      "POPOVER_SHARE_TITLE": "Identity {{title}}"
    },
    "LOOKUP": {
      "TITLE": "Registry",
      "NEWCOMERS": "New members:",
      "NEWCOMERS_COUNT": "{{count}} members",
      "PENDING": "Pending registrations:",
      "PENDING_COUNT": "{{count}} pending registrations",
      "REGISTERED": "Registered {{sigDate | formatFromNow}}",
      "MEMBER_FROM": "Member since {{memberDate|medianFromNowShort}}",
      "BTN_NEWCOMERS": "Latest members",
      "BTN_PENDING": "Pending registrations",
      "SHOW_MORE": "Show more",
      "SHOW_MORE_COUNT": "(current limit to {{limit}})",
      "NO_PENDING": "No pending registrations.",
      "NO_NEWCOMERS": "No members."
    },
    "CONTACTS": {
      "TITLE": "Contacts"
    },
    "MODAL": {
      "TITLE": "Search"
    },
    "CERTIFICATIONS": {
      "TITLE": "{{uid}} - Certifications",
      "SUMMARY": "Received certifications",
      "LIST": "Details of received certifications",
      "PENDING_LIST": "Pending certifications",
      "RECEIVED": "Received certifications",
      "RECEIVED_BY": "Certifications received by {{uid}}",
      "ERROR": "Received certifications in error",
      "SENTRY_MEMBER": "Referring member"
    },
    "OPERATIONS": {
      "TITLE": "{{uid}} - Operations"
    },
    "GIVEN_CERTIFICATIONS": {
      "TITLE": "{{uid}} - Certifications sent",
      "SUMMARY": "Sent certifications",
      "LIST": "Details of sent certifications",
      "PENDING_LIST": "Pending certifications",
      "SENT": "Sent certifications",
      "SENT_BY": "Certifications sent by {{uid}}",
      "ERROR": "Sent certifications with error"
    }
  },
  "LOGIN": {
    "TITLE": "<i class=\"icon ion-log-in\"></i> Login",
    "SCRYPT_FORM_HELP": "Please enter your credentials. <br> Remember to check the public key for your account.",
    "PUBKEY_FORM_HELP": "Please enter a public account key:",
    "FILE_FORM_HELP": "Choose the keychain file to use:",
    "SCAN_FORM_HELP": "Scan the QR code of a wallet.",
    "SALT": "Secret identifier",
    "SALT_HELP": "Secret identifier",
    "SHOW_SALT": "Display secret identifier?",
    "PASSWORD": "Password",
    "PASSWORD_HELP": "Password",
    "PUBKEY_HELP": "Public key or pseudonym",
    "NO_ACCOUNT_QUESTION": "Don't have an account yet?",
    "HAVE_ACCOUNT_QUESTION": "Already have an account ?",
    "CREATE_ACCOUNT": "Create an account",
    "CREATE_FREE_ACCOUNT": "Create a free account",
    "FORGOTTEN_ID": "Forgot password?",
    "ASSOCIATED_PUBKEY": "Public key :",
    "BTN_METHODS": "Other methods",
    "BTN_METHODS_DOTS": "Change method...",
    "METHOD_POPOVER_TITLE": "Methods",
    "MEMORIZE_AUTH_FILE": "Memorize this keychain during the navigation session",
    "SCRYPT_PARAMETERS": "Paramètres (Scrypt) :",
    "AUTO_LOGOUT": {
      "TITLE": "Information",
      "MESSAGE": "<i class=\"ion-android-time\"></i> You were <b>logout</ b> automatically, due to prolonged inactivity.",
      "BTN_RELOGIN": "Sign In",
      "IDLE_WARNING": "You will be logout... {{countdown}}"
    },
    "METHOD": {
      "SCRYPT_DEFAULT": "Secret identifier and password",
      "SCRYPT_ADVANCED": "Advanced salt",
      "FILE": "Keychain file",
      "PUBKEY": "Public key or pseudonym",
      "SCAN": "Scan a QR code"
    },
    "SCRYPT": {
      "SIMPLE": "Light salt",
      "DEFAULT": "Standard salt",
      "SECURE": "Secure salt",
      "HARDEST": "Hardest salt",
      "EXTREME": "Extreme salt",
      "USER": "Personal value",
      "N": "N (Loop):",
      "r": "r (RAM):",
      "p": "p (CPU):"
    },
    "FILE": {
      "HELP": "Expected file format: <b>.dunikey</b> (type PubSec). Other formats are under development (EWIF, WIF)."
    }
  },
  "AUTH": {
    "TITLE": "<i class=\"icon ion-locked\"></i> Authentication",
    "BTN_AUTH": "Authenticate",
    "GENERAL_HELP": "Please authenticate yourself:",
    "EXPECTED_UID_HELP": "Please authenticate to the account <i class=\"ion-person\"></i> {{uid}}:",
    "EXPECTED_PUBKEY_HELP": "Please authenticate to the wallet <i class=\"ion-key\"></i> {{pubkey|formatPubkey}}:",
    "SCAN_FORM_HELP": "Scan the QR code of the <b>private key</b> of the wallet."
  },
  "ACCOUNT": {
    "TITLE": "My Account",
    "BALANCE": "Balance",
    "LAST_TX": "Latest validated transactions",
    "BALANCE_ACCOUNT": "Account balance",
    "NO_TX": "No transaction",
    "SHOW_MORE_TX": "Show more",
    "SHOW_ALL_TX": "Show all",
    "TX_FROM_DATE": "(current limit to {{fromTime|medianFromNowShort}})",
    "PENDING_TX": "Pending transactions",
    "VALIDATING_TX": "Transactions being validated",
    "ERROR_TX": "Transaction not executed",
    "ERROR_TX_SENT": "Sent transactions",
    "PENDING_TX_RECEIVED": "Transactions awaiting receipt",
    "EVENTS": "Events",
    "OUT_DISTANCED": "Your current certifications come from a group too isolated from the <a ng-click=\"showHelpModal('wot')\"> Web of Trust</a> (WoT): the <a ng-click=\"showHelpModal('distance_rule')\">maximum distance rule</a> is violated.<br/>You must obtain certifications from another area of the Web of Trust, or wait for it to tighten.",
    "WAITING_MEMBERSHIP": "Membership application sent. Waiting validation.",
    "WAITING_CERTIFICATIONS": "You need {{needCertificationCount}} certification(s) to become a member and produce the <a ng-click=\"showHelpModal('ud')\">Universal Dividend</a>. Your account is however already operational, to receive and send payments.",
    "WAITING_CERTIFICATIONS_HELP": "To get your certifications, only request members <b>who know you enough</b>, as required by <a ng-click=\"showLicenseModal()\">the currency license</a> that you have accepted.<br/>If you do not know enough members, let them know on <a ng-click=\"openLink($event, $root.settings.userForumUrl)\">the user forum</a>.",
    "WILL_MISSING_CERTIFICATIONS": "You will <b>lack certifications</b> soon (at least {{willNeedCertificationCount}} more are needed)",
    "WILL_NEED_RENEW_MEMBERSHIP": "Your membership <b>will expire {{membershipExpiresIn|formatDurationTo}}</b>. Remember to <a ng-click=\"doQuickFix('renew')\">renew your membership</a> before then.",
    "NEED_RENEW_MEMBERSHIP": "You are no longer a member because your membership <b>has expired</b>. Remember to <a ng-click=\"doQuickFix('renew')\">renew your membership</a>.",
    "NEED_RENEW_MEMBERSHIP_AFTER_CANCELLED": "You are no longer a member because your membership <b>has been cancelled</b> for lack of certifications. Remember to <a ng-click=\"doQuickFix('renew')\">renew your membership</a>.",
    "NO_WAITING_MEMBERSHIP": "No membership application pending. If you'd like to <b>become a member</ b>, please <a ng-click=\"doQuickFix('membership')\">send the membership application</a>.",
    "CERTIFICATION_COUNT": "Received certifications",
    "CERTIFICATION_COUNT_SHORT": "Certifications",
    "SIG_STOCK": "Stock of certifications to give",
    "BTN_RECEIVE_MONEY": "Receive",
    "BTN_SELECT_ALTERNATIVES_IDENTITIES": "Switch to another identity...",
    "BTN_FIX_MEMBERSHIP": "Resubmit membership request...",
    "BTN_MEMBERSHIP_RENEW": "Renew membership",
    "BTN_MEMBERSHIP_RENEW_DOTS": "Renew membership...",
    "BTN_MEMBERSHIP_OUT_DOTS": "Revoke membership...",
    "BTN_SECURITY_DOTS": "Sign-in and security...",
    "BTN_SHOW_DETAILS": "Display technical data",
    "LOCKED_OUTPUTS_POPOVER": {
      "TITLE": "Locked amount",
      "DESCRIPTION": "Here are the conditions for unlocking this amount:",
      "DESCRIPTION_MANY": "This transaction consists of several parts, of which the unlock conditions are:",
      "LOCKED_AMOUNT": "Conditions for the amount:"
    },
    "NEW": {
      "TITLE": "Registration",
      "INTRO_WARNING_TIME": "Creating an account on {{name|capitalize}} is very simple. Please take sufficient time to do this correctly (not to forget the usernames, passwords, etc.).",
      "INTRO_WARNING_SECURITY": "Check that the hardware you are currently using (computer, tablet, phone) <b>is secure and trustworthy </b>.",
      "INTRO_WARNING_SECURITY_HELP": "Up-to-date anti-virus, firewall enabled, session protected by password or pin code...",
      "INTRO_HELP": "Click <b> {{'COMMON.BTN_START'|translate}}</b> to begin creating an account. You will be guided step by step.",
      "REGISTRATION_NODE": "Your registration will be registered via the Duniter peer <b>{{server}}</b> node, which will then be distributed to the rest of the currency network.",
      "REGISTRATION_NODE_HELP": "If you do not trust this peer, please change <a ng-click=\"doQuickFix('settings')\">in the settings</a> of Cesium.",
      "SELECT_ACCOUNT_TYPE": "Choose the type of account to create:",
      "MEMBER_ACCOUNT": "Member account",
      "MEMBER_ACCOUNT_TITLE": "Create a member account",
      "MEMBER_ACCOUNT_HELP": "If you are not yet registered as an individual (one account possible per individual).",
      "WALLET_ACCOUNT": "Simple wallet",
      "WALLET_ACCOUNT_TITLE": "Create a wallet",
      "WALLET_ACCOUNT_HELP": "If you represent a company, association, etc. or simply need an additional wallet. No universal dividend will be created by this account.",
      "SALT_WARNING": "Choose a secret identifier.<br/>You need it for each connection to this account.<br/><br/><b>Make sure to remember this identifier</b>.<br/>If lost, there are no means to retrieve it!",
      "PASSWORD_WARNING": "Choose a password.<br/>You need it for each connection to this account.<br/><br/><b>Make sure to remember this password</b>.<br/>If lost, there are no means to retrieve it!",
      "PSEUDO_WARNING": "Choose a pseudonym.<br/>It may be used by other people to find you more easily.<br/><br/>.Use of <b>commas, spaces and accents</b> is not allowed.<br/><div class='hidden-xs'><br/>Example: <span class='gray'>JohnDalton, JackieChan, etc.</span>",
      "PSEUDO": "Pseudonym",
      "PSEUDO_HELP": "joe123",
      "SALT_CONFIRM": "Confirm",
      "SALT_CONFIRM_HELP": "Confirm the secret identifier",
      "PASSWORD_CONFIRM": "Confirm",
      "PASSWORD_CONFIRM_HELP": "Confirm the password",
      "SLIDE_6_TITLE": "Confirmation:",
      "COMPUTING_PUBKEY": "Computing...",
      "LAST_SLIDE_CONGRATULATION": "You completed all required fields.<br/><b>You can send the account creation request</b>.<br/><br/>For information, the public key below identifies your future account.<br/>It can be communicated to third parties to receive their payment.<br/>Once your account has been approved, you can find this key under <b>{{'ACCOUNT.TITLE'|translate}}</b>.",
      "CONFIRMATION_MEMBER_ACCOUNT": "<b class=\"assertive\">Warning:</b> your secret identifier, password and pseudonym can not be changed.<br/><b>Make sure you always remember it!</b><br/><b>Are you sure</b> you want to send this account creation request?",
      "CONFIRMATION_WALLET_ACCOUNT": "<b class=\"assertive\">Warning:</b> your password and pseudonym can not be changed.<br/><b>Make sure you always remember it!</b><br/><b>Are you sure</b> you want to continue?",
      "CHECKING_PSEUDO": "Checking...",
      "PSEUDO_AVAILABLE": "This pseudonym is available",
      "PSEUDO_NOT_AVAILABLE": "This pseudonym is not available",
      "INFO_LICENSE": "To be able to adhere to the currency, we ask you to kindly read and accept this license.",
      "BTN_ACCEPT": "I accept",
      "BTN_ACCEPT_LICENSE": "I accept the license"
    },
    "POPUP_REGISTER": {
      "TITLE": "Enter a pseudonym",
      "HELP": "A pseudonym is needed to let other members find you."
    },
    "SELECT_IDENTITY_MODAL": {
      "TITLE": "Identity selection",
      "HELP": "Several <b>different identities</b> have been sent, for the public key <span class=\"gray\"> <i class=\"ion-key\"></i> {{pubkey | formatPubkey}}</span>.<br/>Please select the identity to use:"
    },
    "SELECT_WALLET_MODAL": {
      "TITLE": "Wallet selection"
    },
    "WALLET_LIST": {
      "TITLE": "My wallets",
      "BTN_NEW": "Add a wallet",
      "BTN_DOWNLOAD": "Download the list",
      "BTN_IMPORT_FILE_DOTS": "Import from a file...",
      "NO_WALLET": "No secondary wallet",
      "BTN_DELETE": "Remove a secondary wallet...",
      "BTN_RENAME": "Rename the wallet",
      "EXPORT_FILENAME": "my_wallets-{{pubkey|formatPubkey}}-{{currency}}.csv",
      "TOTAL_DOTS": "Total: ",
      "EDIT_POPOVER": {
        "TITLE": "Rename the wallet",
        "HELP": "Fill in the new name",
        "NAME_HELP": "Wallet name"
      },
      "IMPORT_MODAL": {
        "TITLE": "Import secondary wallets",
        "HELP": "To <b>import secodnary wallets</b>, please drag the file in the box below, or click in the box to search for a file.",
        "WALLET_COUNT": "<b>{{count}}</b> new wallet{{count > 1 ? 's' : ''}}",
        "NO_NEW_WALLET": "No new wallet"
      }
    },
    "SECURITY":{
      "ADD_QUESTION" : "Add custom question",
      "BTN_CLEAN" : "Clean",
      "BTN_RESET" : "Reset",
      "DOWNLOAD_REVOKE": "Save a revocation file",
      "DOWNLOAD_REVOKE_HELP" : "Having a revocation file is important, for example in case of loss of identifiers. It allows you to <b>get this account out of the Web Of Trust</b>, thus becoming a simple wallet.",
      "GENERATE_KEYFILE": "Generate my keychain file ...",
      "GENERATE_KEYFILE_HELP": "Generate a file allowing you to authenticate without entering your identifiers.<br/><b>Warning:</b> this file will contain your secret key; It is therefore very important to put it in a safe place!",
      "KEYFILE_FILENAME": "keychain-{{pubkey|formatPubkey}}-{{currency}}-{{format}}.dunikey",
      "MEMBERSHIP_IN": "Register as member...",
      "MEMBERSHIP_IN_HELP": "Allows you to <b>transform </b> a simple wallet account <b>into a member account</b>, by sending a membership request. Useful only if you do not already have another member account.",
      "SEND_IDENTITY": "Publish identity...",
      "SEND_IDENTITY_HELP": "Allows you to associate a pseudonym to this account, but <b>without applying for membership</b> to become a member. This is not very useful because the validity of this pseudonym association is limited in time.",
      "HELP_LEVEL": "Choose <strong> at least {{nb}} questions </strong> :",
      "LEVEL": "Security level",
      "LOW_LEVEL": "Low <span class=\"hidden-xs\">(2 questions minimum)</span>",
      "MEDIUM_LEVEL": "Medium <span class=\"hidden-xs\">(4 questions minimum)</span>",
      "QUESTION_1": "What was your best friend's name when you were a teen ?",
      "QUESTION_2": "What was the name of your first pet ?",
      "QUESTION_3": "What is the first meal you have learned to cook ?",
      "QUESTION_4": "What is the first movie you saw in the cinema?",
      "QUESTION_5": "Where did you go the first time you flew ?",
      "QUESTION_6": "What was your favorite elementary school teacher's name  ?",
      "QUESTION_7": "What would you consider the ideal job ?",
      "QUESTION_8": "Which children's book do you prefer?",
      "QUESTION_9": "What was the model of your first vehicle?",
      "QUESTION_10": "What was your nickname when you were a child ?",
      "QUESTION_11": "What was your favorite movie character or actor when you were a student ?",
      "QUESTION_12": "What was your favorite singer or band when you were a student ?",
      "QUESTION_13": "In which city did your parents meet ?",
      "QUESTION_14": "What was the name of your first boss ?",
      "QUESTION_15": "What is the name of the street where you grew up ?",
      "QUESTION_16": "What is the name of the first beach where you go swim ?",
      "QUESTION_17": "QWhat is the first album you bought ?",
      "QUESTION_18": "What is the name of your favorite sport team ?",
      "QUESTION_19": "What was your grand-father's job ?",
      "RECOVER_ID": "Recover my password...",
      "RECOVER_ID_HELP": "If you have a <b>backup file of your identifiers</b>, you can find them by answering your personal questions correctly.",
      "RECOVER_ID_SELECT_FILE": "Select the <b>backup file of your identifiers</b> to use:",
      "REVOCATION_WITH_FILE" : "Revoke my member account...",
      "REVOCATION_WITH_FILE_DESCRIPTION": "If you have <b>permanently lost your member account credentials (or if account security is compromised), you can use <b>the revocation file</b> of the account <b>to quit the Web Of Trust</b>.",
      "REVOCATION_WITH_FILE_HELP": "To <b>permanently revoke</ b> a member account, please drag the revocation file in the box below, or click in the box to search for a file.",
      "REVOCATION_WALLET": "Revoke this account immediately",
      "REVOCATION_WALLET_HELP": "Requesting revocation of your identity causes <b>will revoke your membership</ b> (definitely for the associated pseudonym and public key). The account will no longer be able to produce a Universal Dividend.<br/>However, you can still use it as a simple wallet.",
      "REVOCATION_FILENAME": "revocation-{{uid}}-{{pubkey|formatPubkey}}-{{currency}}.txt",
      "SAVE_ID": "Save my credentials...",
      "SAVE_ID_HELP": "Creating a backup file, to <b>retrieve your password</b> (and the secret identifier) <b> in case of forgetting</b>. The file is <b>secured</ b> (encrypted) using personal questions.",
      "STRONG_LEVEL": "Strong <span class=\"hidden-xs \">(6 questions minimum)</span>",
      "TITLE": "Account and security",
      "KEYFILE": {
        "PUBSEC_FORMAT": "PubSec format.",
        "PUBSEC_FORMAT_HELP": "This file format is compatible in particular with Cesium and Gannonce. Your keychain is stored <b>without encryption</b>: anyone with a copy of this file will be able to empty your account.",
        "WIF_FORMAT": "Wallet Import Format (WIF)",
        "WIF_FORMAT_HELP": "This format is used in particular by paper wallets. Your keychain is stored <b>without encryption</b>: anyone with a copy of this file will be able to empty your account.",
        "EWIF_FORMAT": "Encrypted Wallet Import Format (WIF)",
        "EWIF_FORMAT_HELP": "This format is used in particular by paper wallets. However, <b>the keychain is encrypted</b> from a passphrase of your choice.",
        "PASSWORD_POPUP": {
          "TITLE": "Keychain file encrypted",
          "HELP": "Please enter the passphrase:",
          "PASSWORD_HELP": "Passphrase"
        },
        "ERROR": {
          "BAD_PASSWORD": "Bad passphrase",
          "BAD_CHECKSUM": "Bad checksum"
        }
      }
    },
    "FILE_NAME": "{{currency}} - Account statement {{pubkey|formatPubkey}} to {{currentTime|formatDateForFile}}.csv",
    "HEADERS": {
      "TIME": "Date",
      "AMOUNT": "Amount",
      "COMMENT": "Comment"
    }
  },
  "TRANSFER": {
    "TITLE": "Transfer",
    "SUB_TITLE": "Transfer money",
    "SUB_TITLE_ALL": "Empty the account",
    "FROM": "From",
    "TO": "To",
    "AMOUNT": "Amount",
    "AMOUNT_HELP": "Amount",
    "COMMENT": "Comment",
    "COMMENT_HELP": "Comment (optional)",
    "BTN_SEND": "Send",
    "BTN_ADD_COMMENT": "Add a comment",
    "REST": "Rest of account",
    "REST_TO": "to",
    "WARN_COMMENT_IS_PUBLIC": "Please note that <b>comments are public</b> (not encrypted).",
    "MODAL": {
      "TITLE": "Transfer"
    }
  },
  "ERROR": {
    "UNKNOWN_URI_FORMAT": "Unknown URI format",
    "PUBKEY_INVALID_CHECKSUM": "Invalid public key (bad checksum).",
    "POPUP_TITLE": "Error",
    "UNKNOWN_ERROR": "Unknown error",
    "CRYPTO_UNKNOWN_ERROR": "Your browser is not compatible with cryptographic features.",
    "DOWNLOAD_KEYFILE_FAILED": "Failed to generate the keychain file.",
    "EQUALS_TO_PSEUDO": "Must be different from pseudonym",
    "EQUALS_TO_SALT": "Must be different from secret identifier",
    "FIELD_REQUIRED": "This field is required.",
    "FIELD_TOO_SHORT": "This field value is too short.",
    "FIELD_TOO_SHORT_WITH_LENGTH": "Value is too short (min {{minLength]] characters).",
    "FIELD_TOO_LONG": "Value is exceeding max length.",
    "FIELD_TOO_LONG_WITH_LENGTH": "Value is too long (max {{maxLength}} characters).",
    "FIELD_MIN": "Minimum value: {{min}}",
    "FIELD_MAX": "Maximal value: {{max}}",
    "FIELD_ACCENT": "Commas and accent characters not allowed",
    "FIELD_NOT_NUMBER": "Value is not a number",
    "FIELD_NOT_INT": "Value is not an integer",
    "FIELD_NOT_EMAIL": "Email adress not valid",
    "PASSWORD_NOT_CONFIRMED": "Must match previous password.",
    "SALT_NOT_CONFIRMED": "Must match previous identifier.",
    "SEND_IDENTITY_FAILED": "Error while trying to register.",
    "SEND_CERTIFICATION_FAILED": "Could not certify identity.",
    "NEED_MEMBER_ACCOUNT_TO_CERTIFY": "You could not send certification, because your account is <b>not a member account</b>.",
    "NEED_MEMBER_ACCOUNT_TO_CERTIFY_HAS_SELF": "You could not send certification now, because your are <b>not a member</b> yet.<br/><br/>You still need certification to become a member.",
    "IDENTITY_TO_CERTIFY_HAS_NO_SELF": "This account could not be certified. No registration found, or need to renew.",
    "LOGIN_FAILED": "Error while sign in.",
    "LOAD_IDENTITY_FAILED": "Could not load identity.",
    "LOAD_REQUIREMENTS_FAILED": "Could not load identity requirements.",
    "SEND_MEMBERSHIP_IN_FAILED": "Error while sending registration as member.",
    "SEND_MEMBERSHIP_OUT_FAILED": "Error while sending membership revocation.",
    "REFRESH_WALLET_DATA": "Could not refresh wallet.",
    "GET_CURRENCY_PARAMETER": "Could not get currency parameters.",
    "GET_CURRENCY_FAILED": "Could not load currency. Please retry later.",
    "SEND_TX_FAILED": "Could not send transaction.",
    "ALL_SOURCES_USED": "Please wait the next block computation (All transaction sources has been used).",
    "NOT_ENOUGH_SOURCES": "Not enough changes to send this amount in one time.<br/>Maximum amount: {{amount}} {{unit}}<sub>{{subUnit}}</sub>.",
    "ACCOUNT_CREATION_FAILED": "Error while creating your member account.",
    "RESTORE_WALLET_DATA_ERROR": "Error while reloading settings from local storage",
    "LOAD_WALLET_DATA_ERROR": "Error while loading wallet data.",
    "COPY_CLIPBOARD_FAILED": "Could not copy to clipboard",
    "TAKE_PICTURE_FAILED": "Could not get picture.",
    "SCAN_FAILED": "Could not scan QR code.",
    "SCAN_UNKNOWN_FORMAT": "Code not recognized.",
    "WOT_LOOKUP_FAILED": "Search failed.",
    "LOAD_PEER_DATA_FAILED": "Duniter peer not accessible. Please retry later.",
    "NEED_LOGIN_FIRST": "Please sign in first.",
    "AMOUNT_REQUIRED": "Amount is required.",
    "AMOUNT_NEGATIVE": "Negative amount not allowed.",
    "NOT_ENOUGH_CREDIT": "Not enough credit.",
    "INVALID_NODE_SUMMARY": "Unreachable peer or invalid address",
    "INVALID_USER_ID": "Field 'pseudonym' must not contains spaces or special characters.",
    "INVALID_COMMENT": "Field 'reference' has a bad format.",
    "INVALID_PUBKEY": "Public key has a bad format.",
    "INVALID_PUBKEY_CHECKSUM": "Invalid checksum.",
    "IDENTITY_REVOKED": "This identity <b>has been revoked</b>. It can no longer become a member.",
    "IDENTITY_REVOKED_WITH_TIME": "This identity <b>has been revoked {{revocationTime|medianFromNow}}</b> ({{revocationTime|medianDate}}). It can no longer become a member.",
    "IDENTITY_PENDING_REVOCATION": "The <b>revocation of this identity</b> has been requested and is awaiting processing. Certification is therefore disabled.",
    "IDENTITY_INVALID_BLOCK_HASH": "This membership application is no longer valid (because it references a block that network peers are cancelled): the person must renew its application for membership <b>before</b> being certified.",
    "IDENTITY_EXPIRED": "This identity has expired: this person must re-apply <b>before</b> being certified.",
    "IDENTITY_SANDBOX_FULL": "Could not register, because peer's sandbox is full.<br/><br/>Please retry later or choose another Duniter peer (in <b>Settings</b>).",
    "IDENTITY_NOT_FOUND": "Identity not found",
    "IDENTITY_TX_FAILED": "Error while getting identity's transactions",
    "WOT_PENDING_INVALID_BLOCK_HASH": "Membership not valid.",
    "WALLET_INVALID_BLOCK_HASH": "Your membership application is no longer valid (because it references a block that network peers are cancelled).<br/>You must <a ng-click=\"doQuickFix('renew')\">renew your application for membership</a> to fix this issue.",
    "WALLET_IDENTITY_EXPIRED": "The publication of your identity <b>has expired</b>.<br/>You must <a ng-click=\"doQuickFix('fixIdentity')\">re-issue your identity</a> to resolve this issue.",
    "WALLET_REVOKED": "Your identity has been <b>revoked</b>: neither your pseudonym nor your public key will be used in the future for a member account.",
    "WALLET_HAS_NO_SELF": "Your identity must first have been published, and not expired.",
    "AUTH_REQUIRED": "Authentication required.",
    "AUTH_INVALID_PUBKEY": "The public key does not match the connected account.",
    "AUTH_INVALID_SCRYPT": "Invalid username or password.",
    "AUTH_INVALID_FILE": "Invalid keychain file.",
    "AUTH_FILE_ERROR": "Failed to open keychain file",
    "IDENTITY_ALREADY_CERTIFY": "You have <b>already certified</b> that identity.<br/><br/>Your certificate is still valid (expires {{expiresIn|formatDuration}}).",
    "IDENTITY_ALREADY_CERTIFY_PENDING": "You have <b>already certified</b> that identity.<br/><br/>Your certification is still pending (Deadline for treatment {{expiresIn|formatDuration}}).",
    "UNABLE_TO_CERTIFY_TITLE": "Unable to certify",
    "LOAD_NEWCOMERS_FAILED": "Unable to load new members.",
    "LOAD_PENDING_FAILED": "Unable to load pending registrations.",
    "ONLY_MEMBER_CAN_EXECUTE_THIS_ACTION": "You must <b>be a member</b> in order to perform this action.",
    "ONLY_MEMBER_OR_WAS_MEMBER_CAN_EXECUTE_THIS_ACTION": "You must <b>be a member (or old member)</b> in order to perform this action.",
    "ONLY_SELF_CAN_EXECUTE_THIS_ACTION": "You must have <b>published your identity</b> in order to perform this action.",
    "GET_BLOCK_FAILED": "Error while getting block",
    "INVALID_BLOCK_HASH": "Block not found (incorrect hash)",
    "DOWNLOAD_REVOCATION_FAILED": "Error while downloading revocation file.",
    "REVOCATION_FAILED": "Error while trying to revoke the identity.",
    "SALT_OR_PASSWORD_NOT_CONFIRMED": "Wrong secret identifier or password ",
    "RECOVER_ID_FAILED": "Could not recover password",
    "LOAD_FILE_FAILED" : "Unable to load file",
    "NOT_VALID_REVOCATION_FILE": "Invalid revocation file (wrong file format)",
    "NOT_VALID_SAVE_ID_FILE": "Invalid credentials backup file (wrong file format)",
    "NOT_VALID_KEY_FILE": "Invalid keychain file (unrecognized format)",
    "EXISTING_ACCOUNT": "Your identifiers correspond to an already existing account, whose <a ng-click=\"showHelpModal('pubkey')\">public key</a> is:",
    "EXISTING_ACCOUNT_REQUEST": "Please modify your credentials so that they correspond to an unused account.",
    "GET_LICENSE_FILE_FAILED": "Unable to get license file",
    "CHECK_NETWORK_CONNECTION": "No peer appears to be accessible.<br/><br/>Please <b>check your Internet connection</b>.",
    "ISSUE_524_TX_FAILED": "Failed to transfer.<br/><br/>A message has been sent to developers to help solve the problem.<b>Thank you for your help</b>.",
    "ADD_SECONDARY_WALLET_FAILED": "Unable to add secondary wallet.",
    "REMOVE_SECONDARY_WALLET_FAILED": "Unable to remove secondary wallet.",
    "UPDATE_WALLET_LIST_FAILED": "Unable to refresh the list of wallets.",
    "LOAD_WALLET_LIST_FAILED": "Unable to load the list of wallets.",
    "SAVE_WALLET_LIST_FAILED": "Unable to save the list of wallets.",
    "COULD_NOT_ADD_MAIN_WALLET": "This wallet <b>is the main account</b> with which you are connected. Unable to add it as a secondary wallet.",
    "COULD_NOT_ADD_EXISTING_WALLET": "Wallet already existing in the list.",
    "UNKNOWN_WALLET_ID": "Unknown secondary wallet.",
    "RESTORE_WALLET_LIST_FAILED": "Unable to restore the list of wallets.",
    "INVALID_FILE_FORMAT": "Invalid file format.",
    "SAME_TX_RECIPIENT": "The recipient must be different from the issuer."
  },
  "INFO": {
    "POPUP_TITLE": "Information",
    "CERTIFICATION_DONE": "Identity successfully signed",
    "NOT_ENOUGH_CREDIT": "Not enough credit",
    "TRANSFER_SENT": "Transfer request successfully sent",
    "COPY_TO_CLIPBOARD_DONE": "Copy succeeded",
    "MEMBERSHIP_OUT_SENT": "Membership revocation sent",
    "NOT_NEED_MEMBERSHIP": "Already a member.",
    "IDENTITY_WILL_MISSING_CERTIFICATIONS": "This identity will soon lack certification (at least {{willNeedCertificationCount}}).",
    "IDENTITY_NEED_MEMBERSHIP": "This identity did not send a membership request. She will have to if she wishes to become a member.",
    "HAS_ALTERNATIVE_IDENTITIES": "There are <b>multiple identities</b> attached to this public key. <b>Before any certification</b>, please <a ng-click=\"doQuickFix('showSelectIdentities')\">check other identities</a> to choose the correct one, or contact the wallet owner.",
    "REVOCATION_SENT": "Revocation sent successfully",
    "REVOCATION_SENT_WAITING_PROCESS": "Revocation <b>has been sent successfully</b>. It is awaiting processing.",
    "FEATURES_NOT_IMPLEMENTED": "This features is not implemented yet.<br/><br/>Why not to contribute to get it faster? ;)",
    "EMPTY_TX_HISTORY": "No operations to export"
  },
  "CONFIRM": {
    "POPUP_TITLE": "<b>Confirmation</b>",
    "POPUP_WARNING_TITLE": "<b>Warning</b>",
    "POPUP_SECURITY_WARNING_TITLE": "<i class=\"icon ion-alert-circled\"></i> <b>Security warning</b>",
    "CERTIFY_RULES_TITLE_UID": "Certify {{uid}}",
    "CERTIFY_RULES": "<b class=\"assertive\">Don't certify an account</b> if you believe that: <ul><li>1.) the issuers identity might be faked.<li>2.) the issuer already has another certified account.<li>3.) the issuer purposely or carelessly violates rule 1 or 2 (he certifies faked or double accounts).</ul></small><br/>Are you sure you want to certify this identity?",
    "FULLSCREEN": "View the application in full screen?",
    "EXIT_APP": "Close the application ?",
    "TRANSFER": "<b>Transfer summary:</b><br/><br/><ul><li> - From: <b>{{from}}</b></li><li> - To: <b>{{to}}</b></li><li> - Amount: <b>{{amount}} {{unit}}</b></li><li> - Comment: <i>{{comment}}</i></li></ul><br/><b>Are-you sure you want to do this transfer?</b>",
    "TRANSFER_ALL": "<b>Transfer summary:</b><br/><br/><ul><li> - From: <b>{{from}}</b></li><li> - To: <b>{{to}}</b></li><li> - Amount: <b>{{amount}} {{unit}}</b></li><li> - Comment: <i>{{comment}}</i></li><br/><li> - Rest : <b>{{restAmount}} {{unit}}</b> to <b>{{restTo}}</b></li></ul><br/><b>Are-you sure you want to do this transfer?</b>",
    "MEMBERSHIP_OUT": "This operation is <b>irreversible</b>.<br/></br/><b>Are you sure you want to terminate your membership?</b>",
    "MEMBERSHIP_OUT_2": "This operation is <b>irreversible</b>!<br/><br/>Are you sure you want to <b>terminate your membership</b>?",
    "LOGIN_UNUSED_WALLET_TITLE": "Typing error?",
    "LOGIN_UNUSED_WALLET": "The account seems to be <b>inactive</b>.<br/><br/>It's probably a <b>typing error</b> when sign in. Please try again, checking that <b>public key is yours<b/>.",
    "FIX_IDENTITY": "The pseudonym <b>{{uid}}</b> will be published again, replacing the old publication that has expired.<br/></br/><b>Are you sure</b> you want to continue?",
    "FIX_MEMBERSHIP": "Your application for membership will be sent.<br/></br/><b>Are you sure?</b>",
    "MEMBERSHIP": "Your membership request will be sent. <br/></br/><b>Are you sure?</b>",
    "RENEW_MEMBERSHIP": "Your membership will be renewed.<br/></br/><b>Are you sure?</b>",
    "REVOKE_IDENTITY": "You will <b>definitely revoke this identity</b>.<br/><br/>The public key and the associated pseudonym <b>will never be used again</b> (for a member account).<br/></br/><b>Are you sure</b> you want to revoke this identity?",
    "REVOKE_IDENTITY_2": "This operation is <b>irreversible</b>!<br/><br/>Are you sure you want to <b>revoke this identity</b>?",
    "NOT_NEED_RENEW_MEMBERSHIP": "Your membership does not need to be renewed (it will only expire in {{membershipExpiresIn|formatDuration}}).<br/></br/><b>Are you sure you</b> want to renew your membership?",
    "SAVE_BEFORE_LEAVE": "Do you want to <b>save your changes</b> before leaving the page?",
    "SAVE_BEFORE_LEAVE_TITLE": "Changes not saved",
    "LOGOUT": "Are you sure you want to logout?",
    "USE_FALLBACK_NODE": "Peer <b>{{old}}</b> unreachable or invalid address.<br/><br/>Do you want to temporarily use the <b>{{new}}</b> node?",
    "ISSUE_524_SEND_LOG": "The transaction was rejected because of a known problem (issue #524) but not reproduced.<br/><br/>To help developers correct this error, do you accept <b>the transmission of your logs</b> per message?<br/><small>(No confidential data is sent)</small>"
  },
  "MODE": {
    "DEMO": {
      "BADGE": "Demo",
      "MODE": "Demonstration mode",
      "FEATURE_NOT_AVAILABLE": "Functionality <b>not available</b> on this demonstration site.",
      "MODE_HELP": "Cesium works in <b>demonstration mode</b>: consultation on account is available, but no operation can be performed.",
      "INSTALL_HELP": "For <b>security reasons</b> we recommend <b>installing</b> your copy of the software.<br/> Visit the site <a href='https://cesium.app'>www.cesium.app</a> for help."
    },
    "READONLY": {
      "BADGE": "Monit",
      "MODE": "Monitoring mode",
      "MODE_HELP": "Cesium works in <b>monitoring mode</b>: only currency monitoring features are available.",
      "INSTALL_HELP": "If you want to <b>create a wallet account</b> to send or received money, we recommend <b>installing</b> your copy of the software.<br/> Visit the site <a href='https://cesium.app'>www.cesium.app</a> for help."
    }
  },
  "DOWNLOAD": {
    "POPUP_TITLE": "<b>Revocation file</b>",
    "POPUP_REVOKE_MESSAGE": "To safeguard your account, please download the <b>account revocation document</b>. It will allow you to cancel your account (in case of account theft, ID, an incorrectly created account, etc.).<br/><br/><b>Please store it in a safe place.</b>"
  },
  "HELP": {
    "TITLE": "Online help",
    "JOIN": {
      "SECTION": "Join",
      "SALT": "The secret identifier is very important. It is used to hash you password, which in turn is used to calculate your <span class=\"text-italic\">public account key</span> (its number) and the private key to access it.<br/><b>Please remeber this identifier well</b>, because there is no way to recover it when lost.<br/>Furthermore, it cannot be changed without having to create a new account.<br/><br/>A good secret identifier must be sufficiently long (8 characters at the very least) and as original as possible.",
      "PASSWORD": "The password is very important. Together with the secret identifier, it is use to calculate your account number (pblic key) and the private key to access it.<br/><b>Please remember it well</b>, because there is no way to recover it when lost.<br/>Furthermore, it cannot be changed without having to create a new account.<br/><br/>A good password is made (ideally) of at least 8 characters, with at least one capital and one number.",
      "PSEUDO": "A pseudonym is used only when joining as <span class=\"text-italic\">member</span>. It is always associated with a wallet (by its <span class=\"text-italic\">public key</span>).<br/>It is published on the network so that other users may identify it, certify or send money to the account.<br/>A pseudonym must be unique among all members (current and past)."
    },
    "LOGIN": {
      "SECTION": "Log in",
      "PUBKEY": "Account public key",
      "PUBKEY_DEF": "The public key of the keychain is generated from the entered identifiers (any), but does not correspond to an account already used.<br/><b>Make sure your public key is the same as your account</b>. Otherwise, you will be logged into an account that is probably never used, as the risk of collision with an existing account is very small.<br/><a href=\"https://en.wikipedia.org/wiki/Elliptic_curve_cryptography\" target=\"_ system\">Learn more about cryptography</a> by public key.",
      "METHOD": "Connection methods",
      "METHOD_DEF": "Several options are available to connect to a portfolios: <br/> - The connection <b>with salt (simple or advanced)</b> mixes your password with the secret identifier, to limit the attempts of piracy<br/> - The connection <b>using public key</b> prevents you from entering your credentials, which you will be asked only when an operation need it.<br/> - The connection <b>using keychain file</b> will read the public and private keys of the account from a file without the need to enter credentials. Several file formats are possible."
    },
    "GLOSSARY": {
      "SECTION": "Glossary",
      "PUBKEY_DEF": "A public key always identifies a wallet. It may identify a member. In Cesium it is calculated using the secret identifier and the password.",
      "MEMBER": "Member",
      "MEMBER_DEF": "A member is a real and living human, wishing to participate freely to the monitary community. The member will receive universal dividend, according to the period and amount as defined in the <span class=\"text-italic\">currency parameters</span>.",
      "CURRENCY_RULES": "Currency rules",
      "CURRENCY_RULES_DEF": "The currency rules are defined only once, and for all. They set the parameters under which the currency will perform: universal dividend calculation, the amount of certifications needed to become a member, the maximum amount of certifications a member can send, etc.<br/><br/>The parameters cannot be modified because of the use of a <span class=\"text-italic\">Blockchain</span> which carries and executes these rules, and constantly verifies their correct application. <a href=\"#/app/currency\">See current parameters</a>.",
      "BLOCKCHAIN": "Blockchain",
      "BLOCKCHAIN_DEF": "The Blockchain is a decentralised system which, in case of Duniter, serves to carry and execute the <span class=\"text-italic\">currency rules</span>.<br/><a href=\"http://en.duniter.org/presentation/\" target=\"_blank\">Read more about Duniter</a> and the working of its blockchain.",
      "UNIVERSAL_DIVIDEND_DEF": "The Universal Dividend (UD) is the quantity of money co-created by each member, according to the period and the calculation defined in the <span class=\"text-italic\">currency rules</span>.<br/>Every term, the members receive an equal amount of new money on their account.<br/><br/>The UD undergoes a steady growth, to remain fair under its members (current and future), calculated by an average life expectancy, as demonstrated in the Relative Theory of Money (RTM).<br/><a href=\"http://trm.creationmonetaire.info\" target=\"_system\">Read more about RTM</a> and open money.",
      "WOT": "Web of Trust (WoT)",
      "WOT_DEF": "The Web of Trust is made up of all the members of the currency, and the links of certification which connect them.",
      "DISTANCE_RULE": "Distance rule",
      "DISTANCE_RULE_DEF": "The rule of distance defines <b>a maximum distance to meet</b> between an applicant and a minimum number of referring member. This distance is calculated using the certification links."
    },
    "TIP": {
      "MENU_BTN_CURRENCY": "Menu <b>{{'MENU.CURRENCY'|translate}}</b> allows discovery of <b>currency parameters</b> and its state.",
      "CURRENCY_WOT": "The <b>member count</b> shows the <b>community's weight and evolution</b>.",
      "CURRENCY_MASS": "Shown here is the <b>total amount</b> currently in circulation and its <b>average distribution</b> per member.<br/><br/>This allows to estimate the <b>worth of any amount</b>, in respect to what <b>others own</b> on their account (on average).",
      "CURRENCY_UNIT_RELATIVE": "The unit used here (&ldquo;<b>{{'COMMON.UD'|translate}}<sub>{{currency|abbreviate}}</sub></b>&rdquo;) signifies that the amounts in {{currency|capitalize}} have been devided by the <b>Universal Dividend</b> (UD).<br/><br/><small>This relative unit is <b>relevant</b> because it is stable in contrast to the permanently growing monitary mass.</small>",
      "CURRENCY_CHANGE_UNIT": "The option <b>{{'COMMON.BTN_RELATIVE_UNIT'|translate}}</b> allows to <b>switch the unit</b> to show amounts in <b>{{currency|capitalize}}</b>, undevided by the Universal Dividend (instead of in &ldquo;<b>{{'COMMON.UD'|translate}}<sub>{{currency|abbreviate}}</sub></b>&rdquo;).",
      "CURRENCY_CHANGE_UNIT_TO_RELATIVE": "The option <b>{{'COMMON.BTN_RELATIVE_UNIT'|translate}}</b> allows to <b>switch the unit</b> to show amounts in &ldquo;<b>{{'COMMON.UD'|translate}}<sub>{{currency|abbreviate}}</sub></b>&rdquo;, which is relative to the Universal Dividend (the amount co-produced by each member).",
      "CURRENCY_RULES": "The <b>rules</b> of the currency determine its <b>exact and predictible</b> performance.<br/><br/>As a true DNA of the currency these rules make the monetary code <b>transparent and understandable</b>.",
      "MENU_BTN_NETWORK": "Menu <b>{{'MENU.NETWORK'|translate}}</b> allows discovery of <b>network's state<b>.",
      "NETWORK_BLOCKCHAIN": "All monetary transactions are recoded in a <b>public and tamper proof</b> ledger, generally referred to as the <b>blockchain</b>.",
      "NETWORK_PEERS": "The <b>peers</b> shown here correspond to <b>computers that update and check</b> the blockchain.<br/><br/>The more active peers there are, the more <b>decentralised</b> and therefore trustworhty the currency becomes.",
      "NETWORK_PEERS_BLOCK_NUMBER": "This <b>number</b> (in green) indicates the peer's <b>latest validated block</b> (last page written in the ledger).<br/><br/>Green indicates that the block was equally validated by the <b>majority of other peers</b>.",
      "NETWORK_PEERS_PARTICIPATE": "<b>Each member</b>, equiped with a computer with Internet, <b>can participate, adding a peer</b> simply by <b>installing the Duniter software</b> (free/libre). <a target=\"_new\" href=\"{{installDocUrl}}\" target=\"_system\">Read the installation manual &gt;&gt;</a>.",
      "MENU_BTN_ACCOUNT": "<b>{{'ACCOUNT.TITLE'|translate}}</b> allows access to your account balance and transaction history.",
      "MENU_BTN_ACCOUNT_MEMBER": "Here you can consult your account status, transaction history and your certifications.",
      "WALLET_CERTIFICATIONS": "Click here to reveiw the details of your certifications (given and received).",
      "WALLET_RECEIVED_CERTIFICATIONS": "Click here to review the details of your <b>received certifications</b>.",
      "WALLET_GIVEN_CERTIFICATIONS": "Click here to review the details of your <b>given certifications</b>.",
      "WALLET_BALANCE": "Your account <b>balance</b> is shown here.",
      "WALLET_BALANCE_RELATIVE": "{{'HELP.TIP.WALLET_BALANCE'|translate}}<br/><br/>The used unit (&ldquo;<b>{{'COMMON.UD'|translate}}<sub>{{currency|abbreviate}}</sub></b>&rdquo;) signifies that the amount in {{currency|capitalize}} has been divided by the <b>Universal Dividend</b> (UD) co-created by each member.<br/>At this moment, 1 UD equals {{currentUD}} {{currency|capitalize}}.",
      "WALLET_BALANCE_CHANGE_UNIT": "You can <b>change the unit</b> in which amounts are shown in <b><i class=\"icon ion-android-settings\"></i>&nbsp;{{'MENU.SETTINGS'|translate}}</b>.<br/><br/>For example, to display amounts <b>directly in {{currency|capitalize}}</b> instead of relative amounts.",
      "WALLET_PUBKEY": "This is your account public key. You can communicate it to a third party so that it more easily identifies your account.",
      "WALLET_SEND": "Issue a payment in just a few clicks.",
      "WALLET_SEND_NO_MONEY": "Issue a payment in just a few clicks.<br/>(Your balance does not allow this yet)",
      "WALLET_OPTIONS": "Please note that this button allows access to <b>other, less used actions</b>.<br/><br/>Don't forget to take a quick look, when you have a moment!",
      "WALLET_RECEIVED_CERTS": "This shows the list of persons that certified you.",
      "WALLET_CERTIFY": "The button <b>{{'WOT.BTN_SELECT_AND_CERTIFY'|translate}}</b> allows selecting an identity and certifying it.<br/><br/>Only users that are <b>already member</b> may certify others.",
      "WALLET_CERT_STOCK": "Your supply of certifications (to send) is limited to <b>{{sigStock}} certifications</b>.<br/><br/>This supply will replete itself over time, as and when earlier certifications expire.",
      "MENU_BTN_WALLETS": "The menu <b>{{'MENU.WALLETS'|translate}}</b> allows you to add additional wallets that you manage.",
      "MENU_BTN_TX": "The menu <b>{{'MENU.TRANSACTIONS'|translate}}</b> allow access to transactions history, and send new payments.",
      "MENU_BTN_WOT": "The menu <b>{{'MENU.WOT'|translate}}</b> allows searching <b>users</b> of the currency (member or not).",
      "WOT_SEARCH_TEXT_XS": "To search in the registry, type the <b>first letters of a users pseudonym or public key</b>.<br/><br/>The search will start automatically.",
      "WOT_SEARCH_TEXT": "To search in the registry, type the <b>first letters of a users pseudonym or public key</b>.<br/><br/>Then hit <b>Enter</b> to start the search.",
      "WOT_SEARCH_RESULT": "Simply click a user row to view the details sheet.",
      "WOT_VIEW_CERTIFICATIONS": "The row <b>{{'ACCOUNT.CERTIFICATION_COUNT'|translate}}</b> shows how many members members validated this identity.<br/><br/>These certifications testify that the account belongs to <b>a living human</b> and this person has <b>no other member account</b>.",
      "WOT_VIEW_CERTIFICATIONS_COUNT": "There are at least <b>{{sigQty}} certifications</b> needed to become a member and receive the <b>Universal Dividend</b>.",
      "WOT_VIEW_CERTIFICATIONS_CLICK": "Click here to open <b>a list of all certifications</b> given to and by this identity.",
      "WOT_VIEW_CERTIFY": "The button <b>{{'WOT.BTN_CERTIFY'|translate}}</b> allows to add your certification to this identity.",
      "CERTIFY_RULES": "<b>Attention:</b> Only certify <b>real and living persons</b> that do not own any other certified account.<br/><br/>The trust carried by the currency depends on each member's vigilance!",
      "MENU_BTN_SETTINGS": "The <b>{{'MENU.SETTINGS'|translate}}</b> allow you to configure the Cesium application.<br/><br/>For example, you can <b>change the unit</b> in which the currency will be shown.",
      "HEADER_BAR_BTN_PROFILE": "Click here to access your <b>user profile</b>",
      "SETTINGS_CHANGE_UNIT": "You can <b>change the display unit</b> of amounts by clicking here.<br/><br/>- Deactivate the option to show amounts in {{currency|capitalize}}.<br/>- Activate the option for relative amounts in {{'COMMON.UD'|translate}}<sub>{{currency|abbreviate}}</sub> (<b>divided</b> by the current Universal Dividend).",
      "END_LOGIN": "This guided visit has <b>ended</b>.<br/><br/>Welcome to the <b>free economy</b>!",
      "END_NOT_LOGIN": "This guided visit has <b>ended</b>.<br/><br/>If you wish to join the currency {{currency|capitalize}}, simply click <b>{{'LOGIN.CREATE_FREE_ACCOUNT'|translate}}</b> below.",
      "END_READONLY": "This guided visit has <b>ended</b>.<br/><br/>{{'MODE.READONLY.INSTALL_HELP'|translate}}."
    }
  },
  "API" :{
    "COMMON": {
      "LINK_DOC": "API documentation",
      "LINK_DOC_HELP": "API documentation for developers",
      "LINK_STANDARD_APP": "Standard version",
      "LINK_STANDARD_APP_HELP": "Open standard version of {{'COMMON.APP_NAME'|translate}}",
      "CONNECTION_ERROR": "Peer <b>{{server}}</b> unreachable or invalid address.<br/><br/>Check your Internet connection, or contact the web site administrator."
    },
    "HOME": {
      "TITLE": "{{'COMMON.APP_NAME'|translate}} API Documentation",
      "MESSAGE": "Welcome to the {{'COMMON.APP_NAME'|translate}} <b>API documentation </b>.<br/>Connect your web site to <a href=\"http://duniter.org\" target=\"_system\">Duniter</a> very easily!",
      "MESSAGE_SHORT": "Connect your websites to <a href=\"http://duniter.org\" target=\"_system\">Duniter</a> very easily!",
      "DOC_HEADER": "Available services:"
    },
    "TRANSFER": {
      "TITLE": "{{'COMMON.APP_NAME'|translate}} - Online payment",
      "TITLE_SHORT": "Online payment",
      "SUMMARY": "Order summary:",
      "AMOUNT": "Amount:",
      "AMOUNTS_HELP": "Please select the amount:",
      "NAME": "Name:",
      "PUBKEY": "Public key of the recipient:",
      "COMMENT": "Order reference:",
      "NODE": "Peer address:",
      "DEMO": {
        "SALT": "demo",
        "PASSWORD": "demo",
        "PUBKEY": "3G28bL6deXQBYpPBpLFuECo46d3kfYMJwst7uhdVBnD1",
        "HELP": "<b>Demonstration mode</b>: No payment will actually be sent during this simulation.<br/>Please use credentials: <b>{{'API.TRANSFER.DEMO.SALT'|translate}} / {{'API.TRANSFER.DEMO.PASSWORD'|translate}}</b>",
        "BAD_CREDENTIALS": "Invalid credentials.<br/>In demonstration mode, credentials should be: {{'API.TRANSFER.DEMO.SALT'|translate}} / {{'API.TRANSFER.DEMO.PASSWORD'|translate}}"
      },
      "INFO": {
        "SUCCESS_REDIRECTING_WITH_NAME": "Payment sent.<br/>Redirect to <b>{{name}}</b>...",
        "SUCCESS_REDIRECTING": "Payment sent.<br/>Redirect to the seller's website...",
        "CANCEL_REDIRECTING_WITH_NAME": "Payment cancelled.<br/>Redirect to <b>{{name}}</b>...",
        "CANCEL_REDIRECTING": "Payment cancelled.<br/>Redirect to the seller's website..."
      },
      "ERROR": {
        "TRANSFER_FAILED": "Payment failed"
      }
    },
    "DOC": {
      "DESCRIPTION_DIVIDER": "Description",
      "URL_DIVIDER": "Calling address",
      "PARAMETERS_DIVIDER": "Parameters",
      "AVAILABLE_PARAMETERS": "Here is the list of al available parameters:",
      "DEMO_DIVIDER": "Try it !",
      "DEMO_HELP": "To test this service, click on this button. The result content will be display below.",
      "DEMO_RESULT": "Result returned by call:",
      "DEMO_RESULT_PEER": "Peer address used:",
      "DEMO_SUCCEED": "<i class=\"icon ion-checkmark\"></i> Success!",
      "DEMO_CANCELLED": "<i class=\"icon ion-close\"></i> Cancelled by user",
      "INTEGRATE_DIVIDER": "Website integration",
      "INTEGRATE_CODE": "Code:",
      "INTEGRATE_RESULT": "Result preview:",
      "INTEGRATE_PARAMETERS": "Parameters",
      "TRANSFER": {
        "TITLE": "Payments",
        "DESCRIPTION": "From a site (eg online marketplace) you can delegate payment in free currency to Cesium API. To do this, simply open a page at the following address:",
        "PARAM_PUBKEY": "Recipient's public key",
        "PARAM_PUBKEY_HELP": "Recipient's public key (required)",
        "PARAM_AMOUNT": "Amount",
        "PARAM_AMOUNT_HELP": "Transaction amount (required)",
        "PARAM_COMMENT": "Reference (or comment)",
        "PARAM_COMMENT_HELP": "Reference or comment. You will allow for example to identify the payment in the BlockChain.",
        "PARAM_NAME": "Name (of recipient or website)",
        "PARAM_NAME_HELP": "The name of your website. This can be a readable name (eg \"My online site\"), or a web address (eg \"www.MySite.com\").",
        "PARAM_REDIRECT_URL": "URL redirection",
        "PARAM_REDIRECT_URL_HELP": "URL redirection after sending payment, after the payment has been sent. Can contain the following strings, which will be replaced by the values of the transaction: \"{tx}\", \"{hash}\", \"{comment}\", \"{amount}\" and \"{pubkey}\".",
        "PARAM_CANCEL_URL": "URL if cancelled",
        "PARAM_CANCEL_URL_HELP": "URL in case of cancellation.  Can contain the following strings, which will be replaced: \"{comment}\", \"{amount}\" and \"{pubkey}\".",
        "PARAM_PREFERRED_NODE": "Preferred Duniter peer",
        "PARAM_PREFERRED_NODE_HELP": "Peer address (URL) to use preferably (\"g1.domain.com:443\" or \"https://g1.domain.com\")",
        "EXAMPLES_HELP": "Examples of integration:",
        "EXAMPLE_BUTTON": "HTML Button",
        "EXAMPLE_BUTTON_DEFAULT_TEXT": "Pay in {{currency|abbreviate}}",
        "EXAMPLE_BUTTON_DEFAULT_STYLE": "Custom style",
        "EXAMPLE_BUTTON_TEXT_HELP": "Button text",
        "EXAMPLE_BUTTON_BG_COLOR": "Background color",
        "EXAMPLE_BUTTON_BG_COLOR_HELP": "eg: #fbc14c, yellow, lightgrey, rgb(180,180,180)",
        "EXAMPLE_BUTTON_FONT_COLOR": "Font color",
        "EXAMPLE_BUTTON_FONT_COLOR_HELP": "eg: black, orange, rgb(180,180,180)",
        "EXAMPLE_BUTTON_TEXT_ICON": "Icon",
        "EXAMPLE_BUTTON_TEXT_WIDTH": "Width",
        "EXAMPLE_BUTTON_TEXT_WIDTH_HELP": "eg: 200px, 50%",
        "EXAMPLE_BUTTON_ICON_NONE": "No icon",
        "EXAMPLE_BUTTON_ICON_DUNITER": "Duniter logo",
        "EXAMPLE_BUTTON_ICON_CESIUM": "Cesium logo",
        "EXAMPLE_BUTTON_ICON_G1_COLOR": "Ğ1 logo",
        "EXAMPLE_BUTTON_ICON_G1_BLACK": "Ğ1 logo (outline)"
      }
    }
  }
}
);

$translateProvider.translations("en", {
  "COMMON": {
    "APP_NAME": "Cesium",
    "APP_VERSION": "v{{version}}",
    "APP_BUILD": "build {{build}}",
    "PUBKEY": "Public key",
    "MEMBER": "Member",
    "BLOCK" : "Block",
    "BTN_OK": "OK",
    "BTN_YES": "Yes",
    "BTN_NO": "No",
    "BTN_SEND": "Send",
    "BTN_SEND_MONEY": "Transfer money",
    "BTN_SEND_MONEY_SHORT": "Transfer",
    "BTN_SAVE": "Save",
    "BTN_YES_SAVE": "Yes, Save",
    "BTN_YES_CONTINUE": "Yes, Continue",
    "BTN_SHOW": "Show",
    "BTN_SHOW_PUBKEY": "Show key",
    "BTN_RELATIVE_UNIT": "Display amounts in UD?",
    "BTN_BACK": "Back",
    "BTN_NEXT": "Next",
    "BTN_IMPORT": "Import",
    "BTN_CANCEL": "Cancel",
    "BTN_CLOSE": "Close",
    "BTN_LATER": "Later",
    "BTN_LOGIN": "Sign In",
    "BTN_LOGOUT": "Logout",
    "BTN_ADD_ACCOUNT": "New Account",
    "BTN_SHARE": "Share",
    "BTN_EDIT": "Edit",
    "BTN_DELETE": "Delete",
    "BTN_ADD": "Add",
    "BTN_SEARCH": "Search",
    "BTN_REFRESH": "Refresh",
    "BTN_RETRY": "Retry",
    "BTN_START": "Start",
    "BTN_CONTINUE": "Continue",
    "BTN_CREATE": "Create",
    "BTN_UNDERSTOOD": "I understand",
    "BTN_OPTIONS": "Options",
    "BTN_HELP_TOUR": "Features tour",
    "BTN_HELP_TOUR_SCREEN": "Discover this screen",
    "BTN_DOWNLOAD": "Download",
    "BTN_DOWNLOAD_ACCOUNT_STATEMENT": "Download account statement",
    "BTN_MODIFY": "Modify",
    "CHOOSE_FILE": "Drag your file<br/>or click to select",
    "DAYS": "days",
    "NO_ACCOUNT_QUESTION": "Not a member yet? Register now!",
    "SEARCH_NO_RESULT": "No result found",
    "LOADING": "Loading...",
    "LOADING_WAIT": "Loading...<br/><small>(Waiting for node availability)</small>",
    "SEARCHING": "Searching...",
    "FROM": "From",
    "TO": "To",
    "COPY": "Copy",
    "LANGUAGE": "Language",
    "UNIVERSAL_DIVIDEND": "Universal dividend",
    "UD": "UD",
    "DATE_PATTERN": "MM/DD/YYYY HH:mm",
    "DATE_FILE_PATTERN": "YYYY-MM-DD",
    "DATE_SHORT_PATTERN": "MM/DD/YY",
    "DATE_MONTH_YEAR_PATTERN": "MM/YYYY",
    "EMPTY_PARENTHESIS": "(empty)",
    "UID": "Pseudonym",
    "ENABLE": "Enabled",
    "DISABLE": "Disabled",
    "RESULTS_LIST": "Results:",
    "RESULTS_COUNT": "{{count}} results",
    "EXECUTION_TIME": "executed in {{duration|formatDurationMs}}",
    "SHOW_VALUES": "Display values openly?",
    "POPOVER_ACTIONS_TITLE": "Options",
    "POPOVER_FILTER_TITLE": "Filters",
    "SHOW_MORE": "Show more",
    "SHOW_MORE_COUNT": "(current limit at {{limit}})",
    "POPOVER_SHARE": {
      "TITLE": "Share",
      "SHARE_ON_TWITTER": "Share on Twitter",
      "SHARE_ON_FACEBOOK": "Share on Facebook",
      "SHARE_ON_DIASPORA": "Share on Diaspora*",
      "SHARE_ON_GOOGLEPLUS": "Share on Google+"
    },
    "FILE": {
      "DATE" : "Date:",
      "TYPE" : "Type:",
      "SIZE": "Size:",
      "VALIDATING": "Validating..."
    }
  },
  "SYSTEM": {
    "PICTURE_CHOOSE_TYPE": "Choose source:",
    "BTN_PICTURE_GALLERY": "Gallery",
    "BTN_PICTURE_CAMERA": "<b>Camera</b>"
  },
  "MENU": {
    "HOME": "Home",
    "WOT": "Registry",
    "CURRENCY": "Currency",
    "ACCOUNT": "My Account",
    "WALLETS": "My wallets",
    "SETTINGS": "Settings",
    "NETWORK": "Network",
    "TRANSACTIONS": "My transactions"
  },
  "ABOUT": {
    "TITLE": "About",
    "LICENSE": "<b>Free/libre software</b> (License GNU AGPLv3).",
    "LATEST_RELEASE": "There is a <b>newer version</ b> of {{'COMMON.APP_NAME' | translate}} (<b>v{{version}}</b>)",
    "PLEASE_UPDATE": "Please update {{'COMMON.APP_NAME' | translate}} (latest version: <b>v{{version}}</b>)",
    "CODE": "Source code:",
    "OFFICIAL_WEB_SITE": "Official web site:",
    "DEVELOPERS": "Developers:",
    "FORUM": "Forum:",
    "PLEASE_REPORT_ISSUE": "Please report any issue to us!",
    "REPORT_ISSUE": "Report an issue",
    "BTN_OPEN_DEV_WINDOW": "Open the debug window"
  },
  "HOME": {
    "TITLE": "Cesium",
    "WELCOME": "Welcome to the Cesium application!",
    "WELCOME_READONLY": "Welcome to Cesium <span class='badge badge-balanced'>Monit</span> !",
    "MESSAGE": "Receive and send libre currency {{currency|abbreviate}}",
    "MESSAGE_READONLY": "Real-time monitoring of libre currency {{currency|abbreviate}}",
    "BTN_CURRENCY": "Explore currency {{currency|abbreviate}}",
    "BTN_ABOUT": "about",
    "BTN_HELP": "Help",
    "BTN_NETWORK": "Network status",
    "FREE_SOFTWARE": "Free software",
    "FORK_ME": "Fork me!",
    "SHOW_LICENSE": "Show license",
    "REPORT_ISSUE": "Report an issue",
    "NOT_YOUR_ACCOUNT_QUESTION" : "You do not own the account <b><i class=\"ion-key\"></i> {{pubkey|formatPubkey}}</b>?",
    "BTN_CHANGE_ACCOUNT": "Disconnect this account",
    "CONNECTION_ERROR": "Peer <b>{{server}}</b> unreachable or invalid address.<br/><br/>Check your Internet connection, or change node <a class=\"positive\" ng-click=\"doQuickFix('settings')\">in the settings</a>.",
    "SHOW_ALL_FEED": "Show all",
    "READ_MORE": "Read more",
    "FEED_SOURCE": "Source"
  },
  "SETTINGS": {
    "TITLE": "Settings",
    "DISPLAY_DIVIDER": "Display",
    "STORAGE_DIVIDER": "Storage",
    "NETWORK_SETTINGS": "Network",
    "PEER": "Duniter peer address",
    "PEER_SHORT": "Peer address",
    "PEER_CHANGED_TEMPORARY": "Address used temporarily",
    "PERSIST_CACHE": "Keep navigation data (experimental)",
    "PERSIST_CACHE_HELP": "Allows faster navigation, locally retaining the data received, for use from one session to another.",
    "USE_LOCAL_STORAGE": "Enable local storage",
    "USE_LOCAL_STORAGE_HELP": "Allows you to save your settings",
    "WALLETS_SETTINGS": "My wallets",
    "USE_WALLETS_ENCRYPTION": "Secure the list",
    "USE_WALLETS_ENCRYPTION_HELP": "Enables you to encrypt the list of your wallets. Authentication required to access it.",
    "ENABLE_HELPTIP": "Enable contextual help tips",
    "DISABLE_HELPTIP": "Disable contextual help tips",
    "ENABLE_UI_EFFECTS": "Enable visual effects",
    "HISTORY_SETTINGS": "Account operations",
    "DISPLAY_UD_HISTORY": "Display produced dividends?",
    "TX_HISTORY_AUTO_REFRESH": "Enable automatic refresh?",
    "TX_HISTORY_AUTO_REFRESH_HELP": "Updates the list of operations to each new block.",
    "AUTHENTICATION_SETTINGS": "Authentication",
    "KEEP_AUTH": "Expiration of authentication",
    "KEEP_AUTH_SHORT": "Expiration",
    "KEEP_AUTH_HELP": "Define when authentication is cleared from memory.",
    "KEEP_AUTH_OPTION": {
      "NEVER": "After each operation",
      "SECONDS": "After {{value}}s of inactivity",
      "MINUTE": "After {{value}}min of inactivity",
      "MINUTES": "After {{value}}min of inactivity",
      "HOUR": "After {{value}}h of inactivity",
      "ALWAYS": "At the end of the session"
    },
    "KEYRING_FILE": "Keyring file",
    "KEYRING_FILE_HELP": "Allow auto-connect at startup, or to authenticate (only if \"Expiration of authentication\" is \"at the end of the session\"",
    "REMEMBER_ME": "Remember me ?",
    "REMEMBER_ME_HELP": "Allows to remain identified from one session to another, keeping the public key locally.",
    "PLUGINS_SETTINGS": "Extensions",
    "BTN_RESET": "Restore default values",
    "EXPERT_MODE": "Enable expert mode",
    "EXPERT_MODE_HELP": "Allow to see more details",
    "BLOCK_VALIDITY_WINDOW": "Block uncertainty time",
    "BLOCK_VALIDITY_WINDOW_SHORT": "Time of uncertainty",
    "BLOCK_VALIDITY_WINDOW_HELP": "Time to wait before considering an information is validated",
    "BLOCK_VALIDITY_OPTION": {
      "NONE": "No delay",
      "N": "{{time | formatDuration}} ({{count}} blocks)"
    },
    "POPUP_PEER": {
      "TITLE" : "Duniter peer",
      "HOST" : "Address",
      "HOST_HELP": "Address: server:port",
      "USE_SSL" : "Secured?",
      "USE_SSL_HELP" : "(SSL Encryption)",
      "BTN_SHOW_LIST" : "Peer's list"
    }
  },
  "BLOCKCHAIN": {
    "HASH": "Hash: {{hash}}",
    "VIEW": {
      "HEADER_TITLE": "Block #{{number}}-{{hash|formatHash}}",
      "TITLE_CURRENT": "Current block",
      "TITLE": "Block #{{number|formatInteger}}",
      "COMPUTED_BY": "Computed by",
      "SHOW_RAW": "Show raw data",
      "TECHNICAL_DIVIDER": "Technical informations",
      "VERSION": "Format version",
      "HASH": "Computed hash",
      "UNIVERSAL_DIVIDEND_HELP": "Money co-produced by each of the {{membersCount}} members",
      "EMPTY": "Aucune donnée dans ce bloc",
      "POW_MIN": "Minimal difficulty",
      "POW_MIN_HELP": "Difficulty imposed in calculating hash",
      "DATA_DIVIDER": "Data",
      "IDENTITIES_COUNT": "New identities",
      "JOINERS_COUNT": "Joiners",
      "ACTIVES_COUNT": "Renewals",
      "ACTIVES_COUNT_HELP": "Members having renewed their membership",
      "LEAVERS_COUNT": "Leavers",
      "LEAVERS_COUNT_HELP": "Members that now refused certification",
      "EXCLUDED_COUNT": "Excluded members",
      "EXCLUDED_COUNT_HELP": "Old members, excluded because missing membreship renewal or certifications",
      "REVOKED_COUNT": "Revoked identities",
      "REVOKED_COUNT_HELP": "These accounts may no longer be member",
      "TX_COUNT": "Transactions",
      "CERT_COUNT": "Certifications",
      "TX_TO_HIMSELF": "Change",
      "TX_OUTPUT_UNLOCK_CONDITIONS": "Unlock conditions",
      "TX_OUTPUT_OPERATOR": {
        "AND": "and",
        "OR": "or"
      },
      "TX_OUTPUT_FUNCTION": {
        "SIG": "<b>Sign</b> of the public key",
        "XHX": "<b>Password</b>, including SHA256 =",
        "CSV": "Blocked during",
        "CLTV": "Bloqué until"
      }
    },
    "LOOKUP": {
      "TITLE": "Blocks",
      "NO_BLOCK": "No bloc",
      "LAST_BLOCKS": "Last blocks:",
      "BTN_COMPACT": "Compact"
    }
  },
  "CURRENCY": {
    "VIEW": {
      "TITLE": "Currency",
      "TAB_CURRENCY": "Currency",
      "TAB_WOT": "Web of trust",
      "TAB_NETWORK": "Network",
      "TAB_BLOCKS": "Blocks",
      "CURRENCY_SHORT_DESCRIPTION": "{{currency|capitalize}} is a <b>libre money</b>, started {{firstBlockTime | formatFromNow}}. It currently counts <b>{{N}} members </b>, who produce and collect a <a ng-click=\"showHelpModal('ud')\">Universal Dividend</a> (DU), each {{dt | formatPeriod}}.",
      "NETWORK_RULES_DIVIDER": "Network rules",
      "CURRENCY_NAME": "Currency name",
      "MEMBERS": "Members count",
      "MEMBERS_VARIATION": "Variation since {{duration|formatDuration}} (since last UD)",
      "MONEY_DIVIDER": "Money",
      "MASS": "Monetary mass",
      "SHARE": "Money share",
      "UD": "Universal Dividend",
      "C_ACTUAL": "Current growth",
      "MEDIAN_TIME": "Current blockchain time",
      "POW_MIN": "Common difficulty",
      "MONEY_RULES_DIVIDER": "Rules of currency",
      "C_RULE": "Theoretical growth target",
      "UD_RULE": "Universal dividend (formula)",
      "DT_REEVAL": "Period between two re-evaluation of the UD",
      "REEVAL_SYMBOL": "reeval",
      "DT_REEVAL_VALUE": "Every <b>{{dtReeval|formatDuration}}</b> ({{dtReeval/86400}} {{'COMMON.DAYS'|translate}})",
      "UD_REEVAL_TIME0": "Date of first reevaluation of the UD",
      "SIG_QTY_RULE": "Required number of certifications to become a member",
      "SIG_STOCK": "Maximum number of certifications sent by a member",
      "SIG_PERIOD": "Minimum delay between 2 certifications sent by one and the same issuer.",
      "SIG_WINDOW": "Maximum delay before a certification will be treated",
      "SIG_VALIDITY": "Lifetime of a certification that has been treated",
      "MS_WINDOW": "Maximum delay before a pending membership will be treated",
      "MS_VALIDITY": "Lifetime of a membership that has been treated",
      "STEP_MAX": "Maximum distance between a newcomer and each referring members.",
      "WOT_RULES_DIVIDER": "Rules for web of trust",
      "SENTRIES": "Required number of certifications (given <b>and</b> received) to become a referring member",
      "SENTRIES_FORMULA": "Required number of certifications to become a referring member (formula)",
      "XPERCENT":"Minimum percent of referring member to reach to match the distance rule",
      "AVG_GEN_TIME": "The average time between 2 blocks",
      "CURRENT": "current",
      "MATH_CEILING": "CEILING",
      "DISPLAY_ALL_RULES": "Display all rules?",
      "BTN_SHOW_LICENSE": "Show license",
      "WOT_DIVIDER": "Web of trust"
    },
    "LICENSE": {
      "TITLE": "Currency license",
      "BTN_DOWNLOAD": "Download file",
      "NO_LICENSE_FILE": "License file not found."
    }
  },
  "NETWORK": {
    "VIEW": {
      "MEDIAN_TIME": "Blockchain time",
      "LOADING_PEERS": "Loading peers...",
      "NODE_ADDRESS": "Address:",
      "SOFTWARE": "Software:",
      "WARN_PRE_RELEASE": "Pre-release (latest stable: <b>{{version}}</b>)",
      "WARN_NEW_RELEASE": "Version <b>{{version}}</b> available",
      "WS2PID": "Identifier:",
      "PRIVATE_ACCESS": "Private access",
      "POW_PREFIX": "Proof of work prefix:",
      "ENDPOINTS": {
        "BMAS": "Secure endpoint (SSL)",
        "BMATOR": "TOR endpoint",
        "WS2P": "WS2P endpoint",
        "ES_USER_API": "Cesium+ data node"
      }
    },
    "INFO": {
      "ONLY_SSL_PEERS": "Non-SSL nodes have a degraded display because Cesium works in HTTPS mode."
    }
  },
  "PEER": {
    "PEERS": "Peers",
    "SIGNED_ON_BLOCK": "Signed on block",
    "MIRROR": "mirror",
    "MIRRORS": "Mirrors",
    "MIRROR_PEERS": "Mirror peers",
    "PEER_LIST" : "Peer's list",
    "MEMBERS" : "Members",
    "MEMBER_PEERS" : "Member peers",
    "ALL_PEERS" : "All peers",
    "DIFFICULTY" : "Difficulty",
    "API" : "API",
    "CURRENT_BLOCK" : "Block #",
    "POPOVER_FILTER_TITLE": "Filter",
    "OFFLINE": "Offline",
    "OFFLINE_PEERS": "Offline peers",
    "BTN_SHOW_PEER": "Show peer",
    "VIEW": {
      "TITLE": "Peer",
      "OWNER": "Owned by ",
      "SHOW_RAW_PEERING": "See peering document",
      "SHOW_RAW_CURRENT_BLOCK": "See current block (raw format)",
      "LAST_BLOCKS": "Last blocks",
      "KNOWN_PEERS": "Known peers :",
      "GENERAL_DIVIDER": "General information",
      "ERROR": {
        "LOADING_TOR_NODE_ERROR": "Could not get peer data, using the TOR network.",
        "LOADING_NODE_ERROR": "Could not get peer data"
      }
    }
  },
  "WOT": {
    "SEARCH_HELP": "Search (member or public key)",
    "SEARCH_INIT_PHASE_WARNING": "During the pre-registration phase, the search for pending registrations <b>may be long</b>. Please wait ...",
    "REGISTERED_SINCE": "Registered on",
    "REGISTERED_SINCE_BLOCK": "Registered since block #",
    "NO_CERTIFICATION": "No validated certification",
    "NO_GIVEN_CERTIFICATION": "No given certification",
    "NOT_MEMBER_PARENTHESIS": "(non-member)",
    "IDENTITY_REVOKED_PARENTHESIS": "(identity revoked)",
    "MEMBER_PENDING_REVOCATION_PARENTHESIS": "(being revoked)",
    "EXPIRE_IN": "Expires",
    "NOT_WRITTEN_EXPIRE_IN": "Deadline<br/>treatment",
    "EXPIRED": "Expired",
    "PSEUDO": "Pseudonym",
    "SIGNED_ON_BLOCK": "Emitted on block #{{block}}",
    "WRITTEN_ON_BLOCK": "Written on block #{{block}}",
    "GENERAL_DIVIDER": "General information",
    "NOT_MEMBER_ACCOUNT": "Non-member account",
    "NOT_MEMBER_ACCOUNT_HELP": "This is a simple wallet, with no pending membership application.",
    "TECHNICAL_DIVIDER": "Technical data",
    "BTN_CERTIFY": "Certify",
    "BTN_YES_CERTIFY": "Yes, certify",
    "BTN_SELECT_AND_CERTIFY": "New certification",
    "ACCOUNT_OPERATIONS": "Account operations",
    "VIEW": {
      "POPOVER_SHARE_TITLE": "Identity {{title}}"
    },
    "LOOKUP": {
      "TITLE": "Registry",
      "NEWCOMERS": "New members:",
      "NEWCOMERS_COUNT": "{{count}} members",
      "PENDING": "Pending registrations:",
      "PENDING_COUNT": "{{count}} pending registrations",
      "REGISTERED": "Registered {{sigDate | formatFromNow}}",
      "MEMBER_FROM": "Member since {{memberDate|medianFromNowShort}}",
      "BTN_NEWCOMERS": "Latest members",
      "BTN_PENDING": "Pending registrations",
      "SHOW_MORE": "Show more",
      "SHOW_MORE_COUNT": "(current limit to {{limit}})",
      "NO_PENDING": "No pending registrations.",
      "NO_NEWCOMERS": "No members."
    },
    "CONTACTS": {
      "TITLE": "Contacts"
    },
    "MODAL": {
      "TITLE": "Search"
    },
    "CERTIFICATIONS": {
      "TITLE": "{{uid}} - Certifications",
      "SUMMARY": "Received certifications",
      "LIST": "Details of received certifications",
      "PENDING_LIST": "Pending certifications",
      "RECEIVED": "Received certifications",
      "RECEIVED_BY": "Certifications received by {{uid}}",
      "ERROR": "Received certifications in error",
      "SENTRY_MEMBER": "Referring member"
    },
    "OPERATIONS": {
      "TITLE": "{{uid}} - Operations"
    },
    "GIVEN_CERTIFICATIONS": {
      "TITLE": "{{uid}} - Certifications sent",
      "SUMMARY": "Sent certifications",
      "LIST": "Details of sent certifications",
      "PENDING_LIST": "Pending certifications",
      "SENT": "Sent certifications",
      "SENT_BY": "Certifications sent by {{uid}}",
      "ERROR": "Sent certifications with error"
    }
  },
  "LOGIN": {
    "TITLE": "<i class=\"icon ion-log-in\"></i> Login",
    "SCRYPT_FORM_HELP": "Please enter your credentials. <br> Remember to check the public key for your account.",
    "PUBKEY_FORM_HELP": "Please enter a public account key:",
    "FILE_FORM_HELP": "Choose the keychain file to use:",
    "SCAN_FORM_HELP": "Scan the QR code of a wallet.",
    "SALT": "Secret identifier",
    "SALT_HELP": "Secret identifier",
    "SHOW_SALT": "Display secret identifier?",
    "PASSWORD": "Password",
    "PASSWORD_HELP": "Password",
    "PUBKEY_HELP": "Public key or pseudonym",
    "NO_ACCOUNT_QUESTION": "Don't have an account yet?",
    "HAVE_ACCOUNT_QUESTION": "Already have an account ?",
    "CREATE_ACCOUNT": "Create an account",
    "CREATE_FREE_ACCOUNT": "Create a free account",
    "FORGOTTEN_ID": "Forgot password?",
    "ASSOCIATED_PUBKEY": "Public key :",
    "BTN_METHODS": "Other methods",
    "BTN_METHODS_DOTS": "Change method...",
    "METHOD_POPOVER_TITLE": "Methods",
    "MEMORIZE_AUTH_FILE": "Memorize this keychain during the navigation session",
    "SCRYPT_PARAMETERS": "Paramètres (Scrypt) :",
    "AUTO_LOGOUT": {
      "TITLE": "Information",
      "MESSAGE": "<i class=\"ion-android-time\"></i> You were <b>logout</ b> automatically, due to prolonged inactivity.",
      "BTN_RELOGIN": "Sign In",
      "IDLE_WARNING": "You will be logout... {{countdown}}"
    },
    "METHOD": {
      "SCRYPT_DEFAULT": "Secret identifier and password",
      "SCRYPT_ADVANCED": "Advanced salt",
      "FILE": "Keychain file",
      "PUBKEY": "Public key or pseudonym",
      "SCAN": "Scan a QR code"
    },
    "SCRYPT": {
      "SIMPLE": "Light salt",
      "DEFAULT": "Standard salt",
      "SECURE": "Secure salt",
      "HARDEST": "Hardest salt",
      "EXTREME": "Extreme salt",
      "USER": "Personal value",
      "N": "N (Loop):",
      "r": "r (RAM):",
      "p": "p (CPU):"
    },
    "FILE": {
      "HELP": "Expected file format: <b>.dunikey</b> (type PubSec). Other formats are under development (EWIF, WIF)."
    }
  },
  "AUTH": {
    "TITLE": "<i class=\"icon ion-locked\"></i> Authentication",
    "BTN_AUTH": "Authenticate",
    "GENERAL_HELP": "Please authenticate yourself:",
    "EXPECTED_UID_HELP": "Please authenticate to the account <i class=\"ion-person\"></i> {{uid}}:",
    "EXPECTED_PUBKEY_HELP": "Please authenticate to the wallet <i class=\"ion-key\"></i> {{pubkey|formatPubkey}}:",
    "SCAN_FORM_HELP": "Scan the QR code of the <b>private key</b> of the wallet."
  },
  "ACCOUNT": {
    "TITLE": "My Account",
    "BALANCE": "Balance",
    "LAST_TX": "Latest validated transactions",
    "BALANCE_ACCOUNT": "Account balance",
    "NO_TX": "No transaction",
    "SHOW_MORE_TX": "Show more",
    "SHOW_ALL_TX": "Show all",
    "TX_FROM_DATE": "(current limit to {{fromTime|medianFromNowShort}})",
    "PENDING_TX": "Pending transactions",
    "VALIDATING_TX": "Transactions being validated",
    "ERROR_TX": "Transaction not executed",
    "ERROR_TX_SENT": "Sent transactions",
    "PENDING_TX_RECEIVED": "Transactions awaiting receipt",
    "EVENTS": "Events",
    "OUT_DISTANCED": "Your current certifications come from a group too isolated from the <a ng-click=\"showHelpModal('wot')\"> Web of Trust</a> (WoT): the <a ng-click=\"showHelpModal('distance_rule')\">maximum distance rule</a> is violated.<br/>You must obtain certifications from another area of the Web of Trust, or wait for it to tighten.",
    "WAITING_MEMBERSHIP": "Membership application sent. Waiting validation.",
    "WAITING_CERTIFICATIONS": "You need {{needCertificationCount}} certification(s) to become a member and produce the <a ng-click=\"showHelpModal('ud')\">Universal Dividend</a>. Your account is however already operational, to receive and send payments.",
    "WAITING_CERTIFICATIONS_HELP": "To get your certifications, only request members <b>who know you enough</b>, as required by <a ng-click=\"showLicenseModal()\">the currency license</a> that you have accepted.<br/>If you do not know enough members, let them know on <a ng-click=\"openLink($event, $root.settings.userForumUrl)\">the user forum</a>.",
    "WILL_MISSING_CERTIFICATIONS": "You will <b>lack certifications</b> soon (at least {{willNeedCertificationCount}} more are needed)",
    "WILL_NEED_RENEW_MEMBERSHIP": "Your membership <b>will expire {{membershipExpiresIn|formatDurationTo}}</b>. Remember to <a ng-click=\"doQuickFix('renew')\">renew your membership</a> before then.",
    "NEED_RENEW_MEMBERSHIP": "You are no longer a member because your membership <b>has expired</b>. Remember to <a ng-click=\"doQuickFix('renew')\">renew your membership</a>.",
    "NEED_RENEW_MEMBERSHIP_AFTER_CANCELLED": "You are no longer a member because your membership <b>has been canceled</b> for lack of certifications. Remember to <a ng-click=\"doQuickFix('renew')\">renew your membership</a>.",
    "NO_WAITING_MEMBERSHIP": "No membership application pending. If you'd like to <b>become a member</ b>, please <a ng-click=\"doQuickFix('membership')\">send the membership application</a>.",
    "CERTIFICATION_COUNT": "Received certifications",
    "CERTIFICATION_COUNT_SHORT": "Certifications",
    "SIG_STOCK": "Stock of certifications to give",
    "BTN_RECEIVE_MONEY": "Receive",
    "BTN_SELECT_ALTERNATIVES_IDENTITIES": "Switch to another identity...",
    "BTN_FIX_MEMBERSHIP": "Resubmit membership request...",
    "BTN_MEMBERSHIP_RENEW": "Renew membership",
    "BTN_MEMBERSHIP_RENEW_DOTS": "Renew membership...",
    "BTN_MEMBERSHIP_OUT_DOTS": "Revoke membership...",
    "BTN_SECURITY_DOTS": "Sign-in and security...",
    "BTN_SHOW_DETAILS": "Display technical data",
    "LOCKED_OUTPUTS_POPOVER": {
      "TITLE": "Locked amount",
      "DESCRIPTION": "Here are the conditions for unlocking this amount:",
      "DESCRIPTION_MANY": "This transaction consists of several parts, of which the unlock conditions are:",
      "LOCKED_AMOUNT": "Conditions for the amount:"
    },
    "NEW": {
      "TITLE": "Registration",
      "INTRO_WARNING_TIME": "Creating an account on {{name|capitalize}} is very simple. Please take sufficient time to do this correctly (not to forget the usernames, passwords, etc.).",
      "INTRO_WARNING_SECURITY": "Check that the hardware you are currently using (computer, tablet, phone) <b>is secure and trustworthy </b>.",
      "INTRO_WARNING_SECURITY_HELP": "Up-to-date anti-virus, firewall enabled, session protected by password or pin code...",
      "INTRO_HELP": "Click <b> {{'COMMON.BTN_START'|translate}}</b> to begin creating an account. You will be guided step by step.",
      "REGISTRATION_NODE": "Your registration will be registered via the Duniter peer <b>{{server}}</b> node, which will then be distributed to the rest of the currency network.",
      "REGISTRATION_NODE_HELP": "If you do not trust this peer, please change <a ng-click=\"doQuickFix('settings')\">in the settings</a> of Cesium.",
      "SELECT_ACCOUNT_TYPE": "Choose the type of account to create:",
      "MEMBER_ACCOUNT": "Member account",
      "MEMBER_ACCOUNT_TITLE": "Create a member account",
      "MEMBER_ACCOUNT_HELP": "If you are not yet registered as an individual (one account possible per individual).",
      "WALLET_ACCOUNT": "Simple wallet",
      "WALLET_ACCOUNT_TITLE": "Create a wallet",
      "WALLET_ACCOUNT_HELP": "If you represent a company, association, etc. or simply need an additional wallet. No universal dividend will be created by this account.",
      "SALT_WARNING": "Choose a secret identifier.<br/>You need it for each connection to this account.<br/><br/><b>Make sure to remember this identifier</b>.<br/>If lost, there are no means to retrieve it!",
      "PASSWORD_WARNING": "Choose a password.<br/>You need it for each connection to this account.<br/><br/><b>Make sure to remember this password</b>.<br/>If lost, there are no means to retrieve it!",
      "PSEUDO_WARNING": "Choose a pseudonym.<br/>It may be used by other people to find you more easily.<br/><br/>.Use of <b>commas, spaces and accents</b> is not allowed.<br/><div class='hidden-xs'><br/>Example: <span class='gray'>JohnDalton, JackieChan, etc.</span>",
      "PSEUDO": "Pseudonym",
      "PSEUDO_HELP": "joe123",
      "SALT_CONFIRM": "Confirm",
      "SALT_CONFIRM_HELP": "Confirm the secret identifier",
      "PASSWORD_CONFIRM": "Confirm",
      "PASSWORD_CONFIRM_HELP": "Confirm the password",
      "SLIDE_6_TITLE": "Confirmation:",
      "COMPUTING_PUBKEY": "Computing...",
      "LAST_SLIDE_CONGRATULATION": "You completed all required fields.<br/><b>You can send the account creation request</b>.<br/><br/>For information, the public key below identifies your future account.<br/>It can be communicated to third parties to receive their payment.<br/>Once your account has been approved, you can find this key under <b>{{'ACCOUNT.TITLE'|translate}}</b>.",
      "CONFIRMATION_MEMBER_ACCOUNT": "<b class=\"assertive\">Warning:</b> your secret identifier, password and pseudonym can not be changed.<br/><b>Make sure you always remember it!</b><br/><b>Are you sure</b> you want to send this account creation request?",
      "CONFIRMATION_WALLET_ACCOUNT": "<b class=\"assertive\">Warning:</b> your password and pseudonym can not be changed.<br/><b>Make sure you always remember it!</b><br/><b>Are you sure</b> you want to continue?",
      "CHECKING_PSEUDO": "Checking...",
      "PSEUDO_AVAILABLE": "This pseudonym is available",
      "PSEUDO_NOT_AVAILABLE": "This pseudonym is not available",
      "INFO_LICENSE": "To be able to adhere to the currency, we ask you to kindly read and accept this license.",
      "BTN_ACCEPT": "I accept",
      "BTN_ACCEPT_LICENSE": "I accept the license"
    },
    "POPUP_REGISTER": {
      "TITLE": "Enter a pseudonym",
      "HELP": "A pseudonym is needed to let other members find you."
    },
    "SELECT_IDENTITY_MODAL": {
      "TITLE": "Identity selection",
      "HELP": "Several <b>different identities</b> have been sent, for the public key <span class=\"gray\"> <i class=\"ion-key\"></i> {{pubkey | formatPubkey}}</span>.<br/>Please select the identity to use:"
    },
    "SELECT_WALLET_MODAL": {
      "TITLE": "Wallet selection"
    },
    "WALLET_LIST": {
      "TITLE": "My wallets",
      "BTN_NEW": "Add a wallet",
      "BTN_DOWNLOAD": "Download the list",
      "BTN_IMPORT_FILE_DOTS": "Import from a file...",
      "NO_WALLET": "No secondary wallet",
      "BTN_DELETE": "Remove a secondary wallet...",
      "BTN_RENAME": "Rename the wallet",
      "EXPORT_FILENAME": "my_wallets-{{pubkey|formatPubkey}}-{{currency}}.csv",
      "TOTAL_DOTS": "Total: ",
      "EDIT_POPOVER": {
        "TITLE": "Rename the wallet",
        "HELP": "Fill in the new name",
        "NAME_HELP": "Wallet name"
      },
      "IMPORT_MODAL": {
        "TITLE": "Import secondary wallets",
        "HELP": "To <b>import secodnary wallets</b>, please drag the file in the box below, or click in the box to search for a file.",
        "WALLET_COUNT": "<b>{{count}}</b> new wallet{{count > 1 ? 's' : ''}}",
        "NO_NEW_WALLET": "No new wallet"
      }
    },
    "SECURITY":{
      "ADD_QUESTION" : "Add custom question",
      "BTN_CLEAN" : "Clean",
      "BTN_RESET" : "Reset",
      "DOWNLOAD_REVOKE": "Save a revocation file",
      "DOWNLOAD_REVOKE_HELP" : "Having a revocation file is important, for example in case of loss of identifiers. It allows you to <b>get this account out of the Web Of Trust</b>, thus becoming a simple wallet.",
      "GENERATE_KEYFILE": "Generate my keychain file ...",
      "GENERATE_KEYFILE_HELP": "Generate a file allowing you to authenticate without entering your identifiers.<br/><b>Warning:</b> this file will contain your secret key; It is therefore very important to put it in a safe place!",
      "KEYFILE_FILENAME": "keychain-{{pubkey|formatPubkey}}-{{currency}}-{{format}}.dunikey",
      "MEMBERSHIP_IN": "Register as member...",
      "MEMBERSHIP_IN_HELP": "Allows you to <b>transform </b> a simple wallet account <b>into a member account</b>, by sending a membership request. Useful only if you do not already have another member account.",
      "SEND_IDENTITY": "Publish identity...",
      "SEND_IDENTITY_HELP": "Allows you to associate a pseudonym to this account, but <b>without applying for membership</b> to become a member. This is not very useful because the validity of this pseudonym association is limited in time.",
      "HELP_LEVEL": "Choose <strong> at least {{nb}} questions </strong> :",
      "LEVEL": "Security level",
      "LOW_LEVEL": "Low <span class=\"hidden-xs\">(2 questions minimum)</span>",
      "MEDIUM_LEVEL": "Medium <span class=\"hidden-xs\">(4 questions minimum)</span>",
      "QUESTION_1": "What was your best friend's name when you were a teen ?",
      "QUESTION_2": "What was the name of your first pet ?",
      "QUESTION_3": "What is the first meal you have learned to cook ?",
      "QUESTION_4": "What is the first movie you saw in the cinema?",
      "QUESTION_5": "Where did you go the first time you flew ?",
      "QUESTION_6": "What was your favorite elementary school teacher's name  ?",
      "QUESTION_7": "What would you consider the ideal job ?",
      "QUESTION_8": "Which children's book do you prefer?",
      "QUESTION_9": "What was the model of your first vehicle?",
      "QUESTION_10": "What was your nickname when you were a child ?",
      "QUESTION_11": "What was your favorite movie character or actor when you were a student ?",
      "QUESTION_12": "What was your favorite singer or band when you were a student ?",
      "QUESTION_13": "In which city did your parents meet ?",
      "QUESTION_14": "What was the name of your first boss ?",
      "QUESTION_15": "What is the name of the street where you grew up ?",
      "QUESTION_16": "What is the name of the first beach where you go swim ?",
      "QUESTION_17": "QWhat is the first album you bought ?",
      "QUESTION_18": "What is the name of your favorite sport team ?",
      "QUESTION_19": "What was your grand-father's job ?",
      "RECOVER_ID": "Recover my password...",
      "RECOVER_ID_HELP": "If you have a <b>backup file of your identifiers</b>, you can find them by answering your personal questions correctly.",
      "RECOVER_ID_SELECT_FILE": "Select the <b>backup file of your identifiers</b> to use:",
      "REVOCATION_WITH_FILE" : "Revoke my member account...",
      "REVOCATION_WITH_FILE_DESCRIPTION": "If you have <b>permanently lost your member account credentials (or if account security is compromised), you can use <b>the revocation file</b> of the account <b>to quit the Web Of Trust</b>.",
      "REVOCATION_WITH_FILE_HELP": "To <b>permanently revoke</ b> a member account, please drag the revocation file in the box below, or click in the box to search for a file.",
      "REVOCATION_WALLET": "Revoke this account immediately",
      "REVOCATION_WALLET_HELP": "Requesting revocation of your identity causes <b>will revoke your membership</ b> (definitely for the associated pseudonym and public key). The account will no longer be able to produce a Universal Dividend.<br/>However, you can still use it as a simple wallet.",
      "REVOCATION_FILENAME": "revocation-{{uid}}-{{pubkey|formatPubkey}}-{{currency}}.txt",
      "SAVE_ID": "Save my credentials...",
      "SAVE_ID_HELP": "Creating a backup file, to <b>retrieve your password</b> (and the secret identifier) <b> in case of forgetting</b>. The file is <b>secured</ b> (encrypted) using personal questions.",
      "STRONG_LEVEL": "Strong <span class=\"hidden-xs \">(6 questions minimum)</span>",
      "TITLE": "Account and security",
      "KEYFILE": {
        "PUBSEC_FORMAT": "PubSec format.",
        "PUBSEC_FORMAT_HELP": "This file format is compatible in particular with Cesium and Gannonce. Your keychain is stored <b>without encryption</b>: anyone with a copy of this file will be able to empty your account.",
        "WIF_FORMAT": "Wallet Import Format (WIF)",
        "WIF_FORMAT_HELP": "This format is used in particular by paper wallets. Your keychain is stored <b>without encryption</b>: anyone with a copy of this file will be able to empty your account.",
        "EWIF_FORMAT": "Encrypted Wallet Import Format (WIF)",
        "EWIF_FORMAT_HELP": "This format is used in particular by paper wallets. However, <b>the keychain is encrypted</b> from a passphrase of your choice.",
        "PASSWORD_POPUP": {
          "TITLE": "Keychain file encrypted",
          "HELP": "Please enter the passphrase:",
          "PASSWORD_HELP": "Passphrase"
        },
        "ERROR": {
          "BAD_PASSWORD": "Bad passphrase",
          "BAD_CHECKSUM": "Bad checksum"
        }
      }
    },
    "FILE_NAME": "{{currency}} - Account statement {{pubkey|formatPubkey}} to {{currentTime|formatDateForFile}}.csv",
    "HEADERS": {
      "TIME": "Date",
      "AMOUNT": "Amount",
      "COMMENT": "Comment"
    }
  },
  "TRANSFER": {
    "TITLE": "Transfer",
    "SUB_TITLE": "Transfer money",
    "SUB_TITLE_ALL": "Empty the account",
    "FROM": "From",
    "TO": "To",
    "AMOUNT": "Amount",
    "AMOUNT_HELP": "Amount",
    "COMMENT": "Comment",
    "COMMENT_HELP": "Comment (optional)",
    "BTN_SEND": "Send",
    "BTN_ADD_COMMENT": "Add a comment",
    "REST": "Rest of account",
    "REST_TO": "to",
    "WARN_COMMENT_IS_PUBLIC": "Please note that <b>comments are public</b> (not encrypted).",
    "MODAL": {
      "TITLE": "Transfer"
    }
  },
  "ERROR": {
    "UNKNOWN_URI_FORMAT": "Unknown URI format",
    "PUBKEY_INVALID_CHECKSUM": "Invalid public key (bad checksum).",
    "POPUP_TITLE": "Error",
    "UNKNOWN_ERROR": "Unknown error",
    "CRYPTO_UNKNOWN_ERROR": "Your browser is not compatible with cryptographic features.",
    "DOWNLOAD_KEYFILE_FAILED": "Failed to generate the keychain file.",
    "EQUALS_TO_PSEUDO": "Must be different from pseudonym",
    "EQUALS_TO_SALT": "Must be different from secret identifier",
    "FIELD_REQUIRED": "This field is required.",
    "FIELD_TOO_SHORT": "This field value is too short.",
    "FIELD_TOO_SHORT_WITH_LENGTH": "Value is too short (min {{minLength]] characters).",
    "FIELD_TOO_LONG": "Value is exceeding max length.",
    "FIELD_TOO_LONG_WITH_LENGTH": "Value is too long (max {{maxLength}} characters).",
    "FIELD_MIN": "Minimum value: {{min}}",
    "FIELD_MAX": "Maximal value: {{max}}",
    "FIELD_ACCENT": "Commas and accent characters not allowed",
    "FIELD_NOT_NUMBER": "Value is not a number",
    "FIELD_NOT_INT": "Value is not an integer",
    "FIELD_NOT_EMAIL": "Email adress not valid",
    "PASSWORD_NOT_CONFIRMED": "Must match previous password.",
    "SALT_NOT_CONFIRMED": "Must match previous identifier.",
    "SEND_IDENTITY_FAILED": "Error while trying to register.",
    "SEND_CERTIFICATION_FAILED": "Could not certify identity.",
    "NEED_MEMBER_ACCOUNT_TO_CERTIFY": "You could not send certification, because your account is <b>not a member account</b>.",
    "NEED_MEMBER_ACCOUNT_TO_CERTIFY_HAS_SELF": "You could not send certification now, because your are <b>not a member</b> yet.<br/><br/>You still need certification to become a member.",
    "IDENTITY_TO_CERTIFY_HAS_NO_SELF": "This account could not be certified. No registration found, or need to renew.",
    "LOGIN_FAILED": "Error while sign in.",
    "LOAD_IDENTITY_FAILED": "Could not load identity.",
    "LOAD_REQUIREMENTS_FAILED": "Could not load identity requirements.",
    "SEND_MEMBERSHIP_IN_FAILED": "Error while sending registration as member.",
    "SEND_MEMBERSHIP_OUT_FAILED": "Error while sending membership revocation.",
    "REFRESH_WALLET_DATA": "Could not refresh wallet.",
    "GET_CURRENCY_PARAMETER": "Could not get currency parameters.",
    "GET_CURRENCY_FAILED": "Could not load currency. Please retry later.",
    "SEND_TX_FAILED": "Could not send transaction.",
    "ALL_SOURCES_USED": "Please wait the next block computation (All transaction sources has been used).",
    "NOT_ENOUGH_SOURCES": "Not enough changes to send this amount in one time.<br/>Maximum amount: {{amount}} {{unit}}<sub>{{subUnit}}</sub>.",
    "ACCOUNT_CREATION_FAILED": "Error while creating your member account.",
    "RESTORE_WALLET_DATA_ERROR": "Error while reloading settings from local storage",
    "LOAD_WALLET_DATA_ERROR": "Error while loading wallet data.",
    "COPY_CLIPBOARD_FAILED": "Could not copy to clipboard",
    "TAKE_PICTURE_FAILED": "Could not get picture.",
    "SCAN_FAILED": "Could not scan QR code.",
    "SCAN_UNKNOWN_FORMAT": "Code not recognized.",
    "WOT_LOOKUP_FAILED": "Search failed.",
    "LOAD_PEER_DATA_FAILED": "Duniter peer not accessible. Please retry later.",
    "NEED_LOGIN_FIRST": "Please sign in first.",
    "AMOUNT_REQUIRED": "Amount is required.",
    "AMOUNT_NEGATIVE": "Negative amount not allowed.",
    "NOT_ENOUGH_CREDIT": "Not enough credit.",
    "INVALID_NODE_SUMMARY": "Unreachable peer or invalid address",
    "INVALID_USER_ID": "Field 'pseudonym' must not contains spaces or special characters.",
    "INVALID_COMMENT": "Field 'reference' has a bad format.",
    "INVALID_PUBKEY": "Public key has a bad format.",
    "INVALID_PUBKEY_CHECKSUM": "Invalid checksum.",
    "IDENTITY_REVOKED": "This identity <b>has been revoked</b>. It can no longer become a member.",
    "IDENTITY_REVOKED_WITH_TIME": "This identity <b>has been revoked {{revocationTime|medianFromNow}}</b> ({{revocationTime|medianDate}}). It can no longer become a member.",
    "IDENTITY_PENDING_REVOCATION": "The <b>revocation of this identity</b> has been requested and is awaiting processing. Certification is therefore disabled.",
    "IDENTITY_INVALID_BLOCK_HASH": "This membership application is no longer valid (because it references a block that network peers are cancelled): the person must renew its application for membership <b>before</b> being certified.",
    "IDENTITY_EXPIRED": "This identity has expired: this person must re-apply <b>before</b> being certified.",
    "IDENTITY_SANDBOX_FULL": "Could not register, because peer's sandbox is full.<br/><br/>Please retry later or choose another Duniter peer (in <b>Settings</b>).",
    "IDENTITY_NOT_FOUND": "Identity not found",
    "IDENTITY_TX_FAILED": "Error while getting identity's transactions",
    "WOT_PENDING_INVALID_BLOCK_HASH": "Membership not valid.",
    "WALLET_INVALID_BLOCK_HASH": "Your membership application is no longer valid (because it references a block that network peers are cancelled).<br/>You must <a ng-click=\"doQuickFix('renew')\">renew your application for membership</a> to fix this issue.",
    "WALLET_IDENTITY_EXPIRED": "The publication of your identity <b>has expired</b>.<br/>You must <a ng-click=\"doQuickFix('fixIdentity')\">re-issue your identity</a> to resolve this issue.",
    "WALLET_REVOKED": "Your identity has been <b>revoked</b>: neither your pseudonym nor your public key will be used in the future for a member account.",
    "WALLET_HAS_NO_SELF": "Your identity must first have been published, and not expired.",
    "AUTH_REQUIRED": "Authentication required.",
    "AUTH_INVALID_PUBKEY": "The public key does not match the connected account.",
    "AUTH_INVALID_SCRYPT": "Invalid username or password.",
    "AUTH_INVALID_FILE": "Invalid keychain file.",
    "AUTH_FILE_ERROR": "Failed to open keychain file",
    "IDENTITY_ALREADY_CERTIFY": "You have <b>already certified</b> that identity.<br/><br/>Your certificate is still valid (expires {{expiresIn|formatDuration}}).",
    "IDENTITY_ALREADY_CERTIFY_PENDING": "You have <b>already certified</b> that identity.<br/><br/>Your certification is still pending (Deadline for treatment {{expiresIn|formatDuration}}).",
    "UNABLE_TO_CERTIFY_TITLE": "Unable to certify",
    "LOAD_NEWCOMERS_FAILED": "Unable to load new members.",
    "LOAD_PENDING_FAILED": "Unable to load pending registrations.",
    "ONLY_MEMBER_CAN_EXECUTE_THIS_ACTION": "You must <b>be a member</b> in order to perform this action.",
    "ONLY_MEMBER_OR_WAS_MEMBER_CAN_EXECUTE_THIS_ACTION": "You must <b>be a member (or old member)</b> in order to perform this action.",
    "ONLY_SELF_CAN_EXECUTE_THIS_ACTION": "You must have <b>published your identity</b> in order to perform this action.",
    "GET_BLOCK_FAILED": "Error while getting block",
    "INVALID_BLOCK_HASH": "Block not found (incorrect hash)",
    "DOWNLOAD_REVOCATION_FAILED": "Error while downloading revocation file.",
    "REVOCATION_FAILED": "Error while trying to revoke the identity.",
    "SALT_OR_PASSWORD_NOT_CONFIRMED": "Wrong secret identifier or password ",
    "RECOVER_ID_FAILED": "Could not recover password",
    "LOAD_FILE_FAILED" : "Unable to load file",
    "NOT_VALID_REVOCATION_FILE": "Invalid revocation file (wrong file format)",
    "NOT_VALID_SAVE_ID_FILE": "Invalid credentials backup file (wrong file format)",
    "NOT_VALID_KEY_FILE": "Invalid keychain file (unrecognized format)",
    "EXISTING_ACCOUNT": "Your identifiers correspond to an already existing account, whose <a ng-click=\"showHelpModal('pubkey')\">public key</a> is:",
    "EXISTING_ACCOUNT_REQUEST": "Please modify your credentials so that they correspond to an unused account.",
    "GET_LICENSE_FILE_FAILED": "Unable to get license file",
    "CHECK_NETWORK_CONNECTION": "No peer appears to be accessible.<br/><br/>Please <b>check your Internet connection</b>.",
    "ISSUE_524_TX_FAILED": "Failed to transfer.<br/><br/>A message has been sent to developers to help solve the problem.<b>Thank you for your help</b>.",
    "ADD_SECONDARY_WALLET_FAILED": "Unable to add secondary wallet.",
    "REMOVE_SECONDARY_WALLET_FAILED": "Unable to remove secondary wallet.",
    "UPDATE_WALLET_LIST_FAILED": "Unable to refresh the list of wallets.",
    "LOAD_WALLET_LIST_FAILED": "Unable to load the list of wallets.",
    "SAVE_WALLET_LIST_FAILED": "Unable to save the list of wallets.",
    "COULD_NOT_ADD_MAIN_WALLET": "This wallet <b>is the main account</b> with which you are connected. Unable to add it as a secondary wallet.",
    "COULD_NOT_ADD_EXISTING_WALLET": "Wallet already existing in the list.",
    "UNKNOWN_WALLET_ID": "Unknown secondary wallet.",
    "RESTORE_WALLET_LIST_FAILED": "Unable to restore the list of wallets.",
    "INVALID_FILE_FORMAT": "Invalid file format.",
    "SAME_TX_RECIPIENT": "The recipient must be different from the issuer."
  },
  "INFO": {
    "POPUP_TITLE": "Information",
    "CERTIFICATION_DONE": "Identity successfully signed",
    "NOT_ENOUGH_CREDIT": "Not enough credit",
    "TRANSFER_SENT": "Transfer request successfully sent",
    "COPY_TO_CLIPBOARD_DONE": "Copy succeeded",
    "MEMBERSHIP_OUT_SENT": "Membership revocation sent",
    "NOT_NEED_MEMBERSHIP": "Already a member.",
    "IDENTITY_WILL_MISSING_CERTIFICATIONS": "This identity will soon lack certification (at least {{willNeedCertificationCount}}).",
    "IDENTITY_NEED_MEMBERSHIP": "This identity did not send a membership request. She will have to if she wishes to become a member.",
    "HAS_ALTERNATIVE_IDENTITIES": "There are <b>multiple identities</b> attached to this public key. <b>Before any certification</b>, please <a ng-click=\"doQuickFix('showSelectIdentities')\">check other identities</a> to choose the correct one, or contact the wallet owner.",
    "REVOCATION_SENT": "Revocation sent successfully",
    "REVOCATION_SENT_WAITING_PROCESS": "Revocation <b>has been sent successfully</b>. It is awaiting processing.",
    "FEATURES_NOT_IMPLEMENTED": "This features is not implemented yet.<br/><br/>Why not to contribute to get it faster? ;)",
    "EMPTY_TX_HISTORY": "No operations to export"
  },
  "CONFIRM": {
    "POPUP_TITLE": "<b>Confirmation</b>",
    "POPUP_WARNING_TITLE": "<b>Warning</b>",
    "POPUP_SECURITY_WARNING_TITLE": "<i class=\"icon ion-alert-circled\"></i> <b>Security warning</b>",
    "CERTIFY_RULES_TITLE_UID": "Certify {{uid}}",
    "CERTIFY_RULES": "<b class=\"assertive\">Don't certify an account</b> if you believe that: <ul><li>1.) the issuers identity might be faked.<li>2.) the issuer already has another certified account.<li>3.) the issuer purposely or carelessly violates rule 1 or 2 (he certifies faked or double accounts).</ul></small><br/>Are you sure you want to certify this identity?",
    "FULLSCREEN": "View the application in full screen?",
    "EXIT_APP": "Close the application ?",
    "TRANSFER": "<b>Transfer summary:</b><br/><br/><ul><li> - From: <b>{{from}}</b></li><li> - To: <b>{{to}}</b></li><li> - Amount: <b>{{amount}} {{unit}}</b></li><li> - Comment: <i>{{comment}}</i></li></ul><br/><b>Are-you sure you want to do this transfer?</b>",
    "TRANSFER_ALL": "<b>Transfer summary:</b><br/><br/><ul><li> - From: <b>{{from}}</b></li><li> - To: <b>{{to}}</b></li><li> - Amount: <b>{{amount}} {{unit}}</b></li><li> - Comment: <i>{{comment}}</i></li><br/><li> - Rest : <b>{{restAmount}} {{unit}}</b> to <b>{{restTo}}</b></li></ul><br/><b>Are-you sure you want to do this transfer?</b>",
    "MEMBERSHIP_OUT": "This operation is <b>irreversible</b>.<br/></br/><b>Are you sure you want to terminate your membership?</b>",
    "MEMBERSHIP_OUT_2": "This operation is <b>irreversible</b>!<br/><br/>Are you sure you want to <b>terminate your membership</b>?",
    "LOGIN_UNUSED_WALLET_TITLE": "Typing error?",
    "LOGIN_UNUSED_WALLET": "The account seems to be <b>inactive</b>.<br/><br/>It's probably a <b>typing error</b> when sign in. Please try again, checking that <b>public key is yours<b/>.",
    "FIX_IDENTITY": "The pseudonym <b>{{uid}}</b> will be published again, replacing the old publication that has expired.<br/></br/><b>Are you sure</b> you want to continue?",
    "FIX_MEMBERSHIP": "Your application for membership will be sent.<br/></br/><b>Are you sure?</b>",
    "MEMBERSHIP": "Your membership request will be sent. <br/></br/><b>Are you sure?</b>",
    "RENEW_MEMBERSHIP": "Your membership will be renewed.<br/></br/><b>Are you sure?</b>",
    "REVOKE_IDENTITY": "You will <b>definitely revoke this identity</b>.<br/><br/>The public key and the associated pseudonym <b>will never be used again</b> (for a member account).<br/></br/><b>Are you sure</b> you want to revoke this identity?",
    "REVOKE_IDENTITY_2": "This operation is <b>irreversible</b>!<br/><br/>Are you sure you want to <b>revoke this identity</b>?",
    "NOT_NEED_RENEW_MEMBERSHIP": "Your membership does not need to be renewed (it will only expire in {{membershipExpiresIn|formatDuration}}).<br/></br/><b>Are you sure you</b> want to renew your membership?",
    "SAVE_BEFORE_LEAVE": "Do you want to <b>save your changes</b> before leaving the page?",
    "SAVE_BEFORE_LEAVE_TITLE": "Changes not saved",
    "LOGOUT": "Are you sure you want to logout?",
    "USE_FALLBACK_NODE": "Peer <b>{{old}}</b> unreachable or invalid address.<br/><br/>Do you want to temporarily use the <b>{{new}}</b> node?",
    "ISSUE_524_SEND_LOG": "The transaction was rejected because of a known problem (issue #524) but not reproduced.<br/><br/>To help developers correct this error, do you accept <b>the transmission of your logs</b> per message?<br/><small>(No confidential data is sent)</small>"
  },
  "MODE": {
    "DEMO": {
      "BADGE": "Demo",
      "MODE": "Demonstration mode",
      "FEATURE_NOT_AVAILABLE": "Functionality <b>not available</b> on this demonstration site.",
      "MODE_HELP": "Cesium works in <b>demonstration mode</b>: consultation on account is available, but no operation can be performed.",
      "INSTALL_HELP": "For <b>security reasons</b> we recommend <b>installing</b> your copy of the software.<br/> Visit the site <a href='https://cesium.app'>www.cesium.app</a> for help."
    },
    "READONLY": {
      "BADGE": "Monit",
      "MODE": "Monitoring mode",
      "MODE_HELP": "Cesium works in <b>monitoring mode</b>: only currency monitoring features are available.",
      "INSTALL_HELP": "If you want to <b>create a wallet account</b> to send or received money, we recommend <b>installing</b> your copy of the software.<br/> Visit the site <a href='https://cesium.app'>www.cesium.app</a> for help."
    }
  },
  "DOWNLOAD": {
    "POPUP_TITLE": "<b>Revocation file</b>",
    "POPUP_REVOKE_MESSAGE": "To safeguard your account, please download the <b>account revocation document</b>. It will allow you to cancel your account (in case of account theft, ID, an incorrectly created account, etc.).<br/><br/><b>Please store it in a safe place.</b>"
  },
  "HELP": {
    "TITLE": "Online help",
    "JOIN": {
      "SECTION": "Join",
      "SALT": "The secret identifier is very important. It is used to hash you password, which in turn is used to calculate your <span class=\"text-italic\">public account key</span> (its number) and the private key to access it.<br/><b>Please remeber this identifier well</b>, because there is no way to recover it when lost.<br/>Furthermore, it cannot be changed without having to create a new account.<br/><br/>A good secret identifier must be sufficiently long (8 characters at the very least) and as original as possible.",
      "PASSWORD": "The password is very important. Together with the secret identifier, it is use to calculate your account number (pblic key) and the private key to access it.<br/><b>Please remember it well</b>, because there is no way to recover it when lost.<br/>Furthermore, it cannot be changed without having to create a new account.<br/><br/>A good password is made (ideally) of at least 8 characters, with at least one capital and one number.",
      "PSEUDO": "A pseudonym is used only when joining as <span class=\"text-italic\">member</span>. It is always associated with a wallet (by its <span class=\"text-italic\">public key</span>).<br/>It is published on the network so that other users may identify it, certify or send money to the account.<br/>A pseudonym must be unique among all members (current and past)."
    },
    "LOGIN": {
      "SECTION": "Log in",
      "PUBKEY": "Account public key",
      "PUBKEY_DEF": "The public key of the keychain is generated from the entered identifiers (any), but does not correspond to an account already used.<br/><b>Make sure your public key is the same as your account</b>. Otherwise, you will be logged into an account that is probably never used, as the risk of collision with an existing account is very small.<br/><a href=\"https://en.wikipedia.org/wiki/Elliptic_curve_cryptography\" target=\"_ system\">Learn more about cryptography</a> by public key.",
      "METHOD": "Connection methods",
      "METHOD_DEF": "Several options are available to connect to a portfolios: <br/> - The connection <b>with salt (simple or advanced)</b> mixes your password with the secret identifier, to limit the attempts of piracy<br/> - The connection <b>using public key</b> prevents you from entering your credentials, which you will be asked only when an operation need it.<br/> - The connection <b>using keychain file</b> will read the public and private keys of the account from a file without the need to enter credentials. Several file formats are possible."
    },
    "GLOSSARY": {
      "SECTION": "Glossary",
      "PUBKEY_DEF": "A public key always identifies a wallet. It may identify a member. In Cesium it is calculated using the secret identifier and the password.",
      "MEMBER": "Member",
      "MEMBER_DEF": "A member is a real and living human, wishing to participate freely to the monitary community. The member will receive universal dividend, according to the period and amount as defined in the <span class=\"text-italic\">currency parameters</span>.",
      "CURRENCY_RULES": "Currency rules",
      "CURRENCY_RULES_DEF": "The currency rules are defined only once, and for all. They set the parameters under which the currency will perform: universal dividend calculation, the amount of certifications needed to become a member, the maximum amount of certifications a member can send, etc.<br/><br/>The parameters cannot be modified because of the use of a <span class=\"text-italic\">Blockchain</span> which carries and executes these rules, and constantly verifies their correct application. <a href=\"#/app/currency\">See current parameters</a>.",
      "BLOCKCHAIN": "Blockchain",
      "BLOCKCHAIN_DEF": "The Blockchain is a decentralised system which, in case of Duniter, serves to carry and execute the <span class=\"text-italic\">currency rules</span>.<br/><a href=\"http://en.duniter.org/presentation/\" target=\"_blank\">Read more about Duniter</a> and the working of its blockchain.",
      "UNIVERSAL_DIVIDEND_DEF": "The Universal Dividend (UD) is the quantity of money co-created by each member, according to the period and the calculation defined in the <span class=\"text-italic\">currency rules</span>.<br/>Every term, the members receive an equal amount of new money on their account.<br/><br/>The UD undergoes a steady growth, to remain fair under its members (current and future), calculated by an average life expectancy, as demonstrated in the Relative Theory of Money (RTM).<br/><a href=\"http://trm.creationmonetaire.info\" target=\"_system\">Read more about RTM</a> and open money.",
      "WOT": "Web of Trust (WoT)",
      "WOT_DEF": "The Web of Trust is made up of all the members of the currency, and the links of certification which connect them.",
      "DISTANCE_RULE": "Distance rule",
      "DISTANCE_RULE_DEF": "The rule of distance defines <b>a maximum distance to meet</b> between an applicant and a minimum number of referring member. This distance is calculated using the certification links."
    },
    "TIP": {
      "MENU_BTN_CURRENCY": "Menu <b>{{'MENU.CURRENCY'|translate}}</b> allows discovery of <b>currency parameters</b> and its state.",
      "CURRENCY_WOT": "The <b>member count</b> shows the <b>community's weight and evolution</b>.",
      "CURRENCY_MASS": "Shown here is the <b>total amount</b> currently in circulation and its <b>average distribution</b> per member.<br/><br/>This allows to estimate the <b>worth of any amount</b>, in respect to what <b>others own</b> on their account (on average).",
      "CURRENCY_UNIT_RELATIVE": "The unit used here (&ldquo;<b>{{'COMMON.UD'|translate}}<sub>{{currency|abbreviate}}</sub></b>&rdquo;) signifies that the amounts in {{currency|capitalize}} have been devided by the <b>Universal Dividend</b> (UD).<br/><br/><small>This relative unit is <b>relevant</b> because it is stable in contrast to the permanently growing monitary mass.</small>",
      "CURRENCY_CHANGE_UNIT": "The option <b>{{'COMMON.BTN_RELATIVE_UNIT'|translate}}</b> allows to <b>switch the unit</b> to show amounts in <b>{{currency|capitalize}}</b>, undevided by the Universal Dividend (instead of in &ldquo;<b>{{'COMMON.UD'|translate}}<sub>{{currency|abbreviate}}</sub></b>&rdquo;).",
      "CURRENCY_CHANGE_UNIT_TO_RELATIVE": "The option <b>{{'COMMON.BTN_RELATIVE_UNIT'|translate}}</b> allows to <b>switch the unit</b> to show amounts in &ldquo;<b>{{'COMMON.UD'|translate}}<sub>{{currency|abbreviate}}</sub></b>&rdquo;, which is relative to the Universal Dividend (the amount co-produced by each member).",
      "CURRENCY_RULES": "The <b>rules</b> of the currency determine its <b>exact and predictible</b> performance.<br/><br/>As a true DNA of the currency these rules make the monetary code <b>transparent and understandable</b>.",
      "MENU_BTN_NETWORK": "Menu <b>{{'MENU.NETWORK'|translate}}</b> allows discovery of <b>network's state<b>.",
      "NETWORK_BLOCKCHAIN": "All monetary transactions are recoded in a <b>public and tamper proof</b> ledger, generally referred to as the <b>blockchain</b>.",
      "NETWORK_PEERS": "The <b>peers</b> shown here correspond to <b>computers that update and check</b> the blockchain.<br/><br/>The more active peers there are, the more <b>decentralised</b> and therefore trustworhty the currency becomes.",
      "NETWORK_PEERS_BLOCK_NUMBER": "This <b>number</b> (in green) indicates the peer's <b>latest validated block</b> (last page written in the ledger).<br/><br/>Green indicates that the block was equally validated by the <b>majority of other peers</b>.",
      "NETWORK_PEERS_PARTICIPATE": "<b>Each member</b>, equiped with a computer with Internet, <b>can participate, adding a peer</b> simply by <b>installing the Duniter software</b> (free/libre). <a target=\"_new\" href=\"{{installDocUrl}}\" target=\"_system\">Read the installation manual &gt;&gt;</a>.",
      "MENU_BTN_ACCOUNT": "<b>{{'ACCOUNT.TITLE'|translate}}</b> allows access to your account balance and transaction history.",
      "MENU_BTN_ACCOUNT_MEMBER": "Here you can consult your account status, transaction history and your certifications.",
      "WALLET_CERTIFICATIONS": "Click here to reveiw the details of your certifications (given and received).",
      "WALLET_RECEIVED_CERTIFICATIONS": "Click here to review the details of your <b>received certifications</b>.",
      "WALLET_GIVEN_CERTIFICATIONS": "Click here to review the details of your <b>given certifications</b>.",
      "WALLET_BALANCE": "Your account <b>balance</b> is shown here.",
      "WALLET_BALANCE_RELATIVE": "{{'HELP.TIP.WALLET_BALANCE'|translate}}<br/><br/>The used unit (&ldquo;<b>{{'COMMON.UD'|translate}}<sub>{{currency|abbreviate}}</sub></b>&rdquo;) signifies that the amount in {{currency|capitalize}} has been divided by the <b>Universal Dividend</b> (UD) co-created by each member.<br/>At this moment, 1 UD equals {{currentUD}} {{currency|capitalize}}.",
      "WALLET_BALANCE_CHANGE_UNIT": "You can <b>change the unit</b> in which amounts are shown in <b><i class=\"icon ion-android-settings\"></i>&nbsp;{{'MENU.SETTINGS'|translate}}</b>.<br/><br/>For example, to display amounts <b>directly in {{currency|capitalize}}</b> instead of relative amounts.",
      "WALLET_PUBKEY": "This is your account public key. You can communicate it to a third party so that it more easily identifies your account.",
      "WALLET_SEND": "Issue a payment in just a few clicks.",
      "WALLET_SEND_NO_MONEY": "Issue a payment in just a few clicks.<br/>(Your balance does not allow this yet)",
      "WALLET_OPTIONS": "Please note that this button allows access to <b>other, less used actions</b>.<br/><br/>Don't forget to take a quick look, when you have a moment!",
      "WALLET_RECEIVED_CERTS": "This shows the list of persons that certified you.",
      "WALLET_CERTIFY": "The button <b>{{'WOT.BTN_SELECT_AND_CERTIFY'|translate}}</b> allows selecting an identity and certifying it.<br/><br/>Only users that are <b>already member</b> may certify others.",
      "WALLET_CERT_STOCK": "Your supply of certifications (to send) is limited to <b>{{sigStock}} certifications</b>.<br/><br/>This supply will replete itself over time, as and when earlier certifications expire.",
      "MENU_BTN_WALLETS": "The menu <b>{{'MENU.WALLETS'|translate}}</b> allows you to add additional wallets that you manage.",
      "MENU_BTN_TX": "The menu <b>{{'MENU.TRANSACTIONS'|translate}}</b> allow access to transactions history, and send new payments.",
      "MENU_BTN_WOT": "The menu <b>{{'MENU.WOT'|translate}}</b> allows searching <b>users</b> of the currency (member or not).",
      "WOT_SEARCH_TEXT_XS": "To search in the registry, type the <b>first letters of a users pseudonym or public key</b>.<br/><br/>The search will start automatically.",
      "WOT_SEARCH_TEXT": "To search in the registry, type the <b>first letters of a users pseudonym or public key</b>.<br/><br/>Then hit <b>Enter</b> to start the search.",
      "WOT_SEARCH_RESULT": "Simply click a user row to view the details sheet.",
      "WOT_VIEW_CERTIFICATIONS": "The row <b>{{'ACCOUNT.CERTIFICATION_COUNT'|translate}}</b> shows how many members members validated this identity.<br/><br/>These certifications testify that the account belongs to <b>a living human</b> and this person has <b>no other member account</b>.",
      "WOT_VIEW_CERTIFICATIONS_COUNT": "There are at least <b>{{sigQty}} certifications</b> needed to become a member and receive the <b>Universal Dividend</b>.",
      "WOT_VIEW_CERTIFICATIONS_CLICK": "Click here to open <b>a list of all certifications</b> given to and by this identity.",
      "WOT_VIEW_CERTIFY": "The button <b>{{'WOT.BTN_CERTIFY'|translate}}</b> allows to add your certification to this identity.",
      "CERTIFY_RULES": "<b>Attention:</b> Only certify <b>real and living persons</b> that do not own any other certified account.<br/><br/>The trust carried by the currency depends on each member's vigilance!",
      "MENU_BTN_SETTINGS": "The <b>{{'MENU.SETTINGS'|translate}}</b> allow you to configure the Cesium application.<br/><br/>For example, you can <b>change the unit</b> in which the currency will be shown.",
      "HEADER_BAR_BTN_PROFILE": "Click here to access your <b>user profile</b>",
      "SETTINGS_CHANGE_UNIT": "You can <b>change the display unit</b> of amounts by clicking here.<br/><br/>- Deactivate the option to show amounts in {{currency|capitalize}}.<br/>- Activate the option for relative amounts in {{'COMMON.UD'|translate}}<sub>{{currency|abbreviate}}</sub> (<b>divided</b> by the current Universal Dividend).",
      "END_LOGIN": "This guided visit has <b>ended</b>.<br/><br/>Welcome to the <b>free economy</b>!",
      "END_NOT_LOGIN": "This guided visit has <b>ended</b>.<br/><br/>If you wish to join the currency {{currency|capitalize}}, simply click <b>{{'LOGIN.CREATE_FREE_ACCOUNT'|translate}}</b> below.",
      "END_READONLY": "This guided visit has <b>ended</b>.<br/><br/>{{'MODE.READONLY.INSTALL_HELP'|translate}}."
    }
  },
  "API" :{
    "COMMON": {
      "LINK_DOC": "API documentation",
      "LINK_DOC_HELP": "API documentation for developers",
      "LINK_STANDARD_APP": "Standard version",
      "LINK_STANDARD_APP_HELP": "Open standard version of {{'COMMON.APP_NAME'|translate}}",
      "CONNECTION_ERROR": "Peer <b>{{server}}</b> unreachable or invalid address.<br/><br/>Check your Internet connection, or contact the web site administrator."
    },
    "HOME": {
      "TITLE": "{{'COMMON.APP_NAME'|translate}} API Documentation",
      "MESSAGE": "Welcome to the {{'COMMON.APP_NAME'|translate}} <b>API documentation </b>.<br/>Connect your web site to <a href=\"http://duniter.org\" target=\"_system\">Duniter</a> very easily!",
      "MESSAGE_SHORT": "Connect your websites to <a href=\"http://duniter.org\" target=\"_system\">Duniter</a> very easily!",
      "DOC_HEADER": "Available services:"
    },
    "TRANSFER": {
      "TITLE": "{{'COMMON.APP_NAME'|translate}} - Online payment",
      "TITLE_SHORT": "Online payment",
      "SUMMARY": "Order summary:",
      "AMOUNT": "Amount:",
      "AMOUNTS_HELP": "Please select the amount:",
      "NAME": "Name:",
      "PUBKEY": "Public key of the recipient:",
      "COMMENT": "Order reference:",
      "NODE": "Peer address:",
      "DEMO": {
        "SALT": "demo",
        "PASSWORD": "demo",
        "PUBKEY": "3G28bL6deXQBYpPBpLFuECo46d3kfYMJwst7uhdVBnD1",
        "HELP": "<b>Demonstration mode</b>: No payment will actually be sent during this simulation.<br/>Please use credentials: <b>{{'API.TRANSFER.DEMO.SALT'|translate}} / {{'API.TRANSFER.DEMO.PASSWORD'|translate}}</b>",
        "BAD_CREDENTIALS": "Invalid credentials.<br/>In demonstration mode, credentials should be: {{'API.TRANSFER.DEMO.SALT'|translate}} / {{'API.TRANSFER.DEMO.PASSWORD'|translate}}"
      },
      "INFO": {
        "SUCCESS_REDIRECTING_WITH_NAME": "Payment sent.<br/>Redirect to <b>{{name}}</b>...",
        "SUCCESS_REDIRECTING": "Payment sent.<br/>Redirect to the seller's website...",
        "CANCEL_REDIRECTING_WITH_NAME": "Payment cancelled.<br/>Redirect to <b>{{name}}</b>...",
        "CANCEL_REDIRECTING": "Payment cancelled.<br/>Redirect to the seller's website..."
      },
      "ERROR": {
        "TRANSFER_FAILED": "Payment failed"
      }
    },
    "DOC": {
      "DESCRIPTION_DIVIDER": "Description",
      "URL_DIVIDER": "Calling address",
      "PARAMETERS_DIVIDER": "Parameters",
      "AVAILABLE_PARAMETERS": "Here is the list of al available parameters:",
      "DEMO_DIVIDER": "Try it !",
      "DEMO_HELP": "To test this service, click on this button. The result content will be display below.",
      "DEMO_RESULT": "Result returned by call:",
      "DEMO_RESULT_PEER": "Peer address used:",
      "DEMO_SUCCEED": "<i class=\"icon ion-checkmark\"></i> Success!",
      "DEMO_CANCELLED": "<i class=\"icon ion-close\"></i> Canceled by user",
      "INTEGRATE_DIVIDER": "Website integration",
      "INTEGRATE_CODE": "Code:",
      "INTEGRATE_RESULT": "Result preview:",
      "INTEGRATE_PARAMETERS": "Parameters",
      "TRANSFER": {
        "TITLE": "Payments",
        "DESCRIPTION": "From a site (eg online marketplace) you can delegate payment in free currency to Cesium API. To do this, simply open a page at the following address:",
        "PARAM_PUBKEY": "Recipient's public key",
        "PARAM_PUBKEY_HELP": "Recipient's public key (required)",
        "PARAM_AMOUNT": "Amount",
        "PARAM_AMOUNT_HELP": "Transaction amount (required)",
        "PARAM_COMMENT": "Reference (or comment)",
        "PARAM_COMMENT_HELP": "Reference or comment. You will allow for example to identify the payment in the BlockChain.",
        "PARAM_NAME": "Name (of recipient or website)",
        "PARAM_NAME_HELP": "The name of your website. This can be a readable name (eg \"My online site\"), or a web address (eg \"www.MySite.com\").",
        "PARAM_REDIRECT_URL": "URL redirection",
        "PARAM_REDIRECT_URL_HELP": "URL redirection after sending payment, after the payment has been sent. Can contain the following strings, which will be replaced by the values of the transaction: \"{tx}\", \"{hash}\", \"{comment}\", \"{amount}\" and \"{pubkey}\".",
        "PARAM_CANCEL_URL": "URL if cancelled",
        "PARAM_CANCEL_URL_HELP": "URL in case of cancellation.  Can contain the following strings, which will be replaced: \"{comment}\", \"{amount}\" and \"{pubkey}\".",
        "PARAM_PREFERRED_NODE": "Preferred Duniter peer",
        "PARAM_PREFERRED_NODE_HELP": "Peer address (URL) to use preferably (\"g1.domain.com:443\" or \"https://g1.domain.com\")",
        "EXAMPLES_HELP": "Examples of integration:",
        "EXAMPLE_BUTTON": "HTML Button",
        "EXAMPLE_BUTTON_DEFAULT_TEXT": "Pay in {{currency|abbreviate}}",
        "EXAMPLE_BUTTON_DEFAULT_STYLE": "Custom style",
        "EXAMPLE_BUTTON_TEXT_HELP": "Button text",
        "EXAMPLE_BUTTON_BG_COLOR": "Background color",
        "EXAMPLE_BUTTON_BG_COLOR_HELP": "eg: #fbc14c, yellow, lightgrey, rgb(180,180,180)",
        "EXAMPLE_BUTTON_FONT_COLOR": "Font color",
        "EXAMPLE_BUTTON_FONT_COLOR_HELP": "eg: black, orange, rgb(180,180,180)",
        "EXAMPLE_BUTTON_TEXT_ICON": "Icon",
        "EXAMPLE_BUTTON_TEXT_WIDTH": "Width",
        "EXAMPLE_BUTTON_TEXT_WIDTH_HELP": "eg: 200px, 50%",
        "EXAMPLE_BUTTON_ICON_NONE": "No icon",
        "EXAMPLE_BUTTON_ICON_DUNITER": "Duniter logo",
        "EXAMPLE_BUTTON_ICON_CESIUM": "Cesium logo",
        "EXAMPLE_BUTTON_ICON_G1_COLOR": "Ğ1 logo",
        "EXAMPLE_BUTTON_ICON_G1_BLACK": "Ğ1 logo (outline)"
      }
    }
  }
}
);

$translateProvider.translations("eo-EO", {
  "COMMON": {
    "APP_NAME": "Cesium",
    "APP_VERSION": "v{{version}}",
    "APP_BUILD": "date : {{build}}",
    "PUBKEY": "Publika ŝlosilo",
    "MEMBER": "Membro",
    "BLOCK" : "Bloko",
    "BTN_OK": "OK",
    "BTN_YES": "Jes",
    "BTN_NO": "Ne",
    "BTN_SEND": "Sendi",
    "BTN_SEND_MONEY": "Fari elspezon",
    "BTN_SEND_MONEY_SHORT": "Elspezo",
    "BTN_SAVE": "Konservi",
    "BTN_YES_SAVE": "Jes, Konservi",
    "BTN_YES_CONTINUE": "Jes, Daŭrigi",
    "BTN_SHOW": "Vidi",
    "BTN_SHOW_PUBKEY": "Afiŝi la publikan ŝlosilon",
    "BTN_RELATIVE_UNIT": "Afiŝi la sumojn en UD?",
    "BTN_BACK": "Reiro",
    "BTN_NEXT": "Sekva",
    "BTN_IMPORT": "Enporti",
    "BTN_CANCEL": "Nuligi",
    "BTN_CLOSE": "Fermi",
    "BTN_LATER": "Poste",
    "BTN_LOGIN": "Konektiĝi",
    "BTN_LOGOUT": "Malkonektiĝo",
    "BTN_ADD_ACCOUNT": "Nova konto",
    "BTN_SHARE": "Diskonigi",
    "BTN_EDIT": "Modifi",
    "BTN_DELETE": "Forigi",
    "BTN_ADD": "Aldoni",
    "BTN_SEARCH": "Serĉi",
    "BTN_REFRESH": "Aktualigi",
    "BTN_RETRY": "Rekomenci",
    "BTN_START": "Komenci",
    "BTN_CONTINUE": "Daŭrigi",
    "BTN_CREATE": "Krei",
    "BTN_UNDERSTOOD": "Mi komprenis",
    "BTN_OPTIONS": "Kromeblecoj",
    "BTN_HELP_TOUR": "Gvidata vizito",
    "BTN_HELP_TOUR_SCREEN": "Malkovri tiun ĉi paĝon",
    "BTN_DOWNLOAD": "Elŝuti",
    "BTN_DOWNLOAD_ACCOUNT_STATEMENT": "Elŝuti la konto-tabelon",
    "BTN_MODIFY": "Modifi",
    "CHOOSE_FILE": "Almetu vian dosieron <br/>aŭ klaku por elekti ĝin",
    "DAYS": "tagoj",
    "NO_ACCOUNT_QUESTION": "Ankoraŭ sen konto? Kreu ĝin senpage!",
    "SEARCH_NO_RESULT": "Neniu rezulto trovita",
    "LOADING": "Bonvolu pacienci...",
    "LOADING_WAIT": "Bonvolu pacienci...<br/><small>(Atendado pri disponebleco de la nodo)</small>",
    "SEARCHING": "Serĉanta...",
    "FROM": "De",
    "TO": "Al",
    "COPY": "Kopii",
    "LANGUAGE": "Lingvo",
    "UNIVERSAL_DIVIDEND": "Universala dividendo",
    "UD": "UD",
    "DATE_PATTERN": "DD/MM/YY HH:mm",
    "DATE_FILE_PATTERN": "YYYY-MM-DD",
    "DATE_SHORT_PATTERN": "DD/MM/YY",
    "DATE_MONTH_YEAR_PATTERN": "MM/YYYY",
    "EMPTY_PARENTHESIS": "(malplena)",
    "UID": "Pseŭdonimo",
    "ENABLE": "Aktiva",
    "DISABLE": "Malaktiva",
    "RESULTS_LIST": "Rezultoj",
    "RESULTS_COUNT": "{{count}} rezultoj",
    "EXECUTION_TIME": "Plenumita en {{duration|formatDurationMs}}",
    "SHOW_VALUES": "Afiŝi la signojn klare?",
    "POPOVER_ACTIONS_TITLE": "Kromeblecoj",
    "POPOVER_FILTER_TITLE": "Filtriloj",
    "SHOW_MORE": "Afiŝi pli",
    "SHOW_MORE_COUNT": "(nuna limo je {{limit}})",
    "POPOVER_SHARE": {
      "TITLE": "Diskonigi",
      "SHARE_ON_TWITTER": "Diskonigi ĉe Twitter",
      "SHARE_ON_FACEBOOK": "Diskonigi ĉe Facebook",
      "SHARE_ON_DIASPORA": "Diskonigi ĉe Diaspora*",
      "SHARE_ON_GOOGLEPLUS": "Diskonigi ĉe Google+"
    },
    "FILE": {
      "DATE": "Dato:",
      "TYPE": "Tipo:",
      "SIZE": "Pezo:",
      "VALIDATING": "Validiĝanta..."
    }
  },
  "SYSTEM": {
    "PICTURE_CHOOSE_TYPE": "Elekti la fonton:",
    "BTN_PICTURE_GALLERY": "Bildaro",
    "BTN_PICTURE_CAMERA": "<b>Kamerao</b>"
  },
  "MENU": {
    "HOME": "Hejmpaĝo",
    "WOT": "Kontaro",
    "CURRENCY": "Mono",
    "ACCOUNT": "Mia konto",
    "WALLETS": "Miaj monujoj",
    "SETTINGS": "Parametroj",
    "NETWORK": "Reto",
    "TRANSACTIONS": "Miaj spezoj"
  },
  "ABOUT": {
    "TITLE": "Prie",
    "LICENSE": "Programo <b>libera</b> (Licenco GNU AGPLv3).",
    "LATEST_RELEASE": "Ekzistas <b>pli freŝdata versio</b> de {{'COMMON.APP_NAME'|translate}} (<b>v{{version}}</b>)",
    "PLEASE_UPDATE": "Bonvolu ĝisdatigi {{'COMMON.APP_NAME'|translate}} (lasta versio: <b>v{{version}}</b>)",
    "CODE": "Fonto-kodo:",
    "OFFICIAL_WEB_SITE": "Oficiala retejo:",
    "DEVELOPERS": "Programita de:",
    "FORUM": "Forumo:",
    "PLEASE_REPORT_ISSUE": "Ne hezitu sciigi al ni la renkontitajn fuŝaĵojn",
    "REPORT_ISSUE": "Sciigi problemon",
    "BTN_OPEN_DEV_WINDOW": "Malfermi la fenestron pri malfuŝigado"
  },
  "HOME": {
    "TITLE": "Cesium",
    "WELCOME": "Bonvenon ĉe la programo Cesium!",
    "WELCOME_READONLY": "Bonvenon ĉe Cesium <span class='badge badge-balanced'>Observo</span>!",
    "MESSAGE": "Ricevu kaj sendu liberan monon {{currency|abbreviate}}",
    "MESSAGE_READONLY": "Sekvu la staton de la libera mono {{currency|abbreviate}} en tuja tempo.",
    "BTN_CURRENCY": "Esploru la monon {{currency|abbreviate}}",
    "BTN_ABOUT": "prie",
    "BTN_HELP": "Reta helpo",
    "BTN_NETWORK": "Stato de la reto",
    "FREE_SOFTWARE": "Libera programo",
    "FORK_ME": "Duobligu min!",
    "SHOW_LICENSE": "Vidi la licencon de la programo",
    "REPORT_ISSUE": "fuŝaĵo",
    "NOT_YOUR_ACCOUNT_QUESTION" : "Vi ne posedas la konton <b class=\"ion-key\"> {{pubkey|formatPubkey}}</b>&nbsp;?",
    "BTN_CHANGE_ACCOUNT": "Malkonektu tiun ĉi konton",
    "CONNECTION_ERROR": "Nodo <b>{{server}}</b> neatingebla aŭ adreso nevalida.<br/><br/>Kontrolu vian retkonekton, aŭ elektu alian nodon <a class=\"positive\" ng-click=\"doQuickFix('settings')\">ĉe la parametroj</a>.",
    "SHOW_ALL_FEED": "Vidi ĉion",
    "READ_MORE": "Legi la sekvon",
    "FEED_SOURCE": "Fonto"
  },
  "SETTINGS": {
    "TITLE": "Parametroj",
    "DISPLAY_DIVIDER": "Afiŝado",
    "STORAGE_DIVIDER": "Stokado",
    "NETWORK_SETTINGS": "Reto",
    "PEER": "Adreso de la nodo Duniter",
    "PEER_SHORT": "Adreso de la nodo",
    "PEER_CHANGED_TEMPORARY": "Adreso provizore uzata",
    "PERSIST_CACHE": "Konservi la datenojn pri retumado (provaĵo)",
    "PERSIST_CACHE_HELP": "Ebligas pli rapidan retumadon, loke konservante la ricevitajn datenojn, por uzi ilin de sesio al alia.",
    "USE_LOCAL_STORAGE": "Aktivigi lokan stokadon",
    "USE_LOCAL_STORAGE_HELP": "Ebligas konservi viajn parametrojn",
    "WALLETS_SETTINGS": "Miaj monujoj",
    "USE_WALLETS_ENCRYPTION": "Sekurigi la liston?",
    "USE_WALLETS_ENCRYPTION_HELP": "Ebligas sekurigi la liston de viaj monujoj (per ĉifrado), postulante aŭtentigado por aliri ilin.",
    "ENABLE_HELPTIP": "Aktivigi la rilatigajn help-vezikojn",
    "DISABLE_HELPTIP": "Malaktivigi la rilatigajn help-vezikojn",
    "ENABLE_UI_EFFECTS": "Aktivigi la vid-efikojn",
    "HISTORY_SETTINGS": "Miaj spezoj",
    "DISPLAY_UD_HISTORY": "Afiŝi la produktitajn dividendojn?",
    "TX_HISTORY_AUTO_REFRESH": "Aktualigi aŭtomate",
    "TX_HISTORY_AUTO_REFRESH_HELP": "Aktualigas la saldon kaj la spezojn aŭtomate, por ĉiu nova bloko de la reto.",
    "AUTHENTICATION_SETTINGS": "Aŭtentigado",
    "KEEP_AUTH": "Aŭtomata malaŭtentigado",
    "KEEP_AUTH_SHORT": "Malaŭtentigado",
    "KEEP_AUTH_HELP": "Difinas la momenton, kiam la aŭtentigado estas forviŝita de la memoro.",
    "KEEP_AUTH_OPTION": {
      "NEVER": "Post ĉiu ago",
      "SECONDS": "Post {{value}}s de neatktiveco",
      "MINUTE": "Post {{value}}min de neatktiveco",
      "MINUTES": "Post {{value}}min de neatktiveco",
      "HOUR": "Post {{value}}h de neatktiveco",
      "ALWAYS": "Fine de la seanco"
    },
    "KEYRING_FILE": "Dosiero pri ŝlosilaro",
    "KEYRING_FILE_HELP": "Ebligas <b>konektiĝi</b> aŭtomate por ĉiu ekuzo<br/>kaj eĉ <b>aŭtentiĝi</b> (nur se \"Finiĝo de la aŭtentiĝo\" estas agordita kiel \"fine de la seanco\").",
    "REMEMBER_ME": "Memori min?",
    "REMEMBER_ME_HELP": "Ebligas resti identigita de seanco al alia, loke konservante la publikan ŝlosilon.",
    "PLUGINS_SETTINGS": "Krom-programoj",
    "BTN_RESET": "Restarigi la originajn valorojn",
    "EXPERT_MODE": "Aktivigi la spertan moduson",
    "EXPERT_MODE_HELP": "Ebligas pli detalan afiŝadon.",
    "BLOCK_VALIDITY_WINDOW": "Limtempo pri necerteco de la blokoj",
    "BLOCK_VALIDITY_WINDOW_SHORT": "Limtempo pri necerteco",
    "BLOCK_VALIDITY_WINDOW_HELP": "Limtempo antaŭ ol taksi, ke iu informo estas validigita",
    "BLOCK_VALIDITY_OPTION": {
      "NONE": "Neniu limtempo",
      "N": "{{time | formatDuration}} ({{count}} blokoj)"
    },
    "POPUP_PEER": {
      "TITLE": "Nodo Duniter",
      "HOST": "Adreso",
      "HOST_HELP": "Adreso: servilo: konektujo",
      "USE_SSL": "Sekurigita?",
      "USE_SSL_HELP": "(SSL-ĉifrado)",
      "BTN_SHOW_LIST": "Listo de la nodoj"
    }
  },
  "BLOCKCHAIN": {
    "HASH": "Haketo: {{hash}}",
    "VIEW": {
      "HEADER_TITLE": "Bloko #{{number}}-{{hash|formatHash}}",
      "TITLE_CURRENT": "Nuna bloko",
      "TITLE": "Bloko #{{number|formatInteger}}",
      "COMPUTED_BY": "Kalkulita de la nodo de",
      "SHOW_RAW": "Vidi la kompletan dosieron",
      "TECHNICAL_DIVIDER": "Teknikaj informoj",
      "VERSION": "Versio de la daten-strukturo",
      "HASH": "Kalkulita haketo",
      "UNIVERSAL_DIVIDEND_HELP": "Mono kunproduktita de ĉiu el la {{membersCount}} membroj",
      "EMPTY": "Neniu dateno en tiu ĉi bloko",
      "POW_MIN": "Minimuma malfacileco",
      "POW_MIN_HELP": "Malfacileco trudita por la haket-kalkulo",
      "DATA_DIVIDER": "Datenoj",
      "IDENTITIES_COUNT": "Novaj identecoj",
      "JOINERS_COUNT": "Novaj membroj",
      "ACTIVES_COUNT": "Revalidigoj",
      "ACTIVES_COUNT_HELP": "Membroj revalidigintaj sian membrecon",
      "LEAVERS_COUNT": "Membroj elirintaj",
      "LEAVERS_COUNT_HELP": "Membroj ne plu dezirantaj atestaĵon",
      "EXCLUDED_COUNT": "Membroj eksigitaj",
      "EXCLUDED_COUNT_HELP": "Malnovaj membroj eksigitaj pro nerevalidiĝo aŭ manko de atestaĵoj",
      "REVOKED_COUNT": "Nuligitaj identecoj",
      "REVOKED_COUNT_HELP": "Tiuj kontoj ne plu povos esti membroj",
      "TX_COUNT": "Spezoj",
      "CERT_COUNT": "Atestaĵoj",
      "TX_TO_HIMSELF": "Operacio pri monŝanĝo",
      "TX_OUTPUT_UNLOCK_CONDITIONS": "Kondiĉoj por malblokado",
      "TX_OUTPUT_OPERATOR": {
        "AND": "kaj",
        "OR": "aŭ"
      },
      "TX_OUTPUT_FUNCTION": {
        "SIG": "<b>Subskribo</b> de ",
        "XHX": "<b>Pasvorto</b>, el kiu SHA256 =",
        "CSV": "Blokita dum",
        "CLTV": "Blokita ĝis"
      }
    },
    "LOOKUP": {
      "TITLE": "Blokoj",
      "NO_BLOCK": "Neniu bloko",
      "LAST_BLOCKS": "Lastaj blokoj:",
      "BTN_COMPACT": "Densigi"
    }
  },
  "CURRENCY": {
    "VIEW": {
      "TITLE": "Mono",
      "TAB_CURRENCY": "Mono",
      "TAB_WOT": "Reto de fido",
      "TAB_NETWORK": "Reto",
      "TAB_BLOCKS": "Blokoj",
      "CURRENCY_SHORT_DESCRIPTION": "{{currency|abbreviate}} estas <b>libera mono</b>, kiu ekis {{firstBlockTime|formatFromNow}}. Ĝi nombras nun <b>{{N}} membrojn</b>, kiuj produktas kaj ricevas <a ng-click=\"showHelpModal('ud')\">Universalan Dividendon</a> (UD), ĉiun {{dt|formatPeriod}}n.",
      "NETWORK_RULES_DIVIDER": "Reguloj de la reto",
      "CURRENCY_NAME": "Nomo de la mono",
      "MEMBERS": "Nombro de membroj",
      "MEMBERS_VARIATION": "Variado depost la lasta UD",
      "MONEY_DIVIDER": "Mono",
      "MASS": "Mona maso",
      "SHARE": "Monkvanto por ĉiu membro",
      "UD": "Universala Dividendo",
      "C_ACTUAL": "Nuna kreskado",
      "MEDIAN_TIME": "Horo de la blokĉeno",
      "POW_MIN": "Minimuma nivelo pri malfacileco de kalkulo",
      "MONEY_RULES_DIVIDER": "Reguloj de la mono",
      "C_RULE": "Teoria kreskado celata",
      "UD_RULE": "Kalkulo de la universala dividendo",
      "DT_REEVAL": "Periodo de revalorigo de la UD",
      "REEVAL_SYMBOL": "reval",
      "DT_REEVAL_VALUE": "Ĉiuj <b>{{dtReeval|formatDuration}}</b> ({{dtReeval/86400}} {{'COMMON.DAYS'|translate}})",
      "UD_REEVAL_TIME0": "Dato de la unua revalorigo",
      "SIG_QTY_RULE": "Nombro de necesaj atestaĵoj por fariĝi membro",
      "SIG_STOCK": "Maksimuma nombro da senditaj atestaĵoj por membro",
      "SIG_PERIOD": "Minimuma daŭro de atendado inter 2 sinsekvaj atestaĵoj senditaj de sama persono",
      "SIG_WINDOW": "Limdaŭro por akcepti atestaĵon",
      "SIG_VALIDITY": "Vivdaŭro de atestaĵo, kiu estis akceptita",
      "MS_WINDOW": "Limdaŭro por la akcepto de aliĝ-peto",
      "MS_VALIDITY": "Vivdaŭro de aliĝo, kiu estis akceptita",
      "STEP_MAX": "Maksimuma distanco, per la atestaĵoj, inter nova eniranto kaj la referencaj membroj",
      "WOT_RULES_DIVIDER": "Reguloj de la reto de fido",
      "SENTRIES": "Nombro de atestaĵoj (senditaj <b>kaj</b> ricevitaj) por fariĝi referenca membro",
      "SENTRIES_FORMULA": "Nombro de atestaĵoj (senditaj <b>kaj</b> ricevitaj) por fariĝi referenca membro (formulo)",
      "XPERCENT":"Minimuma procento da referencaj membroj atingenda por konformiĝi al la regulo pri distanco",
      "AVG_GEN_TIME": "Meza daŭro inter du blokoj",
      "CURRENT": "nuna",
      "MATH_CEILING": "PLAFONO",
      "DISPLAY_ALL_RULES": "Afiŝi ĉiujn regulojn?",
      "BTN_SHOW_LICENSE": "Vidi la licencon",
      "WOT_DIVIDER": "Reto de fido"
    },
    "LICENSE": {
      "TITLE": "Licenco de la mono",
      "BTN_DOWNLOAD": "Elŝuti la dosieron",
      "NO_LICENSE_FILE": "Dosiero pri licenco ne trovita."
    }
  },
  "NETWORK": {
    "VIEW": {
      "MEDIAN_TIME": "Horo de la blokĉeno",
      "LOADING_PEERS": "Nodoj ŝarĝiĝantaj...",
      "NODE_ADDRESS": "Adreso:",
      "SOFTWARE": "Programo",
      "WARN_PRE_RELEASE": "Antaŭ-versio (lasta stabila versio: <b>{{version}}</b>)",
      "WARN_NEW_RELEASE": "Versio <b>{{version}}</b> disponebla",
      "WS2PID": "Identigilo:",
      "PRIVATE_ACCESS": "Privata aliro",
      "POW_PREFIX": "Prefikso pri labor-pruvo:",
      "ENDPOINTS": {
        "BMAS": "Sekurigita interfaco (SSL)",
        "BMATOR": "Reta interfaco TOR",
        "WS2P": "Interfaco WS2P",
        "ES_USER_API": "Nodo de datenoj Cesium+"
      }
    },
    "INFO": {
      "ONLY_SSL_PEERS": "La nodoj ne-SSL estas mis-afiŝitaj, ĉar Cesium funkcias laŭ moduso HTTPS."
    }
  },
  "PEER": {
    "PEERS": "Nodoj",
    "SIGNED_ON_BLOCK": "Skribita en la bloko",
    "MIRROR": "spegulo",
    "MIRRORS": "Speguloj",
    "MIRROR_PEERS": "Spegul-nodoj",
    "PEER_LIST" : "Listo de la nodoj",
    "MEMBERS" : "Membroj",
    "MEMBER_PEERS" : "Membro-nodoj",
    "ALL_PEERS" : "Ĉiuj nodoj",
    "DIFFICULTY" : "Malfacileco",
    "API" : "API",
    "CURRENT_BLOCK" : "Bloko #",
    "POPOVER_FILTER_TITLE": "Filtrilo",
    "OFFLINE": "Nekonektita",
    "OFFLINE_PEERS": "Nekonektitaj nodoj",
    "BTN_SHOW_PEER": "Vidi la nodon",
    "VIEW": {
      "TITLE": "Nodo",
      "OWNER": "Apartenas al",
      "SHOW_RAW_PEERING": "Vidi la samrangan dokumenton",
      "SHOW_RAW_CURRENT_BLOCK": "Vidi la lastan blokon (kompleta strukturo)",
      "LAST_BLOCKS": "Lastaj blokoj konataj",
      "KNOWN_PEERS": "Konataj nodoj:",
      "GENERAL_DIVIDER": "Ĝeneralaj informoj",
      "ERROR": {
        "LOADING_TOR_NODE_ERROR": "Neeblas ricevi la informojn de la nodo. La limdaŭro de atendado estas transpasita.",
        "LOADING_NODE_ERROR": "Neeblas ricevi la informojn de la nodo"
      }
    }
  },
  "WOT": {
    "SEARCH_HELP": "Traserĉado (pseŭdo aŭ publika ŝlosilo)",
    "SEARCH_INIT_PHASE_WARNING": "Dum la periodo de antaŭ-aliĝo, la traserĉado de la atendantaj aliĝoj <b>povas esti longa</b>. Bonvolu pacienci...",
    "REGISTERED_SINCE": "Enskribita la",
    "REGISTERED_SINCE_BLOCK": "Enskribita en la bloko #",
    "NO_CERTIFICATION": "Neniu atestaĵo validigita",
    "NO_GIVEN_CERTIFICATION": "Neniu atestaĵo sendita",
    "NOT_MEMBER_PARENTHESIS": "(ne membro)",
    "IDENTITY_REVOKED_PARENTHESIS": "(identeco nuligita)",
    "MEMBER_PENDING_REVOCATION_PARENTHESIS": "(nuliĝanta)",
    "EXPIRE_IN": "Finiĝo",
    "NOT_WRITTEN_EXPIRE_IN": "Limdato<br/>de traktado",
    "EXPIRED": "Finiĝinta",
    "PSEUDO": "Pseŭdonimo",
    "SIGNED_ON_BLOCK": "Sendita en la bloko #{{block}}",
    "WRITTEN_ON_BLOCK": "Enskribita en la bloko #{{block}}",
    "GENERAL_DIVIDER": "Ĝeneralaj informoj",
    "NOT_MEMBER_ACCOUNT": "Simpla konto (ne membro)",
    "NOT_MEMBER_ACCOUNT_HELP": "Temas pri simpla monujo, sen aliĝ-peto atendanta.",
    "TECHNICAL_DIVIDER": "Teknikaj informoj",
    "BTN_CERTIFY": "Atesti",
    "BTN_YES_CERTIFY": "Jes, atesti",
    "BTN_SELECT_AND_CERTIFY": "Nova atestaĵo",
    "ACCOUNT_OPERATIONS": "Spezoj en la konto",
    "VIEW": {
      "POPOVER_SHARE_TITLE": "Identeco {{title}}"
    },
    "LOOKUP": {
      "TITLE": "Reto de fido",
      "NEWCOMERS": "Novaj membroj",
      "NEWCOMERS_COUNT": "{{count}} membroj",
      "PENDING": "Atendantaj enskribiĝoj",
      "PENDING_COUNT": "{{count}} atendantaj enskribiĝoj",
      "REGISTERED": "Enskribita {{sigDate | formatFromNow}}",
      "MEMBER_FROM": "Membro depost {{memberDate|medianFromNowShort}}",
      "BTN_NEWCOMERS": "Novaj membroj",
      "BTN_PENDING": "Atendantaj enskribiĝoj",
      "SHOW_MORE": "Afiŝi pli",
      "SHOW_MORE_COUNT": "(nuna limo je {{limit}})",
      "NO_PENDING": "Neniu enskribiĝo atendanta.",
      "NO_NEWCOMERS": "Neniu membro."
    },
    "CONTACTS": {
      "TITLE": "Kontaktoj"
    },
    "MODAL": {
      "TITLE": "Traserĉado"
    },
    "CERTIFICATIONS": {
      "TITLE": "{{uid}} - Atestaĵoj",
      "SUMMARY": "Ricevitaj atestaĵoj",
      "LIST": "Detalo pri la ricevitaj atestaĵoj",
      "PENDING_LIST": "Atestaĵoj atendantaj traktadon",
      "RECEIVED": "Ricevitaj atestaĵoj",
      "RECEIVED_BY": "Atestaĵoj ricevitaj de {{uid}}",
      "ERROR": "Atestaĵoj erare ricevitaj",
      "SENTRY_MEMBER": "Referenca membro"
    },
    "OPERATIONS": {
      "TITLE": "{{uid}} - Spezoj"
    },
    "GIVEN_CERTIFICATIONS": {
      "TITLE": "{{uid}} - Senditaj atestaĵoj",
      "SUMMARY": "Senditaj atestaĵoj",
      "LIST": "Detalo pri la senditaj atestaĵoj",
      "PENDING_LIST": "Atestaĵoj atendantaj traktadon",
      "SENT": "Senditaj atestaĵoj",
      "SENT_BY": "Atestaĵoj senditaj de {{uid}}",
      "ERROR": "Atestaĵoj erare senditaj"
    }
  },
  "LOGIN": {
    "TITLE": "<i class=\"icon ion-log-in\"></i> Konektiĝo",
    "SCRYPT_FORM_HELP": "Bonvolu tajpi viajn identigilojn.<br>Pensu kontroli, ke la publika ŝlosilo estas tiu de via konto.",
    "PUBKEY_FORM_HELP": "Bonvolu tajpi publikan ŝlosilon de konto:",
    "FILE_FORM_HELP": "Elektu la ŝlosilaro-dosieron uzotan:",
    "SCAN_FORM_HELP": "Skani la QR-kodon de monujo.",
    "SALT": "Sekreta identigilo",
    "SALT_HELP": "Sekreta identigilo",
    "SHOW_SALT": "Afiŝi la sekretan identigilon?",
    "PASSWORD": "Pasvorto",
    "PASSWORD_HELP": "Pasvorto",
    "PUBKEY_HELP": "Publika ŝlosilo aŭ pseŭdonimo",
    "NO_ACCOUNT_QUESTION": "Vi ankoraŭ ne havas konton?",
    "HAVE_ACCOUNT_QUESTION": "Vi jam havas konton?",
    "CREATE_ACCOUNT": "Krei konton...",
    "CREATE_FREE_ACCOUNT": "Krei konton senpage",
    "FORGOTTEN_ID": "Pasvorto forgesita?",
    "ASSOCIATED_PUBKEY": "Publika ŝlosilo de la ŝlosilaro:",
    "BTN_METHODS": "Aliaj metodoj",
    "BTN_METHODS_DOTS": "Ŝanĝi metodon...",
    "METHOD_POPOVER_TITLE": "Metodoj",
    "MEMORIZE_AUTH_FILE": "Memorigi tiun ŝlosilaron por la daŭro de la retum-seanco",
    "SCRYPT_PARAMETERS": "Parametroj (Skripto):",
    "AUTO_LOGOUT": {
      "TITLE": "Informo",
      "MESSAGE": "<i class=\"ion-android-time\"></i> Vi estis <b>malkonektita</b> aŭtomate, pro tro longa senaktiveco.",
      "BTN_RELOGIN": "Rekonektiĝi",
      "IDLE_WARNING": "Vi estos malkonektita... {{countdown}}"
    },
    "METHOD": {
      "SCRYPT_DEFAULT": "Sekreta identigilo kaj pasvorto",
      "SCRYPT_ADVANCED": "Sperta salumado",
      "FILE": "Dosiero pri ŝlosilaro",
      "PUBKEY": "Publika ŝlosilo aŭ pseŭdonimo",
      "SCAN": "Skani QR-kodon"
    },
    "SCRYPT": {
      "SIMPLE": "Malpeza salumado",
      "DEFAULT": "Kutima salumado",
      "SECURE": "Sekura salumado",
      "HARDEST": "Plej sekura salumado",
      "EXTREME": "Ekstrema salumado",
      "USER": "Personigita salumado",
      "N": "N (Loop):",
      "r": "r (RAM):",
      "p": "p (CPU):"
    },
    "FILE": {
      "HELP": "Atendita strukturo de dosiero: <b>.yml</b> aŭ <b>.dunikey</b> (tipo PubSec, WIF aŭ EWIF)."
    }
  },
  "AUTH": {
    "TITLE": "<i class=\"icon ion-locked\"></i> Aŭtentigado",
    "BTN_AUTH": "Aŭtentiĝi",
    "GENERAL_HELP": "Bonvolu aŭtentiĝi:",
    "EXPECTED_UID_HELP": "Bonvolu aŭtentiĝi ĉe la konto <i class=\"ion-person\"></i> {{uid}} :",
    "EXPECTED_PUBKEY_HELP": "Bonvolu aŭtentiĝi ĉe la monujo <br class=\"visible-xs\"/><i class=\"ion-key\"></i> {{pubkey|formatPubkey}} :",
    "SCAN_FORM_HELP": "Skani la QR-kodon de la <b>privata ŝlosilo</b> de la monujo."
  },
  "ACCOUNT": {
    "TITLE": "Mia konto",
    "BALANCE": "Saldo",
    "LAST_TX": "Lastaj spezoj validigitaj",
    "BALANCE_ACCOUNT": "Konto-saldo",
    "NO_TX": "Neniu spezo",
    "SHOW_MORE_TX": "Afiŝi pli",
    "SHOW_ALL_TX": "Afiŝi ĉion",
    "TX_FROM_DATE": "(nuna limo je {{fromTime|medianFromNowShort}})",
    "PENDING_TX": "Spezoj atendantaj traktadon",
    "VALIDATING_TX": "Spezoj traktitaj, ne validigitaj",
    "ERROR_TX": "Spezoj ne realigitaj",
    "ERROR_TX_SENT": "Spezoj malsukcesintaj",
    "PENDING_TX_RECEIVED": "Spezoj atendantaj ricevon",
    "EVENTS": "Okazaĵoj",
    "OUT_DISTANCED": "Viaj nunaj atestaĵoj venas de tro izolita grupo de la <a ng-click=\"showHelpModal('wot')\">Reto de Fido</a> (RdF): al la <a ng-click=\"showHelpModal('distance_rule')\">regulo de maksimuma distanco</a> vi ne konformiĝas.<br/>Vi devas akiri atestaĵojn venantajn de aliaj lokoj de la RdF, aŭ atendi ke tiu ĉi densiĝos.",
    "WAITING_MEMBERSHIP": "Aliĝo-peto sendita. Atendanta akcepton.",
    "WAITING_CERTIFICATIONS": "Vi devas <b>akiri {{needCertificationCount}} atestaĵo(j)n</b> por fariĝi membro kaj produkti la <a ng-click=\"showHelpModal('ud')\">Universalan Dividendon</a>. Via konto tamen estas jam funkcianta, por ricevi kaj efektivigi pagojn.",
    "WAITING_CERTIFICATIONS_HELP": "Por akiri viajn atestaĵojn, petu nur membrojn <b>kiuj sufiĉe konas vin</b>, kiel postulas <a ng-click=\"showLicenseModal()\">la licenco de la mono</a>, kiun vi akceptis.<br/>Se vi ne konas sufiĉe da membroj, sciigu tion ĉe <a ng-click=\"openLink($event, $root.settings.userForumUrl)\">la forumo por uzantoj</a>.",
    "WILL_MISSING_CERTIFICATIONS": "Baldaŭ <b>mankos al vi atestaĵoj</b> (almenaŭ {{willNeedCertificationCount}} estas necesaj)",
    "WILL_NEED_RENEW_MEMBERSHIP": "Via aliĝo kiel membro <b>estas finiĝonta {{membershipExpiresIn|formatDurationTo}}</b>. Pensu <a ng-click=\"doQuickFix('renew')\">revalidigi vian aliĝon</a> ĝis tiam.",
    "NEED_RENEW_MEMBERSHIP": "Vi ne plu estas membro de la mono, ĉar <b>via aliĝo finiĝis</b>. Pensu <a ng-click=\"doQuickFix('renew')\">revalidigi vian aliĝon</a>.",
    "NEED_RENEW_MEMBERSHIP_AFTER_CANCELLED": "Vi ne plu estas membro de la mono, <b>pro manko da atestaĵoj</b>. Pensu <a ng-click=\"doQuickFix('renew')\">revalidigi vian aliĝon</a>.",
    "NO_WAITING_MEMBERSHIP": "Neniu aliĝo-peto atendanta. Se vi deziras <b>fariĝi membro</b>, pensu <a ng-click=\"doQuickFix('membership')\">sendi la aliĝo-peton</a>.",
    "CERTIFICATION_COUNT": "Ricevitaj atestaĵoj",
    "CERTIFICATION_COUNT_SHORT": "Atestaĵoj",
    "SIG_STOCK": "Senditaj atestaĵoj",
    "BTN_RECEIVE_MONEY": "Enkasigi",
    "BTN_SELECT_ALTERNATIVES_IDENTITIES": "Aliri alian identecon...",
    "BTN_FIX_MEMBERSHIP": "Resendi la aliĝo-peton...",
    "BTN_MEMBERSHIP_RENEW": "Revalidigi la aliĝon",
    "BTN_MEMBERSHIP_RENEW_DOTS": "Revalidigi la aliĝon...",
    "BTN_MEMBERSHIP_OUT_DOTS": "Ĉesigi la aliĝon...",
    "BTN_SECURITY_DOTS": "Konto kaj sekureco...",
    "BTN_SHOW_DETAILS": "Afiŝi la teknikajn informojn",
    "LOCKED_OUTPUTS_POPOVER": {
      "TITLE": "Sumo blokita",
      "DESCRIPTION": "Jen la kondiĉoj de malblokado de tiu sumo:",
      "DESCRIPTION_MANY": "Tiu spezo entenas plurajn partojn, pri kiuj la kondiĉoj de malblokado estas:",
      "LOCKED_AMOUNT": "Kondiĉoj por la sumo:"
    },
    "NEW": {
      "TITLE": "Kreado de konto",
      "INTRO_WARNING_TIME": "La kreado de konto ĉe {{name|capitalize}} estas tre simpla. Bonvolu tamen dediĉi sufiĉe da tempo por ĝuste efektivigi tiun proceduron (por ne forgesi la identigilojn, pasvortojn, ktp.).",
      "INTRO_WARNING_SECURITY": "Kontrolu ke la aparatoj, kiujn vi nun uzas (komputilo, tabuleto, telefono), <b>estas sekurigitaj kaj fidindaj</b>.",
      "INTRO_WARNING_SECURITY_HELP": "Senvirusigilo ĝisdata, fajroŝirmilo aktivigita, seanco protektita per pasvorto aŭ PIN-kodo, ktp.",
      "INTRO_HELP": "Alklaku <b>{{'COMMON.BTN_START'|translate}}</b> por ekigi la kreadon de konto. Vi estos gvidata paŝon post paŝo.",
      "REGISTRATION_NODE": "Via aliĝo estos registrita tra la nodo Duniter <b>{{server}}</b>, kiu dissendos ĝin poste al la cetero de la mon-reto.",
      "REGISTRATION_NODE_HELP": "Se vi ne fidas tiun nodon, bonvolu ŝanĝi ĝin <a ng-click=\"doQuickFix('settings')\">en la parametroj</a> de Cesium.",
      "SELECT_ACCOUNT_TYPE": "Elektu la tipon de konto kreota:",
      "MEMBER_ACCOUNT": "Membro-konto",
      "MEMBER_ACCOUNT_TITLE": "Kreado de membro-konto",
      "MEMBER_ACCOUNT_HELP": "Se vi ankoraŭ ne enskribiĝis kiel individuo (nur unu konto eblas por unu individuo). Tia konto ebligas kunprodukti la monon, ricevante <b> universalan dividendon</b> ĉiun {{parameters.dt|formatPeriod}}n.",
      "WALLET_ACCOUNT": "Simpla monujo",
      "WALLET_ACCOUNT_TITLE": "Kreado de monujo",
      "WALLET_ACCOUNT_HELP": "Por ĉiuj aliaj kazoj, ekzemple se vi bezonas plian konton.<br/>Neniu universala dividendo estos kreita per tia konto.",
      "SALT_WARNING": "Elektu vian sekretan identigilon.<br/>Oni petos ĝin de vi ĉiufoje, kiam vi konektiĝos al tiu konto.<br/><br/><b>Bone memorigu ĝin</b>: kaze de perdo, neniu alia povos aliri vian konton!",
      "PASSWORD_WARNING": "Elektu pasvorton.<br/>Oni petos ĝin de vi ĉiufoje, kiam vi konektiĝos al tiu konto.<br/><br/><b>Bone memorigu tiun pasvorton</b: kaze de perdo, neniu alia povos aliri vian konton!",
      "PSEUDO_WARNING": "Elektu pseŭdonimon.<br/>Ĝi utilas al la aliaj membroj, por identigi vin pli facile.<div class='hidden-xs'><br/>Ĝi <b>ne povos esti modifita</b>, sen rekrei konton.</div><br/><br/>Ĝi entenu <b>nek spacon, nek diakritan literon (kun supersigno, ktp.)</b>.<div class='hidden-xs'><br/>Ekzemple: <span class='gray'>NataljaBelulino, JohanoStelaro, ktp.</span>",
      "PSEUDO": "Pseŭdonimo",
      "PSEUDO_HELP": "Pseŭdonimo",
      "SALT_CONFIRM": "Konfirmo",
      "SALT_CONFIRM_HELP": "Konfirmo de la sekreta identigilo",
      "PASSWORD_CONFIRM": "Konfirmo",
      "PASSWORD_CONFIRM_HELP": "Konfirmo de la pasvorto",
      "SLIDE_6_TITLE": "Konfirmo:",
      "COMPUTING_PUBKEY": "Kalkulanta...",
      "LAST_SLIDE_CONGRATULATION": "Vi tajpis ĉiujn necesajn informojn: Gratulon!<br/>Vi nun povas <b>sendi la peton por kreado</b> de la konto.</b><br/><br/>Por informo, la publika ŝlosilo ĉi-sube identigos vian estontan konton.<br/>Ĝi povos estis sciigita al aliuloj por ricevi iliajn pagojn.<br/><b>Ne estas devige</b> noti ĝin nun, vi ankaŭ povos fari tion poste.",
      "CONFIRMATION_MEMBER_ACCOUNT": "<b class=\"assertive\">Averto:</b> la sekreta identigilo, la pasvorto kaj la pseŭdonimo ne plu povos esti modifitaj.<br/><br/><b>Certiĝu, ke vi ĉiam rememorigos ĝin!</b><br/><br/><b>Ĉu vi certas</b>, ke vi deziras sendi tiun ĉi aliĝo-peton?",
      "CONFIRMATION_WALLET_ACCOUNT": "<b class=\"assertive\">Averto:</b> la sekreta identigilo kaj la pasvorto ne plu povos esti modifitaj.<br/><br/><b>Certiĝu, ke vi ĉiam rememorigos ĝin!</b><br/><br/><b>Ĉu vi certas</b>, ke vi deziras daŭrigi per tiuj ĉi identigiloj?",
      "CHECKING_PSEUDO": "Kontrolo...",
      "PSEUDO_AVAILABLE": "Pseŭdonimo disponebla",
      "PSEUDO_NOT_AVAILABLE": "Pseŭdonimo ne disponebla",
      "INFO_LICENSE": "Antaŭ ol krei membro-konton, <b>bonvolu legi kaj akcepti la licencon</b> pri uzado de la mono:",
      "BTN_ACCEPT": "Mi akceptas",
      "BTN_ACCEPT_LICENSE": "Mi akceptas la licencon"
    },
    "POPUP_REGISTER": {
      "TITLE": "Elektu pseŭdonimon",
      "HELP": "Pseŭdonimo estas deviga por fariĝi membro."
    },
    "SELECT_IDENTITY_MODAL": {
      "TITLE": "Elekto de la identeco",
      "HELP": "Pluraj <b>malsamaj identecoj</b> estis senditaj, por la publika ŝlosilo <span class=\"gray\"><i class=\"ion-key\"></i> {{pubkey|formatPubkey}}</span>.<br/>Bonvolu elekti la dosierujon uzotan:"
    },
    "SELECT_WALLET_MODAL": {
      "TITLE": "Elekto de la monujo"
    },
    "WALLET_LIST": {
      "TITLE": "Miaj monujoj",
      "BTN_NEW": "Aldoni monujon",
      "BTN_DOWNLOAD": "Elŝuti la liston",
      "BTN_IMPORT_FILE_DOTS": "Enporti el dosiero...",
      "NO_WALLET": "Neniu kroma monujo",
      "BTN_DELETE": "Forigi kroman monujon...",
      "BTN_RENAME": "Renomi la monujon",
      "EXPORT_FILENAME": "miaj_monujoj-{{pubkey|formatPubkey}}-{{currency}}.csv",
      "TOTAL_DOTS": "Sumo: ",
      "EDIT_POPOVER": {
        "TITLE": "Renomi la monujon",
        "HELP": "Sciigu la novan nomon",
        "NAME_HELP": "Nomo de la monujo"
      },
      "IMPORT_MODAL": {
        "TITLE": "Enporti monujojn",
        "HELP": "Por <b>enporti monujojn</b>, bonvolu glitigi en la ĉi-suban zonon la dosieron pri la listo de monujoj, aŭ alklaki la zonon por serĉadi dosieron.",
        "WALLET_COUNT": "<b>{{count}}</b> nova{{count > 1 ? 'j' : ''}} monujo{{count > 1 ? 'j' : ''}}",
        "NO_NEW_WALLET": "Neniu nova monujo"
      }
    },
    "SECURITY": {
      "ADD_QUESTION": "Aldoni personigitan demandon",
      "BTN_CLEAN": "Malplenigi",
      "BTN_RESET": "Restartigi",
      "DOWNLOAD_REVOKE": "Konservi mian dosieron pri nuligo",
      "DOWNLOAD_REVOKE_HELP": "Disponi dosieron pri nuligo estas grave, ekzemple kaze de perdo de viaj identigiloj. Ĝi ebligas al vi <b>elirigi tiun konton el la reto de fido</b>, tiel ke ĝi refariĝu simpla monujo.",
      "GENERATE_KEYFILE": "Krei mian dosieron pri ŝlosilaro...",
      "GENERATE_KEYFILE_HELP": "Kreas dosieron, kiu ebligas al vi aŭtentiĝi sen tajpi viajn identigilojn.<br/><b>Atenton:</b> tiu dosiero entenos vian konto-ŝlosilaron (publikan kaj sekretan ŝlosilojn); do tre gravas meti ĝin en sekuran lokon!",
      "KEYFILE_FILENAME": "ŝlosilaro-{{pubkey|formatPubkey}}-{{currency}}-{{format}}.dunikey",
      "MEMBERSHIP_IN": "Transformi en membro-konton...",
      "MEMBERSHIP_IN_HELP": "Ebligas <b>transformi</b> simplan monujo-konton <b>en membro-konton</b>, sendante aliĝo-peton. Utilas nur se vi ne havas jam alian membro-konton.",
      "SEND_IDENTITY": "Publikigi sian identecon...",
      "SEND_IDENTITY_HELP": "Ebligas kunligi pseŭdonimon kun tiu ĉi konto, sed <b>sen fari aliĝo-peton</b> por iĝi membro. Tiu kunligo kutime ne utilas, ĉar la valideco de tiu kunligo de pseŭdonimo estas limigita en la tempo.",
      "HELP_LEVEL": "Por krei konserv-dosieron pri viaj identigiloj, elektu <strong> almenaŭ {{nb}} demandojn:</strong>",
      "LEVEL": "Nivelo de sekureco",
      "LOW_LEVEL": "Malforta <span class=\"hidden-xs\">(2 demandoj minimume)</span>",
      "MEDIUM_LEVEL": "Meza <span class=\"hidden-xs\">(4 demandoj minimume)</span>",
      "QUESTION_1": "Kiel nomiĝis via plej bona amik.in.o, kiam vi estis adoleskant.in.o?",
      "QUESTION_2": "Kiel nomiĝis via unua hejm-besto?",
      "QUESTION_3": "Kiun pladon vi unue lernis kuiradi?",
      "QUESTION_4": "Kiun filmon vi unue spektis en kinejo?",
      "QUESTION_5": "Kien vi iris la unuan fojon, kiam vi vojaĝis per aviadilo?",
      "QUESTION_6": "Kiel nomiĝis via preferata instruist.i.no en bazlernejo?",
      "QUESTION_7": "Kio estus laŭ vi la ideala profesio?",
      "QUESTION_8": "Kiun libron por infanoj vi preferas?",
      "QUESTION_9": "Kio estis la marko de via unua veturilo?",
      "QUESTION_10": "Kio estis via kromnomo, kiam vi estis infano?",
      "QUESTION_11": "Kiun rolant.in.on aŭ aktor.in.on vi preferis en kino, kiam vi estis student.in.o?",
      "QUESTION_12": "Kiun kanzonist.ino.n aŭ muzikgrupon vi preferis, kiam vi estis student.in.o?",
      "QUESTION_13": "En kiu urbo renkontiĝis viaj gepatroj?",
      "QUESTION_14": "Kiel nomiĝis via unua ĉefo?",
      "QUESTION_15": "Kiel nomiĝas la strato, kie vi kreskis?",
      "QUESTION_16": "Kiel nomiĝas la marbordo, kie vi unuafoje baniĝis?",
      "QUESTION_17": "Kiun muzik-albumon vi unuafoje aĉetis?",
      "QUESTION_18": "Kiel nomiĝas via preferata sporto-teamo?",
      "QUESTION_19": "Kio estis la profesio de via avo?",
      "RECOVER_ID": "Retrovi mian pasvorton...",
      "RECOVER_ID_HELP": "Se vi disponas <b>konserv-dosieron pri viaj identigiloj</b>, vi povas retrovi ilin respondante ĝuste viajn personajn demandojn.",
      "RECOVER_ID_SELECT_FILE": "Elektu la uzotan <b>konserv-dosieron pri viaj identigiloj</b>:",
      "REVOCATION_WITH_FILE": "Nuligi mian membro-konton...",
      "REVOCATION_WITH_FILE_DESCRIPTION": "Se vi <b>definitive perdis viajn identigilojn</b> pri via membro-konto (aŭ ke la sekureco de la konto estas endanĝerigita), vi povas uzi <b>la dosieron pri nuligo</b> de la konto por <b>trudi ties definitivan eliradon el la reto de fido</b>.",
      "REVOCATION_WITH_FILE_HELP": "Por <b>definitive nuligi</b> membro-konton, bonvolu glitigi en la ĉi-suban zonon vian dosieron pri nuligo, aŭ alklaki la zonon por serĉadi dosieron.",
      "REVOCATION_WALLET": "Nuligi tiun ĉi konton tuj",
      "REVOCATION_WALLET_HELP": "Peti la nuligon de via identeco estigas la <b>eliradon el la reto de fido</b> (definitivan por la pseŭdonimo kaj la publika ŝlosilo kunligitaj). La konto ne plu povos produkti Universalan Dividendon.<br/>Vi tamen daŭre povos konektiĝi al ĝi, kiel al simpla monujo.",
      "REVOCATION_FILENAME": "nuligo-{{uid}}-{{pubkey|formatPubkey}}-{{currency}}.txt",
      "SAVE_ID": "Konservi miajn identigilojn...",
      "SAVE_ID_HELP": "Kreado de konserv-dosiero, por <b>retrovi vian pasvorton</b> (kaj la sekretan identigilon) <b>kaze de forgeso</b>. La dosiero estas <b>sekurigita</b> (ĉifrita) dank'al personaj demandoj.",
      "STRONG_LEVEL": "Forta <span class=\"hidden-xs \">(6 demandoj minimume)</span>",
      "TITLE": "Konto kaj sekureco",
      "KEYFILE": {
        "PUBSEC_FORMAT": "Strukturo PubSec.",
        "PUBSEC_FORMAT_HELP": "Tiu strukturo stokas vian ŝlosilaron laŭ tre simpla maniero. Ĝi kongruas aparte kun Cesium, ğannonce kaj Duniter.<br/><b>Atenton:</b>La dosiero <b>ne estas ĉifrita</b> (la sekreta ŝlosilo klare aperas en ĝi); bonvolu do stoki ĝin en sekura loko!",
        "WIF_FORMAT": "Strukturo WIF (Wallet Import Format) - v1",
        "WIF_FORMAT_HELP": "Tiu strukturo stokas vian ŝlosilaron inkluzivante en ĝin kontrol-sumon por kontroli la sendifektecon de la dosiero. Ĝi kongruas aparte kun la paper-monujoj (Duniter paper wallet).<br/><b>Atenton:</b>La dosiero <b>ne estas ĉifrita</b> (la sekreta ŝlosilo klare aperas en ĝi); bonvolu do stoki ĝin en sekura loko!",
        "EWIF_FORMAT": "Strukturo EWIF (Encrypted Wallet Import Format) - v1",
        "EWIF_FORMAT_HELP": "Tiu strukturo stokas vian ŝlosilaron <b>laŭ ĉifrita maniero</b> dank'al sekreta frazo elektita de vi. Ĝi ankaŭ inkluzivas kontrol-sumon por kontroli la sendifektecon de la dosiero.<br/><b>Atenton:</b> Zorgu, ke vi ĉiam rememoru vian sekretan frazon!",
	      "PASSWORD_POPUP": {
          "TITLE": "Ĉifrita dosiero pri ŝlosilaro",
          "HELP": "Bonvolu indiki la la sekretan frazon:",
          "PASSWORD_HELP": "Sekreta frazo"
        },
        "ERROR": {
          "BAD_PASSWORD": "Sekreta frazo malĝusta",
          "BAD_CHECKSUM": "Kontrol-sumo malĝusta"
        }
      }
    },
    "FILE_NAME": "{{currency}} - Konto-tabelo {{pubkey|formatPubkey}} je {{currentTime|formatDateForFile}}.csv",
    "HEADERS": {
      "TIME": "Dato",
      "AMOUNT": "Sumo",
      "COMMENT": "Komento"
    }
  },
  "TRANSFER": {
    "TITLE": "Elspezo",
    "SUB_TITLE": "Fari elspezon",
    "SUB_TITLE_ALL": "Malplenigi la konton",
    "FROM": "De",
    "TO": "Al",
    "AMOUNT": "Sumo",
    "AMOUNT_HELP": "Sumo",
    "COMMENT": "Komento",
    "COMMENT_HELP": "Komento",
    "BTN_SEND": "Sendi",
    "BTN_ADD_COMMENT": "Aldoni komenton",
    "REST": "Resto de la konto",
    "REST_TO": "al",
    "WARN_COMMENT_IS_PUBLIC": "Bonvolu noti, ke <b>la komentoj estas publikaj</b> (ne ĉifritaj).",
    "MODAL": {
      "TITLE": "Elspezo"
    }
  },
  "ERROR": {
    "UNKNOWN_URI_FORMAT": "URI-strukturo nekonata",
    "PUBKEY_INVALID_CHECKSUM": "Publika ŝlosilo nevalida (bad checksum).",
    "POPUP_TITLE": "Eraro",
    "UNKNOWN_ERROR": "Eraro nekonata",
    "CRYPTO_UNKNOWN_ERROR": "Via retumilo ŝajnas ne kongrua kun la kriptografiaj funkcioj.",
    "DOWNLOAD_KEYFILE_FAILED": "Malsukceso por la kreado de la dosiero pri ŝlosilaro.",
    "EQUALS_TO_PSEUDO": "Devas esti malsama ol la pseŭdonimo",
    "EQUALS_TO_SALT": "Devas esti malsama ol la sekreta identigilo",
    "FIELD_REQUIRED": "Deviga kampo",
    "FIELD_TOO_SHORT": "Signaro tro mallonga",
    "FIELD_TOO_SHORT_WITH_LENGTH": "Signaro tro mallonga ({{minLength}} signoj minimume)",
    "FIELD_TOO_LONG": "Signaro tro longa",
    "FIELD_TOO_LONG_WITH_LENGTH": "Signaro tro longa ({{maxLength}} signoj maksimume)",
    "FIELD_MIN": "Minimuma longeco: {{min}}",
    "FIELD_MAX": "Maksimuma longeco: {{max}}",
    "FIELD_ACCENT": "Diakritaj literoj kaj komoj ne permesataj",
    "FIELD_NOT_NUMBER": "Nombra valoro atendata",
    "FIELD_NOT_INT": "Entjera nombro atendata",
    "FIELD_NOT_EMAIL": "Retadreso nevalida",
    "PASSWORD_NOT_CONFIRMED": "Ne kongruas kun la pasvorto",
    "SALT_NOT_CONFIRMED": "Ne kongruas kun la sekreta identigilo",
    "SEND_IDENTITY_FAILED": "Aliĝo malsukcesa",
    "SEND_CERTIFICATION_FAILED": "Atestado malsukcesa",
    "NEED_MEMBER_ACCOUNT_TO_CERTIFY": "Vi ne povas efektivigi atestadon, ĉar via konto <b>ne estas membro</b>.",
    "NEED_MEMBER_ACCOUNT_TO_CERTIFY_HAS_SELF": "Vi ne povas efektivigi atestadon, ĉar via konto ankoraŭ ne estas membro.<br/><br/>Ankoraŭ mankas al vi atestaĵoj, aŭ tiuj ĉi ankoraŭ ne estis validigitaj.",
    "IDENTITY_TO_CERTIFY_HAS_NO_SELF": "Konto ne atestebla. Neniu aliĝo-peto estis farita, aŭ la aliĝo ne estis revalidigita.",
    "LOGIN_FAILED": "Eraro dum konektiĝo.",
    "LOAD_IDENTITY_FAILED": "Eraro por ŝarĝi la identecon.",
    "LOAD_REQUIREMENTS_FAILED": "Eraro por ŝarĝi la antaŭ-necesaĵoj de la identeco.",
    "SEND_MEMBERSHIP_IN_FAILED": "Malsukceso pri la provado eniri la komunumon.",
    "SEND_MEMBERSHIP_OUT_FAILED": "Malsukceso pri la ĉesigo de la aliĝo.",
    "REFRESH_WALLET_DATA": "Malsukceso pri la ĝisdatigo de la monujo.",
    "GET_CURRENCY_PARAMETER": "Malsukceso por ricevi la regulojn de la mono.",
    "GET_CURRENCY_FAILED": "Ne eblis ŝarĝi la monon. Bonvolu reprovi pli poste.",
    "SEND_TX_FAILED": "Elspezado malsukcesa.",
    "ALL_SOURCES_USED": "Bonvolu atendi la kalkulon de la venonta bloko (ĉiuj viaj monfontoj estis uzitaj).",
    "NOT_ENOUGH_SOURCES": "Ne sufiĉe da mono por sendi tiun ĉi sumon per ununura spezo.<br/>Maksimuma sumo: {{amount}} {{unit}}<sub>{{subUnit}}</sub>.",
    "ACCOUNT_CREATION_FAILED": "Malsukceso por krei la membro-konton.",
    "RESTORE_WALLET_DATA_ERROR": "Malsukceso por reŝarĝi la parametrojn de la loka stokaĵo",
    "LOAD_WALLET_DATA_ERROR": "Malsukceso por ŝarĝi la datenojn de la monujo.",
    "COPY_CLIPBOARD_FAILED": "Ne eblis kopii la valoron.",
    "TAKE_PICTURE_FAILED": "Malsukceso por ricevi la foton.",
    "SCAN_FAILED": "Malsukceso por skani la QR-kodon.",
    "SCAN_UNKNOWN_FORMAT": "Kodo nerekonata.",
    "WOT_LOOKUP_FAILED": "Serĉado malsukcesa.",
    "LOAD_PEER_DATA_FAILED": "Ne eblis legi la nodon Duniter. Bonvolu reprovi poste.",
    "NEED_LOGIN_FIRST": "Bonvolu unue konektiĝi.",
    "AMOUNT_REQUIRED": "La monsumo estas deviga.",
    "AMOUNT_NEGATIVE": "Negativa sumo nepermesata.",
    "NOT_ENOUGH_CREDIT": "Saldo nesufiĉa.",
    "INVALID_NODE_SUMMARY": "Nodo neatingebla aŭ adreso nevalida.",
    "INVALID_USER_ID": "La pseŭdonimo devas enteni nek spacon nek signon specialan aŭ kun supersigno.",
    "INVALID_COMMENT": "La kampo 'referenco' ne devas enteni literojn kun supersigno.",
    "INVALID_PUBKEY": "La publika ŝlosilo ne havas la atenditan strukturon.",
    "INVALID_PUBKEY_CHECKSUM": "Kontrol-sumo nevalida.",
    "IDENTITY_REVOKED": "Tiu ĉi identeco <b>estis nuligita</b>. Ĝi ne plu povas fariĝi membro.",
    "IDENTITY_REVOKED_WITH_TIME": "Tiu ĉi identeco <b>estis nuligita {{revocationTime|medianFromNow}}</b> ({{revocationTime|medianDate}}). Ĝi ne plu povas fariĝi membro.",
    "IDENTITY_PENDING_REVOCATION": "La <b>nuligo de tiu ĉi identeco</b> estis petita kaj atendas traktadon. La atestado estas do malaktivigita.",
    "IDENTITY_INVALID_BLOCK_HASH": "Tiu ĉi aliĝo-peto ne plu validas (ĉar ĝi rilatas al bloko, kiun nuligis la nodoj de la reto): tiu persono devas refari sian aliĝo-peton <b>antaŭ ol</b> esti atestita.",
    "IDENTITY_EXPIRED": "La publikigo de tiu ĉi identeco finiĝis: tiu persono devas fari novan aliĝo-peton <b>antaŭ ol</b> esti atestita.",
    "IDENTITY_SANDBOX_FULL": "La nodo Duniter uzata de Cesium ne plu povas ricevi novajn identecojn, ĉar ĝia atendo-vico estas plena.<br/><br/>Bonvolu reprovi poste aŭ ŝanĝi la nodon (per la menuo <b>Parametroj</b>).",
    "IDENTITY_NOT_FOUND": "Identeco ne trovita.",
    "IDENTITY_TX_FAILED": "Malsukceso por ŝarĝi la spezojn.",
    "WOT_PENDING_INVALID_BLOCK_HASH": "Aliĝo ne valida.",
    "WALLET_INVALID_BLOCK_HASH": "Via aliĝo-peto ne plu validas (ĉar ĝi rilatas al bloko, kiun nuligis la nodoj de la reto).<br/>Vi devas <a ng-click=\"doQuickFix('fixMembership')\">sendi novan peton</a> por solvi tiun ĉi problemon.",
    "WALLET_IDENTITY_EXPIRED": "La publikigo de <b>via identeco finiĝis</b>.<br/>Vi devas <a ng-click=\"doQuickFix('fixIdentity')\">publikigi denove vian identecon</a> por solvi tiun ĉi problemon.",
    "WALLET_REVOKED": "Via identeco estis <b>nuligita</b>: nek via pseŭdonimo nek via publika ŝlosilo povos esti uzata en la estonteco por membro-konto.",
    "WALLET_HAS_NO_SELF": "Via identeco devas unue esti publikigita, kaj ne esti finiĝinta.",
    "AUTH_REQUIRED": "Aŭtentigado necesa.",
    "AUTH_INVALID_PUBKEY": "La atendata ŝlosilo estas <i class=\"ion-key\"></i> {{pubkey|formatPubkey}}...",
    "AUTH_INVALID_SCRYPT": "Identigilo aŭ pasvorto nevalida.",
    "AUTH_INVALID_FILE": "Dosiero pri ŝlosilaro nevalida.",
    "AUTH_FILE_ERROR": "Malsukceso por malfermi la dosieron pri ŝlosilaro.",
    "IDENTITY_ALREADY_CERTIFY": "Vi <b>jam atestis</b> tiun identecon.<br/><br/>Tiu atestado daŭre validas (finiĝo {{expiresIn|formatDurationTo}}).",
    "IDENTITY_ALREADY_CERTIFY_PENDING": "Vi <b>jam atestis</b> tiun identecon.<br/><br/>Tiu atestado atendas traktadon (limdato de traktado {{expiresIn|formatDurationTo}}).",
    "UNABLE_TO_CERTIFY_TITLE": "Atestado neebla",
    "LOAD_NEWCOMERS_FAILED": "Malsukceso por ŝarĝi la novajn membrojn.",
    "LOAD_PENDING_FAILED": "Malsukceso por ŝarĝi la atendantajn aliĝojn.",
    "ONLY_MEMBER_CAN_EXECUTE_THIS_ACTION": "Vi devas <b>esti membro</b> por rajti efektivigi tiun ĉi agon.",
    "ONLY_MEMBER_OR_WAS_MEMBER_CAN_EXECUTE_THIS_ACTION": "Vi devas <b>esti membro (aŭ eksa membro)</b> por rajti efektivigi tiun ĉi agon.",
    "ONLY_SELF_CAN_EXECUTE_THIS_ACTION": "Via identeco devas <b>jam esti publikigita</b>, por ke vi rajtu efektivigi tiun ĉi agon.",
    "GET_BLOCK_FAILED": "Malsukceso por ricevi la blokon.",
    "INVALID_BLOCK_HASH": "Bloko ne trovita (haketo malsama)",
    "DOWNLOAD_REVOCATION_FAILED": "Malsukceso por elŝuti la dosieron pri nuligo.",
    "REVOCATION_FAILED": "Malsukceso pri nuligo.",
    "SALT_OR_PASSWORD_NOT_CONFIRMED": "Sekreta identigilo aŭ pasvorto malĝusta.",
    "RECOVER_ID_FAILED": "Malsukceso por ricevi la identigilojn",
    "LOAD_FILE_FAILED" : "Malsukceso por ŝarĝi la dosieron",
    "NOT_VALID_REVOCATION_FILE": "Dosiero pri nuligo ne valida (malĝusta strukturo de dosiero)",
    "NOT_VALID_SAVE_ID_FILE": "Dosiero pri konservado ne valida (malĝusta strukturo de dosiero)",
    "NOT_VALID_KEY_FILE": "Dosiero pri ŝlosilaro ne valida (strukturo ne rekonata)",
    "EXISTING_ACCOUNT": "Viaj identigiloj rilatas al jam ekzistanta konto, kies <a ng-click=\"showHelpModal('pubkey')\">publika ŝlosilo</a> estas:",
    "EXISTING_ACCOUNT_REQUEST": "Bonvolu modifi viajn identigilojn, por ke ili rilatu al ne uzata konto.",
    "GET_LICENSE_FILE_FAILED": "La ricevo de la dosiero pri licenco ne eblis.",
    "CHECK_NETWORK_CONNECTION": "Neniu nodo ŝajnas atingebla.<br/><br/>Bonvolu <b>kontroli vian retkonekton</b>.",
    "ISSUE_524_TX_FAILED": "Malsukcesa elspezo.<br/><br/>Mesaĝo estis sendita al la programistoj por faciligi la solvadon de la problemo. <b>Dankon pro via helpo</b>.",
    "ADD_SECONDARY_WALLET_FAILED": "Malsukceso por aldoni kroman monujon.",
    "REMOVE_SECONDARY_WALLET_FAILED": "Malsukceso por forigi la kroman monujon.",
    "UPDATE_WALLET_LIST_FAILED": "Malsukceso por ĝisdatigi la kromajn monujojn.",
    "LOAD_WALLET_LIST_FAILED": "Malsukceso por ŝarĝi la kromajn monujojn.",
    "SAVE_WALLET_LIST_FAILED": "Malsukceso por konservi la kromajn monujojn.",
    "COULD_NOT_ADD_MAIN_WALLET": "Tiu ĉi monujo <b>rilatas al la ĉefa konto</b>, kun kiu vi estas konektita.<br/>Ne eblas aldoni ĝin kiel kroman monujon.",
    "COULD_NOT_ADD_EXISTING_WALLET": "Monujo jam ekzistanta en la listo.",
    "UNKNOWN_WALLET_ID": "Kroma monujo nekonata.",
    "RESTORE_WALLET_LIST_FAILED": "Malsukceso por restarigi la kromajn monujojn.",
    "INVALID_FILE_FORMAT": "Strukturo de dosiero nevalida.",
    "SAME_TX_RECIPIENT": "La adresito devas malsami ol la sendanto."
  },
  "INFO": {
    "POPUP_TITLE": "Informo",
    "CERTIFICATION_DONE": "Atestaĵo sendita",
    "NOT_ENOUGH_CREDIT": "Saldo nesufiĉa",
    "TRANSFER_SENT": "Elspezo sendita",
    "COPY_TO_CLIPBOARD_DONE": "Kopiita en la memoreto",
    "MEMBERSHIP_OUT_SENT": "Eksiĝo sendita",
    "NOT_NEED_MEMBERSHIP": "Vi jam estas membro.",
    "IDENTITY_WILL_MISSING_CERTIFICATIONS": "Al tiu ĉi identeco baldaŭ mankos atestaĵoj (almenaŭ {{willNeedCertificationCount}}).",
    "IDENTITY_NEED_MEMBERSHIP": "Tiu ĉi identeco ne sendis aliĝo-peton. Tion ĝi devos fari, se ĝi deziras fariĝi membro.",
    "HAS_ALTERNATIVE_IDENTITIES": "Ekzistas <b>pluraj identecoj</b> ligitaj kun tiu ĉi publika ŝlosilo. <b>Antaŭ ĉia atestado</b>, pensu <a ng-click=\"doQuickFix('showSelectIdentities')\">trarigardi la aliajn identecojn</a> por elekti la ĝustan, aŭ kontaktu la posedanton de la konto.",
    "REVOCATION_SENT": "Nuligo sendita",
    "REVOCATION_SENT_WAITING_PROCESS": "La <b>nuligo de tiu ĉi identeco</b> estis petita kaj atendas traktadon.",
    "FEATURES_NOT_IMPLEMENTED": "Tiu ĉi funkciaro ankoraŭ estas programiĝanta.<br/>Kial ne <b>kontribui al Cesium</b>, por ekhavi ĝin pli rapide? ;)",
    "EMPTY_TX_HISTORY": "Neniu spezo elportota"
  },
  "CONFIRM": {
    "POPUP_TITLE": "<b>Konfirmo</b>",
    "POPUP_WARNING_TITLE": "<b>Averto</b>",
    "POPUP_SECURITY_WARNING_TITLE": "<i class=\"icon ion-alert-circled\"></i> <b>Averto pri sekureco</b>",
    "CERTIFY_RULES_TITLE_UID": "Atesti {{uid}}",
    "CERTIFY_RULES": "<b class=\"assertive\">NE atestu</b> konton, se vi pensas ke:<br/><br/><ul><li>1.) ĝi ne rilatas al persono <b>fizika kaj vivanta</b>.<li>2.) ĝia posedanto <b>havas alian konton</b> jam atestitan.<li>3.) ĝia posedanto malobservas (vole aŭ ne) la regulon 1 aŭ 2 (ekzemple atestante falsajn kontojn aŭ duoblajn).</ul><br/><b>Ĉu vi certas,</b> ke vi tamen volas atesti tiun ĉi identecon?",
    "FULLSCREEN": "Afiŝi la programon plen-ekrane?",
    "EXIT_APP": "Fermi la programon?",
    "TRANSFER": "<b>Resumo de la elspezo</b> :<br/><br/><ul><li> - De: {{from}}</li><li> - Al: <b>{{to}}</b></li><li> - Sumo: <b>{{amount}} {{unit}}</b></li><li> - Komento: <i>{{comment}}</i></li></ul><br/><b>Ĉu vi certas, ke vi volas efektivigi tiun ĉi elspezon?</b>",
    "TRANSFER_ALL": "<b>Resumo de la elspezo</b>:<br/><br/><ul><li> - De : {{from}}</li><li> - Al : <b>{{to}}</b></li><li> - Sumo: <b>{{amount}} {{unit}}</b></li><li> - Komento: <i>{{comment}}</i></li><br/><li> - Resto: <b>{{restAmount}} {{unit}}</b> al <b>{{restTo}}</b></li></ul><br/><b>Ĉu vi certas, ke vi volas efektivigi tiun ĉi elspezon?</b>",
    "MEMBERSHIP_OUT": "Tiu ĉi ago estas <b>neinversigebla</b>.<br/></br/>Ĉu vi certas, ke vi volas <b>nuligi vian membro-konton</b>?",
    "MEMBERSHIP_OUT_2": "Tiu ĉi ago estas <b>neinversigebla</b> !<br/><br/>Ĉu vi vere certas, ke vi volas <b>nuligi vian aliĝon</b> kiel membron?",
    "LOGIN_UNUSED_WALLET_TITLE": "Tajperaro?",
    "LOGIN_UNUSED_WALLET": "La konektita konto ŝajnas <b>neaktiva</b>.<br/><br/>Temas probable pri <b>tajperaro</b> en viaj konekto-identigiloj. Bonvolu rekomenci, kontrolante ke <b>la publika ŝlosilo estas tiu de via konto</b>.",
    "FIX_IDENTITY": "La pseŭdonimo <b>{{uid}}</b> estos denove publikigita, anstataŭigante la malnovan publikigon, kiu finiĝis.<br/></br/><b>Ĉu vi certas</b>, ke vi volas daŭrigi?",
    "FIX_MEMBERSHIP": "Via aliĝo-peto kiel membro tuj estos resendita.<br/></br/><b>Ĉu vi certas</b>, ke vi volas daŭrigi?",
    "MEMBERSHIP": "Via aliĝo-peto kiel membro tuj estos sendita.<br/></br/><b>Ĉu vi certas</b>, ke vi volas daŭrigi?",
    "RENEW_MEMBERSHIP": "Via aliĝo kiel membro tuj estos revalidigita.<br/></br/><b>Ĉu vi certas</b>, ke vi volas daŭrigi?",
    "REVOKE_IDENTITY": "Vi estas <b>nuligonta definitive tiun ĉi identecon</b>.<br/><br/>La publika ŝlosilo kaj la ligita pseŭdonimo <b>neniam plu povos esti uzataj</b> (por membro-konto). <br/></br/><b>Ĉu vi certas</b>, ke vi volas definitive nuligi tiun ĉi konton?",
    "REVOKE_IDENTITY_2": "Tiu ĉi ago estas <b>neinversigebla</b>!<br/><br/>Ĉu vi vere certas, ke vi volas <b>definitive nuligi</b> tiun ĉi konton?",
    "NOT_NEED_RENEW_MEMBERSHIP": "Via aliĝo ne bezonas esti revalidigita (ĝi finiĝos nur post {{membershipExpiresIn|formatDuration}}).<br/></br/><b>Ĉu vi certas</b>, ke vi volas revalidigi vian aliĝon?",
    "SAVE_BEFORE_LEAVE": "Ĉu vi volas <b>konservi viajn modifojn</b> antaŭ ol eliri el la paĝo?",
    "SAVE_BEFORE_LEAVE_TITLE": "Modifoj ne registritaj",
    "LOGOUT": "Ĉu vi certas, ke vi volas malkonektiĝi?",
    "USE_FALLBACK_NODE": "Nodo <b>{{old}}</b> neatingebla aŭ adreso nevalida.<br/><br/>Ĉu vi volas provizore uzi la nodon <b>{{new}}</b> ?",
    "ISSUE_524_SEND_LOG": "La spezo estis forĵetita, pro konata anomalio (petslipo #524) sed <b>ne ripetita</b>.<br/><br/>Por helpi la programistojn korekti tiun eraron, <b>ĉu vi akceptas la sendadon de viaj protokolaj dosieroj</b> per mesaĝo?<br/><small>(neniu konfidenca dateno estas sendita)</small>."
  },
  "MODE": {
    "DEMO": {
      "BADGE": "Provo",
      "MODE": "Provmontra moduso",
      "FEATURE_NOT_AVAILABLE": "Funkcio <b>ne disponebla</b> en tiu ĉi provmontra retejo.",
      "MODE_HELP": "Cesium funkcias en <b>provmontra moduso</b>: Konsultado de konto eblas, sed neniu operacio povos esti registrita.",
      "INSTALL_HELP": "Pro <b>sekurecaj kialoj</b> ni rekomendas al vi <b>instali</b> vian kopion de la programo Cesium. Vizitu la retejon <a href='https://cesium.app'>www.cesium.app</a> por ricevi helpon."
    },
    "READONLY": {
      "BADGE": "Observo",
      "MODE": "Observada moduso",
      "MODE_HELP": "Cesium funkcias en <b>observada moduso</b>: disponeblas nur la funkciaro pri observado de la valuto.",
      "INSTALL_HELP": "Se vi deziras <b>krei monuj-konton</b> por sendi aŭ ricevi monon, ni rekomendas al vi <b>instali vian kopion</b> de la programo Cesium. Vizitu la retejon <a href='https://cesium.app'>www.cesium.app</a> por ricevi helpon."
    }
  },
  "DOWNLOAD": {
    "POPUP_TITLE": "<b>Dosiero pri nuligo</b>",
    "POPUP_REVOKE_MESSAGE": "Por sekurigi vian konton, bonvolu elŝuti la <b>dokumenton pri konto-nuligo</b>. Ĝi ebligos al vi eventuale nuligi vian konton (kaze de konto-ŝtelo, ŝanĝo de identigilo, konto erare kreita, ktp.).<br/><br/><b>Bonvolu stoki ĝin en sekura loko.</b>"
  },
  "HELP": {
    "TITLE": "Ret-helpo",
    "JOIN": {
      "SECTION": "Enskribiĝo",
      "SALT": "La sekreta identigilo estas tre grava. Ĝi utilas por miksi la pasvorton, antaŭ ol ĝi servos por kalkuli la <span class=\"text-italic\">publikan ŝlosilon</span> de via konto (ties numeron) kaj la sekretan ŝlosilon por aliri ĝin.<br/><b>Zorgu pri ĝia bona memorigado</b>, ĉar neniu rimedo estas nuntempe planita por retrovi ĝin kaze de perdo.<br/>Krom tio, ĝi ne povas esti modifita sen devige krei novan konton.<br/><br/>Bona sekreta identigilo devas esti sufiĉe longa (kun almenaŭ 8 signoj) kaj kiel eble plej originala.",
      "PASSWORD": "La pasvorto estas tre grava. Kun la sekreta identigilo, ĝi servas por kalkuli la numeron (la publikan ŝlosilon) de via konto, kaj la sekretan ŝlosilon por aliri ĝin.<br/><b>Zorgu pri ĝia bona memorigado</b>, ĉar neniu rimedo estas planita por retrovi ĝin kaze de perdo (krom se oni generas konserv-dosieron).<br/>Krom tio, ĝi ne povas esti modifita sen devige krei novan konton.<br/><br/>Bona pasvorto entenas (ideale) almenaŭ 8 signojn, inter kiuj estas almenaŭ unu majusklo kaj unu cifero.",
      "PSEUDO": "La pseŭdonimo estas utila nur kaze de enskribiĝo kiel <span class=\"text-italic\">membro</span>. Ĝi ĉiam estas ligita kun monujo (tra ĝia <span class=\"text-italic\">publika ŝlosilo</span>).<br/>Ĝi estas publikigita en la reto, tiel ke la aliaj uzantoj povu identigi ĝin, atesti ĝin aŭ sendi monon al ĝia konto.<br/>Pseŭdonimo devas esti unika ene de la membroj (<u>nunaj</u> kaj eksaj)."
    },
    "LOGIN": {
      "SECTION": "Konekto",
      "PUBKEY": "Publika ŝlosilo de la ŝlosilaro",
      "PUBKEY_DEF": "La publika ŝlosilo de la ŝlosilaro estas kreita per la tajpitaj identigiloj (iuj ajn), sen ke ili necese rilatu al konto jam uzata.<br/><b>Atente kontrolu, ke la publika ŝlosilo estas tiu de via konto</b>. Alikaze, vi estos konektita al konto probable neniam uzita, la risko de kolizio kun ekzistanta konto estante tre eta.<br/><a href=\"https://fr.wikipedia.org/wiki/Cryptographie_asym%C3%A9trique\" target=\"_system\">Scii pli pri kriptografio</a> per publika ŝlosilo.",
      "METHOD": "Konekto-metodoj",
      "METHOD_DEF": "Pluraj eblecoj disponeblas por konekti vin al monujo:<br/> - La konekto <b>per salumado (simpla aŭ sperta)</b> miksas vian pasvorton dank'al la sekreta identigilo, por limigi la provojn de <a href=\"https://fr.wikipedia.org/wiki/Attaque_par_force_brute\" target=\"_system\">kodrompado per kruda forto</a> (ekzemple per konataj vortoj.<br/> - La konekto <b>per publika ŝlosilo</b> evitigas tajpi viajn identigilojn, kiuj estos petataj de vi, nur kiam venos la momento dum operacio ĉe la konto.<br/> - La konekto <b>per dosiero pri ŝlosilaro</b> legas la ŝlosilojn (publikan kaj privatan) de la konto, per dosiero, sen la bezono tajpi identigilojn. Pluraj strukturoj de dosiero eblas."
    },
    "GLOSSARY": {
      "SECTION": "Glosaro",
      "PUBKEY_DEF": "Publika ŝlosilo identigas monujon, kiu povas identigi membron aŭ rilati al anonima monujo. Ĉe Cesium la publika ŝlosilo estas kalkulita (implicite) dank'al la sekreta identigilo kaj la pasvorto.<br/><a href=\"https://fr.wikipedia.org/wiki/Cryptographie_asym%C3%A9trique\" target=\"_system\">Scii pli pri kriptografio</a> per publika ŝlosilo.",
      "MEMBER": "Membro",
      "MEMBER_DEF": "Membro estas homa persono fizika kaj vivanta, kiu deziras libere partopreni en la mona komunumo. Li/ŝi kunproduktas universalan dividendon, laŭ periodo kaj sumo tiel difinitaj kiel en la <span class=\"text-italic\">reguloj de la mono</span>",
      "CURRENCY_RULES": "Reguloj de la mono",
      "CURRENCY_RULES_DEF": "La reguloj de la mono estas difinitaj definitive. Ili fiksas la funkciadon de la mono: la kalkulon de la universala dividendo, la nombron de necesaj atestaĵoj por esti membro, la maksimuman nombron da atestaĵoj, kiujn povas doni unu membro, ktp. <a href=\"#/app/currency\">Vidi la nuntempajn regulojn</a>.<br/>La nemodifo de la reguloj tra la tempo eblas per uzado de <span class=\"text-italic\">Blokĉeno</span>, kiu entenas kaj plenumas tiujn regulojn, kaj konstante kontrolas ties ĝustan aplikadon.",
      "BLOCKCHAIN": "Ĉeno de blokoj (<span class=\"text-italic\">Blokchain/Blokĉeno</span>)",
      "BLOCKCHAIN_DEF": "La Blokĉeno estas malcentrigita sistemo, kiu, kaze de Duniter, servas por enteni kaj plenumi la <span class=\"text-italic\">regulojn de la mono</span>.<br/><a href=\"https://duniter.org/fr/comprendre/\" target=\"_system\">Scii pli pri Duniter</a> kaj la funkciado de ties blokĉeno.",
      "UNIVERSAL_DIVIDEND_DEF": "La Universala Dividendo (UD) estas la kvanto de mono kunkreita de ĉiu membro, laŭ la periodo kaj kalkulo difinitaj en la <span class=\"text-italic\">reguloj de la mono</span>.<br/>Por ĉiu perioda dato, la membroj ricevas en sian konton la saman kvanton da nova mono.<br/><br/>La UD spertas regulan kreskon, por resti justa inter la membroj (nunaj kaj venontaj), kalkulitan depende de la meza vivespero, kiel estas demonstrite en la Teorio Relativa pri la Mono (TRM).<br/><a href=\"http://trm.creationmonetaire.info\" target=\"_system\">Scii pli pri la TRM</a> kaj la liberaj monoj.",
      "WOT": "Reto de Fido (RdF)",
      "WOT_DEF": "La Reto de Fido konsistas el la tuto de la membroj de la mono, kaj el la atesto-ligoj, kiuj kunligas ilin.",
      "DISTANCE_RULE": "Regulo pri distanco",
      "DISTANCE_RULE_DEF": "La regulo pri distanco de la Reto de Fido difinas <b>maksimuman distancon nepran</b> inter petanto kaj minimuma nombro da referencaj membroj (aŭ centraj membroj). Tiu distanco estas kalkulita uzante la ligojn inter atestaĵoj."
    },
    "TIP": {
      "MENU_BTN_CURRENCY": "La menuo <b>{{'MENU.CURRENCY'|translate}}</b> ebligas konsulti la <b>regulojn de la mono</b> kaj ties staton.",
      "CURRENCY_WOT": "La <b>nombro de membroj</b> montras la gravecon de la komunumo kaj ebligas <b>sekvi ties evoluon</b>.",
      "CURRENCY_MASS": "Sekvu ĉi tie la <b>ĉioman kvanton da mono</b> ekzistanta kaj ties <b>mezan distribuon</b> por membro.<br/><br/>Tio ĉi ebligas taksi la <b>gravecon de iu sumo</b>, kompare kun tio, kion <b>posedas la aliuloj</b> en sia konto (mezume).",
      "CURRENCY_UNIT_RELATIVE": "La unuo uzata (&ldquo;<b>{{'COMMON.UD'|translate}}<sub>{{currency|abbreviate}}</sub></b>&rdquo;) signifas, ke la sumoj en {{currency|capitalize}} estis dividitaj per la <b> Universala Dividendo</b> (UD).<br/><br/><small>Tiu relativa unuo estas <b>trafa</b>, ĉar stabila malgraŭ la kvanto de mono, kiu kreskas seninterrompe.</small>",
      "CURRENCY_CHANGE_UNIT": "La kromaĵo <b>{{'COMMON.BTN_RELATIVE_UNIT'|translate}}</b> ebligas <b>ŝanĝi la unuon</b>, por vidigi la sumojn <b>rekte en {{currency|capitalize}}</b> (prefere ol en &ldquo;<b>{{'COMMON.UD'|translate}}<sub>{{currency|abbreviate}}</sub></b>&rdquo;).",
      "CURRENCY_CHANGE_UNIT_TO_RELATIVE": "La kromaĵo <b>{{'COMMON.BTN_RELATIVE_UNIT'|translate}}</b> ebligas <b>ŝanĝi la unuon</b>, por vidigi la sumojn en &ldquo;<b>{{'COMMON.UD'|translate}}<sub>{{currency|abbreviate}}</sub></b>&rdquo;, tio estas rilate al la Universala Dividendo (la sumo kunproduktita de ĉiu membro).",
      "CURRENCY_RULES": "La <b>reguloj</b> de la mono fiksas ties funkciadon <b>ĝustan kaj antaŭvideblan</b>.<br/><br/>Vera DNA de la mono, ili igas sian monan kodon <b>legebla kaj travidebla</b>.",
      "MENU_BTN_NETWORK": "La menuo <b>{{'MENU.NETWORK'|translate}}</b> ebligas konsulti la staton de la reto.",
      "NETWORK_BLOCKCHAIN": "Ĉiuj operacioj pri la mono estas registritaj en granda konto-libro <b>publika kaj nefalsigebla</b>, ankaŭ nomata <b>blokĉeno</b> (<em>BlockChain</em> en la angla).",
      "NETWORK_PEERS": "La <b>nodoj</b> videblaj ĉi tie rilatas al la <b>komputiloj, kiuj ĝisdatigas kaj kontrolas</b> la blokĉenon.<br/><br/>Ju pli estas nodoj, des pli la mono havas administradon <b>malcentrigitan</b> kaj fidindan.",
      "NETWORK_PEERS_BLOCK_NUMBER": "Tiu ĉi <b>numero</b> (verda) indikas la <b>lastan blokon validigitan</b> por tiu ĉi nodo (lasta paĝo skribita en la granda konto-libro).<br/><br/>La verda koloro indikas, ke tiu ĉi bloko estas validigita ankaŭ de <b>la plej multaj el la aliaj nodoj</b>.",
      "NETWORK_PEERS_PARTICIPATE": "<b>Ĉiu membro</b>, ekipita per komputilo kun interreto, <b>povas partopreni aldonante nodon</b>. Sufiĉas <b>instali la programon Duniter</b> (libera kaj senpaga). <a href=\"{{installDocUrl}}\" target=\"_system\">Vidi la gvidilon pri instalado &gt;&gt;</a>.",
      "MENU_BTN_ACCOUNT": "La menuo <b>{{'MENU.ACCOUNT'|translate}}</b> ebligas aliri la administradon de via konto.",
      "MENU_BTN_ACCOUNT_MEMBER": "Konsultu ĉi tie la staton de via konto kaj la informojn pri viaj atestaĵoj.",
      "WALLET_CERTIFICATIONS": "Alklaku ĉi tien por konsulti la detalon pri viaj atestaĵoj (ricevitaj kaj senditaj).",
      "WALLET_RECEIVED_CERTIFICATIONS": "Alklaku ĉi tien por konsulti la detalon pri viaj <b>ricevitaj atestaĵoj</b>.",
      "WALLET_GIVEN_CERTIFICATIONS": "Alklaku ĉi tien por konsulti la detalon pri viaj <b>senditaj atestaĵoj</b>.",
      "WALLET_BALANCE": "La <b>saldo</b> de via konto afiŝiĝas tie ĉi.",
      "WALLET_BALANCE_RELATIVE": "{{'HELP.TIP.WALLET_BALANCE'|translate}}<br/><br/>La uzata unuo (&ldquo;<b>{{'COMMON.UD'|translate}}<sub>{{currency|abbreviate}}</sub></b>&rdquo;) signifas, ke la sumo en {{currency|capitalize}} estis dividita per la <b>Universala Dividendo</b> (UD) kunkreita de ĉiu membro.<br/><br/>Nuntempe 1 UD valoras {{currentUD|formatInteger}} {{currency|capitalize}}j.",
      "WALLET_BALANCE_CHANGE_UNIT": "Vi povos <b>ŝanĝi la unuon</b> afiŝitan por la sumoj en la <b><i class=\"icon ion-android-settings\"></i>&nbsp;{{'MENU.SETTINGS'|translate}}</b>.<br/><br/>Ekzemple por vidigi la sumojn <b>rekte en {{currency|capitalize}}</b>, prefere ol en relativa unuo.",
      "WALLET_PUBKEY": "Jen la publika ŝlosilo de via konto. Vi povas sciigi ĝin al aliulo, por ke li identigu pli simple vian konton.",
      "WALLET_SEND": "Efektivigi pagon per kelkaj klakoj.",
      "WALLET_SEND_NO_MONEY": "Efektivigi pagon per kelkaj klakoj.<br/>(Via saldo ankoraŭ ne permesas tion)",
      "WALLET_OPTIONS": "Tiu ĉi butono ebligas aliri la <b>agojn pri aliĝo</b> kaj sekureco.<br/><br/>Ne forgesu okulumi al ĝi!",
      "WALLET_RECEIVED_CERTS": "Afiŝiĝos ĉi tie la listo de la personoj, kiuj atestis vin.",
      "WALLET_CERTIFY": "La butono <b>{{'WOT.BTN_SELECT_AND_CERTIFY'|translate}}</b> ebligas elekti identecon kaj atesti ĝin.<br/><br/>Nur uzantoj <b>jam membroj</b> povas atesti aliajn.",
      "WALLET_CERT_STOCK": "Via stoko da atestaĵoj (senditaj) estas limigita je <b>{{sigStock}} atestaĵoj</b>.<br/><br/>Tiu stoko plu evoluas laŭ la tempo, samtempe kiam la atestaĵoj malvalidiĝas.",
      "MENU_BTN_WALLETS": "La menuo <b>{{'MENU.WALLETS'|translate}}</b> ebligas aldoni kromajn monujojn, kiujn vi mastrumas.",
      "MENU_BTN_TX": "La menuo <b>{{'MENU.TRANSACTIONS'|translate}}</b> ebligas konsulti vian saldon, la histori-liston de viaj spezoj, kaj sendi pagon.",
      "MENU_BTN_WOT": "La menuo <b>{{'MENU.WOT'|translate}}</b> ebligas traserĉi inter la <b>uzantoj</b> de la mono (membroj aŭ ne).",
      "WOT_SEARCH_TEXT_XS": "Por traserĉi en la kontaro, tajpu la <b>unuajn literojn de pseŭdonimo</b> (aŭ de publika ŝlosilo).<br/><br/>La serĉado ekos aŭtomate.",
      "WOT_SEARCH_TEXT": "Por traserĉi en la kontaro, tajpu la <b>unuajn literojn de de pseŭdonimo</b> (aŭ de publika ŝlosilo). <br/><br/>Premu poste sur la klavon <b>Enigi</b> por ekigi la serĉadon.",
      "WOT_SEARCH_RESULT": "Vidigu la detalan slipon simple <b>alklakante</b> linion.",
      "WOT_VIEW_CERTIFICATIONS": "La linio <b>{{'ACCOUNT.CERTIFICATION_COUNT'|translate}}</b> montras kiom da membroj validigis tiun ĉi identecon.<br/><br/>Tiuj atestaĵoj pruvas, ke la konto apartenas al <b>persono homa kaj vivanta</b>, havanta <b>neniun alian membro-konton</b>.",
      "WOT_VIEW_CERTIFICATIONS_COUNT": "Necesas almenaŭ <b>{{sigQty}} atestaĵoj</b> por fariĝi membro kaj ricevi la <b>Universalan Dividendon</b>.",
      "WOT_VIEW_CERTIFICATIONS_CLICK": "Alklaki ĉi tien ebligas malfermi <b>la liston de ĉiuj atestaĵoj</b> de la identeco (ricevitaj kaj senditaj).",
      "WOT_VIEW_CERTIFY": "La butono <b>{{'WOT.BTN_CERTIFY'|translate}}</b> ebligas aldoni vian atestaĵon al tiu identeco.",
      "CERTIFY_RULES": "<b>Atenton:</b> Atestu nur <b>personojn fizikajn vivantajn</b>, posedantajn neniun alian membro-konton.<br/><br/>La sekureco de la mono dependas de ĉies atentego!",
      "MENU_BTN_SETTINGS": "La <b>{{'MENU.SETTINGS'|translate}}</b> ebligos al vi agordi la programon.",
      "HEADER_BAR_BTN_PROFILE": "Alklaku ĉi tien por aliri vian <b>uzanto-profilon.</b>",
      "SETTINGS_CHANGE_UNIT": "Vi povos <b>ŝanĝi la afiŝ-unuon</b> de la sumoj alklakante ĉi-supren.<br/><br/>- Malaktivigu la kromaĵon por afiŝi sumojn en {{currency|capitalize}}.<br/>- Aktivigu la kromaĵon por relativa afiŝado en {{'COMMON.UD'|translate}}<sub>{{currency|abbreviate}}</sub> (ĉiuj sumoj estos <b>dividitaj</b> per la Universala Dividendo aktuala).",
      "END_LOGIN": "Tiu ĉi gvidata vizito <b>finiĝis</b>!<br/><br/>Bonan daŭrigon al vi, en la nova mondo de la<b>libera ekonomio</b>!",
      "END_NOT_LOGIN": "Tiu ĉi gvidata vizito <b>finiĝis</b>!<br/><br/>Se vi deziras partopreni en la mono {{currency|capitalize}}, sufiĉos al vi alklaki <b>{{'LOGIN.CREATE_FREE_ACCOUNT'|translate}}</b> ĉi-sube.",
      "END_READONLY": "Tiu ĉi gvidata vizito <b>finiĝis</b>.<br/><br/>{{'MODE.READONLY.INSTALL_HELP'|translate}}."
    }
  },
  "API" :{
    "COMMON": {
      "LINK_DOC": "Dokumentaro API",
      "LINK_DOC_HELP": "Dokumentaro por la programistoj",
      "LINK_STANDARD_APP": "Klasika versio",
      "LINK_STANDARD_APP_HELP": "Malfermi la klasikan version de {{'COMMON.APP_NAME'|translate}}",
      "CONNECTION_ERROR": "Nodo <b>{{server}}</b> neatingebla aŭ adreso nevalida.<br/><br/>Kontrolu vian interretan konekton, aŭ kontaktu la administranton de la retejo</a>."
    },
    "HOME": {
      "TITLE": "Dokumentaro API {{'COMMON.APP_NAME'|translate}}",
      "MESSAGE": "Bonvenon en la <b>dokumentaro de la API</b> {{'COMMON.APP_NAME'|translate}}.<br/>Konektu viajn retejojn al <a href=\"http://duniter.org\" target=\"_system\">Duniter</a> tre simple!",
      "MESSAGE_SHORT": "Konektu viajn retejojn al <a href=\"http://duniter.org\" target=\"_system\">Duniter</a> tre simple!",
      "DOC_HEADER": "Servoj disponeblaj:"
    },
    "TRANSFER": {
      "TITLE": "{{'COMMON.APP_NAME'|translate}} - Reta pago",
      "TITLE_SHORT": "Reta pago",
      "SUMMARY": "Resumo de la pago:",
      "AMOUNT": "Sumo:",
      "AMOUNTS_HELP": "Bonvolu elekti la sumon:",
      "NAME": "Nomo:",
      "PUBKEY": "Publika ŝlosilo de la ricevonto:",
      "COMMENT": "Referenco de la spezo:",
      "NODE": "Adreso de la nodo:",
      "DEMO": {
        "SALT": "demo",
        "PASSWORD": "demo",
        "PUBKEY": "3G28bL6deXQBYpPBpLFuECo46d3kfYMJwst7uhdVBnD1",
        "HELP": "<b>Demonstra moduso</b>: Neniu pago reale estos sendita dum tiu simulado.<br/>Bonvolu uzi la identigilojn: <b>{{'API.TRANSFER.DEMO.SALT'|translate}} / {{'API.TRANSFER.DEMO.PASSWORD'|translate}}</b>",
        "BAD_CREDENTIALS": "Kontrolu vian tajpaĵon.<br/>En demonstra moduso, la identigiloj estas: {{'API.TRANSFER.DEMO.SALT'|translate}} / {{'API.TRANSFER.DEMO.PASSWORD'|translate}}"
      },
      "INFO": {
        "SUCCESS_REDIRECTING_WITH_NAME": "Pago sendita.<br/>Redirektiĝo al <b>{{name}}</b>...",
        "SUCCESS_REDIRECTING": "Pago sendita.<br/>Redirektiĝo al la retejo de la vendanto...",
        "CANCEL_REDIRECTING_WITH_NAME": "Pago nuligita.<br/>Redirektiĝo al <b>{{name}}</b>...",
        "CANCEL_REDIRECTING": "Pago nuligita.<br/>Redirektiĝo al la retejo de la vendanto..."
      },
      "ERROR": {
        "TRANSFER_FAILED": "Pago malsukcesa"
      }
    },
    "DOC": {
      "DESCRIPTION_DIVIDER": "Priskribo",
      "URL_DIVIDER": "Adreso alvokita",
      "PARAMETERS_DIVIDER": "Parametroj",
      "AVAILABLE_PARAMETERS": "Jen la listo de la eblaj parametroj:",
      "DEMO_DIVIDER": "Testi",
      "DEMO_HELP": "Por testi tiun servon, alklaku la butonon ĉi-apude. La rezulto afiŝiĝos sube.",
      "DEMO_RESULT": "Rezulto sendita de la alvoko:",
      "DEMO_RESULT_PEER": "Adreso de la uzata nodo:",
      "DEMO_SUCCEED": "<i class=\"icon ion-checkmark\"></i> Sukceso!",
      "DEMO_CANCELLED": "<i class=\"icon ion-close\"></i> Nuligita de la uzanto",
      "INTEGRATE_DIVIDER": "Integri",
      "INTEGRATE_CODE": "Kodo:",
      "INTEGRATE_RESULT": "Antaŭvidigo de la rezulto:",
      "INTEGRATE_PARAMETERS": "Parametroj",
      "TRANSFER": {
        "TITLE": "Pagoj",
        "DESCRIPTION": "De retejo (ekz.: ret-vendado) vi povas komisii la pagon en libera mono al Cesium API. Por tio, sufiĉas al vi ekigi la malfermon de paĝo ĉe la sekvanta adreso:",
        "PARAM_PUBKEY": "Publika ŝlosilo de la ricevonto",
        "PARAM_PUBKEY_HELP": "Publika ŝlosilo de la ricevonto (devige)",
        "PARAM_AMOUNT": "Sumo",
        "PARAM_AMOUNT_HELP": "Sumo de la spezo (devige). Pluraj valoroj permesataj, uzante apartigilon (punkto-komo, vertikala streko aŭ spaco).",
        "PARAM_COMMENT": "Referenco (aŭ komento)",
        "PARAM_COMMENT_HELP": "Referenco aŭ komento. Tio ekzemple ebligos al vi identigi la pagon en la blokĉeno.",
        "PARAM_NAME": "Nomo (de la ricevonto aŭ de la retejo)",
        "PARAM_NAME_HELP": "La nomo de la ricevonto, aŭ de la retejo alvokanta. Tio povas estis legebla nomo (\"Mia retejo\"), aŭ alie pseŭdo-retadreso (\"MiaRetejo.com\").",
        "PARAM_REDIRECT_URL": "Retadreso por redirektiĝo",
        "PARAM_REDIRECT_URL_HELP": "Retadreso (URL) por redirektiĝo, alvokita kiam la pago estis sendita. Ĝi povas enteni la sekvantajn signojn, kiuj estos anstataŭigitaj per la valoroj de la spezo: \"{tx}\", \"{hash}\", \"{comment}\", \"{amount}\", \"{pubkey}\" kaj \"{node}\".",
        "PARAM_CANCEL_URL": "Retadreso por nuligo",
        "PARAM_CANCEL_URL_HELP": "Retadreso (URL) kaze de nuligo de la pago, fare de la uzanto. Ĝi povas enteni la sekvantajn signojn, kiuj estos anstataŭigitaj lastmomente: \"{comment}\", \"{amount}\" kaj \"{pubkey}\".",
        "PARAM_PREFERRED_NODE": "Adreso de la preferata nodo",
        "PARAM_PREFERRED_NODE_HELP": "Adreso (URL) de la nodo Duniter preferinde uzota (\"g1.domaine.com:443\" aŭ \"https://g1.domaine.com\").",
        "EXAMPLES_HELP": "Jen ekzemploj pri integrado:",
        "EXAMPLE_BUTTON": "Butono HTML",
        "EXAMPLE_BUTTON_DEFAULT_TEXT": "Pagi en {{currency|currencySymbol}}",
        "EXAMPLE_BUTTON_DEFAULT_STYLE": "Personigita stilo",
        "EXAMPLE_BUTTON_TEXT_HELP": "Buton-teksto",
        "EXAMPLE_BUTTON_BG_COLOR": "Fon-koloro",
        "EXAMPLE_BUTTON_BG_COLOR_HELP": "Ekzemplo: #fbc14c, nigra, helgriza, rgb(180,180,180)",
        "EXAMPLE_BUTTON_FONT_COLOR": "Teksto-koloro",
        "EXAMPLE_BUTTON_FONT_COLOR_HELP": "Ekzemplo: nigra, oranĝa, rgb(180,180,180)",
        "EXAMPLE_BUTTON_TEXT_ICON": "Ikono",
        "EXAMPLE_BUTTON_TEXT_WIDTH": "Larĝeco",
        "EXAMPLE_BUTTON_TEXT_WIDTH_HELP": "Ekzemplo: 200px, 50%",
        "EXAMPLE_BUTTON_ICON_NONE": "Neniu",
        "EXAMPLE_BUTTON_ICON_DUNITER": "Insigno Duniter",
        "EXAMPLE_BUTTON_ICON_CESIUM": "Insigno Cesium",
        "EXAMPLE_BUTTON_ICON_G1_COLOR": "Insigno Ğ1",
        "EXAMPLE_BUTTON_ICON_G1_BLACK": "Insigno Ğ1 (nigra)"
      }
    }
  }
}
);

$translateProvider.translations("es-ES", {
  "COMMON": {
    "APP_NAME": "Cesium",
    "APP_VERSION": "v{{version}}",
    "APP_BUILD": "fecha: {{build}}",
    "PUBKEY": "Llave pública",
    "MEMBER": "Miembro",
    "BLOCK": "Bloque",
    "BTN_OK": "OK",
    "BTN_YES": "Sí",
    "BTN_NO": "No",
    "BTN_SEND": "Enviar",
    "BTN_SEND_MONEY": "Hacer un pago",
    "BTN_SEND_MONEY_SHORT": "Pago",
    "BTN_SAVE": "Guardar",
    "BTN_YES_SAVE": "Sí, guardar",
    "BTN_YES_CONTINUE": "Sí, continuar",
    "BTN_SHOW": "Ver",
    "BTN_SHOW_PUBKEY": "Ver la llave",
    "BTN_RELATIVE_UNIT": "Mostrar importes en DU",
    "BTN_BACK": "Anterior",
    "BTN_NEXT": "Siguiente",
    "BTN_IMPORT": "Importar",
    "BTN_CANCEL": "Cancelar",
    "BTN_CLOSE": "Cerrar",
    "BTN_LATER": "Más tarde",
    "BTN_LOGIN": "Conectarse",
    "BTN_LOGOUT": "Desconexión",
    "BTN_ADD_ACCOUNT": "Nueva cuenta",
    "BTN_SHARE": "Compartir",
    "BTN_EDIT": "Modificar",
    "BTN_DELETE": "Suprimir",
    "BTN_ADD": "Añadir",
    "BTN_SEARCH": "Buscar",
    "BTN_REFRESH": "Actualizar",
    "BTN_RETRY": "Empezar de nuevo",
    "BTN_START": "Empezar",
    "BTN_CONTINUE": "Continuar",
    "BTN_CREATE": "Crear",
    "BTN_UNDERSTOOD": "Entendido",
    "BTN_OPTIONS": "Opciones",
    "BTN_HELP_TOUR": "Visita guiada",
    "BTN_HELP_TOUR_SCREEN": "Explicar esta pantalla",
    "BTN_DOWNLOAD": "Descargar",
    "BTN_DOWNLOAD_ACCOUNT_STATEMENT": "Descargar historial de cuenta",
    "BTN_MODIFY": "Modificar",
    "CHOOSE_FILE": "Arrastre el archivo<br/>o haga clic para seleccionarlo",
    "DAYS": "Días",
    "NO_ACCOUNT_QUESTION": "¿Todavía no es miembro? ¡Crear una cuenta!",
    "SEARCH_NO_RESULT": "Ningún resultado encontrado",
    "LOADING": "Espere por favor…",
    "LOADING_WAIT": "Espere por favor…<br/><small>(Esperando disponibilidad de nodo)</small>",
    "SEARCHING": "Búsqueda en proceso…",
    "FROM": "De",
    "TO": "A",
    "COPY": "Copiar",
    "LANGUAGE": "Idioma",
    "UNIVERSAL_DIVIDEND": "Dividendo universal",
    "UD": "DU",
    "DATE_PATTERN": "DD/MM/YYYY HH:mm",
    "DATE_FILE_PATTERN": "YYYY-MM-DD",
    "DATE_SHORT_PATTERN": "DD/MM/YY",
    "DATE_MONTH_YEAR_PATTERN": "MM/YYYY",
    "EMPTY_PARENTHESIS": "(vacío)",
    "UID": "Seudónimo",
    "ENABLE": "Activado",
    "DISABLE": "Desactivado",
    "RESULTS_LIST": "Resultados:",
    "RESULTS_COUNT": "{{count}} resultados",
    "EXECUTION_TIME": "ejecutado en {{duration|formatDurationMs}}",
    "SHOW_VALUES": "¿Publicar los valores no codificados?",
    "POPOVER_ACTIONS_TITLE": "Opciones",
    "POPOVER_FILTER_TITLE": "Filtros",
    "SHOW_MORE": "Mostrar más",
    "SHOW_MORE_COUNT": "(límite actual {{limit}})",
    "POPOVER_SHARE": {
      "TITLE": "Compartir",
      "SHARE_ON_TWITTER": "Compartir en Twitter",
      "SHARE_ON_FACEBOOK": "Compartir en Facebook",
      "SHARE_ON_DIASPORA": "Compartir en Diaspora*",
      "SHARE_ON_GOOGLEPLUS": "Compartir en Google+"
    },
    "FILE": {
      "DATE" : "Fecha:",
      "TYPE" : "Tipo:",
      "SIZE": "Tamaño:",
      "VALIDATING": "Validando…"
    }
  },
  "SYSTEM": {
    "PICTURE_CHOOSE_TYPE": "Elegir la fuente:",
    "BTN_PICTURE_GALLERY": "Galería",
    "BTN_PICTURE_CAMERA": "<b>Cámara</b>"
  },
  "MENU": {
    "HOME": "Inicio",
    "WOT": "Directorio",
    "CURRENCY": "Moneda",
    "ACCOUNT": "Mi cuenta",
    "WALLETS": "Mis monederos",
    "SETTINGS": "Ajustes",
    "NETWORK": "Red",
    "TRANSACTIONS": "Mis transacciones"
  },
  "ABOUT": {
    "BTN_OPEN_DEV_WINDOW": "Abrir ventana de depuración",
    "TITLE": "Acerca de",
    "LICENSE": "Software <b>libre</b> (licencia GNU AGPLv3).",
    "LATEST_RELEASE": "Existe una <b>versión más nueva</b> de {{'COMMON.APP_NAME' | translate}} (<b>v{{version}}</b>)",
    "PLEASE_UPDATE": "Por favor actualice {{'COMMON.APP_NAME' | translate}} (última versión: <b>v{{version}}</b>)",
    "CODE": "Código fuente:",
    "OFFICIAL_WEB_SITE": "Web oficial:",
    "DEVELOPERS": "Desarrollado por:",
    "FORUM": "Foro:",
    "PLEASE_REPORT_ISSUE": "No dude en informarnos de anomalías encontradas",
    "REPORT_ISSUE": "Reportar un problema"
  },
  "HOME": {
    "FEED_SOURCE": "Fuente",
    "READ_MORE": "Leer más",
    "SHOW_ALL_FEED": "Ver todo",
    "TITLE": "Cesium",
    "WELCOME": "¡Bienvenida/o a la aplicación Cesium!",
    "MESSAGE": "Reciba y envíe moneda libre {{currency|abbreviate}} fácilmente",
    "BTN_CURRENCY": "Explorar la moneda",
    "BTN_ABOUT": "Acerca de",
    "BTN_HELP": "Ayuda en línea",
    "REPORT_ISSUE": "Reportar anomalía",
    "NOT_YOUR_ACCOUNT_QUESTION": "¿No es suya la cuenta <b><i class=\"ion-key\"></i> {{pubkey|formatPubkey}}</b>?",
    "BTN_CHANGE_ACCOUNT": "Desconectar esta cuenta",
    "CONNECTION_ERROR": "Nodo <b>{{server}}</b> inalcanzable o dirección inválida.<br/><br/>Compruebe su conexión a Internet, o nodo de conmutación <a class=\"positive\" ng-click=\"doQuickFix('settings')\">en los ajustes</a>."
  },
  "SETTINGS": {
    "TITLE": "Ajustes",
    "DISPLAY_DIVIDER": "Visualización",
    "STORAGE_DIVIDER": "Almacenamiento",
    "NETWORK_SETTINGS": "Red",
    "PEER": "Dirección del nodo Duniter",
    "PEER_CHANGED_TEMPORARY": "Dirección utilizada temporalmente",
    "PEER_SHORT": "Nodo Duniter",
    "PERSIST_CACHE": "Conservar los datos de navegación (experimental)",
    "PERSIST_CACHE_HELP": "Permite una navegación más rápida, conservando localmente los datos recibidos, para usar de una sesión a otra.",
    "USE_LOCAL_STORAGE": "Activar el almacenamiento local",
    "USE_LOCAL_STORAGE_HELP": "Permitir conservar sus ajustes",
    "WALLETS_SETTINGS": "Mis monederos",
    "USE_WALLETS_ENCRYPTION": "Cifrar el listado",
    "USE_WALLETS_ENCRYPTION_HELP": "Permite proteger la lista de sus monederos (mediante cifrado), exigiendo una autenticación para acceder.",
    "ENABLE_HELPTIP": "Activar la ayuda contextual",
    "ENABLE_UI_EFFECTS": "Activar los efectos visuales",
    "HISTORY_SETTINGS": "Transacciones de la cuenta",
    "DISPLAY_UD_HISTORY": "Mostrar los DU creados",
    "TX_HISTORY_AUTO_REFRESH": "Activar actualización automática",
    "TX_HISTORY_AUTO_REFRESH_HELP": "Actualizar el saldo y las transacciones automáticamente, con cada nuevo bloque.",
    "AUTHENTICATION_SETTINGS": "Autenticación",
    "KEEP_AUTH": "Caducidad de la autenticación",
    "KEEP_AUTH_SHORT": "Caducidad",
    "KEEP_AUTH_HELP": "Defina cuándo expira su sesión",
    "KEEP_AUTH_OPTION": {
      "NEVER": "Después de cada operación",
      "SECONDS": "Después de {{value}} segundos de inactividad",
      "MINUTE": "Después de {{value}}min de inactividad",
      "MINUTES": "Después de {{value}}mins de inactividad",
      "HOUR": "Después de {{value}}h de inactividad",
      "ALWAYS": "Al finalizar la sesión"
    },
    "KEYRING_FILE": "Archivo de llaves",
    "KEYRING_FILE_HELP": "Le permite <b>conectarse</b> automáticamente en cada inicio <br/>e incluso de <b>autenticarse</b> (solo si \"Caducidad de la autenticación\" está configurada en modo: \"al finalizar la sesión\").",
    "REMEMBER_ME": "Recordarme",
    "REMEMBER_ME_HELP": "Permite mantenerse siempre conectado (no recomendado), conservando localmente la llave pública.",
    "PLUGINS_SETTINGS": "Extensiones",
    "BTN_RESET": "Restaurar los valores por defecto",
    "EXPERT_MODE": "Modo experto",
    "EXPERT_MODE_HELP": "Permite una visualización más detallada",
    "BLOCK_VALIDITY_WINDOW": "Tiempo de incertitud de los bloques",
    "DISABLE_HELPTIP": "Desactivar la opción de ayuda contextual",
    "BLOCK_VALIDITY_WINDOW_SHORT": "Tiempo de incertitud",
    "BLOCK_VALIDITY_WINDOW_HELP": "Tiempo de espera antes de considerar una información como validada",
    "BLOCK_VALIDITY_OPTION": {
      "NONE": "Sin espera",
      "N": "{{time | formatDuration}} ({{count}} bloques)"
    },
    "POPUP_PEER": {
      "TITLE": "Nodo Duniter",
      "HOST": "Dirección",
      "HOST_HELP": "Dirección: servidor:puerto",
      "USE_SSL": "Conexión segura",
      "USE_SSL_HELP": "(Cifrado SSL)",
      "BTN_SHOW_LIST": "Lista de nodos"
    }
  },
  "BLOCKCHAIN": {
    "HASH": "Hash: {{hash}}",
    "VIEW": {
      "HEADER_TITLE": "Bloque #{{number}}-{{hash|formatHash}}",
      "TITLE_CURRENT": "Bloque actual",
      "TITLE": "Bloque #{{number|formatInteger}}",
      "COMPUTED_BY": "Calculado por el nodo de",
      "SHOW_RAW": "Ver el fichero en bruto",
      "TECHNICAL_DIVIDER": "Informaciones técnicas",
      "VERSION": "Versión del formato",
      "HASH": "Hash calculado",
      "UNIVERSAL_DIVIDEND_HELP": "Moneda co-producida por cada uno de los {{membersCount}} miembros",
      "EMPTY": "Ningún dato en este bloque",
      "POW_MIN": "Dificultad mínima",
      "POW_MIN_HELP": "Dificultad impuesta por el cálculo del hash",
      "DATA_DIVIDER": "Datos",
      "IDENTITIES_COUNT": "Nuevas identidades",
      "JOINERS_COUNT": "Nuevos miembros",
      "ACTIVES_COUNT": "Renovaciones",
      "ACTIVES_COUNT_HELP": "Miembros que han renovado sus adhesiones",
      "LEAVERS_COUNT": "Miembros salientes",
      "LEAVERS_COUNT_HELP": "Miembros salientes que ya no quieren estar certificados",
      "EXCLUDED_COUNT": "Miembros excluidos",
      "EXCLUDED_COUNT_HELP": "Antiguos miembros excluidos por no renovación o falta de certificaciones",
      "REVOKED_COUNT": "Identidades revocadas",
      "REVOKED_COUNT_HELP": "Estas cuentas no podrán ser miembros",
      "TX_COUNT": "Transacciones",
      "CERT_COUNT": "Certificaciones",
      "TX_TO_HIMSELF": "Operación de cambio",
      "TX_OUTPUT_UNLOCK_CONDITIONS": "Condiciones de desbloqueo",
      "TX_OUTPUT_OPERATOR": {
        "AND": "y",
        "OR": "o"
      },
      "TX_OUTPUT_FUNCTION": {
        "SIG": "<b>Firma</b> de ",
        "XHX": "<b>Contraseña</b>, cuyo SHA256 =",
        "CSV": "Bloqueado durante",
        "CLTV": "Bloqueado hasta"
      }
    },
    "LOOKUP": {
      "TITLE": "Bloques",
      "NO_BLOCK": "Ningún bloque",
      "LAST_BLOCKS": "Últimos bloques:",
      "BTN_COMPACT": "Compactar"
    }
  },
  "CURRENCY": {
    "VIEW": {
      "TITLE": "Moneda",
      "TAB_CURRENCY": "Moneda",
      "TAB_WOT": "Red de confianza",
      "TAB_NETWORK": "Red",
      "TAB_BLOCKS": "Bloques",
      "CURRENCY_SHORT_DESCRIPTION": "{{currency|abbreviate}} es una <b>moneda libre</b>, originada {{firstBlockTime|formatFromNow}}. Cuenta actualmente con <b>{{N}} miembros</b>, que producen y reciben un <a ng-click=\"showHelpModal('ud')\">Dividendo Universal</a> (DU) cada {{dt|formatPeriod}}.",
      "NETWORK_RULES_DIVIDER": "Reglas de la red",
      "CURRENCY_NAME": "Nombre de la moneda",
      "MEMBERS": "Cantidad de miembros",
      "MEMBERS_VARIATION": "Variación desde último DU",
      "MONEY_DIVIDER": "Moneda",
      "MASS": "Masa monetaria",
      "SHARE": "Masa media por miembro",
      "UD": "Dividendo Universal",
      "C_ACTUAL": "Crecimiento actual",
      "MEDIAN_TIME": "Hora de la cadena de bloques",
      "POW_MIN": "Nivel mínimo de dificultad de cálculo",
      "MONEY_RULES_DIVIDER": "Reglas de la moneda",
      "C_RULE": "Crecimiento teórico objetivo",
      "UD_RULE": "Cálculo del dividendo universal",
      "DT_REEVAL": "Periodo de revalorización del DU",
      "REEVAL_SYMBOL": "reval",
      "DT_REEVAL_VALUE": "Todos los <b>{{dtReeval|formatDuration}}</b> ({{dtReeval/86400}} {{'COMMON.DAYS'|translate}})",
      "UD_REEVAL_TIME0": "Fecha de la primera revalorización",
      "SIG_QTY_RULE": "Certificaciones requeridas para ser miembro",
      "SIG_STOCK": "Máximo de certificaciones emitibles por miembros",
      "SIG_PERIOD": "Espera mínima entre 2 certificaciones sucesivas emitidas por la misma persona",
      "SIG_WINDOW": "Límite para tener en cuenta una certificación",
      "SIG_VALIDITY": "Duración de una certificación tenida en cuenta",
      "MS_WINDOW": "Límite para aprobar una solicitud de membresía",
      "MS_VALIDITY": "Duración de una membresía aprobada",
      "STEP_MAX": "Distancia máxima entre una nueva candidatura y cada miembro referente",
      "WOT_RULES_DIVIDER": "Reglas de la red de confianza",
      "SENTRIES": "Certificaciones necesarias para ser miembro referente",
      "SENTRIES_FORMULA": "Fórmula de las certificaciones necesarias para ser miembro referente",
      "XPERCENT":"Porcentaje mínimo necesario de miembros referentes respentando la regla de distancia máxima",
      "AVG_GEN_TIME": "Tiempo medio entre dos bloques",
      "CURRENT": "actual",
      "MATH_CEILING": "TECHO",
      "DISPLAY_ALL_RULES": "¿Ver todas las reglas?",
      "BTN_SHOW_LICENSE": "Ver la licencia",
      "WOT_DIVIDER": "Red de confianza"
    },
    "LICENSE": {
      "TITLE": "Licencia de la moneda",
      "BTN_DOWNLOAD": "Descargar el fichero",
      "NO_LICENSE_FILE": "Fichero de licencia no encontrado."
    }
  },
  "NETWORK": {
    "VIEW": {
      "MEDIAN_TIME": "Hora de la cadena de bloques",
      "LOADING_PEERS": "Cargando nodos…",
      "NODE_ADDRESS": "Dirección:",
      "SOFTWARE": "Software:",
      "WARN_PRE_RELEASE": "Prelanzamiento (última versión estable: <b>{{version}}</b>)",
      "WARN_NEW_RELEASE": "Versión <b>{{version}}</b> disponible",
      "WS2PID": "ID:",
      "PRIVATE_ACCESS": "Acceso privado",
      "POW_PREFIX": "Prefijo de la prueba de trabajo:",
      "ENDPOINTS": {
        "BMAS": "Interfaz segura (SSL)",
        "BMATOR": "Interfaz red TOR",
        "WS2P": "Interfaz WS2P",
        "ES_USER_API": "Nodo de datos Cesium+"
      }
    },
    "INFO": {
      "ONLY_SSL_PEERS": "La visualización de los nodos sin SSL está deteriorada porque Cesium funciona en modo HTTPS."
    }
  },
  "PEER": {
    "PEERS": "Nodos",
    "SIGNED_ON_BLOCK": "Firmado sobre el bloque",
    "MIRROR": "espejo",
    "MIRRORS": "Espejo",
    "MIRROR_PEERS": "Nodos espejo",
    "PEER_LIST": "Lista de nodos",
    "MEMBERS": "Miembro",
    "MEMBER_PEERS": "Nodos miembro",
    "ALL_PEERS": "Todos los nodos",
    "DIFFICULTY": "Dificultad",
    "API": "API",
    "CURRENT_BLOCK": "Bloque #",
    "POPOVER_FILTER_TITLE": "Filtro",
    "OFFLINE": "Fuera de línea",
    "OFFLINE_PEERS": "Nodos fuera de línea",
    "BTN_SHOW_PEER": "Ver nodo",
    "VIEW": {
      "TITLE": "Nodo",
      "OWNER": "Propiedad de",
      "SHOW_RAW_PEERING": "Ver la ficha del par",
      "SHOW_RAW_CURRENT_BLOCK": "Ver el último bloque (formato bruto)",
      "LAST_BLOCKS": "Bloques recientes",
      "KNOWN_PEERS": "Nodos conocidos:",
      "GENERAL_DIVIDER": "Información general",
      "ERROR": {
        "LOADING_TOR_NODE_ERROR": "No se pudo obtener la información del nodo usando la red TOR.",
        "LOADING_NODE_ERROR": "No se pudo obtener la información del nodo"
      }
    }
  },
  "WOT": {
    "SEARCH_HELP": "Buscar (seudónimo o llave pública)",
    "SEARCH_INIT_PHASE_WARNING": "Durante la etapa de preinscripción, el tiempo de búsqueda de las candidaturas en espera <b>puede tardar</b>. Por favor espere…",
    "REGISTERED_SINCE": "Se registró en",
    "REGISTERED_SINCE_BLOCK": "Se registró en el bloque #",
    "NO_CERTIFICATION": "Ninguna certificación validada",
    "NO_GIVEN_CERTIFICATION": "Ninguna certificación emitida",
    "NOT_MEMBER_PARENTHESIS": "(no miembro)",
    "IDENTITY_REVOKED_PARENTHESIS": "(identidad revocada)",
    "MEMBER_PENDING_REVOCATION_PARENTHESIS": "(revocación en proceso)",
    "EXPIRE_IN": "Expira",
    "NOT_WRITTEN_EXPIRE_IN": "Fecha límite<br/>de procesamiento",
    "EXPIRED": "Expirado",
    "PSEUDO": "Seudónimo",
    "SIGNED_ON_BLOCK": "Emitida en el bloque #{{block}}",
    "WRITTEN_ON_BLOCK": "Escrita en el bloque #{{block}}",
    "GENERAL_DIVIDER": "Informaciones generales",
    "NOT_MEMBER_ACCOUNT": "Cuenta no miembro",
    "NOT_MEMBER_ACCOUNT_HELP": "Se trata de un monedero simple, sin solicitud de membresía en espera",
    "TECHNICAL_DIVIDER": "Informaciones técnicas",
    "BTN_CERTIFY": "Certificar",
    "BTN_YES_CERTIFY": "Sí, certificar",
    "BTN_SELECT_AND_CERTIFY": "Nueva certificación",
    "ACCOUNT_OPERATIONS": "Transacciones de la cuenta",
    "VIEW": {
      "POPOVER_SHARE_TITLE": "Identidad {{title}}"
    },
    "LOOKUP": {
      "TITLE": "Directorio",
      "NEWCOMERS": "Nuevos miembros:",
      "NEWCOMERS_COUNT": "{{count}} miembros",
      "PENDING": "Inscripciones en espera:",
      "PENDING_COUNT": "{{count}} inscripciones en espera",
      "REGISTERED": "Se inscribió {{sigDate | formatFromNow}}",
      "MEMBER_FROM": "Miembro desde {{memberDate|medianFromNowShort}}",
      "BTN_NEWCOMERS": "Miembros recientes",
      "BTN_PENDING": "Candidaturas en espera",
      "SHOW_MORE": "Mostrar más",
      "SHOW_MORE_COUNT": "(mostrar solo {{limit}})",
      "NO_PENDING": "Ninguna candidatura en espera.",
      "NO_NEWCOMERS": "Sin miembros."
    },
    "CONTACTS": {
      "TITLE": "Contactos"
    },
    "MODAL": {
      "TITLE": "Buscar"
    },
    "CERTIFICATIONS": {
      "TITLE": "{{uid}} - Certificaciones",
      "SUMMARY": "Certificaciones recibidas",
      "LIST": "Detalle de las certificaciones recibidas",
      "PENDING_LIST": "Certificaciones en espera de tratamiento",
      "RECEIVED": "Certificaciones recibidas",
      "RECEIVED_BY": "Certificaciones recibidas por {{uid}}",
      "ERROR": "Certificaciones recibidas por error",
      "SENTRY_MEMBER": "Miembro referente"
    },
    "OPERATIONS": {
      "TITLE": "{{uid}} - Transacciones"
    },
    "GIVEN_CERTIFICATIONS": {
      "TITLE": "{{uid}} - Certificaciones emitidas",
      "SUMMARY": "Certificaciones emitidas",
      "LIST": "Detalle de las certificaciones emitidas",
      "PENDING_LIST": "Certificaciones en espera a ser procesadas",
      "SENT": "Certificaciones emitidas",
      "SENT_BY": "Certificaciones emitidas por {{uid}}",
      "ERROR": "Certificaciones emitidas por error"
    }
  },
  "LOGIN": {
    "TITLE": "<i class=\"icon ion-locked\"></i> Conexión",
    "SCRYPT_FORM_HELP": "Ingrese sus credenciales.<br>Recuerde comprobar que la llave pública pertenece a su cuenta.",
    "PUBKEY_FORM_HELP": "Por favor ingrese una llave pública de cuenta:",
    "FILE_FORM_HELP": "Elija el archivo de llaves a usar:",
    "SCAN_FORM_HELP": "Escanee el código QR de un monedero.",
    "SALT": "Identificador secreto",
    "SALT_HELP": "Identificador secreto",
    "SHOW_SALT": "Mostrar el identificador secreto",
    "PASSWORD": "Contraseña",
    "PASSWORD_HELP": "Contraseña",
    "PUBKEY_HELP": "llave pública",
    "NO_ACCOUNT_QUESTION": "¿Aún no tiene cuenta? ",
    "HAVE_ACCOUNT_QUESTION": "¿Ya tiene cuenta?",
    "CREATE_ACCOUNT": "Crear una cuenta",
    "CREATE_FREE_ACCOUNT": "Crear una cuenta gratis",
    "FORGOTTEN_ID": "¿Olvidó su contraseña?",
    "ASSOCIATED_PUBKEY": "Llave pública del archivo de llaves:",
    "BTN_METHODS": "Otros métodos",
    "BTN_METHODS_DOTS": "Otras vías…",
    "METHOD_POPOVER_TITLE": "Métodos",
    "MEMORIZE_AUTH_FILE": "Memorizar las llaves durante la sesión de navegación",
    "SCRYPT_PARAMETERS": "Ajustes (Scrypt) :",
    "AUTO_LOGOUT": {
      "TITLE": "Información",
      "MESSAGE": "<i class=\"ion-android-time\"></i> Se ha <b>desconectado</b> de forma automática, después de un periodo de inactividad prolongada.",
      "BTN_RELOGIN": "Volver a conectarme",
      "IDLE_WARNING": "Será desconectado en… {{countdown}}"
    },
    "METHOD": {
      "SCRYPT_DEFAULT": "Estándar (por defecto)",
      "SCRYPT_ADVANCED": "Aleatoriedad avanzada",
      "FILE": "Archivo de llaves",
      "PUBKEY": "Llave pública o seudónimo",
      "SCAN": "Escanear un código QR"
    },
    "SCRYPT": {
      "SIMPLE": "Ligero",
      "DEFAULT": "Predeterminado",
      "SECURE": "Seguro",
      "HARDEST": "El más seguro",
      "EXTREME": "Extremo",
      "USER": "Personalizado",
      "N": "N (Loop):",
      "r": "r (RAM):",
      "p": "p (CPU):"
    },
    "FILE": {
      "HELP": "Formato de archivo esperado: <b>.yml</b> o <b>.dunikey</b> (tipo PubSec, WIF o EWIF)."
    }
  },
  "API": {
    "COMMON": {
        "CONNECTION_ERROR": "Nodo <b>{{server}}</b> inalcanzable o dirección inválida.<br/><br/>Verifique su conexión a Internet, o contacte con la administración del sitio.</a>.",
        "LINK_DOC": "Documentación API",
        "LINK_DOC_HELP": "Documentación para desarrolladores",
        "LINK_STANDARD_APP": "Versión clásica",
        "LINK_STANDARD_APP_HELP": "Abrir la versión clásica de {{'COMMON.APP_NAME'|translate}}"
    },
    "DOC": {
        "AVAILABLE_PARAMETERS": "Lista de parámetros disponibles :",
        "DEMO_CANCELLED": "<i class=\"icon ion-close\"></i> Cancelado por el usuario",
        "DEMO_DIVIDER": "Probar",
        "DEMO_HELP": "Para probar este servicio, haga clic en este botón. El resultado se mostrará debajo.",
        "DEMO_RESULT": "Resultado retornado por la llamada :",
        "DEMO_RESULT_PEER": "Dirección del nodo utilizado :",
        "DEMO_SUCCEED": "<i class=\"icon ion-checkmark\"></i> ¡ Éxito !",
        "DESCRIPTION_DIVIDER": "Descripción",
        "INTEGRATE_CODE": "Código :",
        "INTEGRATE_DIVIDER": "Integrar",
        "INTEGRATE_PARAMETERS": "Parámetros",
        "INTEGRATE_RESULT": "Previsualización del resultado :",
        "PARAMETERS_DIVIDER": "Parámetros",
        "TRANSFER": {
            "DESCRIPTION": "Desde una web (ej: tienda online) puede delegar el pago en moneda libre con la API de Cesium. Para eso, simplemente ponga un link a la siguiente dirección :",
            "EXAMPLE_BUTTON": "Botón HTML",
            "EXAMPLE_BUTTON_BG_COLOR": "Color de fondo",
            "EXAMPLE_BUTTON_BG_COLOR_HELP": "Ejemplo : #fbc14c, black, lightgrey, rgb(180,180,180)",
            "EXAMPLE_BUTTON_DEFAULT_STYLE": "Estilo personalizado",
            "EXAMPLE_BUTTON_DEFAULT_TEXT": "Pagar en {{currency|currencySymbol}}",
            "EXAMPLE_BUTTON_FONT_COLOR": "Color del texto",
            "EXAMPLE_BUTTON_FONT_COLOR_HELP": "Ejemplo : black, orange, rgb(180,180,180)",
            "EXAMPLE_BUTTON_ICON_CESIUM": "Logo Cesium",
            "EXAMPLE_BUTTON_ICON_DUNITER": "Logo Duniter",
            "EXAMPLE_BUTTON_ICON_G1_BLACK": "Logo Ğ1 (negro)",
            "EXAMPLE_BUTTON_ICON_G1_COLOR": "Logo Ğ1",
            "EXAMPLE_BUTTON_ICON_NONE": "Ninguno",
            "EXAMPLE_BUTTON_TEXT_HELP": "Texto del botón",
            "EXAMPLE_BUTTON_TEXT_ICON": "Icono",
            "EXAMPLE_BUTTON_TEXT_WIDTH": "Anchura",
            "EXAMPLE_BUTTON_TEXT_WIDTH_HELP": "Ejemplo : 200px, 50%",
            "EXAMPLES_HELP": "Ejemplos de integración :",
            "PARAM_AMOUNT": "Cuantía",
            "PARAM_AMOUNT_HELP": "Cuantía de la transición (obligatorio). Valores múltiples permitidos utilizando un separador (punto y coma, barra vertical o espacio).",
            "PARAM_CANCEL_URL": "Dirección web de cancelación",
            "PARAM_CANCEL_URL_HELP": "Dirección web (URL) en caso de anulación del pago por parte del usuario. Puede contener las siguientes palabras que serán remplazadas por sus valores dinámicamente en cada caso: \"{comment}\", \"{amount}\" y \"{pubkey}\".",
            "PARAM_COMMENT": "Concepto (o comentario)",
            "PARAM_COMMENT_HELP": "Concepto o comentario. Le permitirá por ejemplo identificar el pago en la cadena de bloques (blockchain).",
            "PARAM_NAME": "Nombre (del destinatario o de su sitio web)",
            "PARAM_NAME_HELP": "El nombre del destinatario, o de su sitio web. Puede ser un nombre leíble (\"Mi tienda en línea\"), o un dominio (\"Mitienda.com\").",
            "PARAM_PREFERRED_NODE": "Dirección del nodo preferido",
            "PARAM_PREFERRED_NODE_HELP": "Dirección (URL) del nodo Duniter a utilizar preferentemente (\"g1.domaine.com:443\" o \"https://g1.domaine.com\").",
            "PARAM_PUBKEY": "Llave pública del destinatario",
            "PARAM_PUBKEY_HELP": "La llave pública del destinatario (obligatoria)",
            "PARAM_REDIRECT_URL": "Dirección web de redirección",
            "PARAM_REDIRECT_URL_HELP": "Dirección web (URL) de redirección, llamada cuanda el pago ha sido enviado. Puede contener las palabras siguientes, que serán remplazadas por los valores de la transacción dinámicanente : \"{tx}\", \"{hash}\", \"{comment}\", \"{amount}\", \"{pubkey}\" y \"{node}\".",
            "TITLE": "Pagos"
        },
        "URL_DIVIDER": "Dirección de llamada"
    },
    "HOME": {
        "DOC_HEADER": "Servicios disponibles :",
        "MESSAGE": "Bienvenido/a a la <b>documentación de la API</b> {{'COMMON.APP_NAME'|translate}}.<br/>Conecte sus sitios webs a la cadena de bloques <a href=\"http://duniter.org\" target=\"_system\">Duniter</a> muy fácilmente !",
        "MESSAGE_SHORT": "Conecte sus sitios a <a href=\"http://duniter.org\" target=\"_system\">Duniter</a> muy fácilmente !",
        "TITLE": "Documentación API {{'COMMON.APP_NAME'|translate}}"
    },
    "TRANSFER": {
        "AMOUNT": "Cuantía :",
        "AMOUNTS_HELP": "Elija la cuantía :",
        "COMMENT": "Concepto/Comentario de la operación :",
        "DEMO": {
            "BAD_CREDENTIALS": "Verifique sus credenciales.<br/>En modo demostración, las credenciales son : {{'API.TRANSFER.DEMO.SALT'|translate}} / {{'API.TRANSFER.DEMO.PASSWORD'|translate}}",
            "HELP": "<b>Modo demostración</b> : Ningún pago será enviado realmente durante esta simulación.<br/>Utilice las credenciales : <b>{{'API.TRANSFER.DEMO.SALT'|translate}} / {{'API.TRANSFER.DEMO.PASSWORD'|translate}}</b>",
            "PASSWORD": "demo",
            "PUBKEY": "3G28bL6deXQBYpPBpLFuECo46d3kfYMJwst7uhdVBnD1",
            "SALT": "demo"
        },
        "ERROR": {
            "TRANSFER_FAILED": "Error en el pago"
        },
        "INFO": {
            "CANCEL_REDIRECTING": "Pago cancelado.<br/>Redirigiendo al sitio del vendedor...",
            "CANCEL_REDIRECTING_WITH_NAME": "Pago cancelado.<br/>Redirigiendo a <b>{{name}}</b>...",
            "SUCCESS_REDIRECTING": "Pago enviado.<br/>Redirigiendo al sitio del vendedor...",
            "SUCCESS_REDIRECTING_WITH_NAME": "Pago enviado.<br/>Redirigiendo a <b>{{name}}</b>..."
        },
        "NAME": "Nombre :",
        "NODE": "Dirección del nodo :",
        "PUBKEY": "Llave pública del destinatario :",
        "SUMMARY": "Resumen del pago :",
        "TITLE": "{{'COMMON.APP_NAME'|translate}} - Pago en línea",
        "TITLE_SHORT": "Pago en línea"
    }
  },
  "AUTH": {
    "TITLE": "<i class=\"icon ion-locked\"></i> Autenticación",
    "BTN_AUTH": "Autenticar",
    "GENERAL_HELP": "Por favor, autentíquese:",
    "EXPECTED_UID_HELP": "Por favor inicie sesión en la cuenta de <i class=\"ion-person\"></i> {{uid}}:",
    "EXPECTED_PUBKEY_HELP": "Por favor, autentíquese en el monedero <br class=\"visible-xs\"/><i class=\"ion-key\"></i> {{pubkey|formatPubkey}} :",
    "SCAN_FORM_HELP": "Escanee el código QR de la <b>llave privada</b> del monedero."
  },
  "ACCOUNT": {
    "TITLE": "Mi cuenta",
    "BALANCE": "Saldo",
    "LAST_TX": "Últimas transacciones validadas",
    "BALANCE_ACCOUNT": "Saldo de la cuenta",
    "NO_TX": "Ninguna transacción",
    "SHOW_MORE_TX": "Mostrar más",
    "SHOW_ALL_TX": "Mostrar todo",
    "TX_FROM_DATE": "(mostrar solo {{fromTime|medianFromNowShort}})",
    "OUT_DISTANCED": "Sus certificaciones recibidas provienen de un grupo demasiado aislado de la <a ng-click=\"showHelpModal('wot')\">Red de Confianza</a> (RdC) : la <a ng-click=\"showHelpModal('distance_rule')\">regla de distancia máxima</a> no se cumple.<br/>Deberá obtener certificaciones provinientes de otros sectores de la RdC, o esperar a que ésta estreche sus vínculos.",
    "PENDING_TX": "Transacciones pendientes",
    "VALIDATING_TX": "Transacciones validadas",
    "ERROR_TX": "Transacciones no ejecutadas",
    "ERROR_TX_SENT": "Transacciones ejecutadas fallidas",
    "PENDING_TX_RECEIVED": "Tansacciones en espera de recepción",
    "EVENTS": "Eventos",
    "WAITING_MEMBERSHIP": "Solicitud de membresía emitida. En espera de aceptación.",
    "WAITING_CERTIFICATIONS": "Debe obtener {{needCertificationCount}} certificación(es) para ser miembro.",
    "WAITING_CERTIFICATIONS_HELP": "Para obtener sus certificaciones, solicitelas únicamente a miembros <b>que le conozcan bien (y en persona)</b>, como exige <a ng-click=\"showLicenseModal()\">la licencia de la moneda</a> que usted ha aceptado.<br/>Si no conoce lo suficiente a miembros, hágalo saber en <a ng-click=\"openLink($event, $root.settings.userForumUrl)\">el foro</a> para conocerlos en persona o asistir a algún encuentro.",
    "WILL_MISSING_CERTIFICATIONS": "Pronto le van a <b>faltar certificaciones</b> (al menos {{willNeedCertificationCount}} son necesarias)",
    "WILL_NEED_RENEW_MEMBERSHIP": "Su adhesión como miembro <b>va a expirar {{membershipExpiresIn|formatDurationTo}}</b>. Piense en <a ng-click=\"doQuickFix('renew')\">renovar su adhesión</a> mientras tanto.",
    "NEED_RENEW_MEMBERSHIP": "Ya no es miembro porque su adhesión <b>ha expirado</b>. Piense en <a ng-click=\"doQuickFix('renew')\">renovar su adhesión</a>.",
    "NEED_RENEW_MEMBERSHIP_AFTER_CANCELLED": "Ya no es miembro de la moneda, <b>por falta de certificaciones</b>. Considere <a ng-click=\"doQuickFix('renew')\">renovar su adhesión</a>.",
    "NO_WAITING_MEMBERSHIP": "No hay adhesión miembro en espera. Si desea <b>convertirse en miembro</b>, por favor <a ng-click=\"doQuickFix('membership')\">envíe su adhesión como miembro</a>.",
    "CERTIFICATION_COUNT": "Certificaciones recibidas",
    "CERTIFICATION_COUNT_SHORT": "Certificaciones",
    "SIG_STOCK": "Certificaciones emitidas",
    "BTN_RECEIVE_MONEY": "Recibir",
    "BTN_SELECT_ALTERNATIVES_IDENTITIES": "Cambiar a otra identidad…",
    "BTN_FIX_MEMBERSHIP": "Volver a enviar la candidatura…",
    "BTN_MEMBERSHIP_RENEW": "Renovar la membresía",
    "BTN_MEMBERSHIP_RENEW_DOTS": "Renovar la membresía…",
    "BTN_MEMBERSHIP_OUT_DOTS": "Cancelar la membresía…",
    "BTN_SECURITY_DOTS": "Cuenta y seguridad…",
    "BTN_SHOW_DETAILS": "Publicar la información técnica",
    "LOCKED_OUTPUTS_POPOVER": {
      "TITLE": "Importe bloqueado",
      "DESCRIPTION": "Aquí están las condiciones para desbloquear este importe:",
      "DESCRIPTION_MANY": "Esta transacción esta compuesta de varias partes, cuyas condiciones de desbloqueo son:",
      "LOCKED_AMOUNT": "Condiciones del importe:"
    },
    "NEW": {
      "TITLE": "Registrarse",
      "INTRO_WARNING_TIME": "Crear una cuenta en {{name|capitalize}} es muy simple. Sin embargo, por favor tome el tiempo suficiente para hacerlo correctamente (generar y memorizar bien las credenciales, etc.)",
      "INTRO_WARNING_SECURITY": "Asegúrese de que el dispositivo actual (ordenador, tablet, teléfono) <b>es seguro y de confianza</b>.",
      "INTRO_WARNING_SECURITY_HELP": "Antivirus, cortafuegos, sesión protegida por contraseña o número PIN, etc.",
      "INTRO_HELP": "Haga clic en <b>{{'COMMON.BTN_START'|translate}}</b> para iniciar la creación de la cuenta. Se le guiará paso a paso.",
      "REGISTRATION_NODE": "Su registro será grabado a través del nodo Duniter <b>{{server}}</b>, que luego se transmitirá al resto del sistema de la moneda.",
      "REGISTRATION_NODE_HELP": "Si no confía en este nodo, <a ng-click=\"doQuickFix('settings')\">cambie los ajustes</a> de Cesium.",
      "SELECT_ACCOUNT_TYPE": "Elegir el tipo de cuenta a crear:",
      "MEMBER_ACCOUNT": "Cuenta miembro",
      "MEMBER_ACCOUNT_TITLE": "Crear una cuenta miembro",
      "MEMBER_ACCOUNT_HELP": "Si todavía no tiene membresía (solamente una cuenta miembro posible por persona).",
      "WALLET_ACCOUNT": "Simple monedero",
      "WALLET_ACCOUNT_TITLE": "Crear una cuenta simple",
      "WALLET_ACCOUNT_HELP": "Monedero simple para todos los otros casos, por ejemplo si necesita una cuenta suplementaria.<br/>El Dividendo Universal no será producido para esta cuenta.",
      "SALT_WARNING": "Elija su identificador secreto.<br/>Se solicitará cada vez que se conectará con esta cuenta.<br/><br/><b>Conserve bien este identificador secreto</b>.<br/>¡En caso de pérdida, nadie podrá acceder a su cuenta!",
      "PASSWORD_WARNING": "Elija su contraseña.<br/>Se solicitará cada vez que se conectará con esta cuenta.<br/><br/><b>Conserve bien esta contraseña</b>.<br/>¡En caso de pérdida, nadie podrá acceder su cuenta!",
      "PSEUDO_WARNING": "Elija un seudónimo.<br/>Sirve para que los otros miembros puedan encontrarlo más fácilmente.<br/><br/>No debe contener <b>ni espacios ni caracteres acentuados</b>.<div class='hidden-xs'><br/>Ejemplo: <span class='gray'>SophieDupond, MarcelChemin, etc.</span>",
      "PSEUDO": "Seudónimo",
      "PSEUDO_HELP": "Seudónimo",
      "SALT_CONFIRM": "Confirmación",
      "SALT_CONFIRM_HELP": "Confirmación del identificador secreto",
      "PASSWORD_CONFIRM": "Confirmación",
      "PASSWORD_CONFIRM_HELP": "Confirmación de la contraseña",
      "SLIDE_6_TITLE": "Confirmación:",
      "COMPUTING_PUBKEY": "Cálculo en proceso…",
      "LAST_SLIDE_CONGRATULATION": "<b>¡Bien!</b> Ha introducido todas los datos necesarios.<br/><b>Puede solicitar</b> la creación de su cuenta.</b><br/><br/>Para su información, la llave pública que se muestra más abajo identificará su futura cuenta.<br/>Esta podrá ser comunicada a terceros para recibir pagos.",
      "CONFIRMATION_MEMBER_ACCOUNT": "<b class=\"assertive\">Advertencia:</b> el identificador secreto, la contraseña y el seudónimo no podrán ser modificados.<br/><b>¡Asegúrese siempre de recordarlos!</b><br/><br/><b>¿Desea</b> solicitar la inscripción?",
      "CONFIRMATION_WALLET_ACCOUNT": "<b class=\"assertive\">Advertencia:</b> el identificador secreto y la contraseña no podrán ser modificados.<br/><b>¡Asegúrese de recordarlos siempre!</b><br/><br/><b>¿Desea</b> continuar?",
      "CHECKING_PSEUDO": "Verificando…",
      "PSEUDO_AVAILABLE": "Este nombre está disponible",
      "PSEUDO_NOT_AVAILABLE": "Este nombre de usuario no está disponible",
      "INFO_LICENSE": "Para unirse a la moneda, le pedimos leer y aceptar esta licencia.",
      "BTN_ACCEPT": "Acepto",
      "BTN_ACCEPT_LICENSE": "Acepto la licencia"
    },
    "POPUP_REGISTER": {
      "TITLE": "Elija un seudónimo",
      "HELP": "Un seudónimo es obligatorio para ser miembro."
    },
    "SELECT_IDENTITY_MODAL": {
      "TITLE": "Selección de identidad",
      "HELP": "Se han enviado varias <b>identidades diferentes</b> para la llave pública <span class=\"gray\"><i class=\"ion-key\"></i>{{pubkey | formatPubkey}}</span>.<br/>Por favor, selecciona la carpeta para usar:"
    },
    "SELECT_WALLET_MODAL": {
      "TITLE": "Selección de monedero"
    },
    "WALLET_LIST": {
      "IMPORT_MODAL": {
        "HELP": "Para <b>importar monederos</b>, haga clic para seleccionar o arrastre en la zona de abajo el archivo con la lista de monederos.",
        "NO_NEW_WALLET": "Ningún monedero nuevo",
        "TITLE": "Importar monederos",
        "WALLET_COUNT": "<b>{{count}}</b> nuevo{{count > 1 ? 's' : ''}} monedero{{count > 1 ? 's' : ''}}"
      },
      "TITLE": "Mis monederos",
      "BTN_NEW": "Añadir un monedero",
      "BTN_DOWNLOAD": "Descargue el listado",
      "BTN_IMPORT_FILE_DOTS": "Importar desde fichero…",
      "NO_WALLET": "Sin monedero secundario",
      "BTN_DELETE": "Eliminar un monedero secundario…",
      "BTN_RENAME": "Renombrar el monedero",
      "EXPORT_FILENAME": "monederos-{{pubkey|formatPubkey}}-{{currency}}.csv",
      "TOTAL_DOTS": "Total : ",
      "EDIT_POPOVER": {
        "TITLE": "Renombrar el monedero",
        "HELP": "Escribe el nuevo nombre",
        "NAME_HELP": "Nombre del monedero"
      }
    },
    "SECURITY": {
      "KEYFILE": {
        "ERROR": {
            "BAD_CHECKSUM": "Suma de control (checksum) incorrecta",
            "BAD_PASSWORD": "Frase secreta incorrecta"
        },
        "EWIF_FORMAT": "Formato EWIF (Encrypted Wallet Import Format) - v1",
        "EWIF_FORMAT_HELP": "Este formato almacena su archivo de llaves <b>de forma cifrada</b> a partir de una frase secreta de su elección. También guarda una suma de control (checksum) para verificar la integridad del archivo.<br/><b>Atención :</b>¡ Asegúrese siempre de recordar su frase secreta !",
        "PASSWORD_POPUP": {
            "HELP": "Indique la frase secreta :",
            "PASSWORD_HELP": "Frase secreta",
            "TITLE": "Archivo de llaves cifrado"
        },
        "PUBSEC_FORMAT": "Formato PubSec",
        "PUBSEC_FORMAT_HELP": "Este formato almacena su archivo de llaves de forma simple. Es compatible con Cesium, ğannonce y Duniter.<br/><b>Atención :</b>El archivo <b>no está cifrado</b> (la llave privada aparece en claro) ; ¡ guárdelo en un lugar seguro !",
        "WIF_FORMAT": "Formato WIF (Wallet Import Format) - v1",
        "WIF_FORMAT_HELP": "Este formato almacena su archivo de llaves con una suma de control (checksum) para verificar la integridad del archivo. Es compatible con los monederos en papel (Duniter paper wallet).<br/><b>Atención :</b>El archivo <b>no está cifrado</b> (la llave privada aparece en claro) ; ¡ guárdelo en un lugar seguro !"
      },
      "ADD_QUESTION": "Añadir pregunta personalizada",
      "BTN_CLEAN": "Limpiar",
      "BTN_RESET": "Reiniciar",
      "DOWNLOAD_REVOKE": "Guardar un archivo de revocación",
      "DOWNLOAD_REVOKE_HELP" : "Tener un archivo de revocación es importante, en caso de perdida de las credenciales. Le permitirá <b>invalidar y sacar su cuenta miembro fuera de la Red de Confianza</b>, convirtíendose en un monedero simple.",
      "RECOVER_ID_SELECT_FILE": "Elija el <b>archivo para salvaguardar sus credenciales</b> a utilizar :",
      "GENERATE_KEYFILE": "Generar mi archivo de llaves…",
      "GENERATE_KEYFILE_HELP": "Genera un archivo que le permitirá atenticarse sin tener que introducir las credenciales.<br/><b>Cuidado:</b> este archivo contendrá su llave secreta; ¡Es muy importante conservarlo en un lugar seguro!",
      "KEYFILE_FILENAME": "llavero-{{pubkey|formatPubkey}}-{{currency}}-{{format}}.dunikey",
      "MEMBERSHIP_IN": "Registrarse como miembro…",
      "MEMBERSHIP_IN_HELP": "Le permite <b>transformar</b> una cuenta de monedero simple <b>en una cuenta miembro</b>, enviando una petición de membresía. Solo si todavía no tiene una cuenta miembro.",
      "SEND_IDENTITY": "Publicar identidad…",
      "SEND_IDENTITY_HELP": "Le permite asociar un seudónimo a esta cuenta, pero <b>sin pedir ser miembro</b>. La validez de este seudónimo tiene un plazo limitado.",
      "HELP_LEVEL": "Elija <strong> al menos {{nb}} preguntas:</strong>",
      "LEVEL": "Nivel de seguridad",
      "LOW_LEVEL": "Bajo <span class=\"hidden-xs\">(2 preguntas min.)</span>",
      "MEDIUM_LEVEL": "Medio <span class=\"hidden-xs\">(4 preguntas min.)</span>",
      "QUESTION_1": "¿Cómo se llamaba su mejor amigo de la adolescencia?",
      "QUESTION_2": "¿Cómo se llamaba su primer animal de compañía?",
      "QUESTION_3": "¿Cuál es el primer plato que aprendió a cocinar?",
      "QUESTION_4": "¿Cuál es la primera película que vió en un cine?",
      "QUESTION_5": "¿Cuál era el destino del primer avión que cogió?",
      "QUESTION_6": "¿Cómo se llamaba su docente favorito en la escuela primaria?",
      "QUESTION_7": "¿Cuál sería para usted el mejor oficio?",
      "QUESTION_8": "¿Cuál es su libro infantil preferido?",
      "QUESTION_9": "¿Cuál fue el modelo de su primer vehículo?",
      "QUESTION_10": "¿Cuál fue su sobrenombre durante su infancia?",
      "QUESTION_11": "¿Cuál fue su personaje o actor/actriz preferido/a cuando era estudiante?",
      "QUESTION_12": "¿Cuál fue su cantante o grupo preferido cuando era estudiante?",
      "QUESTION_13": "¿En qué ciudad sus padres se encontraron?",
      "QUESTION_14": "¿Cómo se llamaba su primer jefe/a?",
      "QUESTION_15": "¿Cómo se llama la calle donde creció?",
      "QUESTION_16": "¿Cómo se llama la primera playa donde se bañó?",
      "QUESTION_17": "¿Cuál es el primer álbum que compró?",
      "QUESTION_18": "¿Cuál es el nombre de su equipo deportivo preferido?",
      "QUESTION_19": "¿Cuál fue el oficio de su abuelo?",
      "RECOVER_ID": "Recuperar sus credenciales",
      "REVOCATION_WITH_FILE": "Revocar una identidad a partir de un fichero",
      "REVOCATION_WITH_FILE_DESCRIPTION": "Si ha perdido de forma permanente las credenciales de su cuenta miembro (o la seguridad de la cuenta se ve comprometida), puede usar <b>el archivo de revocación de la cuenta</b> para forzar la salida de la Red de Confianza.",
      "REVOCATION_WITH_FILE_HELP": "Para <b>revocar permanentemente</b> una cuenta miembro, arrastre el archivo de revocación en el cuadro siguiente o haga clic en el cuadro para seleccionar un archivo.",
      "REVOCATION_FILENAME": "revocacion-{{uid}}-{{pubkey|formatPubkey}}-{{currency}}.txt",
      "REVOCATION_WALLET": "Revocar esta identidad",
      "SAVE_ID": "Guardar mis credenciales",
      "STRONG_LEVEL": "Alto <span class=\"hidden-xs \">(6 preguntas min.)</span>",
      "TITLE": "Cuenta y seguridad",
      "RECOVER_ID_HELP": "Si dispone de un <b>archivo de recuperación de sus credenciales</b>, las puede reobtener respondiendo correctamente a las preguntas personales elegidas en su momento.",
      "REVOCATION_WALLET_HELP": "Pedir la revocación de vuestra identidad comporta la <b>salida de la red de confianza</b> (definitiva para el seudónimo y la llave pública asociada). La cuenta no producirá ya más el Dividendo Universal.<br/>Podrá seguir usándola como monedero simple.",
      "SAVE_ID_HELP": "Creación de un archivo de recuperación, para <b>reobtener su contraseña</b> (e identificador secreto) en caso de olvido. El archivo se <b>cifra</b> con ayuda de las preguntas personales elegidas."
    },
    "FILE_NAME": "{{currency}}_HistorialDeCuenta_{{pubkey|formatPubkey}}_{{currentTime|formatDateForFile}}.csv",
    "HEADERS": {
      "TIME": "Fecha",
      "AMOUNT": "Cantidad",
      "COMMENT": "Comentario"
    }
  },
  "TRANSFER": {
    "TITLE": "Transferencia",
    "SUB_TITLE": "Hacer una transferencia",
    "FROM": "De",
    "TO": "A",
    "AMOUNT": "Importe",
    "AMOUNT_HELP": "Importe",
    "COMMENT": "Comentario",
    "COMMENT_HELP": "Comentario",
    "BTN_SEND": "Enviar",
    "BTN_ADD_COMMENT": "Añadir un comentario",
    "REST": "Resto de cuenta",
    "REST_TO": "a",
    "WARN_COMMENT_IS_PUBLIC": "Tenga en cuenta que los <b>comentarios son públicos</b> (sin encriptar).",
    "MODAL": {
      "TITLE": "Transferencia"
    }
  },
  "ERROR": {
    "ADD_SECONDARY_WALLET_FAILED": "Error añadiendo el monedero secundario.",
    "COULD_NOT_ADD_EXISTING_WALLET": "Monedero ya existe en la lista.",
    "COULD_NOT_ADD_MAIN_WALLET": "Este monedero <b>corresponde a la cuenta principal</b> con la que se conecta.<br/>Imposible añadirlo como monedero secundario.",
    "ISSUE_524_TX_FAILED": "Error en la transferencia.<br/><br/>Un mensaje ha sido enviado a los/as desarrolladores/as para facilitar la resolución del problema. <b>Gracias por su ayuda</b>.",
    "LOAD_WALLET_LIST_FAILED": "Error cargando los monederos secundarios.",
    "ONLY_MEMBER_OR_WAS_MEMBER_CAN_EXECUTE_THIS_ACTION": "Usted debe <b>ser miembro (o haber sido miembro)</b> para poder efectuar esta acción.",
    "RESTORE_WALLET_LIST_FAILED": "Error en la restauración de los monederos secundarios.",
    "SAVE_WALLET_LIST_FAILED": "Error al guardar los monederos secundarios.",
    "UNKNOWN_WALLET_ID": "Monedero secundario desconocido.",
    "UPDATE_WALLET_LIST_FAILED": "Error en la actualización de los monederos secundarios.",
    "UNKNOWN_URI_FORMAT": "Formato URI desconocido",
    "PUBKEY_INVALID_CHECKSUM": "Llave pública no válida (suma de comprobación incorrecta).",
    "POPUP_TITLE": "Error",
    "UNKNOWN_ERROR": "Error desconocido",
    "CRYPTO_UNKNOWN_ERROR": "Su navegador parece incompatible con las funcionalidades de cryptografía.",
    "DOWNLOAD_KEYFILE_FAILED": "Error al generar el archivo de llaves.",
    "EQUALS_TO_PSEUDO": "Debe ser diferente del seudónimo.",
    "EQUALS_TO_SALT": "Debe ser diferente del identificador secreto.",
    "FIELD_REQUIRED": "Campo obligatorio.",
    "FIELD_TOO_SHORT": "Valor demasiado corta.",
    "FIELD_TOO_SHORT_WITH_LENGTH": "Valor demasiado corta ({{minLength}} carácteres mín)",
    "FIELD_TOO_LONG": "Valor demasiado largo",
    "FIELD_TOO_LONG_WITH_LENGTH": "Valor demasiado largo, ({{maxLength}} carácteres máx)",
    "FIELD_MIN": "Valor mínimo: {{min}}",
    "FIELD_MAX": "Valor máximo: {{max}}",
    "FIELD_ACCENT": "Caracteres acentuados y comas no autorizados",
    "FIELD_NOT_NUMBER": "Valor numérico esperado",
    "FIELD_NOT_INT": "Valor entero esperado",
    "FIELD_NOT_EMAIL": "Correo electrónico no válido",
    "PASSWORD_NOT_CONFIRMED": "No coincide con la contraseña anterior.",
    "SALT_NOT_CONFIRMED": "No corresponde al identificador secreto anterior.",
    "SEND_IDENTITY_FAILED": "Error de la inscripción.",
    "SEND_CERTIFICATION_FAILED": "Error de la certificación.",
    "NEED_MEMBER_ACCOUNT_TO_CERTIFY": "No se puede certificar, porque su cuenta no <b>es miembro</b>.",
    "NEED_MEMBER_ACCOUNT_TO_CERTIFY_HAS_SELF": "No se puede certificar, porque su cuenta todavía no es miembro.<br/><br/>Todavía faltan certificaciones para serlo.",
    "IDENTITY_TO_CERTIFY_HAS_NO_SELF": "Esta cuenta no se pudo certificar. No se ha solicitado la membresía, o se necesita renovarla.",
    "LOGIN_FAILED": "Error durante la autentificación.",
    "LOAD_IDENTITY_FAILED": "Error de carga de la identidad.",
    "LOAD_REQUIREMENTS_FAILED": "Error de carga de las condiciones de la identidad.",
    "SEND_MEMBERSHIP_IN_FAILED": "Error en el intento de entrada en la comunidad.",
    "SEND_MEMBERSHIP_OUT_FAILED": "Error en la interrupción de adhesión.",
    "REFRESH_WALLET_DATA": "Error en la actualización del monedero.",
    "GET_CURRENCY_PARAMETER": "Error en la recuperación de las reglas de moneda.",
    "GET_CURRENCY_FAILED": "Carga de la moneda imposible. Por favor, intente más tarde.",
    "SEND_TX_FAILED": "Error en la transferencia.",
    "ALL_SOURCES_USED": "Por favor, espera el cálculo del bloque siguiente (Todas sus fuentes de moneda fueron utilizada).",
    "NOT_ENOUGH_SOURCES": "No lo bastante cambio para mandar este importe en una sola transacción.<br/>Importe máximo: {{amount}} {{unit}}<sub>{{subUnit}}</sub>.",
    "ACCOUNT_CREATION_FAILED": "Error en la creación de la cuenta miembro.",
    "RESTORE_WALLET_DATA_ERROR": "Error en la recarga de los ajustes desde el almacenamiento local",
    "LOAD_WALLET_DATA_ERROR": "Error en la carga de los datos del monedero.",
    "COPY_CLIPBOARD_FAILED": "Copia de la valor imposible.",
    "TAKE_PICTURE_FAILED": "Error en la recuperación de la foto.",
    "SCAN_FAILED": "Error en el escán del Codigo QR",
    "SCAN_UNKNOWN_FORMAT": "Codigo no reconocido.",
    "WOT_LOOKUP_FAILED": "Error en la búsqueda",
    "LOAD_PEER_DATA_FAILED": "Lectura del nodo Duniter imposible. Por favor, intente más tarde.",
    "NEED_LOGIN_FIRST": "Por favor, conéctese en primer lugar.",
    "AMOUNT_REQUIRED": "El importe es obligatorio.",
    "AMOUNT_NEGATIVE": "Importe negativo no autorizado.",
    "NOT_ENOUGH_CREDIT": "Crédito insuficiente.",
    "INVALID_NODE_SUMMARY": "Nodo ilocalizable o dirección inválida.",
    "INVALID_USER_ID": "El seudónimo no debe contener ni espacios ni caracteres especiales o acentuado.",
    "INVALID_COMMENT": "El campo 'referencia’ no debe contener carácteres acentuados.",
    "INVALID_PUBKEY": "La llave pública no tiene el formato esperado.",
    "INVALID_PUBKEY_CHECKSUM": "Suma de comprobación inválida.",
    "IDENTITY_REVOKED": "Esta identidad <b>fue revocada</b>. No puede volver a convertirla en miembro.",
    "IDENTITY_REVOKED_WITH_TIME": "Esta identidad <b>fue revocada {{revocationTime|medianFromNow}}</b> ({{revocationTime|medianDate}}). No puede volver a convertirla en miembro.",
    "IDENTITY_PENDING_REVOCATION": "La <b>revocación de esta identidad</b> fue solicitado y esta en espera de tratamiento. Por lo que, la certificación es desactivada.",
    "IDENTITY_INVALID_BLOCK_HASH": "Esta solicitud de adhesión no es valida (porque denomina un bloque los nodos de la red han anulado): esta persona debe renovelar su solicitud de adhesión <b>antes que</b> estar certificada.",
    "IDENTITY_EXPIRED": "La publicación de esta identidad ha caducada: esta persona debe realizar una nueva solicitud de adhesión <b>antes que</b> estar certificada.",
    "IDENTITY_SANDBOX_FULL": "EL nodo Duniter utilizado por Cesium ya no puede recibir más nuevas identidades, porque la fila de espera es llena.<br/><br/>Por favor, intenta ulteriormente o cambia de nodo (vía el menú <b>Ajustes</b>).",
    "IDENTITY_NOT_FOUND": "Identidad no encontrada",
    "IDENTITY_TX_FAILED": "Error cargando las transacciones de la identidad",
    "WOT_PENDING_INVALID_BLOCK_HASH": "Adhesión no validada.",
    "WALLET_INVALID_BLOCK_HASH": "Su solicitud de adhesión ya no está validada (porque denomina un bloque los nodos de la red han anulado).<br/>Debe <a ng-click=\"doQuickFix('fixMembership')\">mandar una nueva solicitud</a> para resolver este problema.",
    "WALLET_IDENTITY_EXPIRED": "La publicación de <b>su identidad ha caducada</b>.<br/>Debe <a ng-click=\"doQuickFix('fixIdentity')\">publicar une outra vez su identidad</a> para resolver este problema.",
    "WALLET_REVOKED": "Su identidad fue <b>revocada</b>: ni su seudónimo ni su llave pública podrán estar utilizados en el futuro por una cuenta miembro.",
    "WALLET_HAS_NO_SELF": "Su identidad debe en primer lugar haber estado publicado, y no estar caducada.",
    "AUTH_REQUIRED": "Autenticación requerida.",
    "AUTH_INVALID_PUBKEY": "La llave pública no se corresponde con la cuenta conectada",
    "AUTH_INVALID_SCRYPT": "De usuario o contraseña no válidos.",
    "AUTH_INVALID_FILE": "archivo de llave no válido.",
    "AUTH_FILE_ERROR": "No se pudo abrir el archivo de llave",
    "IDENTITY_ALREADY_CERTIFY": "Ha <b>ya certificado</b> esta identidad.<br/><br/>Esta certificación todavía es valida (expiration {{expiresIn|formatDurationTo}}).",
    "IDENTITY_ALREADY_CERTIFY_PENDING": "Ha <b>ya certificado</b> esta identidad.<br/><br/>Esta certificación está en espera de tratamiento (fecha límite de tratamiento {{expiresIn|formatDurationTo}}).",
    "UNABLE_TO_CERTIFY_TITLE": "Certificación imposible",
    "LOAD_NEWCOMERS_FAILED": "No se pudo cargar las nuevas membresías.",
    "LOAD_PENDING_FAILED": "No se pudo cargar las inscripciones pendientes.",
    "ONLY_MEMBER_CAN_EXECUTE_THIS_ACTION": "Debe <b>ser miembro</b> para poder realizar esta acción.",
    "ONLY_SELF_CAN_EXECUTE_THIS_ACTION": "Debe haber <b>publicado su identidad</b> para poder realizar esta acción.",
    "GET_BLOCK_FAILED": "Error en la recuperación del bloque",
    "INVALID_BLOCK_HASH": "Bloque no encontrado (hash diferente)",
    "DOWNLOAD_REVOCATION_FAILED": "Debe seleccionar un fichero de texto",
    "REVOCATION_FAILED": "Error en la revocación.",
    "SALT_OR_PASSWORD_NOT_CONFIRMED": "Identificador secreto o contraseña incorrectos",
    "RECOVER_ID_FAILED": "Error en la recuperación de las credenciales",
    "LOAD_FILE_FAILED": "Error en la carga del archivo",
    "NOT_VALID_REVOCATION_FILE": "Archivo de revocación no válido (formato de archivo erróneo)",
    "NOT_VALID_SAVE_ID_FILE": "Archivo no válido (formato de archivo erróneo)",
    "NOT_VALID_KEY_FILE": "Archivo no válido (formato de archivo erróneo)",
    "EXISTING_ACCOUNT": "Sus credenciales corresponden a una cuenta existente, la <a ng-click=\"showHelpModal('pubkey')\">llave pública</a> es:",
    "EXISTING_ACCOUNT_REQUEST": "Por favor, cambie sus credenciales para que coincida con una cuenta sin usar.",
    "GET_LICENSE_FILE_FAILED": "Error al obtener el archivo de licencia",
    "CHECK_NETWORK_CONNECTION": "No se puede conectar a ningún nodo.<br/><br/><b>Compruebe la conexión a Internet</b>.",
    "INVALID_FILE_FORMAT": "Formato de archivo inválido.",
    "SAME_TX_RECIPIENT": "El destinatario debe ser diferente del emisor."
  },
  "INFO": {
    "POPUP_TITLE": "Información",
    "CERTIFICATION_DONE": "Certificación enviada",
    "NOT_ENOUGH_CREDIT": "Crédito insuficiente",
    "TRANSFER_SENT": "Transferencia enviada",
    "COPY_TO_CLIPBOARD_DONE": "Copia realizada",
    "MEMBERSHIP_OUT_SENT": "Anulación enviada",
    "NOT_NEED_MEMBERSHIP": "Ya es miembro.",
    "IDENTITY_WILL_MISSING_CERTIFICATIONS": "Esta identidad pronto va a necesitar certificaciones (al menos {{willNeedCertificationCount}}).",
    "IDENTITY_NEED_MEMBERSHIP": "Esta identidad no envió una solicitud de membresía. Ella tendrá que hacerlo si desea hacerse miembro.",
    "HAS_ALTERNATIVE_IDENTITIES": "Hay <b>identidades múltiples</b> adjuntas a esta llave pública. <b>Antes de cualquier certificación</b>, <a ng-click=\"doQuickFix('showSelectIdentities')\">verifique otras identidades</a> para elegir la correcta o comuníquese con el propietario de la cuenta.",
    "REVOCATION_SENT": "Revocación enviada",
    "REVOCATION_SENT_WAITING_PROCESS": "La <b>revocación de esta identidad</b> fue solicitada y está en espera de ser procesada.",
    "FEATURES_NOT_IMPLEMENTED": "Esta funcionalidad todavía está en proceso de desarrollo.<br/><br/>¿Por qué no <b>contribuir a Cesium</b>, para obtenerla más rápido? ;)",
    "EMPTY_TX_HISTORY": "Ninguna operación a exportar"
  },
  "CONFIRM": {
    "POPUP_TITLE": "<b>Confirmación</b>",
    "POPUP_WARNING_TITLE": "<b>Advertencia</b>",
    "POPUP_SECURITY_WARNING_TITLE": "<i class=\"icon ion-alert-circled\"></i> <b>Advertencia de seguridad</b>",
    "CERTIFY_RULES_TITLE_UID": "Certificar {{uid}}",
    "CERTIFY_RULES": "<b class=\"assertive\">NO CERTIFICAR</b> una cuenta si piensa que :<br/><br/><ul><li>1.) no corresponde a una persona <b>física y viva</b>.<li>2.) su propietario <b>posee otra cuenta</b> ya certificada.<li>3.) su propietario viola (voluntariamente o no) la regla 1 o 2 (por ejemplo certificando cuentas falsas o duplicadas).</ul><br/><b>¿Desea</b> todavía certificar esta identidad?",
    "FULLSCREEN": "¿ Mostrar la aplicación en pantalla completa ?",
    "EXIT_APP": "¿ Cerrar la aplicación ?",
    "TRANSFER": "<b>Resumen de la transferencia</b>:<br/><br/><ul><li> - De: {{from}}</li><li> - A: <b>{{to}}</b></li><li> - Importe: <b>{{amount}} {{unit}}</b></li><li> - Comentario: <i>{{comment}}</i></li></ul><br/><b>Desea realizar esta transferencia?</b>",
    "TRANSFER_ALL": "<b>Resumen de la transferencia</b>:<br/><br/><ul><li> - De: {{from}}</li><li> - A: <b>{{to}}</b></li><li> - Importe: <b>{{amount}} {{unit}}</b></li><li> - Comentario: <i>{{comment}}</i></li><br/><li> - Resto: <b>{{restAmount}} {{unit}}</b> para <b>{{restTo}}</b></li></ul><br/><b>¿Desea realizar esta transferencia?</b>",
    "MEMBERSHIP_OUT": "Esta operación es <b>irreversible</b>.<br/></br/>¿Desea <b>anular su cuenta miembro</b>?",
    "MEMBERSHIP_OUT_2": "¡Esta operación es <b>irreversible</b>!<br/><br/>¿Desea <b>anular su candidatura</b> como miembro?",
    "LOGIN_UNUSED_WALLET_TITLE": "¿Error de introducción de datos?",
    "LOGIN_UNUSED_WALLET": "Las credenciales introducidas corresponden a una cuenta que parece <b>inactiva</b>.<br/></br/><b>¿Quiere sin embargo continuar con esta cuenta?</b>",
    "FIX_IDENTITY": "El seudónimo <b>{{uid}}</b> va a ser publicado de nuevo, en reemplazo del antiguo que caducó.<br/></br/><b>¿Desea</b> continuar?",
    "FIX_MEMBERSHIP": "Su solicitud de adhesión como miembro va a ser enviada de nuevo.<br/></br/><b>¿Desea</b> continuar?",
    "MEMBERSHIP": "Se enviará su solicitud de membresía como miembro.<br/></br/><b>¿Desea</b> continuar?",
    "RENEW_MEMBERSHIP": "Su adhesión como miembro va a estar renovada.<br/></br/><b>¿Desea</b> continuar?",
    "REVOKE_IDENTITY": "Va a <b>revocar definitivamente esta identidad</b>.<br/><br/>La llave pública y el seudónimo asociados <b>jamás podrán ser utilizados</b> (para una cuenta miembro). <br/><br/><b>¿Desea</b> revocar definitivamente esta cuenta?",
    "REVOKE_IDENTITY_2": "¡Esta operación es <b>irreversible</b>!<br/><br/>¿Desea <b>revocar definitivamente</b> esta cuenta?",
    "NOT_NEED_RENEW_MEMBERSHIP": "Su membresía no necesita ser renovada actualmente (caducará en {{membershipExpiresIn|formatDuration}}).<br/></br/><b>¿Confirma</b> querer renovar su membresía?",
    "SAVE_BEFORE_LEAVE": "¿Desea <b>guardar sus cambios</b> antes de abandonar la página?",
    "SAVE_BEFORE_LEAVE_TITLE": "Cambios no registrados",
    "LOGOUT": "¿Desea desconectarse?",
    "USE_FALLBACK_NODE": "Nodo <b>{{old}}</b> inalcanzable o dirección inválida.<br/><br/>¿Desea utilizar temporalmente el nodo <b>{{new}}</b>?",
    "ISSUE_524_SEND_LOG": "La transacción ha sido rechazada a causa de una anomalía conocida (ticket #524) pero todavía <b>no replicable</b>.<br/><br/>Para ayudar a los/as desarrolladores/as a corregir este error, ¿ <b>acepta el envío de los logs(trazas del programa)</b> ?<br/><small>(ningún dato confidencia será enviado)</small>."
  },
  "MODE": {
    "DEMO": {
      "BADGE": "Demo",
      "MODE": "Modo de demostración",
      "FEATURE_NOT_AVAILABLE": "Funcionalidad <b>no disponible</b> en este sitio de demostración.",
      "MODE_HELP": "Cesium funciona en <b> modo de demostración </b>: la consulta está disponible, pero no se puede realizar ninguna operación.",
      "INSTALL_HELP": "Por <b>razones de seguridad</b> recomendamos <b>instalar</b> su copia del software.<br/>Visite el sitio de Internet <a href='https://cesium.app'> www.cesium.app </a> para obtener ayuda."
    },
    "READONLY": {
      "BADGE": "Monit",
      "MODE": "Modo de supervisión",
      "MODE_HELP": "Cesium funciona en <b> modo de supervisión </b>: solo están disponibles las funciones de monitoreo de divisas.",
      "INSTALL_HELP": "Si desea <b>crear una cuenta</b> para enviar o recibir dinero, le recomendamos <b>instalar</b> su copia del software.<br/>Visite el sitio de Internet <a href='https://cesium.app'> www.cesium.app </a> para obtener ayuda."
    }
  },
  "DOWNLOAD": {
    "POPUP_TITLE": "<b>Revocación del archivo</b>",
    "POPUP_REVOKE_MESSAGE": "Para proteger su cuenta, descargue el <b>documento de revocación de cuenta</b>. Le permitirá cancelar su cuenta (en caso de robo, cambio de identificador, cuenta creada incorrectamente, etc.).<br/><br/><b>Por favor, almacénelo en un lugar seguro.</b>"
  },
  "HELP": {
    "TITLE": "Ayuda en línea",
    "JOIN": {
      "SECTION": "Inscripción",
      "SALT": "El identificador secreto es muy importante. Sirve para mezclar(<span class=\"text-italic\">hash</span>) la contraseña, antes de calcular la <span class=\"text-italic\">llave pública</span> (el número de cuenta) y la <span class=\"text-italic\">llave privada</span> para acceder a esta.<br/><b>Por favor, memorícelo muy bien</b> porque no existe ninguna forma de recuperarlo en caso de pérdida.<br/>No puede ser modificado. Deberá crear una nueva cuenta si lo pierde o se olvida.<br/><br/>Un buen identificador secreto debe ser suficientemente largo (al menos 8 carácteres) y lo más original posible.",
      "PASSWORD": "La contraseña es muy importante. Junto al identificador secreto, sirve para calcular la llave pública (el número de cuenta), y la llave privada para acceder a ella.<br/><b>Por favor, memorícela muy bien</b> porque no existe ninguna forma de recuperarla en caso de pérdida (excepto si se tuviese un fichero de respaldo o <span class=\"text-italic\">backup</span>.).<br/>No puede ser modificada. Deberá crear una nueva cuenta si la pierde o se olvida.<br/><br/>Una buena contraseña contiene al menos 8 carácteres, con al menos una mayúscula y un dígito.",
      "PSEUDO": "El seudónimo se utiliza solamente en caso de inscripción como <span class=\"text-italic\">miembro</span>. Siempre está asociado a un monedero (vía su <span class=\"text-italic\">llave pública</span>).<br/>Este se publica en la red para que los demás usuarios puedan identificar, certificar o enviar dinero a la cuenta.<br/>Un seudónimo debe ser único para cada miembro (actuales y antiguos)."
    },
    "LOGIN": {
      "SECTION": "Autenticación",
      "PUBKEY": "Llave pública",
      "PUBKEY_DEF": "La llave pública del archivo de llaves es generada de las credenciales introducidas (cualquiera que sean), sin estar obligatoriamente vinculadas o contrastadas con ninguna cuenta ya usada. <br/><b>Asegúrese por lo tanto de que la llave pública es la misma con la que se creó originalmente su cuenta</b>. De lo contrario, se autogenerará una cuenta vacía que probablemente nunca ha sido usada, ya que el riesgo de coincidir con las credenciales de otra cuenta ajena es muy pequeño.<br/><a href=\"https://es.wikipedia.org/wiki/Criptograf%C3%ADa_de_curva_el%C3%ADptica\" target=\"_ system\">Conozca más sobre criptografía</a> con llaves públicas.",
      "METHOD": "Métodos de autenticación",
      "METHOD_DEF": "Diversas opciones están disponibles para conectar a las cuentas: <br/> - La conexión <b>con aleatoriedad (estándar o avanzada)</b> mezcla su contraseña con su identificador secreto, para limitar los intentos de ataque<br/> - La conexión <b>usando llave pública</b> le permite entrar sin credenciales, las cuales solo se le pedirán cuando alguna operación lo necesite.<br/> - La conexión <b>usando archivo de llaves</b> leerá las llave pública y privada de la cuenta desde un archivo sin necesitar sus credenciales. Varios formatos son posibles."
    },
    "GLOSSARY": {
      "SECTION": "Glosario",
      "PUBKEY_DEF": "Una llave pública identifica un monedero, que puede estar asociado a un miembro o ser un monedero anónimo. En Cesium se calcula a partir del identificador secreto y la contraseña.",
      "MEMBER": "Miembro",
      "MEMBER_DEF": "Cada miembro es una persona humana física y viva, deseosa de participar libremente en la comunidad monetaria. Percibe un dividendo universal, de acuerdo a un periodo e importe definido en las <span class=\"text-italic\">reglas de la moneda</span>",
      "CURRENCY_RULES": "Reglas de la moneda",
      "CURRENCY_RULES_DEF": "Las reglas de la moneda se han definido una vez y para siempre. Establecen el funcionamiento de la moneda: el cálculo del dividendo universal, la cantidad de certificaciones necesarias para ser miembro, la cantidad máxima de certificaciones que cada miembro puede emitir, etc. <a href=\"#/app/currency\">Ver las reglas actuales</a>.<br/> Sus parámetros no pueden alterarse gracias a una <span class=\"text-italic\">Cadena de Bloques</span> que soporta, implementa y verifica la buena aplicación de estas reglas.",
      "BLOCKCHAIN": "Cadena de bloques (<span class=\"text-italic\">Blockchain</span>)",
      "BLOCKCHAIN_DEF": "La cadena de bloques es un sistema descentralizado, que en el caso de Duniter, sirve para mantener e implementar las <span class=\"text-italic\">reglas de la moneda</span>.<br/><a href=\"http://duniter.org\" target=\"_system\">Más información</a> acerca de Duniter y el funcionamiento de su cadena de bloques.",
      "UNIVERSAL_DIVIDEND_DEF": "El Dividendo Universal (DU) es la cantidad de moneda co-creada por cada miembro, dependiendo del periodo y del cálculo definidos en las <span class=\"text-italic\">reglas de la moneda</span>.<br/>En cada periodo, los miembros reciben en sus cuentas la misma cantidad de moneda.<br/><br/>El DU crece regularmente, para ser justo entre cada miembro (actualmente y en el futuro), y calculado en función de la esperanza de vida media, como se demuestra en la <span class=\"text-italic\">Teoría Relativa de la Moneda</span> (TRM, de Stéphane Laborde).<br/><a href=\"http://trm.creationmonetaire.info\">Más información</a> sobre la TRM y las monedas libres.",
      "WOT": "Red de Confianza (RdC)",
      "WOT_DEF": "La Red de Confianza se compone del conjunto de miembros de la moneda, y de los enlaces de certificaciones que los conectan.",
      "DISTANCE_RULE": "Regla de distancia",
      "DISTANCE_RULE_DEF": "La regle de distancia de la Red de Confianza define <b>una distancia máxima a respetar</b> entre una candidatura y número mínimo miembros referentes (aquellos más conectados). Esta distancia es calculada utilizando los enlaces de certificación."
    },
    "TIP": {
      "MENU_BTN_CURRENCY": "El menú <b>{{'MENU.CURRENCY'|translate}}</b> permite consultar las <b>reglas de la moneda</b> y su estado.",
      "CURRENCY_WOT": "El <b>número de miembros</b> muestra el peso de la comunidad y permite <b>seguir su evolución</b>.",
      "CURRENCY_MASS": "Siga aquí la <b>cantidad total de moneda</b> existente y su <b>distribución media</b> por miembro.<br/><br/>Esto permite juzgar la <b>relevancia de un importe</b>, en relación con lo que <b>poseen los demás</b> en sus cuentas (de media).",
      "CURRENCY_UNIT_RELATIVE": "La unidad utilizada (&ldquo;<b>{{'COMMON.UD'|translate}}<sub>{{currency|abbreviate}}</sub></b>&rdquo;) significa que los importes en {{currency|capitalize}} han sido divididos entre el valor del <b>Dividendo Universal</b> (DU).<br/><br/><small> Esta unidad relativa es <b>pertinente</b>, porque permanece estable, independiente de la cantidad de moneda que aumenta constantemente.</small>",
      "CURRENCY_CHANGE_UNIT": "Este botón permite <b>cambiar la unidad</b>, para visualizar los importes <b>directamente en {{currency|capitalize}}</b> (en lugar de &ldquo;<b>{{'COMMON.UD'|translate}}<sub>{{currency|abbreviate}}</sub></b>&rdquo;).",
      "CURRENCY_CHANGE_UNIT_TO_RELATIVE": "Este botón permite <b>cambiar la unidad</b>, para visualizar los importes en &ldquo;<b>{{'COMMON.UD'|translate}}<sub>{{currency|abbreviate}}</sub></b>&rdquo;, es decir, relativo al Dividendo Universal (el monto co-producido por cada miembro).",
      "CURRENCY_RULES": "Las <b>reglas</b> de la moneda fijan su funcionamiento <b>exacto y previsible</b>.<br/><br/>Es el propio ADN de la moneda, que hace que su código monetario sea <b>legible y transparente</b>.",
      "MENU_BTN_NETWORK": "El menú <b>{{'MENU.NETWORK'|translate}}</b> permite consultar el estado de la red.",
      "NETWORK_BLOCKCHAIN": "Todas las transacciones de la moneda están registradas dentro de un gran libro de contabilidad <b>público e infalsificable</b>, conocido como la <b>cadena de bloques</b> (<em>BlockChain</em> en inglés).",
      "NETWORK_PEERS": "Los <b>nodos</b> visibles aquí corresponden a los <b>dispositivos de miembros que actualizan y validan</b> la cadena de bloques.<br/><br/>Cuanto más nodos haya conectados, la moneda tendrá una gestión más <b>descentralizada</b> y digna de confianza.",
      "NETWORK_PEERS_BLOCK_NUMBER": "Este <b>número</b> (en verde) indica el <b>último bloque validado</b> por este nodo (última página escrita en la cadena de bloques).<br/><br/>El color verde indica que este bloque ha sido también validado por <b>la mayoría del resto de nodos</b>.",
      "NETWORK_PEERS_PARTICIPATE": "<b>Cada miembro</b>, equipado de un dispositivo conectado a Internet, <b>puede contribuir añadiendo un nodo</b>.  Necesita <b>instalar el programa Duniter</b> (libre y gratuito). <a href=\"{{installDocUrl}}\" target=\"_system\">Ver manual de uso &gt;&gt;</a>.",
      "MENU_BTN_ACCOUNT": "<b>{{'ACCOUNT.TITLE'|translate}}</b> permite acceder a la gestión y al historial de su cuenta.",
      "MENU_BTN_ACCOUNT_MEMBER": "Consulte aquí el estado de su cuenta y la información sobre sus certificaciones.",
      "WALLET_CERTIFICATIONS": "Haga clic aquí para consultar el detalle de sus certificaciones (recibidas y emitidas).",
      "WALLET_RECEIVED_CERTIFICATIONS": "Haga clic aquí para consultar el detalle de sus <b>certificaciones recibidas</b>.",
      "WALLET_GIVEN_CERTIFICATIONS": "Haga clic aquí para consultar el detalle de sus <b>certificaciones emitidas</b>.",
      "WALLET_BALANCE": "El <b>saldo</b> de su cuenta se visualiza aquí.",
      "WALLET_BALANCE_RELATIVE":
      "{{'HELP.TIP.WALLET_BALANCE'|translate}}<br/><br/>La unidad utilizada (&ldquo;<b>{{'COMMON.UD'|translate}}<sub>{{currency|abbreviate}}</sub></b>&rdquo;) significa que el importe en {{currency|capitalize}} fue dividido entre el <b>Dividendo Universal</b> (DU) co-producido por cada miembro.<br/><br/>Actualmente un DU vale {{currentUD|formatInteger}} {{currency|capitalize}}s.",
      "WALLET_BALANCE_CHANGE_UNIT": "Podrá <b>cambiar la unidad</b> de visualización de los importes en los <b><i class=\"icon ion-android-settings\"></i>&nbsp;{{'MENU.SETTINGS'|translate}}</b>.<br/><br/>Por ejemplo, para visualizar los importes <b>directamente en {{currency|capitalize}}</b>, en lugar de unidad relativa.",
      "WALLET_PUBKEY": "Esta es la llave pública de su cuenta. Puede comunicarla a un tercero para que pueda identificar su cuenta de forma simple.",
      "WALLET_SEND": "Realizar un pago en algunos clics",
      "WALLET_SEND_NO_MONEY": "Realizar un pago en algunos clics.<br/>(Su saldo ya no lo permite)",
      "WALLET_OPTIONS": "Este botón permite acceder a las <b>acciones de adhesión</b> y de seguridad.<br/><br/>¡No olvide echar un vistazo!",
      "WALLET_RECEIVED_CERTS": "Se exhibirá aquí la lista de las personas que le han certificado.",
      "WALLET_CERTIFY": "El botón <b>{{'WOT.BTN_SELECT_AND_CERTIFY'|translate}}</b> permite seleccionar una identidad y certificarla.<br/><br/>Solo quienes son <b>miembros</b> pueden certificar a otras personas.",
      "WALLET_CERT_STOCK": "Su stock de certificaciones (emitidas) es limitado a <b>{{sigStock}} certificaciones</b>.<br/><br/>Este stock se renueva con el tiempo, a medida que las certificaciones caducan.",
      "MENU_BTN_TX": "El menú <b>{{'MENU.TRANSACTIONS'|translate}}</b> permite consultar su saldo, el historial de transacciones y realizar nuevos pagos.",
      "MENU_BTN_WALLETS": "El menú <b>{{'MENU.WALLETS'|translate}}</b> permite añadir monederos complementarios que usted maneja.",
      "MENU_BTN_WOT": "El menú <b>{{'MENU.WOT'|translate}}</b> permite buscar <b>usuarios</b> de la moneda (miembro o no).",
      "WOT_SEARCH_TEXT_XS": "Para buscar en el directorio, escriba las <b>primeras letras de un seudónimo</b> (o de una llave pública).<br/><br/>La búsqueda se iniciará automáticamente.",
      "WOT_SEARCH_TEXT": "Para buscar en el directorio, escriba las <b>primeras letras de un seudónimo</b> (o de una llave pública). <br/><br/>Luego, pulse en la tecla <b>Intro</b> para iniciar la búsqueda.",
      "WOT_SEARCH_RESULT": "Visualice la ficha detallada <b>haciendo clic</b> sobre una fila.",
      "WOT_VIEW_CERTIFICATIONS": "La opción <b>{{'ACCOUNT.CERTIFICATION_COUNT'|translate}}</b> muestra qué miembros han validado esta identidad.<br/><br/>Estas certificaciones atestiguan que la cuenta pertenece a <b>una persona humana viva</b> y que no posee <b>ninguna otra cuenta miembro</b>.",
      "WOT_VIEW_CERTIFICATIONS_COUNT": "Necesita al menos <b>{{sigQty}} certificaciones</b> para ser miembro y recibir el <b>Dividendo Universal</b>.",
      "WOT_VIEW_CERTIFICATIONS_CLICK": "Un clic aquí permite abrir <b>la lista de todas las certificaciones</b> de la identidad (recibidas y emitidas).",
      "WOT_VIEW_CERTIFY": "El botón <b>{{'WOT.BTN_CERTIFY'|translate}}</b> permite añadir su certificación a esta identidad.",
      "CERTIFY_RULES": "<b>Atención:</b> Certifique solamente <b>personas físicas vivas</b>, que no posean ya ninguna otra cuenta miembro.<br/><br/>¡La seguridad de la red de la moneda depende del cuidado de cada persona!",
      "MENU_BTN_SETTINGS": "En <b>{{'MENU.SETTINGS'|translate}}</b> podrá configurar la aplicación.",
      "HEADER_BAR_BTN_PROFILE": "Haga clic aquí para acceder a su <b>perfil</b>",
      "SETTINGS_CHANGE_UNIT": "Podrá <b>cambiar la unidad de visualización</b> de los importes haciendo clic aquí.<br/><br/>- Desactive la opción para mostrar los importes en {{currency|capitalize}}.<br/>- Actívela para importes relativos al {{'COMMON.UD'|translate}}<sub>{{currency|abbreviate}}</sub> (las cantidades de los importes se mostrarán <b>divididos</b> entre el Dividendo Universal actual).",
      "END_LOGIN": "La visita guiada ha <b>terminado</b>.<br/><br/>¡Buena suerte en este nuevo mundo de la <b>economía libre</b> !",
      "END_NOT_LOGIN": "La visita guiada ha <b>terminado</b>.<br/><br/>Si quiere utilizar la moneda {{currency|capitalize}}, tiene que hacer un clic en <b>{{'LOGIN.CREATE_ACCOUNT'|translate}}</b> más abajo.",
      "END_READONLY": "La visita guiada ha <b>terminado</b>.<br/><br/>{{'MODE.READONLY.INSTALL_HELP'|translate}}."
    }
  }
}
);

$translateProvider.translations("fr-FR", {
  "COMMON": {
    "APP_NAME": "Cesium",
    "APP_VERSION": "v{{version}}",
    "APP_BUILD": "date : {{build}}",
    "PUBKEY": "Clé publique",
    "MEMBER": "Membre",
    "BLOCK" : "Bloc",
    "BTN_OK": "OK",
    "BTN_YES": "Oui",
    "BTN_NO": "Non",
    "BTN_SEND": "Envoyer",
    "BTN_SEND_MONEY": "Faire un virement",
    "BTN_SEND_MONEY_SHORT": "Virement",
    "BTN_SAVE": "Enregistrer",
    "BTN_YES_SAVE": "Oui, Enregistrer",
    "BTN_YES_CONTINUE": "Oui, Continuer",
    "BTN_SHOW": "Voir",
    "BTN_SHOW_PUBKEY": "Afficher la clé publique",
    "BTN_RELATIVE_UNIT": "Afficher les montants en DU ?",
    "BTN_BACK": "Retour",
    "BTN_NEXT": "Suivant",
    "BTN_IMPORT": "Importer",
    "BTN_CANCEL": "Annuler",
    "BTN_CLOSE": "Fermer",
    "BTN_LATER": "Plus tard",
    "BTN_LOGIN": "Se connecter",
    "BTN_LOGOUT": "Déconnexion",
    "BTN_ADD_ACCOUNT": "Nouveau compte",
    "BTN_SHARE": "Partager",
    "BTN_EDIT": "Modifier",
    "BTN_DELETE": "Supprimer",
    "BTN_ADD": "Ajouter",
    "BTN_SEARCH": "Rechercher",
    "BTN_REFRESH": "Actualiser",
    "BTN_RETRY": "Recommencer",
    "BTN_START": "Commencer",
    "BTN_CONTINUE": "Continuer",
    "BTN_CREATE": "Créer",
    "BTN_UNDERSTOOD": "J'ai compris",
    "BTN_OPTIONS": "Options",
    "BTN_HELP_TOUR": "Visite guidée",
    "BTN_HELP_TOUR_SCREEN": "Découvrir cet écran",
    "BTN_DOWNLOAD": "Télécharger",
    "BTN_DOWNLOAD_ACCOUNT_STATEMENT": "Télécharger le relevé du compte",
    "BTN_MODIFY": "Modifier",
    "CHOOSE_FILE": "Déposez votre fichier <br/>ou cliquez pour le sélectionner",
    "DAYS": "jours",
    "NO_ACCOUNT_QUESTION": "Pas encore de compte ? Créez-en un gratuitement !",
    "SEARCH_NO_RESULT": "Aucun résultat trouvé",
    "LOADING": "Veuillez patienter...",
    "LOADING_WAIT": "Veuillez patienter...<br/><small>(Cesium interroge le nœud Duniter)</small>",
    "SEARCHING": "Recherche en cours...",
    "FROM": "De",
    "TO": "À",
    "COPY": "Copier",
    "LANGUAGE": "Langue",
    "UNIVERSAL_DIVIDEND": "Dividende universel",
    "UD": "DU",
    "DATE_PATTERN": "DD/MM/YY HH:mm",
    "DATE_FILE_PATTERN": "YYYY-MM-DD",
    "DATE_SHORT_PATTERN": "DD/MM/YY",
    "DATE_MONTH_YEAR_PATTERN": "MM/YYYY",
    "EMPTY_PARENTHESIS": "(vide)",
    "UID": "Pseudonyme",
    "ENABLE": "Activé",
    "DISABLE": "Désactivé",
    "RESULTS_LIST": "Résultats",
    "RESULTS_COUNT": "{{count}} résultats",
    "EXECUTION_TIME": "exécuté en {{duration|formatDurationMs}}",
    "SHOW_VALUES": "Afficher les valeurs en clair ?",
    "POPOVER_ACTIONS_TITLE": "Options",
    "POPOVER_FILTER_TITLE": "Filtres",
    "SHOW_MORE": "Afficher plus",
    "SHOW_MORE_COUNT": "(limite actuelle à {{limit}})",
    "POPOVER_SHARE": {
      "TITLE": "Partager",
      "SHARE_ON_TWITTER": "Partager sur Twitter",
      "SHARE_ON_FACEBOOK": "Partager sur Facebook",
      "SHARE_ON_DIASPORA": "Partager sur Diaspora*",
      "SHARE_ON_GOOGLEPLUS": "Partager sur Google+"
    },
    "FILE": {
      "DATE": "Date :",
      "TYPE": "Type :",
      "SIZE": "Taille :",
      "VALIDATING": "Validation en cours..."
    }
  },
  "SYSTEM": {
    "PICTURE_CHOOSE_TYPE": "Choisir la source :",
    "BTN_PICTURE_GALLERY": "Galerie",
    "BTN_PICTURE_CAMERA": "<b>Caméra</b>"
  },
  "MENU": {
    "HOME": "Accueil",
    "WOT": "Annuaire",
    "CURRENCY": "Monnaie",
    "ACCOUNT": "Mon compte",
    "WALLETS": "Mes portefeuilles",
    "SETTINGS": "Paramètres",
    "NETWORK": "Réseau",
    "TRANSACTIONS": "Mes opérations"
  },
  "ABOUT": {
    "TITLE": "À propos",
    "LICENSE": "Application <b>libre</b> (Licence GNU AGPLv3).",
    "LATEST_RELEASE": "Il existe une <b>version plus récente</b> de {{'COMMON.APP_NAME'|translate}} (<b>v{{version}}</b>)",
    "PLEASE_UPDATE": "Veuillez mettre à jour {{'COMMON.APP_NAME'|translate}} (dernière version : <b>v{{version}}</b>)",
    "CODE": "Code source :",
    "OFFICIAL_WEB_SITE": "Site web officiel :",
    "DEVELOPERS": "Développé par :",
    "FORUM": "Forum :",
    "PLEASE_REPORT_ISSUE": "N'hésitez pas à nous remonter les anomalies rencontrées",
    "REPORT_ISSUE": "Remonter un problème",
    "BTN_OPEN_DEV_WINDOW": "Ouvrir la fenêtre de debuggage"
  },
  "HOME": {
    "TITLE": "Cesium",
    "WELCOME": "Bienvenue dans l'application Cesium !",
    "WELCOME_READONLY": "Bienvenue dans Cesium <span class='badge badge-balanced'>Monit</span> !",
    "MESSAGE": "Recevez et envoyez de la monnaie libre {{currency|abbreviate}}",
    "MESSAGE_READONLY": "Suivez l'état de la monnaie libre {{currency|abbreviate}} en temps réel.",
    "BTN_CURRENCY": "Explorer la monnaie {{currency|abbreviate}}",
    "BTN_ABOUT": "à propos",
    "BTN_HELP": "Aide en ligne",
    "BTN_NETWORK": "État du réseau",
    "FREE_SOFTWARE": "Logiciel libre",
    "FORK_ME": "Clonez-moi !",
    "SHOW_LICENSE": "Voir la license de l'application",
    "REPORT_ISSUE": "anomalie",
    "NOT_YOUR_ACCOUNT_QUESTION" : "Vous n'êtes pas propriétaire du compte <b class=\"ion-key\"> {{pubkey|formatPubkey}}</b>&nbsp;?",
    "BTN_CHANGE_ACCOUNT": "Déconnecter ce compte",
    "CONNECTION_ERROR": "Nœud <b>{{server}}</b> injoignable ou adresse invalide.<br/><br/>Vérifiez votre connexion Internet, ou changer de nœud <a class=\"positive\" ng-click=\"doQuickFix('settings')\">dans les paramètres</a>.",
    "SHOW_ALL_FEED": "Voir tout",
    "READ_MORE": "Lire la suite",
    "FEED_SOURCE": "Source"
  },
  "SETTINGS": {
    "TITLE": "Paramètres",
    "DISPLAY_DIVIDER": "Affichage",
    "STORAGE_DIVIDER": "Stockage",
    "NETWORK_SETTINGS": "Réseau",
    "PEER": "Nœud Duniter",
    "PEER_SHORT": "Nœud Duniter",
    "PEER_CHANGED_TEMPORARY": "Adresse utilisée temporairement",
    "PERSIST_CACHE": "Conserver les données de navigation (expérimental)",
    "PERSIST_CACHE_HELP": "Permet une navigation plus rapide, en conservant localement les données reçues, pour les utiliser d'une session à l'autre.",
    "USE_LOCAL_STORAGE": "Activer le stockage local",
    "USE_LOCAL_STORAGE_HELP": "Permet de sauvegarder vos paramètres",
    "WALLETS_SETTINGS": "Mes portefeuilles",
    "USE_WALLETS_ENCRYPTION": "Sécuriser la liste ?",
    "USE_WALLETS_ENCRYPTION_HELP": "Permet de sécuriser la liste de vos portefeuilles (par chiffrement), en exigeant une authentification pour y accéder.",
    "ENABLE_HELPTIP": "Activer les bulles d'aide contextuelles",
    "DISABLE_HELPTIP": "Désactiver les bulles d'aide contextuelles",
    "ENABLE_UI_EFFECTS": "Activer les effets visuels",
    "HISTORY_SETTINGS": "Mes opérations",
    "DISPLAY_UD_HISTORY": "Afficher les dividendes produits ?",
    "TX_HISTORY_AUTO_REFRESH": "Rafraîchir automatiquement",
    "TX_HISTORY_AUTO_REFRESH_HELP": "Rafraîchit le solde et les opérations automatiquement, à chaque nouveau bloc du réseau.",
    "AUTHENTICATION_SETTINGS": "Authentification",
    "KEEP_AUTH": "Désauthentification automatique",
    "KEEP_AUTH_SHORT": "Désauthentification",
    "KEEP_AUTH_HELP": "Définit le moment où l'authentification est nettoyée de la mémoire.",
    "KEEP_AUTH_OPTION": {
      "NEVER": "Après chaque opération",
      "SECONDS": "Après {{value}}s d'inactivité",
      "MINUTE": "Après {{value}}min d'inactivité",
      "MINUTES": "Après {{value}}min d'inactivité",
      "HOUR": "Après {{value}}h d'inactivité",
      "ALWAYS": "A la fin de la session"
    },
    "KEYRING_FILE": "Fichier de trousseau",
    "KEYRING_FILE_HELP": "Permet de vous <b>connecter</b> automatiquement à chaque lancement<br/>et même de vous <b>authentifier</b> (seulement si \"Expiration de l'authentification\" est configurée \"à la fin de la session\").",
    "REMEMBER_ME": "Se souvenir de moi ?",
    "REMEMBER_ME_HELP": "Permet de rester identifié d'une session à l'autre, en conservant localement la clé publique.",
    "PLUGINS_SETTINGS": "Extensions",
    "BTN_RESET": "Restaurer les valeurs par défaut",
    "EXPERT_MODE": "Activer le mode expert",
    "EXPERT_MODE_HELP": "Permet un affichage plus détaillé.",
    "BLOCK_VALIDITY_WINDOW": "Délai d'incertitude des blocs",
    "BLOCK_VALIDITY_WINDOW_SHORT": "Délai d'incertitude",
    "BLOCK_VALIDITY_WINDOW_HELP": "Délai avant de considérer qu'une information est validée",
    "BLOCK_VALIDITY_OPTION": {
      "NONE": "Aucun délai",
      "N": "{{time | formatDuration}} ({{count}} blocs)"
    },
    "POPUP_PEER": {
      "TITLE": "Nœud Duniter",
      "HOST": "Adresse",
      "HOST_HELP": "Adresse : serveur:port",
      "USE_SSL": "Sécurisé ?",
      "USE_SSL_HELP": "(Chiffrement SSL)",
      "BTN_SHOW_LIST": "Liste des noeuds"
    }
  },
  "BLOCKCHAIN": {
    "HASH": "Hash : {{hash}}",
    "VIEW": {
      "HEADER_TITLE": "Bloc #{{number}}-{{hash|formatHash}}",
      "TITLE_CURRENT": "Bloc courant",
      "TITLE": "Bloc #{{number|formatInteger}}",
      "COMPUTED_BY": "Calculé par le noeud de",
      "SHOW_RAW": "Voir le fichier brut",
      "TECHNICAL_DIVIDER": "Informations techniques",
      "VERSION": "Version du format",
      "HASH": "Hash calculé",
      "UNIVERSAL_DIVIDEND_HELP": "Monnaie co-produite par chacun des {{membersCount}} membres",
      "EMPTY": "Aucune donnée dans ce bloc",
      "POW_MIN": "Difficulté minimale",
      "POW_MIN_HELP": "Difficulté imposée pour le calcul du hash",
      "DATA_DIVIDER": "Données",
      "IDENTITIES_COUNT": "Nouvelles identités",
      "JOINERS_COUNT": "Nouveaux membres",
      "ACTIVES_COUNT": "Renouvellements",
      "ACTIVES_COUNT_HELP": "Membres ayant renouvelé leur adhésion",
      "LEAVERS_COUNT": "Membres sortants",
      "LEAVERS_COUNT_HELP": "Membres ne souhaitant plus de certification",
      "EXCLUDED_COUNT": "Membres exclus",
      "EXCLUDED_COUNT_HELP": "Anciens membres exclus par non renouvellement ou manque de certifications",
      "REVOKED_COUNT": "Identités révoquées",
      "REVOKED_COUNT_HELP": "Ces comptes ne pourront plus être membres",
      "TX_COUNT": "Transactions",
      "CERT_COUNT": "Certifications",
      "TX_TO_HIMSELF": "Opération de change",
      "TX_OUTPUT_UNLOCK_CONDITIONS": "Conditions de déblocage",
      "TX_OUTPUT_OPERATOR": {
        "AND": "et",
        "OR": "ou"
      },
      "TX_OUTPUT_FUNCTION": {
        "SIG": "<b>Signature</b> de ",
        "XHX": "<b>Mot de passe</b>, dont SHA256 =",
        "CSV": "Bloqué pendant",
        "CLTV": "Bloqué jusqu'à"
      }
    },
    "LOOKUP": {
      "TITLE": "Blocs",
      "NO_BLOCK": "Aucun bloc",
      "LAST_BLOCKS": "Derniers blocs :",
      "BTN_COMPACT": "Compacter"
    }
  },
  "CURRENCY": {
    "VIEW": {
      "TITLE": "Monnaie",
      "TAB_CURRENCY": "Monnaie",
      "TAB_WOT": "Toile de confiance",
      "TAB_NETWORK": "Réseau",
      "TAB_BLOCKS": "Blocs",
      "CURRENCY_SHORT_DESCRIPTION": "{{currency|abbreviate}} est une <b>monnaie libre</b>, démarrée {{firstBlockTime|formatFromNow}}. Elle compte actuellement <b>{{N}} membres</b>, qui produisent et perçoivent un <a ng-click=\"showHelpModal('ud')\">Dividende Universel</a> (DU), chaque {{dt|formatPeriod}}.",
      "NETWORK_RULES_DIVIDER": "Règles du réseau",
      "CURRENCY_NAME": "Nom de la monnaie",
      "MEMBERS": "Nombre de membres",
      "MEMBERS_VARIATION": "Variation depuis le dernier DU",
      "MONEY_DIVIDER": "Monnaie",
      "MASS": "Masse monétaire",
      "SHARE": "Masse par membre",
      "UD": "Dividende universel",
      "C_ACTUAL": "Croissance actuelle",
      "MEDIAN_TIME": "Heure de la blockchain",
      "POW_MIN": "Niveau minimal de difficulté de calcul",
      "MONEY_RULES_DIVIDER": "Règles de la monnaie",
      "C_RULE": "Croissance théorique cible",
      "UD_RULE": "Calcul du dividende universel",
      "DT_REEVAL": "Période de revalorisation du DU",
      "REEVAL_SYMBOL": "reval",
      "DT_REEVAL_VALUE": "Tous les <b>{{dtReeval|formatDuration}}</b> ({{dtReeval/86400}} {{'COMMON.DAYS'|translate}})",
      "UD_REEVAL_TIME0": "Date de la 1ère revalorisation",
      "SIG_QTY_RULE": "Nombre de certifications requises pour devenir membre",
      "SIG_STOCK": "Nombre maximal de certifications émises par membre",
      "SIG_PERIOD": "Délai minimal d'attente entre 2 certifications successives émises par une même personne",
      "SIG_WINDOW": "Délai limite de prise en compte d'une certification",
      "SIG_VALIDITY": "Durée de vie d'une certification qui a été prise en compte",
      "MS_WINDOW": "Délai limite de prise en compte d'une demande d'adhésion comme membre",
      "MS_VALIDITY": "Durée de vie d'une adhésion qui a été prise en compte",
      "STEP_MAX": "Distance maximale, par les certifications, entre un nouvel entrant et les membres référents",
      "WOT_RULES_DIVIDER": "Règles de la toile de confiance",
      "SENTRIES": "Nombre de certifications (émises <b>et</b> reçues) pour devenir membre référent",
      "SENTRIES_FORMULA": "Nombre de certifications (émises <b>et</b> reçues) pour devenir membre référent (formule)",
      "XPERCENT":"Pourcentage minimum de membres référents à atteindre pour respecter la règle de distance",
      "AVG_GEN_TIME": "Temps moyen entre deux blocs",
      "CURRENT": "actuel",
      "MATH_CEILING": "PLAFOND",
      "DISPLAY_ALL_RULES": "Afficher toutes les règles ?",
      "BTN_SHOW_LICENSE": "Voir la licence",
      "WOT_DIVIDER": "Toile de confiance"
    },
    "LICENSE": {
      "TITLE": "Licence de la monnaie",
      "BTN_DOWNLOAD": "Télécharger le fichier",
      "NO_LICENSE_FILE": "Fichier de licence non trouvé."
    }
  },
  "NETWORK": {
    "VIEW": {
      "MEDIAN_TIME": "Heure de la blockchain",
      "LOADING_PEERS": "Chargement des noeuds...",
      "NODE_ADDRESS": "Adresse :",
      "SOFTWARE": "Logiciel",
      "WARN_PRE_RELEASE": "Pré-version (dernière version stable : <b>{{version}}</b>)",
      "WARN_NEW_RELEASE": "Version <b>{{version}}</b> disponible",
      "WS2PID": "Identifiant :",
      "PRIVATE_ACCESS": "Accès privé",
      "POW_PREFIX": "Préfixe de preuve de travail :",
      "ENDPOINTS": {
        "BMAS": "Interface sécurisée (SSL)",
        "BMATOR": "Interface réseau TOR",
        "WS2P": "Interface WS2P",
        "ES_USER_API": "Noeud de données Cesium+"
      }
    },
    "INFO": {
      "ONLY_SSL_PEERS": "Les noeuds non SSL ont un affichage dégradé, car Cesium fonctionne en mode HTTPS."
    }
  },
  "PEER": {
    "PEERS": "Nœuds",
    "SIGNED_ON_BLOCK": "Signé sur le bloc",
    "MIRROR": "miroir",
    "MIRRORS": "Miroirs",
    "MIRROR_PEERS": "Nœuds miroirs",
    "PEER_LIST" : "Liste des nœuds",
    "MEMBERS" : "Membres",
    "MEMBER_PEERS" : "Nœuds membres",
    "ALL_PEERS" : "Tous les nœuds",
    "DIFFICULTY" : "Difficulté",
    "API" : "API",
    "CURRENT_BLOCK" : "Bloc #",
    "POPOVER_FILTER_TITLE": "Filtre",
    "OFFLINE": "Hors ligne",
    "OFFLINE_PEERS": "Nœuds hors ligne",
    "BTN_SHOW_PEER": "Voir le nœud",
    "VIEW": {
      "TITLE": "Nœud",
      "OWNER": "Appartient à",
      "SHOW_RAW_PEERING": "Voir la fiche de pair",
      "SHOW_RAW_CURRENT_BLOCK": "Voir le dernier bloc (format brut)",
      "LAST_BLOCKS": "Derniers blocs connus",
      "KNOWN_PEERS": "Nœuds connus :",
      "GENERAL_DIVIDER": "Informations générales",
      "ERROR": {
        "LOADING_TOR_NODE_ERROR": "Récupération des informations du noeud impossible. Le délai d'attente est dépassé.",
        "LOADING_NODE_ERROR": "Récupération des informations du noeud impossible"
      }
    }
  },
  "WOT": {
    "SEARCH_HELP": "Recherche (pseudo ou clé publique)",
    "SEARCH_INIT_PHASE_WARNING": "Durant la phase de pré-inscription, la recherche des inscriptions en attente <b>peut être longue</b>. Merci de patienter...",
    "REGISTERED_SINCE": "Inscrit le",
    "REGISTERED_SINCE_BLOCK": "Inscrit au bloc #",
    "NO_CERTIFICATION": "Aucune certification validée",
    "NO_GIVEN_CERTIFICATION": "Aucune certification émise",
    "NOT_MEMBER_PARENTHESIS": "(non membre)",
    "IDENTITY_REVOKED_PARENTHESIS": "(identité révoquée)",
    "MEMBER_PENDING_REVOCATION_PARENTHESIS": "(en cours de révocation)",
    "EXPIRE_IN": "Expiration",
    "NOT_WRITTEN_EXPIRE_IN": "Date limite<br/>de traitement",
    "EXPIRED": "Expiré",
    "PSEUDO": "Pseudonyme",
    "SIGNED_ON_BLOCK": "Emise au bloc #{{block}}",
    "WRITTEN_ON_BLOCK": "Ecrite au bloc #{{block}}",
    "GENERAL_DIVIDER": "Informations générales",
    "NOT_MEMBER_ACCOUNT": "Compte simple (non membre)",
    "NOT_MEMBER_ACCOUNT_HELP": "Il s'agit d'un simple portefeuille, sans demande d'adhésion en attente.",
    "TECHNICAL_DIVIDER": "Informations techniques",
    "BTN_CERTIFY": "Certifier",
    "BTN_YES_CERTIFY": "Oui, certifier",
    "BTN_SELECT_AND_CERTIFY": "Nouvelle certification",
    "ACCOUNT_OPERATIONS": "Opérations sur le compte",
    "VIEW": {
      "POPOVER_SHARE_TITLE": "Identité {{title}}"
    },
    "LOOKUP": {
      "TITLE": "Toile de confiance",
      "NEWCOMERS": "Nouveaux membres",
      "NEWCOMERS_COUNT": "{{count}} membres",
      "PENDING": "Inscriptions en attente",
      "PENDING_COUNT": "{{count}} inscriptions en attente",
      "REGISTERED": "Inscrit {{sigDate | formatFromNow}}",
      "MEMBER_FROM": "Membre depuis {{memberDate|medianFromNowShort}}",
      "BTN_NEWCOMERS": "Nouveaux membres",
      "BTN_PENDING": "Inscriptions en attente",
      "SHOW_MORE": "Afficher plus",
      "SHOW_MORE_COUNT": "(limite actuelle à {{limit}})",
      "NO_PENDING": "Aucune inscription en attente.",
      "NO_NEWCOMERS": "Aucun membre."
    },
    "CONTACTS": {
      "TITLE": "Contacts"
    },
    "MODAL": {
      "TITLE": "Recherche"
    },
    "CERTIFICATIONS": {
      "TITLE": "{{uid}} - Certifications",
      "SUMMARY": "Certifications reçues",
      "LIST": "Détail des certifications reçues",
      "PENDING_LIST": "Certifications en attente de traitement",
      "RECEIVED": "Certifications reçues",
      "RECEIVED_BY": "Certifications reçues par {{uid}}",
      "ERROR": "Certifications reçues en erreur",
      "SENTRY_MEMBER": "Membre référent"
    },
    "OPERATIONS": {
      "TITLE": "{{uid}} - Opérations"
    },
    "GIVEN_CERTIFICATIONS": {
      "TITLE": "{{uid}} - Certifications émises",
      "SUMMARY": "Certifications émises",
      "LIST": "Détail des certifications émises",
      "PENDING_LIST": "Certifications en attente de traitement",
      "SENT": "Certifications émises",
      "SENT_BY": "Certifications émises par {{uid}}",
      "ERROR": "Certifications émises en erreur"
    }
  },
  "LOGIN": {
    "TITLE": "<i class=\"icon ion-log-in\"></i> Connexion",
    "SCRYPT_FORM_HELP": "Veuillez saisir vos identifiants.<br>Pensez à vérifier que la clé publique est celle de votre compte.",
    "PUBKEY_FORM_HELP": "Veuillez saisir une clé publique de compte :",
    "FILE_FORM_HELP": "Choisissez le fichier de trousseau à utiliser :",
    "SCAN_FORM_HELP": "Scanner le QR code d'un portefeuille.",
    "SALT": "Identifiant secret",
    "SALT_HELP": "Identifiant secret",
    "SHOW_SALT": "Afficher l'identifiant secret ?",
    "PASSWORD": "Mot de passe",
    "PASSWORD_HELP": "Mot de passe",
    "PUBKEY_HELP": "Clé publique ou pseudonyme",
    "NO_ACCOUNT_QUESTION": "Vous n'avez pas encore de compte ?",
    "HAVE_ACCOUNT_QUESTION": "Vous avez déjà un compte ?",
    "CREATE_ACCOUNT": "Créer un compte...",
    "CREATE_FREE_ACCOUNT": "Créer un compte gratuitement",
    "FORGOTTEN_ID": "Mot de passe oublié ?",
    "ASSOCIATED_PUBKEY": "Clé publique du trousseau :",
    "BTN_METHODS": "Autres méthodes",
    "BTN_METHODS_DOTS": "Changer de méthode...",
    "METHOD_POPOVER_TITLE": "Méthodes",
    "MEMORIZE_AUTH_FILE": "Mémoriser ce trousseau le temps de la session de navigation",
    "SCRYPT_PARAMETERS": "Paramètres (Scrypt) :",
    "AUTO_LOGOUT": {
      "TITLE": "Information",
      "MESSAGE": "<i class=\"ion-android-time\"></i> Vous avez été <b>déconnecté</b> automatiquement, suite à une inactivité prolongée.",
      "BTN_RELOGIN": "Me reconnecter",
      "IDLE_WARNING": "Vous allez être déconnecté... {{countdown}}"
    },
    "METHOD": {
      "SCRYPT_DEFAULT": "Identifiant secret et mot de passe",
      "SCRYPT_ADVANCED": "Salage avancé",
      "FILE": "Fichier de trousseau",
      "PUBKEY": "Clé publique ou pseudonyme",
      "SCAN": "Scanner un QR code"
    },
    "SCRYPT": {
      "SIMPLE": "Salage léger",
      "DEFAULT": "Salage standard",
      "SECURE": "Salage sûr",
      "HARDEST": "Salage le plus sûr",
      "EXTREME": "Salage extrême",
      "USER": "Salage personnalisé",
      "N": "N (Loop):",
      "r": "r (RAM):",
      "p": "p (CPU):"
    },
    "FILE": {
      "HELP": "Format de fichier attendu : <b>.yml</b> ou <b>.dunikey</b> (type PubSec, WIF ou EWIF)."
    }
  },
  "AUTH": {
    "TITLE": "<i class=\"icon ion-locked\"></i> Authentification",
    "BTN_AUTH": "S'authentifier",
    "GENERAL_HELP": "Veuillez vous authentifier :",
    "EXPECTED_UID_HELP": "Veuillez vous authentifier sur le compte <i class=\"ion-person\"></i> {{uid}} :",
    "EXPECTED_PUBKEY_HELP": "Veuillez vous authentifier sur le portefeuille <br class=\"visible-xs\"/><i class=\"ion-key\"></i> {{pubkey|formatPubkey}} :",
    "SCAN_FORM_HELP": "Scanner le QR code de la <b>clef privée</b> du portefeuille."
  },
  "ACCOUNT": {
    "TITLE": "Mon compte",
    "BALANCE": "Solde",
    "LAST_TX": "Dernières transactions validées",
    "BALANCE_ACCOUNT": "Solde du compte",
    "NO_TX": "Aucune transaction",
    "SHOW_MORE_TX": "Afficher plus",
    "SHOW_ALL_TX": "Afficher tout",
    "TX_FROM_DATE": "(limite actuelle à {{fromTime|medianFromNowShort}})",
    "PENDING_TX": "Transactions en attente de traitement",
    "VALIDATING_TX": "Transactions traitées, non validées",
    "ERROR_TX": "Transactions non executées",
    "ERROR_TX_SENT": "Transactions envoyées en échec",
    "PENDING_TX_RECEIVED": "Transactions en attente de réception",
    "EVENTS": "Evénements",
    "OUT_DISTANCED": "Vos certifications actuelles proviennent d'un groupe trop isolé de la <a ng-click=\"showHelpModal('wot')\">Toile de Confiance</a> (TdC) : la <a ng-click=\"showHelpModal('distance_rule')\">règle de distance maximale</a> n'est pas respectée.<br/>Vous devez obtenir des certifications provenant d'autres secteurs de la TdC, ou bien attendre que celle-ci se resserre.",
    "WAITING_MEMBERSHIP": "Demande d'adhésion envoyée. En attente d'acceptation.",
    "WAITING_CERTIFICATIONS": "Vous devez <b>obtenir {{needCertificationCount}} certification(s)</b> pour devenir membre et produire le <a ng-click=\"showHelpModal('ud')\">Dividende Universel</a>. Votre compte est cependant déjà opérationnel, pour recevoir et effectuer des paiements.",
    "WAITING_CERTIFICATIONS_HELP": "Pour obtenir vos certifications, sollicitez uniquement des membres <b>qui vous connaissent suffisamment</b>, comme l'exige <a ng-click=\"showLicenseModal()\">la licence de la monnaie</a> que vous avez acceptée.<br/>Si vous ne connaissez pas suffisamment de membres, faites-le savoir sur <a ng-click=\"openLink($event, $root.settings.userForumUrl)\">le forum utilisateur</a>.",
    "WILL_MISSING_CERTIFICATIONS": "Vous allez bientôt <b>manquer de certifications</b> (au moins {{willNeedCertificationCount}} sont requises)",
    "WILL_NEED_RENEW_MEMBERSHIP": "Votre adhésion comme membre <b>va expirer {{membershipExpiresIn|formatDurationTo}}</b>. Pensez à <a ng-click=\"doQuickFix('renew')\">renouveler votre adhésion</a> d'ici là.",
    "NEED_RENEW_MEMBERSHIP": "Vous n'êtes plus membre de la monnaie, car <b>votre adhésion a expiré</b>. Pensez à <a ng-click=\"doQuickFix('renew')\">renouveler votre adhésion</a>.",
    "NEED_RENEW_MEMBERSHIP_AFTER_CANCELLED": "Vous n'êtes plus membre de la monnaie, <b>pour manque de certifications</b>. Pensez à <a ng-click=\"doQuickFix('renew')\">renouveler votre adhésion</a>.",
    "NO_WAITING_MEMBERSHIP": "Aucune demande d'adhésion en attente. Si vous souhaitez <b>devenir membre</b>, pensez à <a ng-click=\"doQuickFix('membership')\">envoyer la demande d'adhésion</a>.",
    "CERTIFICATION_COUNT": "Certifications reçues",
    "CERTIFICATION_COUNT_SHORT": "Certifications",
    "SIG_STOCK": "Certifications envoyées",
    "BTN_RECEIVE_MONEY": "Encaisser",
    "BTN_SELECT_ALTERNATIVES_IDENTITIES": "Basculer vers une autre identité...",
    "BTN_FIX_MEMBERSHIP": "Renvoyer la demande d'adhésion...",
    "BTN_MEMBERSHIP_RENEW": "Renouveler l'adhésion",
    "BTN_MEMBERSHIP_RENEW_DOTS": "Renouveler l'adhésion...",
    "BTN_MEMBERSHIP_OUT_DOTS": "Arrêter l'adhésion...",
    "BTN_SECURITY_DOTS": "Compte et sécurité...",
    "BTN_SHOW_DETAILS": "Afficher les infos techniques",
    "LOCKED_OUTPUTS_POPOVER": {
      "TITLE": "Montant verrouillé",
      "DESCRIPTION": "Voici les conditions de déverrouillage de ce montant :",
      "DESCRIPTION_MANY": "Cette transaction est composé de plusieurs parties, dont voici les conditions de déverrouillage :",
      "LOCKED_AMOUNT": "Conditions pour le montant :"
    },
    "NEW": {
      "TITLE": "Création de compte",
      "INTRO_WARNING_TIME": "La création d'un compte sur {{name|capitalize}} est très simple. Veuillez néanmoins prendre suffisament de temps pour faire correctement cette formalité (pour ne pas oublier les identifiants, mots de passe, etc.).",
      "INTRO_WARNING_SECURITY": "Vérifiez que le matériel que vous utilisez actuellement (ordinateur, tablette, téléphone) <b>est sécurisé et digne de confiance</b>.",
      "INTRO_WARNING_SECURITY_HELP": "Anti-virus à jour, pare-feu activé, session protégée par mot de passe ou code pin, etc.",
      "INTRO_HELP": "Cliquez sur <b>{{'COMMON.BTN_START'|translate}}</b> pour débuter la création de compte. Vous serez guidé étape par étape.",
      "REGISTRATION_NODE": "Votre inscription sera enregistrée via le noeud Duniter <b>{{server}}</b>, qui le diffusera ensuite au reste du réseau de la monnaie.",
      "REGISTRATION_NODE_HELP": "Si vous ne faites pas confiance en ce noeud, veuillez en changer <a ng-click=\"doQuickFix('settings')\">dans les paramètres</a> de Cesium.",
      "SELECT_ACCOUNT_TYPE": "Choisissez le type de compte à créer :",
      "MEMBER_ACCOUNT": "Compte membre",
      "MEMBER_ACCOUNT_TITLE": "Création d'un compte membre",
      "MEMBER_ACCOUNT_HELP": "Si vous n'êtes pas encore inscrit en tant qu'individu (un seul compte possible par individu). Ce compte permet de co-produire la monnaie, en recevant un <b>dividende universel</b> chaque {{parameters.dt|formatPeriod}}.",
      "WALLET_ACCOUNT": "Simple portefeuille",
      "WALLET_ACCOUNT_TITLE": "Création d'un portefeuille",
      "WALLET_ACCOUNT_HELP": "Pour tous les autres cas, par exemple si vous avez besoin d'un compte supplémentaire.<br/>Aucun dividende universel ne sera créé par ce compte.",
      "SALT_WARNING": "Choisissez votre identifiant secret.<br/>Il vous sera demandé à chaque connexion sur ce compte.<br/><br/><b>Retenez le bien</b> : en cas de perte, plus personne ne pourra accéder à votre compte !",
      "PASSWORD_WARNING": "Choisissez un mot de passe.<br/>Il vous sera demandé à chaque connexion sur ce compte.<br/><br/><b>Retenez bien ce mot de passe</b : en cas de perte, plus personne ne pourra accéder à votre compte !",
      "PSEUDO_WARNING": "Choisissez un pseudonyme.<br/>Il sert aux autres membres, pour vous identifier plus facilement.<div class='hidden-xs'><br/>Il <b>ne pourra pas être modifié</b>, sans refaire un compte.</div><br/><br/>Il ne doit contenir <b>ni espace, ni de caractère accentué</b>.<div class='hidden-xs'><br/>Exemple : <span class='gray'>SophieDupond, MarcelChemin, etc.</span>",
      "PSEUDO": "Pseudonyme",
      "PSEUDO_HELP": "Pseudonyme",
      "SALT_CONFIRM": "Confirmation",
      "SALT_CONFIRM_HELP": "Confirmation de l'identifiant secret",
      "PASSWORD_CONFIRM": "Confirmation",
      "PASSWORD_CONFIRM_HELP": "Confirmation du mot de passe",
      "SLIDE_6_TITLE": "Confirmation :",
      "COMPUTING_PUBKEY": "Calcul en cours...",
      "LAST_SLIDE_CONGRATULATION": "Vous avez saisi toutes les informations nécessaires : Bravo !<br/>Vous pouvez maintenant <b>envoyer la demande de création</b> de compte.</b><br/><br/>Pour information, la clé publique ci-dessous identifiera votre futur compte.<br/>Elle pourra être communiquée à des tiers pour recevoir leurs paiements.<br/><b>Il n'est pas obligatoire</b> de la noter ici, vous pourrez également le faire plus tard.",
      "CONFIRMATION_MEMBER_ACCOUNT": "<b class=\"assertive\">Avertissement :</b> l'identifiant secret, le mot de passe et le pseudonyme ne pourront plus être modifiés.<br/><br/><b>Assurez-vous de toujours vous en rappeler !</b><br/><br/><b>Êtes-vous sûr</b> de vouloir envoyer cette demande d'inscription ?",
      "CONFIRMATION_WALLET_ACCOUNT": "<b class=\"assertive\">Avertissement :</b> l'identifiant secret et le mot de passe ne pourront plus être modifiés.<br/><br/><b>Assurez-vous de toujours vous en rappeler !</b><br/><br/><b>Êtes-vous sûr</b> de vouloir continuer avec ces identifiants ?",
      "CHECKING_PSEUDO": "Vérification...",
      "PSEUDO_AVAILABLE": "Pseudonyme disponible",
      "PSEUDO_NOT_AVAILABLE": "Pseudonyme non disponible",
      "INFO_LICENSE": "Avant de créer un compte membre, <b>veuillez lire et accepter la licence</b> d'usage de la monnaie :",
      "BTN_ACCEPT": "J'accepte",
      "BTN_ACCEPT_LICENSE": "J'accepte la licence"
    },
    "POPUP_REGISTER": {
      "TITLE": "Choisissez un pseudonyme",
      "HELP": "Un pseudonyme est obligatoire pour devenir membre."
    },
    "SELECT_IDENTITY_MODAL": {
      "TITLE": "Sélection de l'identité",
      "HELP": "Plusieurs <b>identités différentes</b> ont été envoyées, pour la clé publique <span class=\"gray\"><i class=\"ion-key\"></i> {{pubkey|formatPubkey}}</span>.<br/>Veuillez sélectionner le dossier à utiliser :"
    },
    "SELECT_WALLET_MODAL": {
      "TITLE": "Sélection du portefeuille"
    },
    "WALLET_LIST": {
      "TITLE": "Mes portefeuilles",
      "BTN_NEW": "Ajouter un portefeuille",
      "BTN_DOWNLOAD": "Télécharger la liste",
      "BTN_IMPORT_FILE_DOTS": "Importer depuis un fichier...",
      "NO_WALLET": "Aucun portefeuille secondaire",
      "BTN_DELETE": "Retirer un portefeuille secondaire...",
      "BTN_RENAME": "Renommer le portefeuille",
      "EXPORT_FILENAME": "mes_portefeuilles-{{pubkey|formatPubkey}}-{{currency}}.csv",
      "TOTAL_DOTS": "Total : ",
      "EDIT_POPOVER": {
        "TITLE": "Renommer le portefeuille",
        "HELP": "Renseignez le nouveau nom",
        "NAME_HELP": "Nom du portefeuille"
      },
      "IMPORT_MODAL": {
        "TITLE": "Importer des portefeuilles",
        "HELP": "Pour <b>importer des porftefeuilles</b>, veuillez glisser dans la zone ci-dessous le fichier de la liste des portefeuilles, ou bien cliquer dans la zone pour rechercher un fichier.",
        "WALLET_COUNT": "<b>{{count}}</b> nouveau{{count > 1 ? 'x' : ''}} portefeuille{{count > 1 ? 's' : ''}}",
        "NO_NEW_WALLET": "Aucun nouveau portefeuille"
      }
    },
    "SECURITY": {
      "ADD_QUESTION": "Ajouter une question personnalisée",
      "BTN_CLEAN": "Vider",
      "BTN_RESET": "Réinitialiser",
      "DOWNLOAD_REVOKE": "Sauvegarder mon fichier de révocation",
      "DOWNLOAD_REVOKE_HELP": "Disposer d'un fichier de révocation est important, par exemple en cas de perte de vos identifiants. Il vous permet de <b>sortir ce compte de la toile de confiance</b>, en redevenant ainsi un simple portefeuille.",
      "GENERATE_KEYFILE": "Générer mon fichier de trousseau...",
      "GENERATE_KEYFILE_HELP": "Génère un fichier permettant de vous authentifier sans saisir vos identifiants.<br/><b>Attention :</b> ce fichier contiendra votre trousseau de compte (clefs publique et secrète) ; il est donc très important de le mettre en lieu sûr !",
      "KEYFILE_FILENAME": "trousseau-{{pubkey|formatPubkey}}-{{currency}}-{{format}}.dunikey",
      "MEMBERSHIP_IN": "Transformer en compte membre...",
      "MEMBERSHIP_IN_HELP": "Permet de <b>transformer</b> un compte simple portefeuille <b>en compte membre</b>, en envoyant une demande d'adhésion. Utile uniquement si vous n'avez pas déjà un autre compte membre.",
      "SEND_IDENTITY": "Publier son identité...",
      "SEND_IDENTITY_HELP": "Permet d'associer un pseudonyme à ce compte, mais <b>sans faire de demande d'adhésion</b> pour devenir membre. Cette association n'est généralement pas utile, car la validité de cette association de pseudonyme est limitée dans le temps.",
      "HELP_LEVEL": "Pour générer un fichier de sauvegarde de vos identifiants, choisissez <strong> au moins {{nb}} questions :</strong>",
      "LEVEL": "Niveau de sécurité",
      "LOW_LEVEL": "Faible <span class=\"hidden-xs\">(2 questions minimum)</span>",
      "MEDIUM_LEVEL": "Moyen <span class=\"hidden-xs\">(4 questions minimum)</span>",
      "QUESTION_1": "Comment s'appelait votre meilleur ami lorsque vous étiez adolescent ?",
      "QUESTION_2": "Comment s'appelait votre premier animal de compagnie ?",
      "QUESTION_3": "Quel est le premier plat que vous avez appris à cuisiner ?",
      "QUESTION_4": "Quel est le premier film que vous avez vu au cinéma ?",
      "QUESTION_5": "Où êtes-vous allé la première fois que vous avez pris l'avion ?",
      "QUESTION_6": "Comment s'appelait votre instituteur préféré à l'école primaire ?",
      "QUESTION_7": "Quel serait selon vous le métier idéal ?",
      "QUESTION_8": "Quel est le livre pour enfants que vous préférez ?",
      "QUESTION_9": "Quel était le modèle de votre premier véhicule ?",
      "QUESTION_10": "Quel était votre surnom lorsque vous étiez enfant ?",
      "QUESTION_11": "Quel était votre personnage ou acteur de cinéma préféré lorsque vous étiez étudiant ?",
      "QUESTION_12": "Quel était votre chanteur ou groupe préféré lorsque vous étiez étudiant ?",
      "QUESTION_13": "Dans quelle ville vos parents se sont-ils rencontrés ?",
      "QUESTION_14": "Comment s'appelait votre premier patron ?",
      "QUESTION_15": "Quel est le nom de la rue où vous avez grandi ?",
      "QUESTION_16": "Quel est le nom de la première plage où vous vous êtes baigné ?",
      "QUESTION_17": "Quel est le premier album que vous avez acheté ?",
      "QUESTION_18": "Quel est le nom de votre équipe de sport préférée ?",
      "QUESTION_19": "Quel était le métier de votre grand-père ?",
      "RECOVER_ID": "Retrouver mon mot de passe...",
      "RECOVER_ID_HELP": "Si vous disposez d'un <b>fichier de sauvegarde de vos identifiants</b>, vous pouvez les retrouver en répondant correctement à vos questions personnelles.",
      "RECOVER_ID_SELECT_FILE": "Choisissez le <b>fichier de sauvegarde de vos identifiants</b> à utiliser :",
      "REVOCATION_WITH_FILE": "Révoquer mon compte membre...",
      "REVOCATION_WITH_FILE_DESCRIPTION": "Si vous avez <b>définitivement perdus vos identifiants</b> de compte membre (ou que la sécurité du compte est compromise), vous pouvez utiliser <b>le fichier de révocation</b> du compte pour <b>forcer sa sortie définitive de la toile de confiance</b>.",
      "REVOCATION_WITH_FILE_HELP": "Pour <b>révoquer définitivement</b> un compte membre, veuillez glisser dans la zone ci-dessous votre fichier de révocation, ou bien cliquer dans la zone pour rechercher un fichier.",
      "REVOCATION_WALLET": "Révoquer immédiatement ce compte",
      "REVOCATION_WALLET_HELP": "Demander la révocation de votre identité entraîne la <b>sortie de la toile de confiance</b> (définitive pour le pseudonyme et la clé publique associés). Le compte ne pourra plus produire de Dividende Universel.<br/>Vous pourrez toutefois encore vous y connecter, comme à un simple portefeuille.",
      "REVOCATION_FILENAME": "revocation-{{uid}}-{{pubkey|formatPubkey}}-{{currency}}.txt",
      "SAVE_ID": "Sauvegarder mes identifiants...",
      "SAVE_ID_HELP": "Création d'un fichier de sauvegarde, pour <b>retrouver votre mot de passe</b> (et l'identifiant secret) <b>en cas de d'oubli</b>. Le fichier est <b>sécurisé</b> (chiffré) à l'aide de questions personnelles.",
      "STRONG_LEVEL": "Fort <span class=\"hidden-xs \">(6 questions minimum)</span>",
      "TITLE": "Compte et sécurité",
      "KEYFILE": {
        "PUBSEC_FORMAT": "Format PubSec.",
        "PUBSEC_FORMAT_HELP": "Ce format stocke votre trousseau de manière très simple. Il est compatible notamment avec Cesium, ğannonce et Duniter.<br/><b>Attention :</b>Le fichier <b>n'est pas chiffré</b> (la clef secrète y apparaît en clair) ; veuillez donc le stocker en lieu sûr !",
        "WIF_FORMAT": "Format WIF (Wallet Import Format) - v1",
        "WIF_FORMAT_HELP": "Ce format stocke votre trousseau en y intégrant une somme de contrôle pour vérifier l'intégrité du fichier. Il est compatible notamment avec les portefeuilles papier (Duniter paper wallet).<br/><b>Attention :</b>Le fichier <b>n'est pas chiffré</b> (la clef secrète y apparaît en clair) ; veuillez donc le stocker en lieu sûr !",
        "EWIF_FORMAT": "Format EWIF (Encrypted Wallet Import Format) - v1",
        "EWIF_FORMAT_HELP": "Ce format stocke votre trousseau <b>de manière chiffrée</b> à partir d'une phrase secrète de votre choix. Il intègre aussi une somme de contrôle pour vérifier l'intégrité du fichier.<br/><b>Attention :</b> Veillez à toujours vous souvenir de votre phrase secrète !",
        "PASSWORD_POPUP": {
          "TITLE": "Fichier de trousseau chiffré",
          "HELP": "Veuillez indiquer la phrase secrète :",
          "PASSWORD_HELP": "Phrase secrète"
        },
        "ERROR": {
          "BAD_PASSWORD": "Phrase secrète incorrecte",
          "BAD_CHECKSUM": "Somme de contrôle incorrecte"
        }
      }
    },
    "FILE_NAME": "{{currency}} - Relevé du compte {{pubkey|formatPubkey}} au {{currentTime|formatDateForFile}}.csv",
    "HEADERS": {
      "TIME": "Date",
      "AMOUNT": "Montant",
      "COMMENT": "Commentaire"
    }
  },
  "TRANSFER": {
    "TITLE": "Virement",
    "SUB_TITLE": "Faire un virement",
    "SUB_TITLE_ALL": "Vider le compte",
    "FROM": "De",
    "TO": "À",
    "AMOUNT": "Montant",
    "AMOUNT_HELP": "Montant",
    "COMMENT": "Commentaire",
    "COMMENT_HELP": "Commentaire",
    "BTN_SEND": "Envoyer",
    "BTN_ADD_COMMENT": "Ajouter un commentaire",
    "REST": "Reste du compte",
    "REST_TO": "à",
    "WARN_COMMENT_IS_PUBLIC": "Veuillez noter que <b>les commentaires sont publics</b> (non chiffrés).",
    "MODAL": {
      "TITLE": "Virement"
    }
  },
  "ERROR": {
    "UNKNOWN_URI_FORMAT": "Format d'URI inconnu",
    "PUBKEY_INVALID_CHECKSUM": "Clé publique invalide (bad checksum).",
    "POPUP_TITLE": "Erreur",
    "UNKNOWN_ERROR": "Erreur inconnue",
    "CRYPTO_UNKNOWN_ERROR": "Votre navigateur ne semble pas compatible avec les fonctionnalités de cryptographie.",
    "DOWNLOAD_KEYFILE_FAILED": "Échec de la génération du fichier de trousseau.",
    "EQUALS_TO_PSEUDO": "Doit être différent du pseudonyme",
    "EQUALS_TO_SALT": "Doit être différent de l'identifiant secret",
    "FIELD_REQUIRED": "Champ obligatoire",
    "FIELD_TOO_SHORT": "Valeur trop courte",
    "FIELD_TOO_SHORT_WITH_LENGTH": "Valeur trop courte ({{minLength}} caractères min)",
    "FIELD_TOO_LONG": "Valeur trop longue",
    "FIELD_TOO_LONG_WITH_LENGTH": "Valeur trop longue ({{maxLength}} caractères max)",
    "FIELD_MIN": "Valeur minimale : {{min}}",
    "FIELD_MAX": "Valeur maximale : {{max}}",
    "FIELD_ACCENT": "Caractères accentués et virgules non autorisés",
    "FIELD_NOT_NUMBER": "Valeur numérique attendue",
    "FIELD_NOT_INT": "Valeur entière attendue",
    "FIELD_NOT_EMAIL": "Adresse email non valide",
    "PASSWORD_NOT_CONFIRMED": "Ne correspond pas au mot de passe",
    "SALT_NOT_CONFIRMED": "Ne correspond pas à l'identifiant secret",
    "SEND_IDENTITY_FAILED": "Échec de l'inscription",
    "SEND_CERTIFICATION_FAILED": "Échec de la certification",
    "NEED_MEMBER_ACCOUNT_TO_CERTIFY": "Vous ne pouvez pas effectuer de certification, car ce compte n'est <b>pas membre</b>.",
    "NEED_MEMBER_ACCOUNT_TO_CERTIFY_HAS_SELF": "Vous ne pouvez pas effectuer de certification, car ce compte n'est pas encore membre.<br/><br/>Il vous manque encore des certifications, ou bien celles-ci n'ont pas encore été validées.",
    "IDENTITY_TO_CERTIFY_HAS_NO_SELF": "Compte non certifiable. Aucune demande d'adhésion n'a été faite, ou bien elle n'a pas été renouvelée.",
    "LOGIN_FAILED": "Erreur lors de la connexion.",
    "LOAD_IDENTITY_FAILED": "Erreur de chargement de l'identité.",
    "LOAD_REQUIREMENTS_FAILED": "Erreur de chargement des prérequis de l'identité.",
    "SEND_MEMBERSHIP_IN_FAILED": "Échec de la tentative d'entrée dans la communauté.",
    "SEND_MEMBERSHIP_OUT_FAILED": "Échec de l'arrêt de l'adhésion.",
    "REFRESH_WALLET_DATA": "Échec du rafraîchissement du portefeuille.",
    "GET_CURRENCY_PARAMETER": "Échec de la récupération des règles de la monnaie.",
    "GET_CURRENCY_FAILED": "Chargement de la monnaie impossible. Veuillez réessayer plus tard.",
    "SEND_TX_FAILED": "Échec du virement.",
    "ALL_SOURCES_USED": "Veuillez attendre le calcul du prochain bloc (toutes vos sources de monnaie ont été utilisées).",
    "NOT_ENOUGH_SOURCES": "Pas assez de change pour envoyer ce montant en une seule transaction.<br/>Montant maximum : {{amount}} {{unit}}<sub>{{subUnit}}</sub>.",
    "ACCOUNT_CREATION_FAILED": "Échec de la création du compte membre.",
    "RESTORE_WALLET_DATA_ERROR": "Échec du rechargement des paramètres depuis le stockage local",
    "LOAD_WALLET_DATA_ERROR": "Échec du chargement des données du portefeuille.",
    "COPY_CLIPBOARD_FAILED": "Copie de la valeur impossible.",
    "TAKE_PICTURE_FAILED": "Échec de la récupération de la photo.",
    "SCAN_FAILED": "Échec du scan de QR-code.",
    "SCAN_UNKNOWN_FORMAT": "Code non reconnu.",
    "WOT_LOOKUP_FAILED": "Échec de la recherche.",
    "LOAD_PEER_DATA_FAILED": "Lecture du nœud Duniter impossible. Veuillez réessayer ultérieurement.",
    "NEED_LOGIN_FIRST": "Veuillez d'abord vous connecter.",
    "AMOUNT_REQUIRED": "Le montant est obligatoire.",
    "AMOUNT_NEGATIVE": "Montant négatif non autorisé.",
    "NOT_ENOUGH_CREDIT": "Crédit insuffisant.",
    "INVALID_NODE_SUMMARY": "Nœud injoignable ou adresse invalide.",
    "INVALID_USER_ID": "Le pseudonyme ne doit contenir ni espace ni caractère spécial ou accentué.",
    "INVALID_COMMENT": "Le champ 'référence' ne doit pas contenir de caractères accentués.",
    "INVALID_PUBKEY": "La clé publique n'a pas le format attendu.",
    "INVALID_PUBKEY_CHECKSUM": "Somme de contrôle invalide.",
    "IDENTITY_REVOKED": "Cette identité <b>a été révoquée</b>. Elle ne peut plus devenir membre.",
    "IDENTITY_REVOKED_WITH_TIME": "Cette identité <b>a été révoquée {{revocationTime|medianFromNow}}</b> ({{revocationTime|medianDate}}). Elle ne peut plus devenir membre.",
    "IDENTITY_PENDING_REVOCATION": "La <b>révocation de cette identité</b> a été demandée et est en attente de traitement. La certification est donc désactivée.",
    "IDENTITY_INVALID_BLOCK_HASH": "Cette demande d'adhésion n'est plus valide (car elle référence un bloc que les nœuds du réseau ont annulé) : cette personne doit renouveler sa demande d'adhésion <b>avant</b> d'être certifiée.",
    "IDENTITY_EXPIRED": "La publication de cette identité a expiré : cette personne doit effectuer une nouvelle demande d'adhésion <b>avant</b> d'être certifiée.",
    "IDENTITY_SANDBOX_FULL": "Le nœud Duniter utilisé par Cesium ne peut plus recevoir de nouvelles identités, car sa file d'attente est pleine.<br/><br/>Veuillez réessayer ultérieurement ou changer de nœud (via le menu <b>Paramètres</b>).",
    "IDENTITY_NOT_FOUND": "Identité non trouvée.",
    "IDENTITY_TX_FAILED": "Échec du chargement des opérations.",
    "WOT_PENDING_INVALID_BLOCK_HASH": "Adhésion non valide.",
    "WALLET_INVALID_BLOCK_HASH": "Votre demande d'adhésion n'est plus valide (car elle référence un bloc que les nœuds du réseau ont annulé).<br/>Vous devez <a ng-click=\"doQuickFix('fixMembership')\">envoyer une nouvelle demande</a> pour résoudre ce problème.",
    "WALLET_IDENTITY_EXPIRED": "La publication de <b>votre identité a expirée</b>.<br/>Vous devez <a ng-click=\"doQuickFix('fixIdentity')\">publier à nouveau votre identité</a> pour résoudre ce problème.",
    "WALLET_REVOKED": "Votre identité a été <b>révoquée</b> : ni votre pseudonyme ni votre clef publique ne pourra être utilisé à l'avenir pour un compte membre.",
    "WALLET_HAS_NO_SELF": "Votre identité doit d'abord avoir été publiée, et ne pas être expirée.",
    "AUTH_REQUIRED": "Authentification requise.",
    "AUTH_INVALID_PUBKEY": "La clef attendue est <i class=\"ion-key\"></i> {{pubkey|formatPubkey}}...",
    "AUTH_INVALID_SCRYPT": "Identifiant ou mot de passe invalide.",
    "AUTH_INVALID_FILE": "Fichier de trousseau invalide.",
    "AUTH_FILE_ERROR": "Échec de l'ouverture du fichier de trousseau.",
    "IDENTITY_ALREADY_CERTIFY": "Vous avez <b>déjà certifié</b> cette identité.<br/><br/>Cette certification est encore valide (expiration {{expiresIn|formatDurationTo}}).",
    "IDENTITY_ALREADY_CERTIFY_PENDING": "Vous avez <b>déjà certifié</b> cette identité.<br/><br/>Cette certification est en attente de traitement (date limite de traitement {{expiresIn|formatDurationTo}}).",
    "UNABLE_TO_CERTIFY_TITLE": "Certification impossible",
    "LOAD_NEWCOMERS_FAILED": "Échec du chargement des nouveaux membres.",
    "LOAD_PENDING_FAILED": "Échec du chargement des inscriptions en attente.",
    "ONLY_MEMBER_CAN_EXECUTE_THIS_ACTION": "Vous devez <b>être membre</b> pour pouvoir effectuer cette action.",
    "ONLY_MEMBER_OR_WAS_MEMBER_CAN_EXECUTE_THIS_ACTION": "Vous devez <b>être membre (ou ancien membre)</b> pour pouvoir effectuer cette action.",
    "ONLY_SELF_CAN_EXECUTE_THIS_ACTION": "Vous devez avoir <b>publié votre identité</b> pour pouvoir effectuer cette action.",
    "GET_BLOCK_FAILED": "Échec de la récupération du bloc.",
    "INVALID_BLOCK_HASH": "Bloc non trouvé (hash différent).",
    "DOWNLOAD_REVOCATION_FAILED": "Échec du téléchargement du fichier de révocation.",
    "REVOCATION_FAILED": "Échec de la révocation.",
    "SALT_OR_PASSWORD_NOT_CONFIRMED": "Identifiant secret ou mot de passe incorrect.",
    "RECOVER_ID_FAILED": "Échec de la récupération des identifiants",
    "LOAD_FILE_FAILED" : "Échec du chargement du fichier",
    "NOT_VALID_REVOCATION_FILE": "Fichier de révocation non valide (mauvais format de fichier)",
    "NOT_VALID_SAVE_ID_FILE": "Fichier de récupération non valide (mauvais format de fichier)",
    "NOT_VALID_KEY_FILE": "Fichier de trousseau non valide (format non reconnu)",
    "EXISTING_ACCOUNT": "Vos identifiants correspondent à un compte déjà existant, dont la <a ng-click=\"showHelpModal('pubkey')\">clef publique</a> est :",
    "EXISTING_ACCOUNT_REQUEST": "Veuillez modifier vos identifiants afin qu'ils correspondent à un compte non utilisé.",
    "GET_LICENSE_FILE_FAILED": "Récupération du fichier de licence impossible.",
    "CHECK_NETWORK_CONNECTION": "Aucun nœud ne semble accessible.<br/><br/>Veuillez <b>vérifier votre connexion Internet</b>.",
    "ISSUE_524_TX_FAILED": "Échec du virement.<br/><br/>Un message a été envoyé aux développeurs pour faciliter la résolution du problème. <b>Merci de votre aide</b>.",
    "ADD_SECONDARY_WALLET_FAILED": "Échec de l'ajout du portefeuille secondaire.",
    "REMOVE_SECONDARY_WALLET_FAILED": "Échec de la suppression du portefeuille secondaire.",
    "UPDATE_WALLET_LIST_FAILED": "Échec du rafraîchissement des portefeuilles secondaires.",
    "LOAD_WALLET_LIST_FAILED": "Échec du chargement des portefeuilles secondaires.",
    "SAVE_WALLET_LIST_FAILED": "Échec de la sauvegarde des portefeuilles secondaires.",
    "COULD_NOT_ADD_MAIN_WALLET": "Ce portefeuille <b>correspond au compte principal</b> avec lequel vous êtes connecté.<br/>Impossible de l'ajouter comme portefeuille secondaire.",
    "COULD_NOT_ADD_EXISTING_WALLET": "Portefeuille déjà existant dans la liste.",
    "UNKNOWN_WALLET_ID": "Portefeuille secondaire inconnu.",
    "RESTORE_WALLET_LIST_FAILED": "Échec de la restauration des portefeuilles secondaires.",
    "INVALID_FILE_FORMAT": "Format de fichier invalide.",
    "SAME_TX_RECIPIENT": "Le destinataire doit être différent de l'émetteur."
  },
  "INFO": {
    "POPUP_TITLE": "Information",
    "CERTIFICATION_DONE": "Certification envoyée",
    "NOT_ENOUGH_CREDIT": "Crédit insuffisant",
    "TRANSFER_SENT": "Virement envoyé",
    "COPY_TO_CLIPBOARD_DONE": "Copié dans le presse-papier",
    "MEMBERSHIP_OUT_SENT": "Résiliation envoyée",
    "NOT_NEED_MEMBERSHIP": "Vous êtes déjà membre.",
    "IDENTITY_WILL_MISSING_CERTIFICATIONS": "Cette identité va bientôt manquer de certifications (au moins {{willNeedCertificationCount}}).",
    "IDENTITY_NEED_MEMBERSHIP": "Cette identité n'a pas envoyée de demande d'adhésion. Elle le devra si elle souhaite devenir membre.",
    "HAS_ALTERNATIVE_IDENTITIES": "Il existe <b>plusieurs identités</b> rattachées à cette clé publique. <b>Avant toute certification</b>, pensez à <a ng-click=\"doQuickFix('showSelectIdentities')\">consulter les autres identités</a> pour choisir la bonne, ou bien contacter le propriétaire du compte.",
    "REVOCATION_SENT": "Révocation envoyée",
    "REVOCATION_SENT_WAITING_PROCESS": "La <b>révocation de cette identité</b> a été demandée et est en attente de traitement.",
    "FEATURES_NOT_IMPLEMENTED": "Cette fonctionnalité est encore en cours de développement.<br/>Pourquoi ne pas <b>contribuer à Cesium</b>, pour l'obtenir plus rapidement ? ;)",
    "EMPTY_TX_HISTORY": "Aucune opération à exporter"
  },
  "CONFIRM": {
    "POPUP_TITLE": "<b>Confirmation</b>",
    "POPUP_WARNING_TITLE": "<b>Avertissement</b>",
    "POPUP_SECURITY_WARNING_TITLE": "<i class=\"icon ion-alert-circled\"></i> <b>Avertissement de sécurité</b>",
    "CERTIFY_RULES_TITLE_UID": "Certifier {{uid}}",
    "CERTIFY_RULES": "<b class=\"assertive\">Ne PAS certifier</b> un compte si vous pensez que :<br/><br/><ul><li>1.) il ne correspond pas à une personne <b>physique et vivante</b>.<li>2.) son propriétaire <b>possède un autre compte</b> déjà certifié.<li>3.) son propriétaire viole (volontairement ou non) la règle 1 ou 2 (par exemple en certifiant des comptes factices ou en double).</ul><br/><b>Êtes-vous sûr</b> de vouloir néanmoins certifier cette identité ?",
    "FULLSCREEN": "Afficher l'application en plein écran ?",
    "EXIT_APP": "Fermer l'application ?",
    "TRANSFER": "<b>Récapitulatif du virement</b> :<br/><br/><ul><li> - De : {{from}}</li><li> - A : <b>{{to}}</b></li><li> - Montant : <b>{{amount}} {{unit}}</b></li><li> - Commentaire : <i>{{comment}}</i></li></ul><br/><b>Êtes-vous sûr de vouloir effectuer ce virement ?</b>",
    "TRANSFER_ALL": "<b>Récapitulatif du virement</b> :<br/><br/><ul><li> - De : {{from}}</li><li> - A : <b>{{to}}</b></li><li> - Montant : <b>{{amount}} {{unit}}</b></li><li> - Commentaire : <i>{{comment}}</i></li><br/><li> - Reste : <b>{{restAmount}} {{unit}}</b> à <b>{{restTo}}</b></li></ul><br/><b>Êtes-vous sûr de vouloir effectuer ce virement ?</b>",
    "MEMBERSHIP_OUT": "Cette opération est <b>irréversible</b>.<br/></br/>Êtes-vous sûr de vouloir <b>résilier votre compte membre</b> ?",
    "MEMBERSHIP_OUT_2": "Cette opération est <b>irreversible</b> !<br/><br/>Êtes-vous vraiment sûr de vouloir <b>résilier votre adhésion</b> comme membre ?",
    "LOGIN_UNUSED_WALLET_TITLE": "Erreur de saisie ?",
    "LOGIN_UNUSED_WALLET": "Le compte connecté semble <b>inactif</b>.<br/><br/>Il s'agit probablement d'une <b>erreur de saisie</b> dans vos identifiants de connexion. Veuillez recommencer, en vérifiant que <b>la clé publique est celle de votre compte</b>.",
    "FIX_IDENTITY": "Le pseudonyme <b>{{uid}}</b> va être publiée à nouveau, en remplacement de l'ancienne publication qui a expirée.<br/></br/><b>Êtes-vous sûr</b> de vouloir continuer ?",
    "FIX_MEMBERSHIP": "Votre demande d'adhésion comme membre va être renvoyée.<br/></br/><b>Êtes-vous sûr</b> de vouloir continuer ?",
    "MEMBERSHIP": "Votre demande d'adhésion comme membre va être envoyée.<br/></br/><b>Êtes-vous sûr</b> de vouloir continuer ?",
    "RENEW_MEMBERSHIP": "Votre adhésion comme membre va être renouvelée.<br/></br/><b>Êtes-vous sûr</b> de vouloir continuer ?",
    "REVOKE_IDENTITY": "Vous allez <b>revoquer définitivement cette identité</b>.<br/><br/>La clé publique et le pseudonyme associés <b>ne pourront plus jamais être utilisés</b> (pour un compte membre). <br/></br/><b>Êtes-vous sûr</b> de vouloir révoquer définitivement ce compte ?",
    "REVOKE_IDENTITY_2": "Cette opération est <b>irreversible</b> !<br/><br/>Êtes-vous vraiment sûr de vouloir <b>révoquer définitivement</b> ce compte ?",
    "NOT_NEED_RENEW_MEMBERSHIP": "Votre adhésion n'a pas besoin d'être renouvelée (elle n'expirera que dans {{membershipExpiresIn|formatDuration}}).<br/></br/><b>Êtes-vous sûr</b> de vouloir renouveler votre adhésion ?",
    "SAVE_BEFORE_LEAVE": "Voulez-vous <b>sauvegarder vos modifications</b> avant de quitter la page ?",
    "SAVE_BEFORE_LEAVE_TITLE": "Modifications non enregistrées",
    "LOGOUT": "Êtes-vous sûr de vouloir vous déconnecter ?",
    "USE_FALLBACK_NODE": "Nœud <b>{{old}}</b> injoignable ou adresse invalide.<br/><br/>Voulez-vous temporairement utiliser le nœud <b>{{new}}</b> ?",
    "ISSUE_524_SEND_LOG": "La transaction a été rejetée, à cause d'une anomalie connue (ticket #524) mais <b>non reproduite</b>.<br/><br/>Pour aider les développeurs à corriger cette erreur, <b>acceptez-vous la transmission de vos logs</b> par message ?<br/><small>(aucune donnée confidentielle n'est envoyée)</small>."
  },
  "MODE": {
    "DEMO": {
      "BADGE": "Démo",
      "MODE": "Mode démonstration",
      "FEATURE_NOT_AVAILABLE": "Fonctionnalité <b>non disponible</b> sur ce site de démonstration.",
      "MODE_HELP": "Cesium fonctionne en <b>mode démonstration</b> : la consultation de compte est possible, mais aucune opération ne pourra être réalisée.",
      "INSTALL_HELP": "Pour des <b>raisons de sécurité</b> nous vous recommandons <b>d'installer</b> votre copie de l'application Cesium. Visitez le site <a href='https://cesium.app'>www.cesium.app</a> pour obtenir de l'aide."
    },
    "READONLY": {
      "BADGE": "Monit",
      "MODE": "Mode monitoring",
      "MODE_HELP": "Cesium fonctionne en <b>mode monitoring</b> : ne sont disponibles que les fonctionnalités de supervision de la monnaie.",
      "INSTALL_HELP": "Si vous souhaitez <b>créer un compte portefeuille</b> pour envoyer ou recevoir de la monnaie, nous vous recommandons <b>d'installer votre copie</b> de l'application Cesium. Visitez le site <a href='https://cesium.app'>www.cesium.app</a> pour obtenir de l'aide."
    }
  },
  "DOWNLOAD": {
    "POPUP_TITLE": "<b>Fichier de révocation</b>",
    "POPUP_REVOKE_MESSAGE": "Pour sécuriser votre compte, veuillez télécharger le <b>document de révocation de compte</b>. Il vous permettra le cas échéant d'annuler votre compte (en cas d'un vol de compte, d'un changement d'identifiant, d'un compte créé à tort, etc.).<br/><br/><b>Veuillez le stocker en lieu sûr.</b>"
  },
  "HELP": {
    "TITLE": "Aide en ligne",
    "JOIN": {
      "SECTION": "Inscription",
      "SALT": "L'identifiant secret est très important. Il sert à mélanger le mot de passe, avant qu'il ne serve à calculer la <span class=\"text-italic\">clé publique</span> de votre compte (son numéro) et la clé secrète pour y accéder.<br/><b>Veillez à bien la mémoriser</b>, car aucun moyen n'est actuellement prévu pour la retrouver en cas de perte.<br/>Par ailleurs, il ne peut pas être modifié sans devoir créer un nouveau compte.<br/><br/>Un bon identifiant secret doit être suffisamment long (au moins 8 caractères) et le plus original possible.",
      "PASSWORD": "Le mot de passe est très important. Avec l'identifiant secret, il sert à calculer le numéro (la clé publique) de votre compte, et la clé secrète pour y accéder.<br/><b>Veillez à bien le mémoriser</b>, car aucun moyen n'est prévu de le retrouver en cas de perte (sauf à générer un fichier de sauvegarde).<br/>Par ailleurs, il ne peut pas être modifié sans devoir créer un nouveau compte.<br/><br/>Un bon mot de passe contient (idéalement) au moins 8 caractères, dont au moins une majuscule et un chiffre.",
      "PSEUDO": "Le pseudonyme est utilisé uniquement dans le cas d'inscription comme <span class=\"text-italic\">membre</span>. Il est toujours associé à un portefeuille (via sa <span class=\"text-italic\">clé publique</span>).<br/>Il est publié sur le réseau, afin que les autres utilisateurs puisse l'identifier, le certifier ou envoyer de la monnaie sur le compte.<br/>Un pseudonyme doit être unique au sein des membres (<u>actuels</u> et anciens)."
    },
    "LOGIN": {
      "SECTION": "Connexion",
      "PUBKEY": "Clé publique du trousseau",
      "PUBKEY_DEF": "La clef publique du trousseau est générée à partir des identifiants saisis (n'importe lesquels), sans pour autant qu'ils correspondent à un compte déjà utilisé.<br/><b>Vérifiez attentivement que la clé publique est celle de votre compte</b>. Dans le cas contraire, vous serez connecté à un compte probablement jamais utilisé, le risque de collision avec un compte existant étant infime.<br/><a href=\"https://fr.wikipedia.org/wiki/Cryptographie_asym%C3%A9trique\" target=\"_system\">En savoir plus sur la cryptographie</a> par clé publique.",
      "METHOD": "Méthodes de connexion",
      "METHOD_DEF": "Plusieurs options sont disponibles pour vous connecter à un portefeuille :<br/> - La connexion <b>par salage (simple ou avancé)</b> mélange votre mot de passe grâce à l'identifiant secret, pour limiter les tentatives de <a href=\"https://fr.wikipedia.org/wiki/Attaque_par_force_brute\" target=\"_system\">piratage par force brute</a> (par exemple à partir de mots connus).<br/> - La connexion <b>par clé publique</b> évite de saisir vos identifiants, qui vous seront demandé seulement le moment venu lors d'une opération sur le compte.<br/> - La connexion <b>par fichier de trousseau</b> va lire les clés (publique et privée) du compte, depuis un fichier, sans besoin de saisir d'identifiants. Plusieurs formats de fichier sont possibles."
    },
    "GLOSSARY": {
      "SECTION": "Glossaire",
      "PUBKEY_DEF": "Une clé publique identifie un portefeuille de monnaie, qui peut identifier un membre ou correspondre à un portefeuille anonyme. Dans Cesium la clé publique est calculée (par défaut) grâce à l'identifiant secret et au mot de passe.<br/><a href=\"https://fr.wikipedia.org/wiki/Cryptographie_asym%C3%A9trique\" target=\"_system\">En savoir plus sur la cryptographie</a> par clé publique.",
      "MEMBER": "Membre",
      "MEMBER_DEF": "Un membre est une personne humaine physique et vivante, désireuse de participer librement à la communauté monétaire. Elle co-produit un dividende universel, suivant une période et un montant tels que définis dans les <span class=\"text-italic\">règles de la monnaie</span>",
      "CURRENCY_RULES": "Règles de la monnaie",
      "CURRENCY_RULES_DEF": "Les règles de la monnaie sont définies une fois pour toutes. Elle fixe le fonctionnement de la monnaie : le calcul du dividende universel, le nombre de certifications nécessaire pour être membre, le nombre de certification maximum qu'un membre peut donner, etc. <a href=\"#/app/currency\">Voir les règles actuelles</a>.<br/>La non modification des règles dans le temps est possible par l'utilisation d'une <span class=\"text-italic\">BlockChain</span> qui porte et exécute ces règles, et en vérifie constamment la bonne application.",
      "BLOCKCHAIN": "Chaîne de blocs (<span class=\"text-italic\">Blockchain</span>)",
      "BLOCKCHAIN_DEF": "La BlockChain est un système décentralisé, qui, dans le cas de Duniter, sert à porter et exécuter les <span class=\"text-italic\">règles de la monnaie</span>.<br/><a href=\"https://duniter.org/fr/comprendre/\" target=\"_system\">En savoir plus sur Duniter</a> et le fonctionnement de sa blockchain.",
      "UNIVERSAL_DIVIDEND_DEF": "Le Dividende Universel (DU) est la quantité de monnaie co-créée par chaque membre, suivant la période et le calcul définis dans les <span class=\"text-italic\">règles de la monnaie</span>.<br/>A chaque échéance, les membres recoivent sur leur compte la meme quantité de nouvelle monnaie.<br/><br/>Le DU subit une croissance régulière, pour rester juste entre les membres (actuels et à venir), calculée en fonction de l'espérance de vie moyenne, telle que démontré dans la Thérorie Relative de la Monnaie (TRM).<br/><a href=\"http://trm.creationmonetaire.info\" target=\"_system\">En savoir plus sur la TRM</a> et les monnaies libres.",
      "WOT": "Toile de Confiance (TdC)",
      "WOT_DEF": "La Toile de Confiance est constituée de l'ensemble des membres de la monnaie, et des liens de certification qui les relient.",
      "DISTANCE_RULE": "Règle de distance",
      "DISTANCE_RULE_DEF": "La règle de distance de la Toile de Confiance définie <b>une distance maximale à respecter</b> entre un postulant et un nombre minimum de membres référents (ou membres centraux). Cette distance est calculée en utilisant les liens de certification."
    },
    "TIP": {
      "MENU_BTN_CURRENCY": "Le menu <b>{{'MENU.CURRENCY'|translate}}</b> permet la consultation des <b>règles de la monnaie</b> et de son état.",
      "CURRENCY_WOT": "Le <b>nombre de membres</b> montre l'importance de la communauté et permet de <b>suivre son évolution</b>.",
      "CURRENCY_MASS": "Suivez ici la <b>quantité totale de monnaie</b> existante et sa <b>répartition moyenne</b> par membre.<br/><br/>Ceci permet de juger de l'<b>importance d'un montant</b>, vis à vis de ce que <b>possède les autres</b> sur leur compte (en moyenne).",
      "CURRENCY_UNIT_RELATIVE": "L'unité utilisée (&ldquo;<b>{{'COMMON.UD'|translate}}<sub>{{currency|abbreviate}}</sub></b>&rdquo;) signifie que les montants en {{currency|capitalize}} ont été divisés par le <b>Dividende Universel</b> (DU).<br/><br/><small>Cette unité relative est <b>pertinente</b>, car stable malgré la quantitié de monnaie qui augmente en permanence.</small>",
      "CURRENCY_CHANGE_UNIT": "L'option <b>{{'COMMON.BTN_RELATIVE_UNIT'|translate}}</b> permet de <b>changer d'unité</b>, pour visualiser les montants <b>directement en {{currency|capitalize}}</b> (plutôt qu'en &ldquo;<b>{{'COMMON.UD'|translate}}<sub>{{currency|abbreviate}}</sub></b>&rdquo;).",
      "CURRENCY_CHANGE_UNIT_TO_RELATIVE": "L'option <b>{{'COMMON.BTN_RELATIVE_UNIT'|translate}}</b> permet de <b>changer d'unité</b>, pour visualiser les montants en &ldquo;<b>{{'COMMON.UD'|translate}}<sub>{{currency|abbreviate}}</sub></b>&rdquo;, c'est-à-dire relativement au Dividende Universel (le montant co-produit par chaque membre).",
      "CURRENCY_RULES": "Les <b>règles</b> de la monnaie fixent son fonctionnement <b>exact et prévisible</b>.<br/><br/>Véritable ADN de la monnaie, elles rendent son code monétaire <b>lisible et transparent</b>.",
      "MENU_BTN_NETWORK": "Le menu <b>{{'MENU.NETWORK'|translate}}</b> permet la consultation de l'état du réseau.",
      "NETWORK_BLOCKCHAIN": "Toutes les opérations de la monnaie sont enregistrées dans un grand livre de compte <b>public et infalsifiable</b>, appelé aussi <b>chaine de blocs</b> (<em>BlockChain</em> en anglais).",
      "NETWORK_PEERS": "Les <b>nœuds</b> visibles ici correspondent aux <b>ordinateurs qui actualisent et contrôlent</b> la chaine de blocs.<br/><br/>Plus il y a de nœuds, plus la monnaie a une gestion <b>décentralisée</b> et digne de confiance.",
      "NETWORK_PEERS_BLOCK_NUMBER": "Ce <b>numéro</b> (en vert) indique le <b>dernier bloc validé</b> pour ce nœud (dernière page écrite dans le grand livre de comptes).<br/><br/>La couleur verte indique que ce bloc est également validé par <b>la plupart des autres nœuds</b>.",
      "NETWORK_PEERS_PARTICIPATE": "<b>Chaque membre</b>, équipé d'un ordinateur avec Internet, <b>peut participer en ajoutant un nœud</b>. Il suffit d'<b>installer le logiciel Duniter</b> (libre et gratuit). <a href=\"{{installDocUrl}}\" target=\"_system\">Voir le manuel d'installation &gt;&gt;</a>.",
      "MENU_BTN_ACCOUNT": "Le menu <b>{{'MENU.ACCOUNT'|translate}}</b> permet d'accéder à la gestion de votre compte.",
      "MENU_BTN_ACCOUNT_MEMBER": "Consultez ici l'état de votre compte et les informations sur vos certifications.",
      "WALLET_CERTIFICATIONS": "Cliquez ici pour consulter le détail de vos certifications (reçues et émises).",
      "WALLET_RECEIVED_CERTIFICATIONS": "Cliquez ici pour consulter le détail de vos <b>certifications reçues</b>.",
      "WALLET_GIVEN_CERTIFICATIONS": "Cliquez ici pour consulter le détail de vos <b>certifications émises</b>.",
      "WALLET_BALANCE": "Le <b>solde</b> de votre compte s'affiche ici.",
      "WALLET_BALANCE_RELATIVE": "{{'HELP.TIP.WALLET_BALANCE'|translate}}<br/><br/>L'unité utilisée (&ldquo;<b>{{'COMMON.UD'|translate}}<sub>{{currency|abbreviate}}</sub></b>&rdquo;) signifie que le montant en {{currency|capitalize}} a été divisé par le <b>Dividende Universel</b> (DU) co-créé par chaque membre.<br/><br/>Actuellement 1 DU vaut {{currentUD|formatInteger}} {{currency|capitalize}}s.",
      "WALLET_BALANCE_CHANGE_UNIT": "Vous pourrez <b>changer l'unité</b> d'affichage des montants dans les <b><i class=\"icon ion-android-settings\"></i>&nbsp;{{'MENU.SETTINGS'|translate}}</b>.<br/><br/>Par exemple pour visualiser les montants <b>directement en {{currency|capitalize}}</b>, plutôt qu'en unité relative.",
      "WALLET_PUBKEY": "Voici la clé publique de votre compte. Vous pouvez la communiquer à un tiers afin qu'il identifie plus simplement votre compte.",
      "WALLET_SEND": "Effectuer un paiement en quelques clics.",
      "WALLET_SEND_NO_MONEY": "Effectuer un paiement en quelques clics.<br/>(Votre solde ne le permet pas encore)",
      "WALLET_OPTIONS": "Ce bouton permet l'accès aux <b>actions d'adhésion</b> et de sécurité.<br/><br/>N'oubliez pas d'y jeter un oeil !",
      "WALLET_RECEIVED_CERTS": "S'affichera ici la liste des personnes qui vous ont certifié.",
      "WALLET_CERTIFY": "Le bouton <b>{{'WOT.BTN_SELECT_AND_CERTIFY'|translate}}</b> permet de sélectionner une identité et de la certifier.<br/><br/>Seuls des utilisateurs <b>déjà membres</b> peuvent en certifier d'autres.",
      "WALLET_CERT_STOCK": "Votre stock de certifications (émises) est limité à <b>{{sigStock}} certifications</b>.<br/><br/>Ce stock se renouvelle avec le temps, au fur et à mesure que les certifications s'invalident.",
      "MENU_BTN_WALLETS": "Le menu <b>{{'MENU.WALLETS'|translate}}</b> permet d'ajouter des portefeuilles supplémentaires que vous gérez.",
      "MENU_BTN_TX": "Le menu <b>{{'MENU.TRANSACTIONS'|translate}}</b> permet de consulter votre solde, l'historique vos transactions et d'envoyer un paiement.",
      "MENU_BTN_WOT": "Le menu <b>{{'MENU.WOT'|translate}}</b> permet de rechercher parmi les <b>utilisateurs</b> de la monnaie (membres ou non).",
      "WOT_SEARCH_TEXT_XS": "Pour rechercher dans l'annuaire, tapez les <b>premières lettres d'un pseudonyme</b> (ou d'une clé publique).<br/><br/>La recherche se lancera automatiquement.",
      "WOT_SEARCH_TEXT": "Pour rechercher dans l'annuaire, tapez les <b>premières lettres d'un pseudonyme</b> (ou d'une clé publique). <br/><br/>Appuyer ensuite sur <b>Entrée</b> pour lancer la recherche.",
      "WOT_SEARCH_RESULT": "Visualisez la fiche détaillée simplement en <b>cliquant</b> sur une ligne.",
      "WOT_VIEW_CERTIFICATIONS": "La ligne <b>{{'ACCOUNT.CERTIFICATION_COUNT'|translate}}</b> montre combien de membres ont validé cette identité.<br/><br/>Ces certifications attestent que le compte appartient à <b>une personne humaine vivante</b> n'ayant <b>aucun autre compte membre</b>.",
      "WOT_VIEW_CERTIFICATIONS_COUNT": "Il faut au moins <b>{{sigQty}} certifications</b> pour devenir membre et recevoir le <b>Dividende Universel</b>.",
      "WOT_VIEW_CERTIFICATIONS_CLICK": "Un clic ici permet d'ouvrir <b>la liste de toutes les certifications</b> de l'identité (reçues et émises).",
      "WOT_VIEW_CERTIFY": "Le bouton <b>{{'WOT.BTN_CERTIFY'|translate}}</b> permet d'ajouter votre certification à cette identité.",
      "CERTIFY_RULES": "<b>Attention :</b> Ne certifiez que des <b>personnes physiques vivantes</b>, ne possédant aucun autre compte membre.<br/><br/>La sécurité de la monnaie dépend de la vigilance de chacun !",
      "MENU_BTN_SETTINGS": "Les <b>{{'MENU.SETTINGS'|translate}}</b> vous permettront de configurer l'application.",
      "HEADER_BAR_BTN_PROFILE": "Cliquez ici pour accéder à votre <b>profil utilisateur.</b>",
      "SETTINGS_CHANGE_UNIT": "Vous pourrez <b>changer d'unité d'affichage</b> des montants en cliquant ci-dessus.<br/><br/>- Désactivez l'option pour un affichage des montants en {{currency|capitalize}}.<br/>- Activez l'option pour un affichage relatif en {{'COMMON.UD'|translate}}<sub>{{currency|abbreviate}}</sub> (tous les montants seront <b>divisés</b> par le Dividende Universel courant).",
      "END_LOGIN": "Cette visite guidée est <b>terminée</b> !<br/><br/>Bonne continuation à vous, dans le nouveau monde de l'<b>économie libre</b> !",
      "END_NOT_LOGIN": "Cette visite guidée est <b>terminée</b> !<br/><br/>Si vous souhaitez rejoindre la monnaie {{currency|capitalize}}, il vous suffira de cliquer sur <b>{{'LOGIN.CREATE_FREE_ACCOUNT'|translate}}</b> ci-dessous.",
      "END_READONLY": "Cette visite guidée est <b>terminée</b>.<br/><br/>{{'MODE.READONLY.INSTALL_HELP'|translate}}."
    }
  },
  "API" :{
    "COMMON": {
      "LINK_DOC": "Documentation API",
      "LINK_DOC_HELP": "Documentation pour les développeurs",
      "LINK_STANDARD_APP": "Version classique",
      "LINK_STANDARD_APP_HELP": "Ouvrir la version classique de {{'COMMON.APP_NAME'|translate}}",
      "CONNECTION_ERROR": "Nœud <b>{{server}}</b> injoignable ou adresse invalide.<br/><br/>Vérifiez votre connexion Internet, ou contactez l'administrateur du site."
    },
    "HOME": {
      "TITLE": "Documentation API {{'COMMON.APP_NAME'|translate}}",
      "MESSAGE": "Bienvenue dans la <b>documentation de l'API</b> {{'COMMON.APP_NAME'|translate}}.<br/>Connectez vos sites web à <a href=\"http://duniter.org\" target=\"_system\">Duniter</a> très simplement !",
      "MESSAGE_SHORT": "Connectez vos sites à <a href=\"http://duniter.org\" target=\"_system\">Duniter</a> très simplement !",
      "DOC_HEADER": "Services disponibles :"
    },
    "TRANSFER": {
      "TITLE": "{{'COMMON.APP_NAME'|translate}} - Paiement en ligne",
      "TITLE_SHORT": "Paiement en ligne",
      "SUMMARY": "Récapitulatif du paiement :",
      "AMOUNT": "Montant :",
      "AMOUNTS_HELP": "Veuillez choisir le montant :",
      "NAME": "Nom :",
      "PUBKEY": "Clé publique du destinataire :",
      "COMMENT": "Référence de l'opération :",
      "NODE": "Adresse du nœud :",
      "DEMO": {
        "SALT": "demo",
        "PASSWORD": "demo",
        "PUBKEY": "3G28bL6deXQBYpPBpLFuECo46d3kfYMJwst7uhdVBnD1",
        "HELP": "<b>Mode démonstration</b> : Aucun paiement ne sera réellement envoyé pendant cette simulation.<br/>Veuillez utiliser les identifiants : <b>{{'API.TRANSFER.DEMO.SALT'|translate}} / {{'API.TRANSFER.DEMO.PASSWORD'|translate}}</b>",
        "BAD_CREDENTIALS": "Vérifiez votre saisie.<br/>En mode démonstration, les identifiants sont : {{'API.TRANSFER.DEMO.SALT'|translate}} / {{'API.TRANSFER.DEMO.PASSWORD'|translate}}"
      },
      "INFO": {
        "SUCCESS_REDIRECTING_WITH_NAME": "Paiement envoyé.<br/>Redirection vers <b>{{name}}</b>...",
        "SUCCESS_REDIRECTING": "Paiement envoyé.<br/>Redirection vers le site du vendeur...",
        "CANCEL_REDIRECTING_WITH_NAME": "Paiement annulé.<br/>Redirection vers <b>{{name}}</b>...",
        "CANCEL_REDIRECTING": "Paiement annulé.<br/>Redirection vers le site du vendeur..."
      },
      "ERROR": {
        "TRANSFER_FAILED": "Échec du paiement"
      }
    },
    "DOC": {
      "DESCRIPTION_DIVIDER": "Description",
      "URL_DIVIDER": "Adresse d'appel",
      "PARAMETERS_DIVIDER": "Paramètres",
      "AVAILABLE_PARAMETERS": "Voici la liste des paramètres possibles :",
      "DEMO_DIVIDER": "Tester",
      "DEMO_HELP": "Pour tester ce service, cliquez sur le bouton ci-contre. Le résultat s'affichera en dessous.",
      "DEMO_RESULT": "Résultat retourné par l'appel :",
      "DEMO_RESULT_PEER": "Adresse du nœud utilisé :",
      "DEMO_SUCCEED": "<i class=\"icon ion-checkmark\"></i> Succès !",
      "DEMO_CANCELLED": "<i class=\"icon ion-close\"></i> Annulé par l'utilisateur",
      "INTEGRATE_DIVIDER": "Intégrer",
      "INTEGRATE_CODE": "Code :",
      "INTEGRATE_RESULT": "Prévisualisation du résultat :",
      "INTEGRATE_PARAMETERS": "Paramètres",
      "TRANSFER": {
        "TITLE": "Paiements",
        "DESCRIPTION": "Depuis un site (ex: vente en ligne) vous pouvez déléguer le paiement en monnaie libre à Cesium API. Pour cela, il vous suffit de déclencher l'ouverture d'une page sur l'adresse suivante :",
        "PARAM_PUBKEY": "Clé publique du destinataire",
        "PARAM_PUBKEY_HELP": "Clé publique du destinataire (obligatoire)",
        "PARAM_AMOUNT": "Montant",
        "PARAM_AMOUNT_HELP": "Montant de la transaction (obligatoire). Valeurs multiples autorisées, en utilisant un séparateur (point-virgule, barre verticale ou espace).",
        "PARAM_COMMENT": "Référence (ou commentaire)",
        "PARAM_COMMENT_HELP": "Référence ou commentaire. Vous permettra par exemple d'identifier le paiement dans la BlockChain.",
        "PARAM_NAME": "Nom (du destinataire ou du site web)",
        "PARAM_NAME_HELP": "Le nom du destinataire, ou du site web appelant. Cela peut être un nom lisible (\"Mon site en ligne\"), ou encore une pseudo-adresse web (\"MonSite.com\").",
        "PARAM_REDIRECT_URL": "Adresse web de redirection",
        "PARAM_REDIRECT_URL_HELP": "Adresse web (URL) de redirection, appelé quand le paiement a été envoyé. Peut contenir les chaînes suivantes, qui seront remplacées par les valeurs de la transaction : \"{tx}\", \"{hash}\", \"{comment}\", \"{amount}\", \"{pubkey}\" et \"{node}\".",
        "PARAM_CANCEL_URL": "Adresse web d'annulation",
        "PARAM_CANCEL_URL_HELP": "Adresse web (URL) en cas d'annulation du paiement, par l'utilisateur. Peut contenir les chaînes suivantes, qui seront remplacées dynamiquement : \"{comment}\", \"{amount}\" et \"{pubkey}\".",
        "PARAM_PREFERRED_NODE": "Adresse du nœud préféré",
        "PARAM_PREFERRED_NODE_HELP": "Adresse (URL) du nœud Duniter à utiliser de préférence (\"g1.domaine.com:443\" ou \"https://g1.domaine.com\").",
        "EXAMPLES_HELP": "Voici des exemples d'intégration :",
        "EXAMPLE_BUTTON": "Bouton HTML",
        "EXAMPLE_BUTTON_DEFAULT_TEXT": "Payer en {{currency|currencySymbol}}",
        "EXAMPLE_BUTTON_DEFAULT_STYLE": "Style personnalisé",
        "EXAMPLE_BUTTON_TEXT_HELP": "Texte du bouton",
        "EXAMPLE_BUTTON_BG_COLOR": "Couleur du fond",
        "EXAMPLE_BUTTON_BG_COLOR_HELP": "Exemple : #fbc14c, black, lightgrey, rgb(180,180,180)",
        "EXAMPLE_BUTTON_FONT_COLOR": "Couleur du texte",
        "EXAMPLE_BUTTON_FONT_COLOR_HELP": "Exemple : black, orange, rgb(180,180,180)",
        "EXAMPLE_BUTTON_TEXT_ICON": "Icône",
        "EXAMPLE_BUTTON_TEXT_WIDTH": "Largeur",
        "EXAMPLE_BUTTON_TEXT_WIDTH_HELP": "Exemple : 200px, 50%",
        "EXAMPLE_BUTTON_ICON_NONE": "Aucune",
        "EXAMPLE_BUTTON_ICON_DUNITER": "Logo Duniter",
        "EXAMPLE_BUTTON_ICON_CESIUM": "Logo Cesium",
        "EXAMPLE_BUTTON_ICON_G1_COLOR": "Logo Ğ1",
        "EXAMPLE_BUTTON_ICON_G1_BLACK": "Logo Ğ1 (noir)"
      }
    }
  }
}
);

$translateProvider.translations("it-IT", {
   "COMMON": {
     "APP_NAME": "Cesium",
     "APP_VERSION": "v{{version}}",
     "APP_BUILD": "build {{build}}",
     "PUBKEY": "Chiave privata",
     "MEMBER": "Membro",
     "BLOCK" : "Blocco",
     "BTN_OK": "OK",
     "BTN_YES": "Si",
     "BTN_NO": "No",
     "BTN_SEND": "Inviare",
     "BTN_SEND_MONEY": "Trasferire soldi",
     "BTN_SEND_MONEY_SHORT": "Trasferire",
     "BTN_SAVE": "Salvare",
     "BTN_YES_SAVE": "Si, salvare",
     "BTN_YES_CONTINUE": "Si, continuare",
     "BTN_SHOW": "Mostrare",
     "BTN_SHOW_PUBKEY": "Mostrare chiave pubblica",
     "BTN_RELATIVE_UNIT": "Mostra importi in DU?",
     "BTN_BACK": "Indietro",
     "BTN_NEXT": "Avanti",
     "BTN_IMPORT": "Importazione",
     "BTN_CANCEL": "Cancellare",
     "BTN_CLOSE": "Chiudere",
     "BTN_LATER": "Più tardi",
     "BTN_LOGIN": "Accedi",
     "BTN_LOGOUT": "Log out",
     "BTN_ADD_ACCOUNT": "Nuovo conto",
     "BTN_SHARE": "Condividere",
     "BTN_EDIT": "Modificare",
     "BTN_DELETE": "Eliminare",
     "BTN_ADD": "Aggiungere",
     "BTN_SEARCH": "Cercare",
     "BTN_REFRESH": "Aggiornare",
     "BTN_RETRY": "Riprovare",
     "BTN_START": "Iniziare",
     "BTN_CONTINUE": "Continuare",
     "BTN_CREATE": "Creare",
     "BTN_UNDERSTOOD": "Ho capito",
     "BTN_OPTIONS": "Opzioni",
     "BTN_HELP_TOUR": "Mostrami le funzionalità",
     "BTN_HELP_TOUR_SCREEN": "Scoprire questo schermo",
     "BTN_DOWNLOAD": "Scaricare",
     "BTN_DOWNLOAD_ACCOUNT_STATEMENT": "Scaricare estratto conto",
     "BTN_MODIFY": "Modificare",
     "CHOOSE_FILE": "Trascini un file <br/>o cliccare per selezionare",
     "DAYS": "giorni",
     "NO_ACCOUNT_QUESTION": "Non sei ancora membro? Registrati subito!",
     "SEARCH_NO_RESULT": "Nessun risultato trovato",
     "LOADING": "Caricando...",
     "LOADING_WAIT": "Caricando...<br/><small>(Cesium interroga dal nodo peer Duniter)</small>",
     "SEARCHING": "Cercando...",
     "FROM": "Da",
     "TO": "A",
     "COPY": "Copiare",
     "LANGUAGE": "Lingua",
     "UNIVERSAL_DIVIDEND": "Dividendo universale",
     "UD": "UD",
     "DATE_PATTERN": "DD/MM/YYYY HH:mm",
     "DATE_FILE_PATTERN": "YYYY-MM-DD",
     "DATE_SHORT_PATTERN": "DD/MM/YY",
     "DATE_MONTH_YEAR_PATTERN": "MM/YYYY",
     "EMPTY_PARENTHESIS": "(empty)",
     "UID": "Pseudonimo",
     "ENABLE": "Attivato",
     "DISABLE": "Disattivato",
     "RESULTS_LIST": "Risultati:",
     "RESULTS_COUNT": "{{count}} risultati",
     "EXECUTION_TIME": "eeseguit in {{duration|formatDurationMs}}",
     "SHOW_VALUES": "Mostrare valori in modo trasparente?",
     "POPOVER_ACTIONS_TITLE": "Opzioni",
     "POPOVER_FILTER_TITLE": "Filtri",
     "SHOW_MORE": "Mostrare di più",
     "SHOW_MORE_COUNT": "(limite attuale di {{limit}})",
     "POPOVER_SHARE": {
       "TITLE": "Condividere",
       "SHARE_ON_TWITTER": "Condividere su Twitter",
       "SHARE_ON_FACEBOOK": "Condividere su Facebook",
       "SHARE_ON_DIASPORA": "Condividere su Diaspora*",
       "SHARE_ON_GOOGLEPLUS":"Condividere su Google+"
     },
     "FILE": {
       "DATE" : "Data:",
       "TYPE" : "Tipo:",
       "SIZE": "Dimensioni del file:",
       "VALIDATING": "Validazione in corso..."
     }
   },
   "SYSTEM": {
     "PICTURE_CHOOSE_TYPE": "Scegliere un file:",
     "BTN_PICTURE_GALLERY": "Galleria",
     "BTN_PICTURE_CAMERA": "<b>Camera</b>"
   },
   "MENU": {
     "HOME": "Home",
     "WOT": "Annuario",
     "CURRENCY": "Moneta",
     "ACCOUNT": "Mio conto",
     "WALLETS": "I miei portafogli",
     "SETTINGS": "Impostazioni",
     "NETWORK": "Rete",
     "TRANSACTIONS": "Miei pagamenti"
   },
   "ABOUT": {
     "TITLE": "A proposito",
     "LICENSE": "<b>Free/libre software</b> (License GNU AGPLv3).",
     "CODE": "Codice sorgente:",
     "OFFICIAL_WEB_SITE": "Sito ufficiale:",
     "DEVELOPERS": "Sviluppatori:",
     "FORUM": "Forum:",
     "PLEASE_REPORT_ISSUE": "Non esitate a parlarci delle anomalie riscontrate",
     "REPORT_ISSUE": "Segnalare un bug"
   },
   "HOME": {
     "TITLE": "Cesium",
     "WELCOME": "Benvenuti nell'Cesium App!",
     "WELCOME_READONLY": "Benvenuti nell'Cesium <span class='badge badge-balanced'>Monit</span>!",
     "MESSAGE": "Scambiate in moneta libera {{currency|abbreviate}}",
     "MESSAGE_READONLY": "Monitoraggio in tempo reale di moneta libera {{currency|abbreviate}}",
     "BTN_CURRENCY": "Esplorare la moneta {{currency|abbreviate}}",
     "BTN_ABOUT": "a proposito",
     "BTN_HELP": "Aiuto",
     "BTN_NETWORK": "Stato della rete",
     "FREE_SOFTWARE": "Free software",
     "FORK_ME": "Fork me!",
     "SHOW_LICENSE": "Mostra licenza",
     "REPORT_ISSUE": "Segnalare un bug",
     "NOT_YOUR_ACCOUNT_QUESTION" : "Non sei proprietario del conto <b><i class=\"ion-key\"></i> {{pubkey|formatPubkey}}</b>?",
     "BTN_CHANGE_ACCOUNT": "Disconettere questo conto",
     "CONNECTION_ERROR": "Peer <b>{{server}}</b> irraggiungibile o indirizzo invalido. <br/><br/> Verifica tua connessione or cambia nodo. <a class=\"positive\" ng-click=\"doQuickFix('settings')\">nell impostazioni. </a>.",
     "SHOW_ALL_FEED": "Mostra tutto",
     "READ_MORE": "Leggi di più",
     "FEED_SOURCE": "Fonte"
   },
   "SETTINGS": {
     "TITLE": "Impostazioni",
     "DISPLAY_DIVIDER": "Schermo",
     "STORAGE_DIVIDER": "Conservazione",
     "NETWORK_SETTINGS": "Rete",
     "PEER": "Indirizzo peer Duniter",
     "PEER_SHORT": "Indirizzo peer",
     "PEER_CHANGED_TEMPORARY": "Indirizzo usato per un tempo determinato",
     "PERSIST_CACHE": "Conserva i dati di navigazione (sperimentale)",
     "USE_LOCAL_STORAGE": "Abilitare local storage",
     "USE_LOCAL_STORAGE_HELP": "Permette di salvare tue impostazioni",
     "ENABLE_HELPTIP": "Abilitare consigli dinamici",
     "ENABLE_UI_EFFECTS": "Abilitare effetti visivi",
     "HISTORY_SETTINGS": "Mio conto",
     "DISPLAY_UD_HISTORY": "Mostrare dividendi prodotti?",
     "AUTHENTICATION_SETTINGS": "Autenticazione",
     "KEEP_AUTH": "Scadenza dell'autenticazione",
     "KEEP_AUTH_SHORT": "Scadenza",
     "KEEP_AUTH_HELP": "Definire quando l'autenticazione verrà eliminata dalla memoria.",
     "KEEP_AUTH_OPTION": {
       "NEVER": "Dopo ogni operazione",
       "SECONDS": "Dopo {{value}}s d'inattività",
       "MINUTE": "Dopo{{value}}min d'inattività",
       "MINUTES": "Dopo {{value}}min d'inattività",
       "HOUR": "Dopo {{value}}h d'inattività",
       "ALWAYS": "Alla fine della sessione"
     },
     "REMEMBER_ME": "Ricordarsi di me?",
     "REMEMBER_ME_HELP": "Rimanere identificato/a da una sessione all'altra, conservando la chiave localmente.",
     "PLUGINS_SETTINGS": "Estensioni",
     "BTN_RESET": "Ripristini valori predefiniti",
     "EXPERT_MODE": "Abilitare modlità eseperto",
     "EXPERT_MODE_HELP": "Permette di vedere più dettagli",
     "POPUP_PEER": {
       "TITLE" : "Peer Duniter",
       "HOST" : "Indirizzo",
       "HOST_HELP": "Indirizzo: server:port",
       "USE_SSL" : "Securizzato?",
       "USE_SSL_HELP" : "(SSL Encryption)",
       "BTN_SHOW_LIST" : "Lista dei peers"
     }
   },
   "BLOCKCHAIN": {
     "HASH": "Hash: {{hash}}",
     "VIEW": {
       "HEADER_TITLE": "Blocco #{{number}}-{{hash|formatHash}}",
       "TITLE_CURRENT": "Blocco attuale",
       "TITLE": "Blocco #{{number|formatInteger}}",
       "COMPUTED_BY": "Calcolato da",
       "SHOW_RAW": "Mostrare dati grezzi",
       "TECHNICAL_DIVIDER": "Informazioni tecniche",
       "VERSION": "Versione di formatto",
       "HASH": "Hash calcolato",
       "UNIVERSAL_DIVIDEND_HELP": "Moneta co-prodotta da ciasciun dei {{membersCount}} membri",
       "EMPTY": "Nessun dati in questo blocco",
       "POW_MIN": "Difficoltà minimale",
       "POW_MIN_HELP": "Difficoltà imposta nel calcolo del hash",
       "DATA_DIVIDER": "Dati",
       "IDENTITIES_COUNT": "Nuove identità",
       "JOINERS_COUNT": "Nuovi membri",
       "ACTIVES_COUNT": "Rinnovi",
       "ACTIVES_COUNT_HELP": "Membri che hanno rinnovato la loro presenza nella rete",
       "LEAVERS_COUNT": "",
       "LEAVERS_COUNT_HELP": "Membri che si sono fatti escludere dalla rete",
       "EXCLUDED_COUNT": "Membri esclusi",
       "EXCLUDED_COUNT_HELP": "Vecchi membri, esclusi per certificazione non rinnovata o soglia di certificazioni non raggiunta.",
       "REVOKED_COUNT": "Identità revocate",
       "REVOKED_COUNT_HELP": "Può essere che questi conti non siano più attivi",
       "TX_COUNT": "Transazioni",
       "CERT_COUNT": "Certificazioni",
       "TX_TO_HIMSELF": "Cambio",
       "TX_OUTPUT_UNLOCK_CONDITIONS": "Sbloccare condizioni",
       "TX_OUTPUT_OPERATOR": {
         "AND": "e",
         "OR": "o"
       },
       "TX_OUTPUT_FUNCTION": {
         "SIG": "<b>Firma</b> della chive pubblica",
         "XHX": "<b>Password</b>, incluso SHA256 =",
         "CSV": "Bloccato per",
         "CLTV": "Bloccato fino a"
       }
     },
     "LOOKUP": {
       "TITLE": "Blocchi",
       "NO_BLOCK": "Nessun blocco",
       "LAST_BLOCKS": "Ultimi blocchi:",
       "BTN_COMPACT": "Compact"
     }
   },
   "CURRENCY": {
     "VIEW": {
       "TITLE": "Moneta",
       "TAB_CURRENCY": "Moneta",
       "TAB_WOT": "Web of trust",
       "TAB_NETWORK": "Rete",
       "TAB_BLOCKS": "Blocchi",
       "CURRENCY_SHORT_DESCRIPTION": "{{currency|capitalize}} è <b>una moneta libera</b>, {{firstBlockTime | formatFromNow}}. La rete comprende <b>{{N}} membri </b>, che produccono e ricevono un <a ng-click=\"showHelpModal('ud')\">Dividendo Universale</a> (DU), ogni {{dt | formatPeriod}}.",
       "NETWORK_RULES_DIVIDER": "Regole della rete",
       "CURRENCY_NAME": "Nome della moneta",
       "MEMBERS": "Numero di membri",
       "MEMBERS_VARIATION": "Variazione da {{duration|formatDuration}} (dall' ultimo UD)",
       "MONEY_DIVIDER": "Moneta",
       "MASS": "Massa monetaria",
       "SHARE": "Quantità a testa",
       "UD": "Dividendo universale",
       "C_ACTUAL": "Crescita attuale",
       "MEDIAN_TIME": "Current blockchain time",
       "POW_MIN": "Difficoltà commune",
       "MONEY_RULES_DIVIDER": "Regole della moneta",
       "C_RULE": "Obbietivo teorico di crescità",
       "UD_RULE": "Dividendo universale (formula)",
       "DT_REEVAL": "Periodo tra due re-evaluazioni del UD",
       "REEVAL_SYMBOL": "reeval",
       "DT_REEVAL_VALUE": "Ogni <b>{{dtReeval|formatDuration}}</b> ({{dtReeval/86400}} {{'COMMON.DAYS'|translate}})",
       "UD_REEVAL_TIME0": "Data della prima re-evaluzione del UD",
       "SIG_QTY_RULE": "Numero di certificazioni requisiti per diventare membro",
       "SIG_STOCK": "Numero massimo di certificazioni inviate da un membro",
       "SIG_PERIOD": "Tempo minimo tra 2 certificazioni inviate da un unico membro.",
       "SIG_WINDOW": "Periodo massimo prima che una certificazione venga studiata",
       "SIG_VALIDITY": "Durata di vita di una certificazione che è state presa in conto",
       "MS_WINDOW": "Periodo massimo prima che una certificazione pendente sia validata",
       "MS_VALIDITY": "Durata di vita di un'adesione che è state presa in conto",
       "STEP_MAX": "Distanza massima tra un nuovo membro e ogni membro referente.",
       "WOT_RULES_DIVIDER": "Regole della Web of Trust",
       "SENTRIES": "Numero di certificazioni (date <b>e</b> ricevute) per diventare membro referente ",
       "SENTRIES_FORMULA": "Numero di certificazioni necessarie per diventare membro (formula)",
       "XPERCENT":"Percentaggio minimino di membri referenti per rispettare la regola di distanza tra i membri",
       "AVG_GEN_TIME": "Tempo medio tra due blocchi",
       "CURRENT": "attuale",
       "MATH_CEILING": "CEILING",
       "DISPLAY_ALL_RULES": "Mostrare tutte le regole?",
       "BTN_SHOW_LICENSE": "Mostrare licenza",
       "WOT_DIVIDER": "Web of trust"
     },
     "LICENSE": {
       "TITLE": "Licensa attuale",
       "BTN_DOWNLOAD": "Scaricare il file",
       "NO_LICENSE_FILE": "File di licenza non trovato ."
     }
   },
   "NETWORK": {
     "VIEW": {
       "MEDIAN_TIME": "Blockchain time",
       "LOADING_PEERS": "Caricando peers...",
       "NODE_ADDRESS": "Indirizzo del peer",
       "SOFTWARE": "Software",
       "WARN_PRE_RELEASE": "Pre-versione (ultima versione stabile: <b>{{version}}</b>)",
       "WARN_NEW_RELEASE": "Versione <b>{{version}}</b> disponibile",
       "WS2PID": "Identificativo :",
       "PRIVATE_ACCESS": "Accesso privato",
       "POW_PREFIX": "Prefisso Prova di Lavoro :",
       "ENDPOINTS": {
         "BMAS": "Endpoint sicuro (SSL)",
         "BMATOR": "Interfaccia rete TOR",
         "WS2P": "Interfaccia WS2P",
         "ES_USER_API": "Cesium+ data node"
       }
     },
     "INFO": {
       "ONLY_SSL_PEERS": "I nodi non-SSL hanno un display semplificato perche Cesium funziona in modalità HTTPS."
     }
   },
   "PEER": {
     "PEERS": "Peers-Nodi",
     "SIGNED_ON_BLOCK": "Firmato nel blocco",
     "MIRROR": "Specchio",
     "MIRRORS": "Specchio",
     "MIRROR_PEERS": "Peers specchio",
     "PEER_LIST" : "Lista dei peers",
     "MEMBERS" : "Membri",
     "MEMBER_PEERS" : "Peers membri",
     "ALL_PEERS" : "Tutti i peers",
     "DIFFICULTY" : "Difficoltà",
     "API" : "API",
     "CURRENT_BLOCK" : "Blocco #",
     "POPOVER_FILTER_TITLE": "Filtro",
     "OFFLINE": "Sconessi",
     "OFFLINE_PEERS": "Peers sconessi",
     "BTN_SHOW_PEER": "Mostrare peer",
     "VIEW": {
       "TITLE": "Peer",
       "OWNER": "Proprietà di ",
       "SHOW_RAW_PEERING": "Vedere il documento di peering",
      "SHOW_RAW_CURRENT_BLOCK": "Vedere l'utimo blocco (formatto grezzo)",
       "LAST_BLOCKS": "Ultimi blocchi",
       "KNOWN_PEERS": "Peers conosciuti :",
       "GENERAL_DIVIDER": "Informazioni generali",
       "ERROR": {
         "LOADING_TOR_NODE_ERROR": "Impossibile ottenere i dati del peer, periodo di attesa scaduto.",
         "LOADING_NODE_ERROR": "Impossibile ottenere i dati del peer"
       }
     }
   },
   "WOT": {
     "SEARCH_HELP": "Cercare (membro o chiave pubblica)",
     "SEARCH_INIT_PHASE_WARNING": "La ricerca per le certificazioni pendenti <b>può essere lunga</b> durante la fase di pre-certificazione. La preghiamo di attendere...",
     "REGISTERED_SINCE": "Certificato/a dal",
     "REGISTERED_SINCE_BLOCK": "Certificato/a dal blocco #",
     "NO_CERTIFICATION": "Nessuna certificazione valida",
     "NO_GIVEN_CERTIFICATION": "Nessuna certificazione data",
     "NOT_MEMBER_PARENTHESIS": "(non-membro)",
     "IDENTITY_REVOKED_PARENTHESIS": "(identità revocata)",
     "MEMBER_PENDING_REVOCATION_PARENTHESIS": "(Cancellazione dell'identità pendente)",
     "EXPIRE_IN": "Scade",
     "NOT_WRITTEN_EXPIRE_IN": "Scadenza <br/> ",
     "EXPIRED": "Scaduto",
     "PSEUDO": "Pseudonimo",
     "SIGNED_ON_BLOCK": "Emessa nel blocco #{{block}}",
     "WRITTEN_ON_BLOCK": "Scritta nel blocco #{{block}}",
     "GENERAL_DIVIDER": "Informazioni generali",
     "NOT_MEMBER_ACCOUNT": "Conto non-membro",
     "NOT_MEMBER_ACCOUNT_HELP": "Questo è un semplice portafoglio osservatore, senza richiesta di certificazione emessa.",
     "TECHNICAL_DIVIDER": "Dati tecnici",
     "BTN_CERTIFY": "Certificare",
     "BTN_YES_CERTIFY": "Si, certificare",
     "BTN_SELECT_AND_CERTIFY": "Nuova certificazione",
     "ACCOUNT_OPERATIONS": "Operazioni sul conto",
     "VIEW": {
       "POPOVER_SHARE_TITLE": "Identità {{title}}"
     },
     "LOOKUP": {
       "TITLE": "Annuario",
       "NEWCOMERS": "Nuovi membri:",
       "NEWCOMERS_COUNT": "{{count}} membri",
       "PENDING": "Registrazioni pendenti",
       "PENDING_COUNT": "{{count}} inscrizioni pendenti",
       "REGISTERED": "Registrato {{sigDate | formatFromNow}}",
       "MEMBER_FROM": "Membro dal {{memberDate|medianFromNowShort}}",
       "BTN_NEWCOMERS": "Ultimi membri",
       "BTN_PENDING": "Registrazioni pendenti",
       "SHOW_MORE": "Vedere di più",
       "SHOW_MORE_COUNT": "(limite attuale di {{limit}})",
       "NO_PENDING": "Nessuna certificazione pendente.",
       "NO_NEWCOMERS": "Nessun membro."
     },
     "CONTACTS": {
      "TITLE": "Contatti"
    },
     "MODAL": {
       "TITLE": "Ricerca"
     },
     "CERTIFICATIONS": {
       "TITLE": "{{uid}} - Certificazioni",
       "SUMMARY": "Certificazioni ricevute",
       "LIST": "Dettagli delle certificazioni ricevute",
       "PENDING_LIST": "Certificazioni pendenti",
       "RECEIVED": "Certificazioni ricevute",
       "RECEIVED_BY": "Certifications ricevute da {{uid}}",
       "ERROR": "Certificazioni ricevute per errore",
       "SENTRY_MEMBER": "Membro referente"
     },
     "OPERATIONS": {
       "TITLE": "{{uid}} - Operazioni"
     },
     "GIVEN_CERTIFICATIONS": {
       "TITLE": "{{uid}} - Certificazioni inviate",
       "SUMMARY": "Certificazioni inviate",
       "LIST": "Dettagli delle certificazioni inviate",
       "PENDING_LIST": "Certificazioni ",
       "SENT": "Certificazioni inviate",
       "SENT_BY": "Certificazioni inviate da {{uid}}",
       "ERROR": "Certificazioni inviate per errore"
     }
   },
   "LOGIN": {
     "TITLE": "<i class=\"icon ion-log-in\"></i> Accedi",
     "SCRYPT_FORM_HELP": "Accedi con tuoi dati <br> Ricordati di verificare che stai utilizzando la chiave del tuo conto.",
     "PUBKEY_FORM_HELP": "Scrivi qui la tua chiave privata:",
     "FILE_FORM_HELP": "Scegliere un portachiavi da utilizzare:",
     "SCAN_FORM_HELP": "Scansiona il codice QR di un portafoglio.",
     "SALT": "Identificativo segreto",
     "SALT_HELP": "Identificativo segreto",
     "SHOW_SALT": "Mostrare identificativo segreto?",
     "PASSWORD": "Passsord",
     "PASSWORD_HELP": "Password",
     "PUBKEY_HELP": "Chiave pubblica, pseudonimo",
     "NO_ACCOUNT_QUESTION": "Ancora non hai un conto?",
     "HAVE_ACCOUNT_QUESTION": "Hai già un account?",
     "CREATE_ACCOUNT": "Creare un conto",
     "CREATE_FREE_ACCOUNT": "Crea un conto gratuito",
     "FORGOTTEN_ID": "Non ricordi la password?",
     "ASSOCIATED_PUBKEY": "Chiave pubblica:",
     "BTN_METHODS": "Altri metodi",
     "BTN_METHODS_DOTS": "Cambiare metodo...",
     "METHOD_POPOVER_TITLE": "Metodi",
     "MEMORIZE_AUTH_FILE": "Memorizzare questo portachiavi per la durata di questa sessione",
     "SCRYPT_PARAMETERS": "Parametri (Scrypt) :",
     "AUTO_LOGOUT": {
       "TITLE": "Informazioni",
       "MESSAGE": "<i class=\"ion-android-time\"></i> Sei stato <b>sconesso/ b> automaticamente, per un periodo di inattività prolongata",
       "BTN_RELOGIN": "Accedi",
       "IDLE_WARNING": "Sarai disconesso in... {{countdown}}"
     },
     "METHOD": {
       "SCRYPT_DEFAULT": "Salatura standard (imp. predefinita)",
       "SCRYPT_ADVANCED": "Salatura avanzata",
       "FILE": "File del portachiavi",
       "PUBKEY": "Chiave pubblica soltanto",
       "SCAN": "Scansiona un codice QR"
     },
     "SCRYPT": {
       "SIMPLE": "Salatura leggera",
       "DEFAULT": "Salatura standard",
       "SECURE": "Salatura sicura",
       "HARDEST": "Salatura più sicura",
       "EXTREME": "Salatura estrema",
       "USER": "Salatura personalizzata",
       "N": "N (Loop):",
       "r": "r (RAM):",
       "p": "p (CPU):"
     },
     "FILE": {
       "HELP": "Format del file atteso: <b>.dunikey</b> (type PubSec). Altri formati in sviluppo (EWIF, WIF)."
     }
   },
   "AUTH": {
     "TITLE": "<i class=\"icon ion-locked\"></i> Autenticazione",
     "BTN_AUTH": "Autenticarsi",
     "GENERAL_HELP": "Autenticati :",
     "EXPECTED_UID_HELP": "Effettua il login nell'account <i class=\"ion-person\"></i> {{uid}}:",
     "EXPECTED_PUBKEY_HELP": "Si prega di autenticarsi sul portafoglio <i class=\"ion-key\"></i> {{pubkey|formatPubkey}}:",
     "SCAN_FORM_HELP": "Scansiona il codice QR della <b>chiave privata</b> del portafoglio."
   },
   "ACCOUNT": {
     "TITLE": "Mio conto",
     "BALANCE": "Saldo",
     "LAST_TX": "Ultime transazioni",
     "BALANCE_ACCOUNT": "Saldo del conto",
     "NO_TX": "Nessuna transazione",
     "SHOW_MORE_TX": "Mostrare di più",
     "SHOW_ALL_TX": "Mostrare tutte",
     "TX_FROM_DATE": "(limite attuale del {{fromTime|medianFromNowShort}})",
     "PENDING_TX": "Transazioni pendenti",
     "VALIDATING_TX": "Transazioni in corso di convalida",
     "ERROR_TX": "Transaction non eseguite",
     "ERROR_TX_SENT": "Transazioni inviate",
     "PENDING_TX_RECEIVED": "Transazioni in attesa di recezione",
     "EVENTS": "Eventi",
     "WAITING_MEMBERSHIP": "Richiesta di certificazione inviata. In attesa di validazione.",
     "WAITING_CERTIFICATIONS": "Hai bisogno di {{needCertificationCount}} certificazione(i) per diventare membro.",
     "WILL_MISSING_CERTIFICATIONS": "Mancherai a breve <b>di certificazioni</b> (occorrono almeno {{willNeedCertificationCount}} altre certificazioni)",
     "WILL_NEED_RENEW_MEMBERSHIP": "Tua certificazione <b>scaderà{{membershipExpiresIn|formatDurationTo}}</b>. Ricordati di <a ng-click=\"doQuickFix('renew')\">rinnovarla</a> prima.",
     "NEED_RENEW_MEMBERSHIP": "You are no longer a member because your membership <b>has expired</b>. Remember to <a ng-click=\"doQuickFix('renew')\">renew your membership</a>.",
     "NO_WAITING_MEMBERSHIP": "Nessuna domanda di adesione pendente. Se desideri <b>diventare membro</b>, ricordati di <a ng-click=\"doQuickFix('membership')\">inviare tua domanda di adesione</a>.",
     "CERTIFICATION_COUNT": "Certificazioni ricevute",
     "CERTIFICATION_COUNT_SHORT": "Certificazioni",
     "SIG_STOCK": "Stock di certificazioni da inviare",
     "BTN_RECEIVE_MONEY": "Ricevere",
     "BTN_SELECT_ALTERNATIVES_IDENTITIES": "Usare un'altra identità..",
     "BTN_FIX_MEMBERSHIP": "Invia nuovamente di adesione...",
     "BTN_MEMBERSHIP_RENEW": "Rinnovare adesione",
     "BTN_MEMBERSHIP_RENEW_DOTS": "Rinnovare adesione ...",
     "BTN_MEMBERSHIP_OUT_DOTS": "Revocare adesione...",
     "BTN_SECURITY_DOTS": "Login e securità...",
     "BTN_SHOW_DETAILS": "Visualizzare dati tecnici",
     "LOCKED_OUTPUTS_POPOVER": {
       "TITLE": "Importo bloccata",
       "DESCRIPTION": "Ecco le condizioni per sbloccare questo importo:",
       "DESCRIPTION_MANY": "Questa transazione è fatta da diverse parti, di cui queste sono le condizioni di sblocco:",
       "LOCKED_AMOUNT": "Condizioni per l'importo:"
     },
     "NEW": {
       "TITLE": "Registrazione",
       "INTRO_WARNING_TIME": "Crearsi un conto su {{name|capitalize}} è molto semplice. E consigliato prendere il giusto tempo per farlo correttamente (per evitare di dimenticare passwords, pseudonimi etc.).",
       "INTRO_WARNING_SECURITY": "Occorre verificare che il hardware che stai utilizzando (computer, tablet, cellulare) <b>è sicuro e affidabile</b>.",
       "INTRO_WARNING_SECURITY_HELP": "Anti-virus aggiornato, firewall abilitato, session protteta da un password o codice PIN...",
       "INTRO_HELP": "Cliccare <b> {{'COMMON.BTN_START'|translate}}</b> per avviare la creazione del conto. Ti accompagniamo passo alla volta.",
       "REGISTRATION_NODE": "Tua iscrizione verrà salvata dal nodo peer Duniter <b>{{server}}</b>, è verrà poi condivisa nella rete della moneta.",
       "REGISTRATION_NODE_HELP": "Se non ti fidi di questo peer, per favore cambialo <a ng-click=\"doQuickFix('settings')\">nelle impostazioni/a> di Cesium.",
       "SELECT_ACCOUNT_TYPE": "Scegliere un tipo di conto:",
       "MEMBER_ACCOUNT": "Conto membro",
       "MEMBER_ACCOUNT_TITLE": "Creare un conto membro",
       "MEMBER_ACCOUNT_HELP": "Se non sei ancora registrato come individuo (un conto a persona soltanto).",
       "WALLET_ACCOUNT": "Semplice portafoglio",
       "WALLET_ACCOUNT_TITLE": "Creare un portafoglio",
       "WALLET_ACCOUNT_HELP": "Se rappresenti un'azienda, associazione, altra ente o hai necessita di un altro portafoglio. Nessun Dividendo Universale sarà prodotto da questo conto.",
       "SALT_WARNING": "Scegliere un identificativo segreto.<br/>E necessario per ogni connessione a questo conto.<br/><br/><b>Accertati di ricordarlo!</b>.<br/>Se lo dimentichi non ti potrà aiutare nessuno!",
       "PASSWORD_WARNING": "Scegliere una password.<br/>E necessario per ogni connessione a questo conto.<br/><br/><b>Accertati di ricordarla!</b>.<br/>Se la dimentichi non ti potrà aiutare nessuno!",
       "PSEUDO_WARNING": "Segliere uno pseudonimo.<br/>Puo essere utile per chi ti cerca nella rete.<br/><br/>.L'utilizzo delle<b>virgole, spazi e accenti</b> è vietato.<br/><div class='hidden-xs'><br/>Esempio: <span class='gray'>JohnDalton, JackieChan, etc.</span>",
       "PSEUDO": "Pseudonimo",
       "PSEUDO_HELP": "joe123",
       "SALT_CONFIRM": "Confermare",
       "SALT_CONFIRM_HELP": "Confermare l'identificativo segreto",
       "PASSWORD_CONFIRM": "Confermare",
       "PASSWORD_CONFIRM_HELP": "Confermare la password",
       "SLIDE_6_TITLE": "Conferma:",
       "COMPUTING_PUBKEY": "Calcolando...",
       "LAST_SLIDE_CONGRATULATION": "Hai riempito tutti i campi richiesti.<br/><b>Puoi inviare la richiesta di creazione del conto</b>.<br/><br/>Per tua informazione, la chiave pubblica qui sotto identifica il tuo futuro conto.<br/>Puo essere communicata a chi ti deve pagare per esempio.<br/>Quando tuo conto verrà approvato potrai trovare la chiave qui <b>{{'ACCOUNT.TITLE'|translate}}</b>.",
       "CONFIRMATION_MEMBER_ACCOUNT": "<b class=\"assertive\">Warning:</b> tuo identificare segreto, tua password e tuo pseudonimo non si possono cambiare.<br/><b>Ricordali per sempre!</b><br/><b>Sei sicuro/a</b>di voler inviare questa richiesta di creazione di conto?",
       "CONFIRMATION_WALLET_ACCOUNT": "<b class=\"assertive\">Warning:</b> tuo identificare segreto, tua password e tuo pseudonimo non si possono cambiare..<br/><b>Ricordali per sempre!</b><br/><b>Sei sicuro/a</b> di voler continuare?",
       "CHECKING_PSEUDO": "Verificazione in corso...",
       "PSEUDO_AVAILABLE": "Pseudonimo disponibile",
       "PSEUDO_NOT_AVAILABLE": "Pseudonimo indisponibile",
       "INFO_LICENSE": "TPer aderire alla moneta, ti chiediamo di leggere e accetare le condizioni della licenza.",
       "BTN_ACCEPT": "Accetto",
       "BTN_ACCEPT_LICENSE": "Accetto la licenza"
     },
     "POPUP_REGISTER": {
       "TITLE": "Pseudonimo",
       "HELP": "Un pseudonimo è necessario per che gli altri ti possino trovare."
     },
     "SELECT_IDENTITY_MODAL": {
      "TITLE": "Selezionare una identità",
      "HELP": "Più <b>identità diverse</b> sono state inviate per la chiave pubblica <span class=\"gray\"><i class=\"ion-key\"></i> {{pubkey|formatPubkey}}</span>.<br/>Seleziona un dossier da usare :"
    },
     "SELECT_WALLET_MODAL": {
       "TITLE": "Selezione del portafoglio"
     },
     "WALLET_LIST": {
       "TITLE": "Portafoglio secondario",
       "BTN_NEW": "Aggiungi un portfolio",
       "NO_WALLET": "Nessun portafoglio secondario",
       "BTN_DELETE": "Rimuovi un portafoglio secondario ...",
       "BTN_RENAME": "Rinominare il portafoglio",
       "EDIT_POPOVER": {
         "TITLE": "Rinominare il portafoglio",
         "HELP": "Compila il nuovo nome",
         "NAME_HELP": "Nome del portafoglio"
       }
     },
     "SECURITY":{
       "ADD_QUESTION" : "Aggiungere domanda personalizzata",
       "BTN_CLEAN" : "Svuotare",
       "BTN_RESET" : "Reset",
       "DOWNLOAD_REVOKE": "Salvare un file di revoca",
       "DOWNLOAD_REVOKE_HELP" : "Avere une file di revoca è necessario in caso di smarrimento dei tuoi credenziali. Ti permette <b> di rimuovere tuo conto dalla Web Of Trust</b>, per farlo tornare ad essere un semplice portafoglio.",
       "HELP_LEVEL": "Scegliere <strong> almeno{{nb}} domande </strong> :",
       "LEVEL": "Livello di sicurezza",
       "LOW_LEVEL": "Basso <span class=\"hidden-xs\">(minimo di 2 domande)</span>",
       "MEDIUM_LEVEL": "Medio <span class=\"hidden-xs\">(minimo di 4 domande)</span>",
       "QUESTION_1": "Qual'era il nome del tuo miglior amico quando eri adolescente ?",
       "QUESTION_2": "Qual'era il nome del tuo primo animale domestico?",
       "QUESTION_3": "Qual'è il primo piatto che imparasti a cucinare?",
       "QUESTION_4": "Qual'è il primo film che hai visto al cinema?",
       "QUESTION_5": "Qual'era la destinazione del tuo primo volo?",
       "QUESTION_6": "Qual'era il nome del tuo professore preferito in scuola ?",
       "QUESTION_7": "Quale sarebbe il tuo lavoro preferito?",
       "QUESTION_8": "Qual'è il tuo libro per bimbi preferito?",
       "QUESTION_9": "Qual'era il marchio della tua prima macchina?",
       "QUESTION_10": "Qual'era il tuo nomignolo da ragazzino/a ?",
       "QUESTION_11": "Qual'era il tuo personaggio di film o attore preferito quand eri studente?",
       "QUESTION_12": "Qual'era il tuo musicista/cantante/grupo preferito quand eri studente ?",
       "QUESTION_13": "In che città si sono conosciuti tuoi genitori ?",
       "QUESTION_14": "Qual'era il nome del tuo primo capo ?",
       "QUESTION_15": "Qual'è il nome della strada dove sei cresciuto/a ?",
       "QUESTION_16": "Qual'è il nome della tua spiaggia preferita ?",
       "QUESTION_17": "Qual'è il primo album che ti sei comprato ?",
       "QUESTION_18": "Qual'è il nome della squadra di sport preferita ?",
       "QUESTION_19": "Cosa faceva tuo nonno ?",
       "RECOVER_ID": "Ricuperare mia password...",
       "RECOVER_ID_HELP": "Se hai un<b<file di backup dei tuoi credenziali</b>, li puoi trovare rispondendo correttamente alle tue domande personalizzate.",
       "REVOCATION_WITH_FILE" : "Revocare il mio conto membro...",
      "REVOCATION_WITH_FILE_DESCRIPTION": "Se pensi di aver perso <b>definitivamente tuoi credenziali</b> di conto membro (o che la sicurezza del tuo conto è compromessa), puoi usare <b>il file di revoca</b> del conto <b>per forzare la sua uscita permanente dalla Tela di Fiducia</b>.",
       "REVOCATION_WITH_FILE_HELP": "Se hai <b>definitivamente perso tuoi credenziali (o se la sicurezza del tuo conto è compromessa), puoi usare <b>il file di revoca</b> del conto <b>per uscire dalla Web Of Trust</b>.",
       "REVOCATION_WALLET": "Revocare questo conto subito",
       "REVOCATION_WALLET_HELP": "Richiedere la cancellazione dell'identità <b>revocherà la tua adesione alla tua rete</ b> (con certezza per il pseudonimo e la chiave pubblica associata). Il conto non potrà più produrre il Dividendo Universale.<br/>Nonostante ciò, puoi ancora usare il conto come semplice portafoglio.",
       "REVOCATION_FILENAME": "revocation-{{uid}}-{{pubkey|formatPubkey}}-{{currency}}.txt",
       "SAVE_ID": "Salvare miei credenziali...",
       "SAVE_ID_HELP": "Creare un file di backup, per <b>ricuperare vostra password</b> (e l'identificativo segreto) <b> in caso di smarrimento</b>. Il file è <b>sicuro</ b> (cryptato) utilizzando le domande personalizzate.",
       "STRONG_LEVEL": "Alto <span class=\"hidden-xs \">(minimo di 6 domande)</span>",
       "TITLE": "Conto e sicurezza"
     },
     "FILE_NAME": "{{currency}} - Account statement {{pubkey|formatPubkey}} to {{currentTime|formatDateForFile}}.csv",
     "HEADERS": {
       "TIME": "Date",
       "AMOUNT": "Amount",
       "COMMENT": "Comment"
     }
   },
   "TRANSFER": {
     "TITLE": "Bonifico",
     "SUB_TITLE": "Fare un bonifico",
     "FROM": "Da",
     "TO": "A",
     "AMOUNT": "Importo",
     "AMOUNT_HELP": "Importo",
     "COMMENT": "Commenti",
     "COMMENT_HELP": "Commenti",
     "BTN_SEND": "Inviare",
     "BTN_ADD_COMMENT": "Scrivere un comento ?",
     "WARN_COMMENT_IS_PUBLIC": "Ti avvertiamo <b>che i commenti sono pubblici</b> (non cifrati).",
     "MODAL": {
       "TITLE": "Bonifico"
     }
   },
   "ERROR": {
     "UNKNOWN_URI_FORMAT": "Formato URI sconosciuto",
     "POPUP_TITLE": "Errore",
     "UNKNOWN_ERROR": "Errore",
     "CRYPTO_UNKNOWN_ERROR": "Suo navigatore non sembra compatibile con le funzionalità di cryptografia.",
     "EQUALS_TO_PSEUDO": "Deve essere diverso dal pseudonimo",
     "EQUALS_TO_SALT": "Deve essere diverso dal identificativo segreto",
     "FIELD_REQUIRED": "Campo obbligatorio.",
     "FIELD_TOO_SHORT": "Valore troppo corto.",
     "FIELD_TOO_SHORT_WITH_LENGTH": "Valore troppo corto ({{minLength}} caratteri min)",
     "FIELD_TOO_LONG": "Valore troppo lungo",
     "FIELD_TOO_LONG_WITH_LENGTH": "Valore troppo lungo ({{maxLength}} caractteri max)",
     "FIELD_MIN": "Valore minimo : {{min}}",
     "FIELD_MAX": "Valore massimo : {{max}}",
     "FIELD_ACCENT": "Virgole e caratteri accentati vietati",
     "FIELD_NOT_NUMBER": "Valore numerico atteso",
     "FIELD_NOT_INT": "Valore intero atteso",
     "FIELD_NOT_EMAIL": "Indirizzo mail non valido",
     "PASSWORD_NOT_CONFIRMED": "Non corrisponde alla password.",
     "SALT_NOT_CONFIRMED": "Non corrisponde al identificativo segreto.",
     "SEND_IDENTITY_FAILED": "Iscrizione fallita.",
     "SEND_CERTIFICATION_FAILED": "Certificazione fallita.",
     "NEED_MEMBER_ACCOUNT_TO_CERTIFY": "Non puoi inviare certificazioni perche tuo conto <b>non è ancora un conto membro</b>.",
     "NEED_MEMBER_ACCOUNT_TO_CERTIFY_HAS_SELF": "Non puoi inviare certificazioni adesso perche <b>non sei ancora membro</b>.<br/><br/>Devi ancora entrare nella WOT.",
     "IDENTITY_TO_CERTIFY_HAS_NO_SELF": "Impossibile certificare questo conto. Nessuna richiesta di certificazione trovata o bisogna rinnovarla.",
     "LOGIN_FAILED": "Errore di login.",
     "LOAD_IDENTITY_FAILED": "Impossibile caricare la tua identità.",
     "LOAD_REQUIREMENTS_FAILED": "Impossibile caricare i prerequisiti dell'identità.",
     "SEND_MEMBERSHIP_IN_FAILED": "Ingresso nella WOT fallito.",
     "SEND_MEMBERSHIP_OUT_FAILED": "Errore nel invio della revocazione.",
     "REFRESH_WALLET_DATA": "Impossibile aggiornare il portafoglio.",
     "GET_CURRENCY_PARAMETER": "Impossibile ricuperare i parametri della moneta.",
     "GET_CURRENCY_FAILED": "Impossibile caricare la moneta. Riprovare più tardi.",
     "SEND_TX_FAILED": "Impossibile eseguire la transazione.",
     "ALL_SOURCES_USED": "Per favore aspetta il calcolo del prossimo blocco (Tutte le tue fonti di moneta sono state utilizzate).",
     "NOT_ENOUGH_SOURCES": "Non hai abbastanza cambio per inviare questo importo in una sola transazione.<br/>Importo massimo: {{amount}} {{unit}}<sub>{{subUnit}}</sub>.",
     "ACCOUNT_CREATION_FAILED": "Errore nella creazione del tuo conto membro.",
     "RESTORE_WALLET_DATA_ERROR": "Errore nel aggiornamento delle impostazioni definite in local storage.",
     "LOAD_WALLET_DATA_ERROR": "Errore nel caricamento dei dati del portafoglio.",
     "COPY_CLIPBOARD_FAILED": "Impossibile copiare al clipboard",
     "TAKE_PICTURE_FAILED": "Impossibile ricuperare foto.",
     "SCAN_FAILED": "Impossibile scansionare il codice QR.",
     "SCAN_UNKNOWN_FORMAT": "Codice non riconosciuto.",
     "WOT_LOOKUP_FAILED": "Ricerca fallita.",
     "LOAD_PEER_DATA_FAILED": "Peer Duniter non accessibile. Riprovare più tardi.",
     "NEED_LOGIN_FIRST": "Accedi al tuo conto prima.",
     "AMOUNT_REQUIRED": "Importo necessario.",
     "AMOUNT_NEGATIVE": "Importo negativo non consentito.",
     "NOT_ENOUGH_CREDIT": "Saldo insufficiente",
     "INVALID_NODE_SUMMARY": "Impossibile comunicare col peer o indirizzo non valido",
     "INVALID_USER_ID": "Il campo del 'pseudonimo' non deve avere spazi vuoti o caratteri speciali.",
     "INVALID_COMMENT": "Il formato del campo 'reference' è errato.",
     "INVALID_PUBKEY": "If formato della chiave pubblica è errato.",
     "INVALID_PUBKEY_CHECKSUM": "Checkum non valido.",
     "IDENTITY_REVOKED": "Questa identità <b>è stata revocata</b>. Non puo più diventare membro.",
     "IDENTITY_REVOKED_WITH_TIME": "Questa identità <b>è stata revocata {{revocationTime|medianFromNow}}</b> ({{revocationTime|medianDate}}). Non puo più diventare membro.",
     "IDENTITY_PENDING_REVOCATION": "L'<b>annulamento di questa identità</b> è stata richiesta ed è in corso di evaluazione. Capacità ad inviare certificazioni disabilitata",
     "IDENTITY_INVALID_BLOCK_HASH": "Questa richiesta di certificazione non è più valida (perche si riferisce ad un blocco che è stato eliminato dai peers): la persona deve rinnovare la sua domanda di certificazione <b>prima</b> di essere certificata.",
     "IDENTITY_EXPIRED": "Questa identità è scaduta: la persona deve fare una nuova domanda di certificazione <b>prima di</b> essere certificata.",
     "IDENTITY_SANDBOX_FULL": "Il nodo Duniter utilizzato da Cesium non puo ricevere altre domande di certificazione per ora, la lista d'attesa è piena.<br/><br/>Riprova più tardi o scegli un'altro peer Duniter (nelle <b>Impostazioni</b>).",
     "IDENTITY_NOT_FOUND": "Identità non trovata",
     "IDENTITY_TX_FAILED": "Impossibile caricare le operazioni",
     "WOT_PENDING_INVALID_BLOCK_HASH": "Adesione non valida.",
     "WALLET_INVALID_BLOCK_HASH": "Tua domanda di certificazione non è più valida (perche si riferisce ad un blocco che è stato eliminato dai peers).<br/>Devi <a ng-click=\"doQuickFix('renew')\">rinnvoare la tua richiesta di adesione alla WOT</a> per risolvere il problema.",
     "WALLET_IDENTITY_EXPIRED": "La pubblicazione della tua identità <b>è scaduta</b>.<br/>Devi <a ng-click=\"doQuickFix('fixIdentity')\">ripubblicare la tua identità</a> per risolvere il problema.",
     "WALLET_REVOKED": "La tua identità è stata <b>revocata</b>: ne tuo pseudonimo ne tua chiave pubblica sarano utilizzati in futuro.",
     "WALLET_HAS_NO_SELF": "La tua identità deve prima essere stata pubblicata e non essere ancora scaduta.",
     "AUTH_REQUIRED": "Autenticazione necessaria.",
     "AUTH_INVALID_PUBKEY": "La chiave pubblica non corrisponde al conto conesso.",
     "AUTH_INVALID_SCRYPT": "Password o nome di utente non valido.",
     "AUTH_INVALID_FILE": "File di portachiavi non valido.",
     "AUTH_FILE_ERROR": "Impossibile aprire il file di portachiavi",
     "IDENTITY_ALREADY_CERTIFY": "Hai <b>già certificato</b> questa identità.<br/><br/>Tuo certificato è ancora valido (scade {{expiresIn|formatDuration}}).",
     "IDENTITY_ALREADY_CERTIFY_PENDING": "Hai <b>già certificato</b> questa identità.<br/><br/>Tua certificazione è ancora pendente (Scadenza del periodo di  treatment {{expiresIn|formatDuration}}).",
     "UNABLE_TO_CERTIFY_TITLE": "Impossibile certificare",
     "LOAD_NEWCOMERS_FAILED": "Impossibile caricare i nuovi membri.",
     "LOAD_PENDING_FAILED": "Impossibile caricare le certificazioni pendenti.",
     "ONLY_MEMBER_CAN_EXECUTE_THIS_ACTION": "Devi <b>essere membro</b> per poter fare questo.",
     "ONLY_MEMBER_OR_WAS_MEMBER_CAN_EXECUTE_THIS_ACTION": "Devi <b>essere membro</b> (o era un membro) per poter fare questo.",
     "ONLY_SELF_CAN_EXECUTE_THIS_ACTION": "Devi aver <b>publiccato tua identità</b> per poter fare questo.",
     "GET_BLOCK_FAILED": "Impossibile caricare il blocco",
     "INVALID_BLOCK_HASH": "Blocco non trovato (hash errato)",
     "DOWNLOAD_REVOCATION_FAILED": "Errore avvenuto nel download del file di cancellazione d'identità.",
     "REVOCATION_FAILED": "Errore avvenuto durante la richiesta di cancellazione dell'identità.",
     "SALT_OR_PASSWORD_NOT_CONFIRMED": "identificativo segreto o password sbagliati",
     "RECOVER_ID_FAILED": "Impossibile ricuperare la password",
     "LOAD_FILE_FAILED" : "Impossibile caricare il file",
     "NOT_VALID_REVOCATION_FILE": "File di cancellazione dell'identità errato (formato di file incorreto)",
     "NOT_VALID_SAVE_ID_FILE": "File di backup dei credenziali errato (formato di file incorreto)",
     "NOT_VALID_KEY_FILE": "File di portachiavi non valido (formato non riconosciuto)",
     "EXISTING_ACCOUNT": "Tuoi credenziali corrispondono a quelli di un conto già esistente,di cui <a ng-click=\"showHelpModal('pubkey')\">la chiave pubblica</a> è:",
     "EXISTING_ACCOUNT_REQUEST": "Per favore cambi tuoi credenziali in modo che corrispondino ad un conto non utilizzato.",
     "GET_LICENSE_FILE_FAILED": "Impossibile caricare il file della licenza",
     "CHECK_NETWORK_CONNECTION": "Nessun peer sembra disponibile.<br/><br/>Per favore <b>verifica la tua connessione Internet</b>.",
     "ISSUE_524_TX_FAILED": "Bonifico .<br/><br/>Un message a été envoyé aux développeurs pour faciliter la résolution du problème. <b>Merci de votre aide</b>."
    },
   "INFO": {
     "POPUP_TITLE": "Informazioni",
     "CERTIFICATION_DONE": "Identità firmata con successo",
     "NOT_ENOUGH_CREDIT": "Saldo insufficiente",
     "TRANSFER_SENT": "Transazione inviata con successo",
     "COPY_TO_CLIPBOARD_DONE": "Copiato con successo",
     "MEMBERSHIP_OUT_SENT": "Revoca dell'identità inviata",
     "NOT_NEED_MEMBERSHIP": "Già un membro.",
     "IDENTITY_WILL_MISSING_CERTIFICATIONS": "Questa identità mancherà a breve di certificazioni (almeno {{willNeedCertificationCount}}).",
     "REVOCATION_SENT": "Revoca dell'identità inviata",
     "REVOCATION_SENT_WAITING_PROCESS": "Cancellazione dell'identità <b>inviata con successo</b>. In attesa di validazione.",
     "FEATURES_NOT_IMPLEMENTED": "Questa funzionalità non è ancora disponibile.<br/><br/>Vuoi contribuire per velocizzarne la disponibilità? ;)",
     "EMPTY_TX_HISTORY": "Nessuna operazione da esportare"
   },
   "CONFIRM": {
     "POPUP_TITLE": "<b>Conferma</b>",
     "POPUP_WARNING_TITLE": "<b>Avviso</b>",
     "POPUP_SECURITY_WARNING_TITLE": "<i class=\"icon ion-alert-circled\"></i> <b>Avvertimento di sicurezza</b>",
     "CERTIFY_RULES_TITLE_UID": "Certificare {{uid}}",
     "CERTIFY_RULES": "<b class=\"assertive\">Non certificare un conto</b> se credi che: <ul><li>1.) l'identità della persona potrebbe essere finta.<li>2.) la oersona ha già un conto certicato.<li>3.) la persona trasgredisce la regola 1 o 2 o entrambe. (Certifica conti finti o gemelli).</ul></small><br/>Sei sicuro/a di voler certificare questa identità?",
     "TRANSFER": "<b>Resoconto del bonifico:</b><br/><br/><ul><li> - Inviato da: <b>{{from}}</b></li><li> - A: <b>{{to}}</b></li><li> - Importo: <b>{{amount}} {{unit}}</b></li><li> - Comento: <i>{{comment}}</i></li></ul><br/><b>Sei sicuro di voler procedere con questo bonifico?</b>",
     "MEMBERSHIP_OUT": "Questa operazione è <b>irreversibile</b>.<br/></br/><b>Sei sicuro/a di voler cancellare la tua presenza nella WOT?</b>",
     "MEMBERSHIP_OUT_2": "Questa operazione è <b>irreversibile</b>!<br/><br/>Sei sicuro/a <b>di voler revocare la tua identità</b>?",
     "LOGIN_UNUSED_WALLET_TITLE": "Errore di battitura?",
     "LOGIN_UNUSED_WALLET": "Il conto sembra <b>inattivo</b>.<br/><br/>Probabilmente è un<b>errore di battitura</b> mientre digitavi i tuoi credenziali. Per favore riprova, verificando che la <b>chiave pubblica sia tua<b/>.",
     "FIX_IDENTITY": "Lo pseudonimo <b>{{uid}}</b> verrà pubblicato nuovamente. Si sostituirà alla precedente pubblicazione che è scaduta.<br/></br/><b>Sei sicuro/a</b> di voler procedere?",
     "FIX_MEMBERSHIP": "Tua domanda di certificazione sarà inviata alla rete.<br/></br/><b>Sei sicuro/a?</b>",
     "MEMBERSHIP": "Tua domanda per diventare membro sta per essere inviata alla rete.<br/></br/><b>Sei sicuro/a/b> di voler continuare ?",
     "RENEW_MEMBERSHIP": "Tua adesione verrà rinnovata.<br/></br/><b>Sei sicuro/a?</b>",
     "REVOKE_IDENTITY": "Stai per <b>revocare definitivamente questa identità</b>.<br/><br/>La chiave pubblica e lo pseudonimo associato <b>non saranno mai più utilizzati</b> (per un conto membro).<br/></br/><b>Sei sicuro/a</b> di voler revocare questa identità?",
     "REVOKE_IDENTITY_2": "Questa operazione è <b>irreversibile</b>!<br/><br/>Sei sicuro/a di volern<b>revocare questa identità</b>?",
     "NOT_NEED_RENEW_MEMBERSHIP": "Tua presenza nella rete non deve ancora essere rinnovata (scaderà tra {{membershipExpiresIn|formatDuration}}).<br/></br/><b>Sei sicuro/a</b> di voler rinnovare la tua presenza?",
     "SAVE_BEFORE_LEAVE": "Vuoi <b>salvare tue modifiche</b> prima di uscira dalla pagina?",
     "SAVE_BEFORE_LEAVE_TITLE": "Modifiche non salvate",
     "LOGOUT": "Sei sicuro/a di voler chiudere la sessione?",
     "USE_FALLBACK_NODE": "Peer <b>{{old}}</b> indisponibile o indirizzo errato.<br/><br/>Vuoi utilizzare temporanemante il <b>{{new}}</b> nodo?",
     "INVALID_FILE_FORMAT": "Formato file non valido.",
     "SAME_TX_RECIPIENT": "Il destinatario deve essere diverso dall'emittente."
  },
  "MODE": {
    "DEMO": {
      "BADGE": "Demo",
      "MODE": "Modalità dimostrativa",
      "FEATURE_NOT_AVAILABLE": "Funzionalità <b>non disponibile</b> su questo sito dimostrativo.",
      "MODE_HELP": "Il cesio funziona in <b>modalità dimostrativa</b>: è disponibile la consultazione per conto, ma non è possibile eseguire alcuna operazione per conto.",
      "INSTALL_HELP": "Per <b>motivi di sicurezza</b> ti consigliamo di <b>installare</b> la tua copia del software.<br/>Visita il sito <a href='https://cesium.app'>www.cesium.app</a> per assistenza."
    },
    "READONLY": {
      "BADGE": "Monit",
      "MODE": "Modalità di monitoraggio",
      "MODE_HELP": "Il cesio funziona in <b>modalità monitoraggio</b>: sono disponibili solo le funzionalità di monitoraggio della valuta.",
      "INSTALL_HELP": "Se desidera <b>creare un account di portafoglio</b> per inviare o ricevere valuta, ti consigliamo di <b>installare</b> la tua copia del software.<br/>Visita il sito <a href='https://cesium.app'>www.cesium.app</a> per assistenza."
    }
  },
   "DOWNLOAD": {
     "POPUP_TITLE": "<b>File di cancellazione dell'identità/b>",
     "POPUP_REVOKE_MESSAGE": "Per migliorare la sicurezza del tuo conto, scarica <b>il documento di revoca del conto</b>. Ti consentirà di revocare tuo conto (nel caso di violazione del conto, della tua identità, conto creato con errori, etc.).<br/><br/><b>Tiene questo document al sicuro.</b>"
   },
   "HELP": {
     "TITLE": "Aiuto online",
     "JOIN": {
       "SECTION": "Entrare nella rete",
       "SALT": "Il tuo identificativo segreto è molto importante. E utilizzato per cryptare tua password che permette poi di calcolare tua <span class=\"text-italic\">chiave pubblica</span> (suo numero) è la chiave privata che ne consenta l'accesso.<br/><b>Ricordati bene di questo identificativo</b>, perche non ti potrà aiutare nessuno se lo perdi.<br/>Tra l'altro, non puo essere cambiato senza dover creare un conto nuovo.<br/><br/>Raccomandiamo che sia abbastanza lungo (8 caratteri almeno) è il più originale possibile. (buona entropia)",
       "PASSWORD": "La password è molto importante, è utilizzata per calcolare tuo numero di conto (tua chiave pubblica) e la chiave privata che ne consento l'accesso.<br/><b>Ricordatila bene</b>, perche non ti potrà aiutare nessuno se lo perdi.<br/>Tra l'altro, non puo essere cambiata senza dover creare un conto nuovo.<br/><br/>Una buona password (preferibilmente) è composta da almeno 8 caratteri, con almeno una maiuscola e un numero.",
       "PSEUDO": "Un pseudonimo è utilizzato quando ti iscrivi come <span class=\"text-italic\">membro</span>. E sempre associato ad un portafoglio (con sua <span class=\"text-italic\">chiave pubblica</span>).<br/>E pubblicato sulla rete perche gli altri membri possino identificarla, certificarla o invarle soldi. <br/> Lo pseudonimo deve essere unico nella rete (tra quelli utilizzati adesso e in passato)."
     },
     "LOGIN": {
       "SECTION": "Accedi",
       "PUBKEY": "Chiave pubblica del conto",
       "PUBKEY_DEF": "La chiave pubblica del portachiavi è generata dai credenziali, ma non corrispode ad un conto già utilizzato.<br/><b>Accertati che tua chiave pubblica corrisponda al tuo conto</b>. Nel caso contrario, sarai conesso/a ad un conto probabilmente mai usato, datto che il rischio di collisione con un conto esistente è molto ridotto.<br/><a href=\"https://en.wikipedia.org/wiki/Elliptic_curve_cryptography\" target=\"_ system\">Saperne di più sulla cryptografia </a> con chiave pubblica.",
       "METHOD": "Metodi di connessione",
       "METHOD_DEF": "Hai diverse opzioni per accedere ad un portafoglio:<br/> - Accedendo con <b>salatura (leggera o sicura)</b> tua password sarà cryptata dal tuo identificativo segreto per scoraggiare tentativi di attachi di 'brute force' (per esempio con passwords conosciute).<br/> - Accedendo con la <b>chiave pubblica</b> ti evita di dover digitare tuoi credenziali che ti saranno chiesti solo quando vorrai fare una operazione col conto.<br/> - Accedendo <b>con un portachiavi</b> che leggerà tue chiave pubbliche e private da un file esterno, senza che tu li debba entrare."
     },
     "GLOSSARY": {
       "SECTION": "Glossario",
       "PUBKEY_DEF": "Una chiave pubblica permette di identificare un portafoglio. Puo anche identificare un membro. In Cesium  è calcolata con la password e lo pseudonimo.",
       "MEMBER": "Membro",
       "MEMBER_DEF": "Un membro è una persona reale e viva, che desidera participare liberamente alla communità monetaria. Questo membro riceverà un Dividendo Universale, a secondo delle regole definite <span class=\"text-italic\">nei parametri della moneta</span>.",
       "CURRENCY_RULES": "Regole della moneta",
       "CURRENCY_RULES_DEF": "I parametri delle moneta sono state definite per sempre e per tutti. I parametri con i quali la moneta si comporta: il calcolo del Dividendo Universale, il numero di certificazioni necessarie per diventare membro, il numero massimo di certificazioni che un membro puo inviare, etc.<br/><br/>I parametri non possono essere modificati perche c'è una<span class=\"text-italic\">Blockchain</span> che implementa e esegue queste regole e verifica costantemente la loro applicazione. <a href=\"#/app/currency\">Vedere i parametri </a>.",
       "BLOCKCHAIN": "Blockchain",
       "BLOCKCHAIN_DEF": "La Blockchain è un sistema decentralizzato che, nel caso di Duniter, permette di rispettare e implementare <span class=\"text-italic\">le regole della moneta</span>.<br/><a href=\"http://en.duniter.org/presentation/\" target=\"_blank\">Saperne di più su Duniter</a> e il funzionamento della blockchain.",
       "UNIVERSAL_DIVIDEND_DEF": "Il Dividendo Universale (UD) è la quantità di moneta co-creata da ogni membro, seguendo le formule mathematiche definite nelle <span class=\"text-italic\">regole della moneta</span>.<br/>Al inizio di ogni periodo, il conto di ogni membro riceve una quantità uguale della nuova moneta creata. <br/><br/>Il DU conosce una crescita costante per rimanere equo nei confronti dei membri (attuali e passati). Viene calcolato tenendo in conto la speranza di vità media, cosi come dimostrato nella Teoria Relativa della Moneta (TRM).<br/><a href=\"http://trm.creationmonetaire.info\" target=\"_system\">Saperne di più sulla TRM</a> e la moneta libera."
     },
     "TIP": {
       "MENU_BTN_CURRENCY": "Menu <b>{{'MENU.CURRENCY'|translate}}</b> permette la scoperta dei <b>parametri della moneta</b> e la sua condizione presente.",
       "CURRENCY_WOT": "Il <b>numero di membri</b> mostra <b>le dimensioni della WoT e la sua evoluzione </b>.",
       "CURRENCY_MASS": "In evidenza qui è <b>l'importo totale</b> attualmente in circolazione e la sua <b> ripartizione media </b> a testa.<br/><br/>Questa cifra permette di avere un'idea <b>del valore di qualsiasi importo</b>, in base a quello <b>hanno gli altri</b> sul loro conto (in media).",
       "CURRENCY_UNIT_RELATIVE": "L'unità usata qui (&ldquo;<b>{{'COMMON.UD'|translate}}<sub>{{currency|abbreviate}}</sub></b>&rdquo;) significa che gli importi in {{currency|capitalize}} sono stati divisi dal <b>Dividendo Universale</b> (DU).<br/><br/><small>Questa unità relativa <b>ha senso</b> perche è stabile in contrasto con la massa monetaria che cresce costantemente.</small>",
       "CURRENCY_CHANGE_UNIT": "Questa opzione <b>{{'COMMON.BTN_RELATIVE_UNIT'|translate}}</b> permette di <b>permutare unità</b> per vedere gli importi in <b>{{currency|capitalize}}</b>, non divisi dal Dividendo Universale (piuttosto che in &ldquo;<b>{{'COMMON.UD'|translate}}<sub>{{currency|abbreviate}}</sub></b>&rdquo;).",
       "CURRENCY_CHANGE_UNIT_TO_RELATIVE": "Questa opzione <b>{{'COMMON.BTN_RELATIVE_UNIT'|translate}}</b> permette <b>di permutare unità</b> per vedere gli importi in &ldquo;<b>{{'COMMON.UD'|translate}}<sub>{{currency|abbreviate}}</sub></b>&rdquo;, che è relativo al Dividendo Universale (l'importo co-prodotto da ogni membro).",
       "CURRENCY_RULES": "Le<b>regole</b> della moneta determinano il suo <b>esatto e previdibile</b> comportamento.<br/><br/> Considerate come il proprio DNA della moneta, queste regole rendono il codice monetario <b>trasparente e comprensibile</b>.",
       "MENU_BTN_NETWORK": "Menu <b>{{'MENU.NETWORK'|translate}}</b> permette la scopertà dello <b>stato della rete<b>.",
       "NETWORK_BLOCKCHAIN": "Tutte le transazioni monetarie sono registrate in <b>registro sicuro e a prova di manomissione</b>, spesso chiamato <b>blockchain</b>.",
       "NETWORK_PEERS": "I<b>peers</b> mostrati qui corrispondono a <b>dei computers che aggiornano e monitorano</b> la blockchain.<br/><br/>Più peers ci sono, più <b>decentralizzata</b> e più affidabile diventa la moneta.",
       "NETWORK_PEERS_BLOCK_NUMBER": "Questo <b>numero</b> (in verda) indica <b>l'ultimo blocco validato</b> dal peer (ultima pagina scritta nel regitro).<br/><br/>Il verda indica che il blocco è stato validato anche dalla <b>maggioranza degli altri peers</b>.",
       "NETWORK_PEERS_PARTICIPATE": "<b>Ogni membro</b>, che dispone di un computer connesso a Internet <b>puo partecipare, aggiungendosi come peer installando il software Duniter</b> (free/libre). <a target=\"_new\" href=\"{{installDocUrl}}\" target=\"_system\">Leggi il manuale d'installazione &gt;&gt;</a>.",
       "MENU_BTN_ACCOUNT": "<b>{{'ACCOUNT.TITLE'|translate}}</b> permette l'accesso al saldo del conto e la cronologia delle transazioni.",
       "MENU_BTN_ACCOUNT_MEMBER": "Qui puoi consultare lo stato del tuo conto, la cronologia delle transazioni e le tue certificazioni.",
       "WALLET_CERTIFICATIONS": "Clicca qui per vedere i dettagli delle tue certificazioni (date o ricevute).",
       "WALLET_RECEIVED_CERTIFICATIONS": "Clicca qui per vedere i dettagli delle <b>certificazioni che hai ricevuto</b>.",
       "WALLET_GIVEN_CERTIFICATIONS": "Clicca qui per vedere i dettagli delle <b>certificazioni che hai date</b>.",
       "WALLET_BALANCE": "Il <b>soldo</b> del tuo conto è visibile qui.",
       "WALLET_BALANCE_RELATIVE": "{{'HELP.TIP.WALLET_BALANCE'|translate}}<br/><br/>L'unità utilizzata (&ldquo;<b>{{'COMMON.UD'|translate}}<sub>{{currency|abbreviate}}</sub></b>&rdquo;) significa che questo importo in {{currency|capitalize}} è stato diviso dal <b>Dividendo Universale</b> (DU) co-creato da ogni membro.<br/>Ad oggi, 1 DU equivale a {{currentUD}} {{currency|capitalize}}.",
       "WALLET_BALANCE_CHANGE_UNIT": "Puoi <b>cambiare l'unità</b> in cui sono mostrati gli importi in <b><i class=\"icon ion-android-settings\"></i>&nbsp;{{'MENU.SETTINGS'|translate}}</b>.<br/><br/>Per esempio, per mostrare gli importi <b>direttamente in {{currency|capitalize}}</b> piuttosto che in unità relativa.",
       "WALLET_PUBKEY": "Questa è la chiave pubblica del tuo conto. La puoi dare ad un terzo perche possa identificare tuo conto.",
       "WALLET_SEND": "Paghi in pochi clics.",
       "WALLET_SEND_NO_MONEY": "Paghi in pochi clics.<br/>(Tuo saldo ancora non lo permette)",
       "WALLET_OPTIONS": "Questo bottone permette di fare <b>altre, meno frequenti azioni</b>.<br/><br/> Non dimenticarti di fare il tour guidato di Cesium quando hai un attimo!",
       "WALLET_RECEIVED_CERTS": "Questo mostra l'elenco delle persone che ti hanno fatto entrare nella WoT.",
       "WALLET_CERTIFY": "Questo bottone <b>{{'WOT.BTN_SELECT_AND_CERTIFY'|translate}}</b> permette di selezionare e certificare una identità.<br/><br/>Solo gli utenti <b>che sono già membri</b> possono certificare gli altri.",
       "WALLET_CERT_STOCK": "Tuo stock di certificazioni da dare è limitato a <b>{{sigStock}} certificazioni</b>.<br/><br/>Questo stock si rifornisce col tempo, man mano che le certificazioni inviate scadono.",
       "MENU_BTN_TX": "<b>{{'MENU.TRANSACTIONS'|translate}}</b> permette l'accesso alla cronologia delle transazioni, e permette di fare nuovi bonifici.",
       "MENU_BTN_WOT": "Il menu<b>{{'MENU.WOT'|translate}}</b> permette di cercare <b>utenti</b> della moneta (membri o non).",
       "WOT_SEARCH_TEXT_XS": "Per fare una ricerca nel annuario, digita <b>le prime lettere dello pseudonimo o della chiave pubblica di un utente</b>.<br/><br/>La ricerca inizierà automaticamente.",
       "WOT_SEARCH_TEXT": "Per cercare nel annuario, digita <b>le prime lettere dello pseudonimo o della chiave pubblica di un utente</b>.<br/><br/>Dopodichè calca <b>Enter</b> per avviare la ricerca.",
       "WOT_SEARCH_RESULT": "Visualizza la scheda dettagliata di un utente con un semplice click sulla linea.",
       "WOT_VIEW_CERTIFICATIONS": "La linea <b>{{'ACCOUNT.CERTIFICATION_COUNT'|translate}}</b> mostra quanti membri hanno certificato questa identità.<br/><br/>Queste certificazioni dimostrano che il conto appartiene ad <b>una persona viva</b> e che questa persona non ha <b>nessun altro conto membro</b>.",
       "WOT_VIEW_CERTIFICATIONS_COUNT": "Ci vogliono almeno <b>{{sigQty}} certificazioni</b> per diventare membro e co-produrre il <b>Dividendo Universale</b>.",
       "WOT_VIEW_CERTIFICATIONS_CLICK": "Clicca qui per aprire <b>una lista di tutte le certificazioni</b> ricevute e date da questa identità.",
       "WOT_VIEW_CERTIFY": "Il bottone <b>{{'WOT.BTN_CERTIFY'|translate}}</b> permette di aggiungere tua certificazione a questa identità.",
       "CERTIFY_RULES": "<b>Attenzione:</b> Certifichi <b> solo persone reali e vive</b> che non hanno nessun altro conto membro.<br/><br/>L'affidabilità della moneta dipende della vigilanza di ciascuno.",
       "MENU_BTN_SETTINGS": "Les <b>{{'MENU.SETTINGS'|translate}}</b> ti permettono di configurare Cesium.<br/><br/>Per esempio, puoi <b>cambiare l'unità</b> in cui visualizzi la moneta.",
       "HEADER_BAR_BTN_PROFILE": "Clicca qui per entrare nel <b>tuo profilo utente</b>",
       "SETTINGS_CHANGE_UNIT": "Puoi cambiare <b>l'unità</b> della moneta cliccando qui.<br/><br/>- Disabilita questa opzione per vedere gli importi in {{currency|capitalize}}.<br/>- Abilita l'opzione per importi relativi in {{'COMMON.UD'|translate}}<sub>{{currency|abbreviate}}</sub> (<b>divisi</b> dal attuale Dividendo Universale).",
       "END_LOGIN": "Il tour guidato <b>è finito</b>.<br/><br/>Benvenuto nel <b>economia libera</b>!",
       "END_NOT_LOGIN": "Il tour guidato <b>è finito</b>.<br/><br/>Se desideri entrare nella Web of Trust {{currency|capitalize}}, basta cliccare <b>{{'LOGIN.CREATE_ACCOUNT'|translate}}</b> qui sotto.",
       "END_READONLY": "Il tour guidato <b>è finito</b>.<br/><br/>{{'MODE.READONLY.INSTALL_HELP'|translate}}."
     }
   },
  "API" :{
    "COMMON": {
      "LINK_DOC": "documentazione API",
      "LINK_DOC_HELP": "Documentazione dello sviluppatore",
      "LINK_STANDARD_APP": "versione classica",
      "LINK_STANDARD_APP_HELP": "Apri la versione classica di {{'COMMON.APP_NAME'|translate}}"
    },
    "HOME": {
      "TITLE": "Documentazione API {{'COMMON.APP_NAME'|translate}}",
      "MESSAGE": "Bienvenue dans la <b>documentation de l'API</b> {{'COMMON.APP_NAME'|translate}}.<br/>Connecter vos sites web à <a href=\"http://duniter.org\" target=\"_system\">Duniter</a> très simplement !",
      "MESSAGE_SHORT": "Connecter vos sites à <a href=\"http://duniter.org\" target=\"_system\">Duniter</a> très simplement !",
      "DOC_HEADER": "Services disponibles :"
    },
    "TRANSFER": {
      "TITLE": "{{'COMMON.APP_NAME'|translate}} - Paiement en ligne",
      "TITLE_SHORT": "Pagamento online",
      "SUMMARY": "Récapitulatif de la commande :",
      "AMOUNT": "Montant :",
      "NAME": "Nom :",
      "PUBKEY": "Clé publique du destinaire :",
      "COMMENT": "Référence de la commande :",
      "DEMO": {
        "SALT": "demo",
        "PASSWORD": "demo",
        "PUBKEY": "3G28bL6deXQBYpPBpLFuECo46d3kfYMJwst7uhdVBnD1",
        "HELP": "<b>Mode démonstration</b> : Aucun paiement ne sera réellement envoyé pendant cette simulation.<br/>Veuillez utiliser les identifiants : <b>{{'API.TRANSFER.DEMO.SALT'|translate}} / {{'API.TRANSFER.DEMO.PASSWORD'|translate}}</b>",
        "BAD_CREDENTIALS": "Vérifiez votre saisie.<br/>En mode démonstration, les identifiants sont : {{'API.TRANSFER.DEMO.SALT'|translate}} / {{'API.TRANSFER.DEMO.PASSWORD'|translate}}"
      },
      "INFO": {
        "SUCCESS_REDIRECTING_WITH_NAME": "Paiement envoyé.<br/>Redirection vers <b>{{name}}</b>...",
        "SUCCESS_REDIRECTING": "Paiement envoyé.<br/>Redirection vers le site du vendeur...",
        "CANCEL_REDIRECTING_WITH_NAME": "Paiement annulé.<br/>Redirection vers <b>{{name}}</b>...",
        "CANCEL_REDIRECTING": "Paiement annulé.<br/>Redirection vers le site du vendeur..."
      },
      "ERROR": {
        "TRANSFER_FAILED": "Mancato pagamento"
      }
    },
    "DOC": {
      "DESCRIPTION_DIVIDER": "Descrizione",
      "URL_DIVIDER": "Indirizzo chiamata",
      "PARAMETERS_DIVIDER": "Impostazioni",
      "AVAILABLE_PARAMETERS": "Ecco l'elenco dei parametri disponibili :",
      "DEMO_DIVIDER": "Provare",
      "DEMO_HELP": "Per provare questo servizio, clicca sul bottone qui a fianco. Il risultato apparirà qui sotto .",
      "DEMO_RESULT": "Risultato della chiamata :",
      "DEMO_SUCCEED": "<i class=\"icon ion-checkmark\"></i> Successo !",
      "DEMO_CANCELLED": "<i class=\"icon ion-close\"></i> Annulato dal utente",
      "INTEGRATE_DIVIDER": "Integrare",
      "INTEGRATE_CODE": "Codice :",
      "INTEGRATE_RESULT": "Previsualizzare il risultato :",
      "INTEGRATE_PARAMETERS": "Parametri",
      "TRANSFER": {
        "TITLE": "Pagamenti",
        "DESCRIPTION": "Da un sito (per es. : un sito e-commerce) si può delegare il pagamento in moneta libera a Cesium API. Per invocare l'API, basta innescare l'apertura di una pagina con questo indirizzo:",
        "PARAM_PUBKEY": "Chiave pubblica del destinatario",
        "PARAM_PUBKEY_HELP": "Chiave pubblica del destinatario (obliggatoria)",
        "PARAM_AMOUNT": "Importo",
        "PARAM_AMOUNT_HELP": "Importo della transazione (obligatorio)",
        "PARAM_COMMENT": "Riferimento (o commento)",
        "PARAM_COMMENT_HELP": "Riferimento o commento. Ti può aiutare per esempio a trovare tuo pagamento nella blockchain.",
        "PARAM_NAME": "Nome (de destinatario o del sito web)",
        "PARAM_NAME_HELP": "Nom del sito web o del destinatario chiamando l'API. Può essere un nome leggibile (\"Mio sito\"), oppure l'indirizzo http del sito (\"MioSito.com\").",
        "PARAM_REDIRECT_URL": "Indirizzo web di redirezione",
        "PARAM_REDIRECT_URL_HELP": "Indirizzo web (URL) di redirezione, chiamato dopo aver inviato il pagamento. Può includere le seguenti stringe, che saranno sostituite con i valori della transazione : \"{tx}\", \"{hash}\", \"{comment}\", \"{amount}\" e {pubkey}.",
        "PARAM_CANCEL_URL": "Indirizzo web della cancellazione",
        "PARAM_CANCEL_URL_HELP": "Indirizzo web (URL) in caso dell'annullamento del pagamento dall'utente. Può includere le seguenti stringe, che saranno sostituite dinamicamente : \"{comment}\", \"{amount}\" e {pubkey}.",
        "EXAMPLES_HELP": "Ecco esempi di integrazione :",
        "EXAMPLE_BUTTON": "Bottone HTML",
        "EXAMPLE_BUTTON_DEFAULT_TEXT": "Pagare in {{currency|currencySymbol}}",
        "EXAMPLE_BUTTON_DEFAULT_STYLE": "Stile personnalizzato",
        "EXAMPLE_BUTTON_TEXT_HELP": "Testo del bottone",
        "EXAMPLE_BUTTON_BG_COLOR": "Colore del fondo",
        "EXAMPLE_BUTTON_BG_COLOR_HELP": "Per esempio: #fbc14c, black, lightgrey, rgb(180,180,180)",
        "EXAMPLE_BUTTON_FONT_COLOR": "Colore del testo",
        "EXAMPLE_BUTTON_FONT_COLOR_HELP": "Esempio: black, orange, rgb(180,180,180)",
        "EXAMPLE_BUTTON_TEXT_ICON": "Icona",
        "EXAMPLE_BUTTON_TEXT_WIDTH": "Larghezza",
        "EXAMPLE_BUTTON_TEXT_WIDTH_HELP": "Esempio: 200px, 50%",
        "EXAMPLE_BUTTON_ICON_NONE": "Nessuna",
        "EXAMPLE_BUTTON_ICON_DUNITER": "Logo Duniter",
        "EXAMPLE_BUTTON_ICON_CESIUM": "Logo Cesium",
        "EXAMPLE_BUTTON_ICON_G1_COLOR": "Logo Ğ1",
        "EXAMPLE_BUTTON_ICON_G1_BLACK": "Logo Ğ1 (nero)"
      }
    }
  }
}
);

$translateProvider.translations("nl-NL", {
  "COMMON": {
    "APP_NAME": "Cesium",
    "APP_VERSION": "v{{version}}",
    "APP_BUILD": "build {{build}}",
    "PUBKEY": "Publieke sleutel",
    "MEMBER": "Lid",
    "BLOCK": "Blok",
    "BTN_OK": "OK",
    "BTN_YES": "Ja",
    "BTN_NO": "Nee",
    "BTN_SEND": "Verzenden",
    "BTN_SEND_MONEY": "Verstuur geld",
    "BTN_SEND_MONEY_SHORT": "Versturen",
    "BTN_SAVE": "Opslaan",
    "BTN_YES_SAVE": "Ja, opslaan",
    "BTN_YES_CONTINUE": "Ja, doorgaan",
    "BTN_SHOW": "Tonen",
    "BTN_SHOW_PUBKEY": "Toon sleutel",
    "BTN_RELATIVE_UNIT": "Gebruik relatieve eenheid",
    "BTN_BACK": "Terug",
    "BTN_NEXT": "Volgende",
    "BTN_CANCEL": "Annuleer",
    "BTN_CLOSE": "Sluit",
    "BTN_LATER": "Later",
    "BTN_LOGIN": "Aanmelden",
    "BTN_LOGOUT": "Uitloggen",
    "BTN_ADD_ACCOUNT": "Nieuwe Rekening",
    "BTN_SHARE": "Delen",
    "BTN_EDIT": "Bewerken",
    "BTN_DELETE": "Wissen",
    "BTN_ADD": "Toevoegen",
    "BTN_SEARCH": "Zoeken",
    "BTN_REFRESH": "Verwezenlijken",
    "BTN_START": "Beginnen",
    "BTN_CONTINUE": "Doorgaan",
    "BTN_UNDERSTOOD": "Ik heb het begrepen",
    "BTN_OPTIONS": "Opties",
    "BTN_HELP_TOUR": "Rondleiding",
    "BTN_HELP_TOUR_SCREEN": "Ontdek dit scherm",
    "BTN_DOWNLOAD": "Downloaden",
    "BTN_DOWNLOAD_ACCOUNT_STATEMENT": "Downloaden het rekeningoverzicht",
    "BTN_MODIFY": "Bewerken",
    "DAYS": "dagen",
    "NO_ACCOUNT_QUESTION": "Nog geen lid? Registreer nu!",
    "SEARCH_NO_RESULT": "Geen resultaten",
    "LOADING": "Even geduld...",
    "SEARCHING": "Zoeken...",
    "FROM": "Van",
    "TO": "Aan",
    "COPY": "Kopieren",
    "LANGUAGE": "Taal",
    "UNIVERSAL_DIVIDEND": "Universeel dividend",
    "UD": "UD",
    "DATE_PATTERN": "DD-MM-YYYY HH:mm",
    "DATE_FILE_PATTERN": "YYYY-MM-DD",
    "DATE_SHORT_PATTERN": "DD-MM-YY",
    "DATE_MONTH_YEAR_PATTERN": "MM-YYYY",
    "EMPTY_PARENTHESIS": "(leeg)",
    "UID": "Pseudoniem",
    "ENABLE": "Geactiveerd",
    "DISABLE": "Gedeactiveerd",
    "RESULTS_LIST": "Resultaten:",
    "RESULTS_COUNT": "{{count}} uitslagen",
    "EXECUTION_TIME": "uitgevoerd in {{duration|formatDurationMs}}",
    "SHOW_VALUES": "Toon waarden openlijk?",
    "POPOVER_ACTIONS_TITLE": "Opties",
    "POPOVER_FILTER_TITLE": "Filters",
    "SHOW_MORE": "Toon meer",
    "SHOW_MORE_COUNT": "(huidig limiet op {{limit}})",
    "POPOVER_SHARE": {
      "TITLE": "Delen",
      "SHARE_ON_TWITTER": "Deel op Twitter",
      "SHARE_ON_FACEBOOK": "Deel op Facebook",
      "SHARE_ON_DIASPORA": "Deel op Diaspora*",
      "SHARE_ON_GOOGLEPLUS": "Deel op Google+"
    }
  },
  "SYSTEM": {
    "PICTURE_CHOOSE_TYPE": "Selecteer bron:",
    "BTN_PICTURE_GALLERY": "Gallerij",
    "BTN_PICTURE_CAMERA": "<b>Camera</b>"
  },
  "MENU": {
    "HOME": "Welkom",
    "WOT": "Register",
    "CURRENCY": "Valuta",
    "CURRENCIES": "Valuta's",
    "ACCOUNT": "Mijn rekening",
    "SETTINGS": "Instellingen",
    "NETWORK": "Netwerk",
    "TRANSACTIONS": "Mijn transacties"
  },
  "ABOUT": {
    "TITLE": "Over",
    "LICENSE": "<b>Vrije</b> software (GNU AGPLv3 licentie).",
    "CODE": "Broncode:",
    "DEVELOPERS": "Ontwikkelaars:",
    "FORUM": "Forum:",
    "DEV_WARNING": "Waarschuwing",
    "DEV_WARNING_MESSAGE": "Deze applicatie is nog in actieve onwikkeling.<br/>Meld ons elk pobleem!",
    "DEV_WARNING_MESSAGE_SHORT": "Deze App is nog instabiel (in ontwikkeling).",
    "REPORT_ISSUE": "Meld een probleem"
  },
  "HOME": {
    "TITLE": "Cesium",
    "WELCOME": "Welkom bij de Cesium Applicatie!",
    "MESSAGE": "Bekijk je {{currency|abbreviate}} portefeilles in real time.",
    "BTN_REGISTRY": "Register",
    "BTN_CURRENCY": "Verken valuta",
    "BTN_ABOUT": "over",
    "BTN_HELP": "Help",
    "REPORT_ISSUE": "Meld een probleem",
    "NOT_YOUR_ACCOUNT_QUESTION" : "Is rekening <b><i class=\"ion-key\"></i> {{pubkey|formatPubkey}}</b> niet van jou?",
    "BTN_CHANGE_ACCOUNT": "Dze rekening ontkoppelen",
    "CONNECTION_ERROR": "Node <b>{{server}}</b> onbereikbaar of ongeldig adres.<br/><br/>Controleer de internetverbinding, of schakel knooppunt <a class=\"positive\" ng-click=\"doQuickFix('settings')\">in parameters</a>."
  },
  "SETTINGS": {
    "TITLE": "Instellingen",
    "NETWORK_SETTINGS": "Netwerk",
    "PEER": "Duniter knooppunt adres",
    "PEER_CHANGED_TEMPORARY": "Adres tijdelijk worden gebruikt",
    "USE_LOCAL_STORAGE": "Lokale opslag inschakelen",
    "USE_LOCAL_STORAGE_HELP": "Laat je instellingen opslaan",
    "ENABLE_HELPTIP": "Contextgebonden hulp inschakelen",
    "ENABLE_UI_EFFECTS": "Schakel visuele effecten",
    "HISTORY_SETTINGS": "Mijn rekening",
    "DISPLAY_UD_HISTORY": "Toon geproduceerde dividenden?",
    "AUTHENTICATION_SETTINGS": "Authentificatie",
    "REMEMBER_ME": "Onthoud mij",
    "REMEMBER_ME_HELP": "Hiermee kunt u blijven altijd aangesloten (niet aanbevolen).",
    "PLUGINS_SETTINGS": "Uitbreidingen",
    "BTN_RESET": "Herstel standaardinstellingen",
    "EXPERT_MODE": "Geavanceerde modus inschakelen",
    "EXPERT_MODE_HELP": "Toon meer details",
    "POPUP_PEER": {
      "TITLE" : "Duniter Knooppunt",
      "HOST" : "Adres",
      "HOST_HELP": "Aadres: server:poort",
      "USE_SSL" : "Secure?",
      "USE_SSL_HELP" : "(SSL-encryptie)",
      "BTN_SHOW_LIST" : "Lijst van knooppunten"
    }
  },
  "BLOCKCHAIN": {
    "HASH": "Hachee : {{hash}}",
    "VIEW": {
      "HEADER_TITLE": "Blok #{{number}}-{{hash|formatHash}}",
      "TITLE_CURRENT": "Huidige blok",
      "TITLE": "Blok #{{number|formatInteger}}",
      "COMPUTED_BY": "Berekend door het knooppunt",
      "SHOW_RAW": "Bekijk RAW-bestand",
      "TECHNICAL_DIVIDER": "Technische informatie",
      "VERSION": "Format versie",
      "HASH": "Hash berekend",
      "UNIVERSAL_DIVIDEND_HELP": "Munt gecoproduceerd door elk van de {{membersCount}} ledental",
      "EMPTY": "Er zijn geen gegevens in dit blok",
      "POW_MIN": "Mminimum moeilijkheid",
      "POW_MIN_HELP": "Moeilijkheid opgelegd hash te berekenen",
      "DATA_DIVIDER": "Gegevens",
      "IDENTITIES_COUNT": "Nieuwe identiteiten",
      "JOINERS_COUNT": "Nieuwe leden",
      "ACTIVES_COUNT": "Verlengingen",
      "ACTIVES_COUNT_HELP": "Leden die hun lidmaatschap te vernieuwen",
      "LEAVERS_COUNT": "Verlaters",
      "LEAVERS_COUNT_HELP": "Leden die niet langer wenst certificering",
      "EXCLUDED_COUNT": "Uitgesloten leden",
      "EXCLUDED_COUNT_HELP": "Oud-leden uitgesloten door niet-verlenging of gebrek aan certificeringen",
      "REVOKED_COUNT": "Identiteiten ingetrokken",
      "REVOKED_COUNT_HELP": "Deze rekeningen zullen niet langer leden",
      "TX_COUNT": "Transacties",
      "CERT_COUNT": "Certificeringen",
      "TX_TO_HIMSELF": "Ruil deal",
      "TX_OUTPUT_UNLOCK_CONDITIONS": "Omstandigheden van de introductie",
      "TX_OUTPUT_OPERATOR": {
        "AND": "en",
        "OR": "of"
      },
      "TX_OUTPUT_FUNCTION": {
        "SIG": "<b>handtekening</b> ",
        "XHX": "<b>Wachtwoord</b>, wiens SHA256 =",
        "CSV": "Geblokkeerd",
        "CLTV": "Opgesloten"
      }
    },
    "LOOKUP": {
      "TITLE": "Blokken",
      "NO_BLOCK": "Geen blok",
      "LAST_BLOCKS": "Recente blokken :",
      "BTN_COMPACT": "Compact"
    }
  },
  "CURRENCY": {
    "SELECT": {
      "TITLE": "Valuta's",
      "CURRENCIES": "Bekende valuta's",
      "MEMBERS_COUNT": "{{membersCount}} leden"
    },
    "VIEW": {
      "TITLE": "Valuta",
      "TAB_CURRENCY": "Valuta",
      "TAB_WOT": "Gemeenschap",
      "TAB_NETWORK": "Netwerk",
      "CURRENCY_NAME": "Valuta naam",
      "MEMBERS": "Ledental",
      "MEMBERS_VARIATION": "Variatie since {{duration | formatDuration}}",
      "MONEY_DIVIDER": "Geld",
      "MASS": "Monetaire massa",
      "SHARE": "Aandeel per lid",
      "UD": "Universeel Dividend",
      "C_ACTUAL": "Huidige toename",
      "MEDIAN_TIME": "Blockchain tijd",
      "POW_MIN": "Algemene moeilijkheidsgraad",
      "MONEY_RULES_DIVIDER": "Monetaire regels",
      "C_RULE": "Toename",
      "UD_RULE": "Universeel dividend (formule)",
      "SIG_QTY_RULE": "Benodigd aantal certificaties om lid te worden",
      "SIG_STOCK": "Maximum aantal certificaties te versturen per lid",
      "SIG_PERIOD": "Minimum vertraging tussen 2 certificaties verzonden door één en dezelfde persoon.",
      "SIG_WINDOW": "Maximum vertraging voor een certificatie in behandeling wordt genomen",
      "STEP_MAX": "Maximum afstand tussen elk WoT lid en een nieuw lid.",
      "WOT_RULES_DIVIDER": "Lidmaatschapseisen",
      "XPERCENT":"Minimum percentage schildwachten te bereiken om de afstandsregel te respecteren"
    }
  },
  "NETWORK": {
    "VIEW": {
      "MEDIAN_TIME": "Blockchain tijd",
      "LOADING_PEERS": "Even geduld...",
      "NODE_ADDRESS": "Adres :",
      "ENDPOINTS": {
        "BMAS": "Endpoint (SSL)",
        "BMATOR": "Endpoint TOR",
        "ES_USER_API": "Knoop Cesium+"
      }
    },
    "INFO": {
      "ONLY_SSL_PEERS": "Les noeuds non SSL ont un affichage dégradé, car Cesium fonctionne en mode HTTPS."
    }
  },
  "PEER": {
    "PEERS": "Knopen",
    "SIGNED_ON_BLOCK": "Getekend op blok",
    "MIRROR": "spiegel",
    "CURRENT_BLOCK": "Blok #",
    "VIEW": {
      "TITLE": "Knoop",
      "OWNER": "Maakt deel uit van",
      "SHOW_RAW_PEERING": "Zie netwerkdocument",
      "KNOWN_PEERS": "Bekende knopen :",
      "GENERAL_DIVIDER": "Algemene informatie",
      "ERROR": {
        "LOADING_TOR_NODE_ERROR": "Kan knooppunt niet worden opgehaald. De wachttijd wordt overschreden.",
        "LOADING_NODE_ERROR": "Kan knooppunt niet worden opgehaald"
      }
    }
  },
  "WOT": {
    "SEARCH_HELP": "Zoeken (lid of publieke sleutel)",
    "SEARCH_INIT_PHASE_WARNING": "Tijdens de pre-registratiefase, het zoeken van lopende registraties <b>kan lang</b> zijn. Dank je wel geduld...",
    "REGISTERED_SINCE": "Registratie",
    "REGISTERED_SINCE_BLOCK": "Geregistreerd op blok #",
    "NO_CERTIFICATION": "Geen gevalideerde certificaties",
    "NO_GIVEN_CERTIFICATION": "Geen uitgegeven certificaties",
    "NOT_MEMBER_PARENTHESIS": "(niet-lid)",
    "IDENTITY_REVOKED_PARENTHESIS": "(ingetrokken identiteit)",
    "MEMBER_PENDING_REVOCATION_PARENTHESIS": "(intrekking in behandeling)",
    "EXPIRE_IN": "Verloopt",
    "NOT_WRITTEN_EXPIRE_IN": "Uiterlijke<br/>behandeling",
    "EXPIRED": "Verlopen",
    "PSEUDO": "Pseudoniem",
    "SIGNED_ON_BLOCK": "Uitgegeven op block #{{block}}",
    "WRITTEN_ON_BLOCK": "Geschreven op block #{{block}}",
    "GENERAL_DIVIDER": "Algemene informatie",
    "NOT_MEMBER_ACCOUNT": "Simpele rekening (geen lid)",
    "NOT_MEMBER_ACCOUNT_HELP": "Dit is een eenvoudige rekening, zonder dat er een aanvraag voor lidmaatschap in de wacht wordt gezet.",
    "TECHNICAL_DIVIDER": "Technische informatie",
    "BTN_CERTIFY": "Certificeren",
    "BTN_YES_CERTIFY": "Ja, Certificeren",
    "BTN_SELECT_AND_CERTIFY": "Nieuwe certificatie",
    "ACCOUNT_OPERATIONS": "Operaties op de rekening",
    "VIEW": {
      "POPOVER_SHARE_TITLE": "Identiteit {{title}}"
    },
    "LOOKUP": {
      "TITLE": "Register",
      "NEWCOMERS": "Nieuwe leden:",
      "PENDING": "Aspirant leden:",
      "REGISTERED": "Geregistreerd {{sigDate | formatFromNow}}",
      "MEMBER_FROM": "Lid sinds {{memberDate|medianFromNowShort}}",
      "BTN_NEWCOMERS": "Nieuwste leden",
      "BTN_PENDING": "Registraties in afwachting",
      "SHOW_MORE": "Toon meer",
      "SHOW_MORE_COUNT": "(huidige limiet op {{limit}})",
      "NO_PENDING": "Er zijn geen registraties in afwachting gevonden.",
      "NO_NEWCOMERS": "Er zijn geen nieuwe leden gevonden."
    },
    "MODAL": {
      "TITLE": "Zoeken"
    },
    "CERTIFICATIONS": {
      "TITLE": "{{uid}} - Certificaties",
      "SUMMARY": "Ontvangen certificaties",
      "LIST": "Details van ontvangen certificaties",
      "PENDING_LIST": "Certificaties in afwachting",
      "RECEIVED": "Ontvangen certificaties",
      "RECEIVED_BY": "Certificaties ontvanged door {{uid}}",
      "ERROR": "Ontvangen vertificaties met fout",
      "SENTRY_MEMBER": "Referent lid"
    },
    "GIVEN_CERTIFICATIONS": {
      "TITLE": "{{uid}} - Verzonden certificaties",
      "SUMMARY": "Verzonden certificaties",
      "LIST": "Details van verzonden certificaties",
      "PENDING_LIST": "Certificaties in afwachting",
      "SENT": "Verzonden certificaties",
      "SENT_BY": "Certificaties verzonden door {{uid}}",
      "ERROR": "Verzonden certificaties met fout"
    }
  },
  "LOGIN": {
    "TITLE": "<i class=\"icon ion-locked\"></i> Inloggen",
    "SALT": "Beveiligingszin",
    "SALT_HELP": "Zin ter beveiliging van je rekening",
    "SHOW_SALT": "Toon de beveiligingszin",
    "PASSWORD": "Wachtwoord",
    "PASSWORD_HELP": "Wachtwoord ter beveiliging van je rekening",
    "NO_ACCOUNT_QUESTION": "Nog geen rekening?",
    "CREATE_ACCOUNT": "Open een rekening",
    "FORGOTTEN_ID": "Wachtwoord vergeten?"
  },
  "ACCOUNT": {
    "TITLE": "Mijn rekening",
    "BALANCE": "Saldo",
    "LAST_TX": "Recente transacties",
    "BALANCE_ACCOUNT": "Rekeningsaldo",
    "NO_TX": "Geen transacties",
    "SHOW_MORE_TX": "Show more",
    "SHOW_ALL_TX": "Show all",
    "TX_FROM_DATE": "(huidige limiet op {{fromTime|medianFromNowShort}})",
    "PENDING_TX": "Transacties in afwachting",
    "ERROR_TX": "Niet uitgevoerde transacties",
    "ERROR_TX_SENT": "Verzonden transacties",
    "ERROR_TX_RECEIVED": "Ontvangen transacties",
    "EVENTS": "Gebeurtenissen",
    "WAITING_MEMBERSHIP": "Lidmaatschapsverzoek verzonden. In afwachting van validatie.",
    "WAITING_CERTIFICATIONS": "Je hebt {{needCertificationCount}} certificatie(s) nodig om lid te worden",
    "WILL_MISSING_CERTIFICATIONS": "Je heeft binnenkort <b>onvoldoende certificaties</b> (ten minste {{willNeedCertificationCount}} benodigd)",
    "WILL_NEED_RENEW_MEMBERSHIP": "Je lidmaatschap <b>gaat verlopen op {{membershipExpiresIn|formatDurationTo}}</b>. Vergeet niet <a ng-click=\"doQuickFix('renew')\">je lidmaatschap te vernieuwen</a> voor die tijd.",
    "CERTIFICATION_COUNT": "Aantal certificaties",
    "CERTIFICATION_COUNT_SHORT": "Certificaties",
    "SIG_STOCK": "Voorraad uit te geven certificaties",
    "BTN_RECEIVE_MONEY": "Ontvangen",
    "BTN_MEMBERSHIP_IN_DOTS": "Lidmaatschap aanvragen...",
    "BTN_MEMBERSHIP_RENEW": "Lidmaatschap verlengen",
    "BTN_MEMBERSHIP_RENEW_DOTS": "Lidmaatschap verlengen...",
    "BTN_MEMBERSHIP_OUT_DOTS": "Lidmaatschap opzeggen...",
    "BTN_SEND_IDENTITY_DOTS": "Identiteit publiceren...",
    "BTN_SECURITY_DOTS": "Rekening en veiligheid...",
    "BTN_SHOW_DETAILS": "Tonen technische informatie",
    "BTN_REVOKE": "Deze identiteit<span class='hidden-xs hidden-sm'> definitief</span> opzeggen...",
    "NEW": {
      "TITLE": "Registratie",
      "SLIDE_1_TITLE": "Selecteer een valuta:",
      "SLIDE_2_TITLE": "Soort rekening:",
      "MEMBER_ACCOUNT": "Persoonlijke rekening (lidmaatschap)",
      "MEMBER_ACCOUNT_HELP": "Als je nog niet als individu geregistreerd bent (één rekening per individu mogelijk).",
      "WALLET_ACCOUNT": "Eenvoudige portefeille",
      "WALLET_ACCOUNT_HELP": "Als je een onderneming, stichting etc. vertegenwoordigd of eenvoudigweg een additionele portefeille nodig hebt. Geen individueel universeel dividend zal door deze rekening gecréeerd worden.",
      "SALT_WARNING": "Kies een beveiligingszin.<br/>Deze heb je nodig voor ieder verbinding met je rekening.<br/><br/><b>Zorg dat je deze zin goed onthoud</b>.<br/>Eenmaal verloren, is er geen mogelijkheid om hem te achterhalen!",
      "PASSWORD_WARNING": "Kies een wachtwoord.<br/>Deze heb je nodig voor ieder verbinding met je rekening.<br/><br/><b>Zorg dat je dit woord goed onthoud</b>.<br/>Eenmaal verloren, is er geen mogelijkheid om hem te achterhalen!",
      "PSEUDO_WARNING": "Kies een pseudoniem.<br/>Het dient om makkelijker gevonden te worden door anderen.<br/><br/>.Gebruik van spaties, komma's en accenten is niet toegestaan.<br/><div class='hidden-xs'><br/>Voorbeeld: <span class='gray'>JulesDeelder, JohanVermeer, etc.</span>",
      "PSEUDO": "Pseudoniem",
      "PSEUDO_HELP": "joe123",
      "SALT_CONFIRM": "Bevestig",
      "SALT_CONFIRM_HELP": "Bevestig de beveiligingszin",
      "PASSWORD_CONFIRM": "Bevestig",
      "PASSWORD_CONFIRM_HELP": "Bevestig het wachtwoord",
      "SLIDE_6_TITLE": "Bevestiging:",
      "COMPUTING_PUBKEY": "Berekening...",
      "LAST_SLIDE_CONGRATULATION": "Bravo! Je hebt alle verplichte velden ingevuld.<br/>Je kunt je <b>rekeningaanvraag verzenden</b>.<br/><br/>Ter informatie, de publieke sleutel hieronder identificeert je toekomstige rekening.<br/>Je kunt deze aan derde partijen communiceren om geld te ontvangen. Zodra je rekening geopend is, kun je de sleutel terugvinden onder <b>{{'ACCOUNT.TITLE'|translate}}</b>.",
      "CONFIRMATION_MEMBER_ACCOUNT": "<b class=\"assertive\">Waarschuwing:</b> je beveiligingszin, wachtwoord en pseudoniem kunnen hierna niet gewijzigd worden.<br/><b>Zorg dat ze goed onthoudt!</b><br/><b>Weet je zeker</b> dat je je persoonlijke rekeningaanvraag wil verzenden?",
      "CONFIRMATION_WALLET_ACCOUNT": "<b class=\"assertive\">Waarschuwing:</b> je wachtwoord en pseudoniem kunnen hierna niet gewijzigd worden.<br/><b>Zorg dat ze goed onthoudt!</b><br/><b>Weet je zeker</b> dat je deze portefeilleaanvraag wil verzenden?",
      "PSEUDO_AVAILABLE": "Deze naam is beschikbaar",
      "PSEUDO_NOT_AVAILABLE": "Deze gebruikersnaam is niet beschikbaar",
      "INFO_LICENSE": "Om de valuta te sluiten, vragen wij u om te lezen en deze licentie te accepteren.",
      "BTN_ACCEPT": "Ik accepteer",
      "BTN_ACCEPT_LICENSE": "Ik ga akkoord met de licentie"
    },
    "POPUP_REGISTER": {
      "TITLE": "Voer een pseudoniem in",
      "HELP": "Een pseudoniem is nodig voor anderen om je te kunnen vinden."
    },
    "FILE_NAME": "{{currency}} - Rekeningafschrift {{pubkey|formatPubkey}} {{currentTime|formatDateForFile}}.csv",
    "HEADERS": {
      "TIME": "Datum",
      "AMOUNT": "Bedrag",
      "COMMENT": "Commentaar"
    }
  },
  "TRANSFER": {
    "TITLE": "Overboeken",
    "SUB_TITLE": "Geld overboeken",
    "FROM": "Van",
    "TO": "Aan",
    "AMOUNT": "Bedrag",
    "AMOUNT_HELP": "Bedrag",
    "COMMENT": "Opmerking",
    "COMMENT_HELP": "Opmerking (optioneel)",
    "BTN_SEND": "Verzenden",
    "BTN_ADD_COMMENT": "Opmerking toevoegen",
    "WARN_COMMENT_IS_PUBLIC": "Houd er rekening mee dat <b>reacties openbaar zijn </b> (niet-versleuteld).",
    "MODAL": {
      "TITLE": "Overboeking"
    }
  },
  "ERROR": {
    "POPUP_TITLE": "Error",
    "UNKNOWN_ERROR": "Unknown error",
    "CRYPTO_UNKNOWN_ERROR": "Your browser is not compatible with cryptographic features.",
    "FIELD_REQUIRED": "This field is required.",
    "FIELD_TOO_SHORT": "Value is too short (min {{minLength]] characters).",
    "FIELD_TOO_SHORT_WITH_LENGTH": "This field value is too short.",
    "FIELD_TOO_LONG": "Value is exceeding max length.",
    "FIELD_TOO_LONG_WITH_LENGTH": "Value is too long (max {{maxLength}} characters).",
    "FIELD_ACCENT": "Commas and accent characters not allowed",
    "FIELD_NOT_NUMBER": "Value is not a number",
    "FIELD_NOT_INT": "Value is not an integer",
    "PASSWORD_NOT_CONFIRMED": "Must match previous password.",
    "SALT_NOT_CONFIRMED": "Must match previous phrase.",
    "SEND_IDENTITY_FAILED": "Error while trying to register.",
    "SEND_CERTIFICATION_FAILED": "Could not certify identity.",
    "NEED_MEMBER_ACCOUNT_TO_CERTIFY": "You could not send certification, because your account is <b>not a member account</b>.",
    "NEED_MEMBER_ACCOUNT_TO_CERTIFY_HAS_SELF": "You could not send certification now, because your are <b>not a member</b> yet.<br/><br/>You still need certification to become a member.",
    "IDENTITY_TO_CERTIFY_HAS_NO_SELF": "This account could not be certified. No registration found, or need to renew.",
    "LOGIN_FAILED": "Error while sign in.",
    "LOAD_IDENTITY_FAILED": "Could not load identity.",
    "LOAD_REQUIREMENTS_FAILED": "Could not load identity requirements.",
    "SEND_MEMBERSHIP_IN_FAILED": "Error while sending registration as member.",
    "SEND_MEMBERSHIP_OUT_FAILED": "Error while sending membership revocation.",
    "REFRESH_WALLET_DATA": "Could not refresh wallet.",
    "GET_CURRENCY_PARAMETER": "Could not get currency parameters.",
    "GET_CURRENCY_FAILED": "Could not load currency.",
    "SEND_TX_FAILED": "Could not send transaction.",
    "ALL_SOURCES_USED": "Please wait the next block computation (All transaction sources has been used).",
    "NOT_ENOUGH_SOURCES": "Not enough changes to send this amount in one time.<br/>Maximum amount: {{amount}} {{unit}}<sub>{{subUnit}}</sub>.",
    "ACCOUNT_CREATION_FAILED": "Error while creating your member account.",
    "RESTORE_WALLET_DATA_ERROR": "Error while reloading settings from local storage",
    "LOAD_WALLET_DATA_ERROR": "Error while loading wallet data.",
    "COPY_CLIPBOARD_FAILED": "Could not copy to clipboard",
    "TAKE_PICTURE_FAILED": "Could not get picture.",
    "SCAN_FAILED": "Could not scan QR code.",
    "SCAN_UNKNOWN_FORMAT": "Code not recognized.",
    "WOT_LOOKUP_FAILED": "Search failed.",
    "LOAD_PEER_DATA_FAILED": "Duniter peer not accessible. Please retry later.",
    "NEED_LOGIN_FIRST": "Please sign in first.",
    "AMOUNT_REQUIRED": "Amount is required.",
    "AMOUNT_NEGATIVE": "Negative amount not allowed.",
    "NOT_ENOUGH_CREDIT": "Not enough credit.",
    "INVALID_NODE_SUMMARY": "Unreachable peer or invalid address",
    "INVALID_USER_ID": "Field 'pseudonym' must not contains spaces or special characters.",
    "INVALID_COMMENT": "Field 'reference' has a bad format.",
    "INVALID_PUBKEY": "Public key has a bad format.",
    "IDENTITY_INVALID_BLOCK_HASH": "This membership application is no longer valid (because it references a block that network peers are cancelled): the person must renew its application for membership <b>before</b> being certified.",
    "IDENTITY_EXPIRED": "This identity has expired: this person must re-apply <b>before</b> being certified.",
    "IDENTITY_SANDBOX_FULL": "Could not register, because peer's sandbox is full.<br/><br/>Please retry later or choose another Duniter peer (in <b>Settings</b>).",
    "WOT_PENDING_INVALID_BLOCK_HASH": "Membership not valid.",
    "WALLET_INVALID_BLOCK_HASH": "Your membership application is no longer valid (because it references a block that network peers are cancelled).<br/>You must <a ng-click=\"doQuickFix('renew')\">renew your application for membership</a> to fix this issue.",
    "WALLET_IDENTITY_EXPIRED": "The publication of your identity <b>has expired</b>.<br/>You must <a ng-click=\"doQuickFix('fixIdentity')\">re-issue your identity</a> to resolve this issue.",
    "WALLET_HAS_NO_SELF": "Your identity must first have been published, and not expired.",
    "IDENTITY_ALREADY_CERTIFY": "You have <b>already certified</b> that identity.<br/><br/>Your certificate is still valid (expires {{expiresIn|formatDuration}}).",
    "IDENTITY_ALREADY_CERTIFY_PENDING": "You have <b>already certified</b> that identity.<br/><br/>Your certification is still pending (Deadline for treatment {{expiresIn|formatDuration}}).",
    "UNABLE_TO_CERTIFY_TITLE": "Unable to certify",
    "LOAD_NEWCOMERS_FAILED": "Unable to load new members.",
    "LOAD_PENDING_FAILED": "Unable to load pending registrations.",
    "ONLY_MEMBER_CAN_EXECUTE_THIS_ACTION": "You must <b>be a member</b> in order to perform this action.",
    "ONLY_SELF_CAN_EXECUTE_THIS_ACTION": "You must have <b>published your identity</b> in order to perform this action.",
    "EXISTING_ACCOUNT": "Je gegevens komen overeen met een bestaande rekening, met de <a ng-click=\"showHelpModal('pubkey')\">publieke sleutel</a>:",
    "EXISTING_ACCOUNT_REQUEST": "Gelieve je gegevens te wijzigen zodat ze met een niet gebruikte rekening overeenkomen."
  },
  "INFO": {
    "POPUP_TITLE": "Informatie",
    "CERTIFICATION_DONE": "Identiteit succesvol getekend",
    "NOT_ENOUGH_CREDIT": "Niet genoeg krediet",
    "TRANSFER_SENT": "Verzoek tot overboeken succesvol verzonden",
    "COPY_TO_CLIPBOARD_DONE": "Kopie geslaagd",
    "MEMBERSHIP_OUT_SENT": "Opzegging lidmaatschap succesvol verzonden",
    "NOT_NEED_MEMBERSHIP": "Je bent al lid.",
    "IDENTITY_WILL_MISSING_CERTIFICATIONS": "Deze identiteit heeft binnenkort onvoldoende certificaties (ten minste {{willNeedCertificationCount}} nodig).",
    "REVOCATION_SENT": "Intrekking succesvol verzonden",
    "REVOCATION_SENT_WAITING_PROCESS": "Intrekking <b>is succesvol verzonden</b>. Het wacht op verwerking.",
    "FEATURE_NOT_AVAILABLE_ON_DEMO": "Functionaliteit niet beschikbaar op deze demonstratiesite.<br/>Om <b>veiligheidsredenen</b> raden we u aan uw kopie van de software te <b>installeren</b>.<br/>Bezoek de website <a href='https://cesium.app'>www.cesium.app</a> voor hulp.",
    "EMPTY_TX_HISTORY": "Aucune operatie à exporteur"
  },
  "CONFIRM": {
    "POPUP_TITLE": "<b>Bevestiging</b>",
    "POPUP_WARNING_TITLE": "<b>Waarschuwing</b>",
    "CERTIFY_RULES_TITLE_UID": "Certificeer {{uid}}",
    "CERTIFY_RULES": "<b>Beveiligingswaarschuwing:</b><br/><br/><b class=\"assertive\">Certificeer een rekening niet</b> als je gelooft dat: <ul><li>1.) de aanvrager niet echt is.<li>2.) de aanvrager al een andere gecertificeerde rekening heeft.<li>3.) de aanvrager opzettelijk of door onzorgvuldigheid regel 1 of 2 overtreedt bij het verzenden van certificaten.</ul></small><br/>Weet je zeker dat je deze identieit wilt certificeren?",
    "TRANSFER": "<b>Samenvatting van de overboeking:</b><br/><br/><ul><li> - Van: <b>{{from}}</b></li><li> - Aan: <b>{{to}}</b></li><li> - Bedrag: <b>{{amount}} {{unit}}</b></li><li> - Opmerking: <i>{{comment}}</i></li></ul><br/><b>Weet je zeker dat je deze overboeking wil doen?</b>",
    "MEMBERSHIP_OUT": "<b>Waarschuwing</b>:<br/>Je staat op het punt je lidmaatschap te beëindigen. Dit kan <b>niet ongedaan</b> worden gemaakt.<br/></br/><b>Weet je zeker dat je door wil gaan?</b>",
    "LOGIN_UNUSED_WALLET_TITLE": "Typefout?",
    "LOGIN_UNUSED_WALLET": "Je bent ingelogged op een rekening die <b>inactief</b> lijkt te zijn.<br/><br/>Als deze rekening niet met de jouwe overeenkomt, komt dat waarschijnlijk door een <b>typefout</b> bij het inloggen.<br/><br/><b>Wilt u toch doorgaan met deze rekening?</b>",
    "FIX_IDENTITY": "De pseudoniem <b>{{uid}}</b> zal opnieuw gepubliceerd worden, waarmee de oude verlopen publicatie wordt vervangen.<br/></br/><bWeet je zeker</b> dat je door wil gaan?",
    "FIX_MEMBERSHIP": "Je verzoek to lidmaatschap zal verstuurd worden.<br/></br/><b>Weet je het zeker?</b>",
    "RENEW_MEMBERSHIP": "Je lidmaatschap zal verlengd worden.<br/></br/><b>Weet je het zeker?</b>",
    "REVOKE_IDENTITY": "<b>Beveiligingswaarschuwing:</b><br/>You will <b>definitely revoke this identity</b>.<br/><br/>The public key and the associated nickname <b>will never be used again</b> (for a member account).<br/></br/><b>Are you sure</b> you want to continue?",
    "REVOKE_IDENTITY_2": "Deze handeling is <b>niet terug te draaien</b>!<br/><br/><b>Weet je zeker</b> dat je door wil gaan?",
    "NOT_NEED_RENEW_MEMBERSHIP": "Je lidmaatschap hoeft niet verlengd te worden (het zal pas verlopen na {{membershipExpiresIn|formatDuration}}).<br/></br/><b>Weet je zeker</b> dat je een verlengingsaanvraag wil versturen?",
    "SAVE_BEFORE_LEAVE": "Wil je <b>je wijzigingen opslaan</b> voor je de pagina verlaat?",
    "SAVE_BEFORE_LEAVE_TITLE": "Wijzigingen niet opgeslagen",
    "LICENCE": "Ik heb gelezen en geaccepteerd de voorwaarden van de vergunning G1"
  },
  "DOWNLOAD": {
    "POPUP_TITLE": "<b>Intrekkingsdocument</b>",
    "POPUP_REVOKE_MESSAGE": "Om je rekening te beveiligen, download het <b>rekening intrekkingsdocument</b>. Dit heb je nodig om je rekening op te heffen (in het geval van diefstal, een verandering van ID, een ten onrechte gemaakte rekening, etc.).<br/><br/><b>Bewaar deze op een veilige plaats.</b>"
  },
  "HELP": {
    "TITLE": "Online help",
    "JOIN": {
      "SECTION": "Join",
      "SALT": "The protection phrase is very important. It is used to hash you password, which in turn is used to calculate your <span class=\"text-italic\">public account key</span> (its number) and the private key to access it. <b>Please remeber this phrase well</b>, because there is no way to recover it when lost. What's more, it cannot be changed without having to create a new account.<br/><br/>A good protection phrase must be sufficiently long (8 characters at the very least) and as original as possible.",
      "PASSWORD": "The password is very important. Together with the protection phrase, it is use to calculate your account number (public key) and the private key to access it. <b>Please remember it well</b>, because there is no way to recover it when lost. What's more, it cannot be changed without having to create a new account.<br/><br/>A good password is made (ideally) of at least 8 characters, with at least one capital and one number.",
      "PSEUDO": "A pseudonym is used only when joining as <span class=\"text-italic\">member</span>. It is always associated with a wallet (by its <span class=\"text-italic\">public key</span>). It is published on the network so that other users may identify it, certify or send money to the account. A pseudonym must be unique among all members (current and past)."
    },
    "GLOSSARY": {
      "SECTION": "Glossary",
      "PUBKEY_DEF": "Een publieke sleutel identificeert altijd een portemonnee. Het kan een lid identificeren. In Cesium wordt berekend met de geheime ID en wachtwoord.",
      "MEMBER": "Member",
      "MEMBER_DEF": "A member is a real and living human, wishing to participate freely to the monitary community. The member will receive universal dividend, according to the period and amount as defined in the <span class=\"text-italic\">currency parameters</span>.",
      "CURRENCY_RULES": "Currency rules",
      "CURRENCY_RULES_DEF": "The currency rules are defined only once, and for all. They set the parameters under which the currency will perform: universal dividend calculation, the amount of certifications needed to become a member, the maximum amount of certifications a member can send, etc.<br/><br/>The parameters cannot be modified because of the use of a <span class=\"text-italic\">Blockchain</span> which carries and executes these rules, and constantly verifies their correct application. <a href=\"#/app/currency\">See current parameters</a>.",
      "BLOCKCHAIN": "Blockchain",
      "BLOCKCHAIN_DEF": "The Blockchain is a decentralised system which, in case of Duniter, serves to carry and execute the <span class=\"text-italic\">currency rules</span>.<br/><a href=\"http://en.duniter.org/presentation/\" target=\"_blank\">Read more about Duniter</a> and the working of its blockchain.",
      "UNIVERSAL_DIVIDEND_DEF": "The Universal Dividend (UD) is the quantity of money co-created by each member, according to the period and the calculation defined in the <span class=\"text-italic\">currency rules</span>.<br/>Every term, the members receive an equal amount of new money on their account.<br/><br/>The UD undergoes a steady growth, to remain fair under its members (current and future), calculated by an average life expectancy, as demonstrated in the Relative Theory of Money (RTM).<br/><a href=\"http://trm.creationmonetaire.info\" target=\"_system\">Read more about RTM</a> and open money."
    },
    "TIP": {
      "MENU_BTN_CURRENCY": "Menu <b>{{'MENU.CURRENCY'|translate}}</b> allows discovery of <b>currency parameters</b> and its state.",
      "CURRENCY_WOT": "The <b>member count</b> shows the <b>community's weight and evolution</b>.",
      "CURRENCY_MASS": "Shown here is the <b>total amount</b> currently in circulation and its <b>average distribution</b> per member.<br/><br/>This allows to estimate the <b>worth of any amount</b>, in respect to what <b>others own</b> on their account (on average).",
      "CURRENCY_UNIT_RELATIVE": "The unit used here (&ldquo;<b>{{'COMMON.UD'|translate}}<sub>{{currency|abbreviate}}</sub></b>&rdquo;) signifies that the amounts in {{currency|capitalize}} have been devided by the <b>Universal Dividend</b> (UD).<br/><br/><small>This relative unit is <b>relevant</b> because it is stable in contrast to the permanently growing monitary mass.</small>",
      "CURRENCY_CHANGE_UNIT": "This button allows to <b>switch the unit</b> to show amounts in <b>{{currency|capitalize}}</b>, undevided by the Universal Dividend (instead of in &ldquo;<b>{{'COMMON.UD'|translate}}<sub>{{currency|abbreviate}}</sub></b>&rdquo;).",
      "CURRENCY_CHANGE_UNIT_TO_RELATIVE": "This button allows to <b>switch the unit</b> to show amounts in &ldquo;<b>{{'COMMON.UD'|translate}}<sub>{{currency|abbreviate}}</sub></b>&rdquo;, which is relative to the Universal Dividend (the amount co-produced by each member).",
      "CURRENCY_RULES": "The <b>rules</b> of the currency determine its <b>exact and predictible</b> performance.<br/><br/>As a true DNA of the currency these rules make the monetary code <b>transparent and understandable</b>.",
      "NETWORK_BLOCKCHAIN": "All monetary transactions are recoded in a <b>public and tamper proof</b> ledger, generally referred to as the <b>blockchain</b>.",
      "NETWORK_PEERS": "The <b>peers</b> shown here correspond to <b>computers that update and check</b> the blockchain.<br/><br/>The more active peers there are, the more <b>decentralised</b> and therefore trustworhty the currency becomes.",
      "NETWORK_PEERS_BLOCK_NUMBER": "This <b>number</b> indicates the peer's <b>latest validated block</b> (last page written in the ledger).<br/><br/>Green indicates that the block was equally validated by the <b>majority of other peers</b>.",
      "NETWORK_PEERS_PARTICIPATE": "<b>Each member</b>, equiped with a computer with Internet, <b>can participate, adding a peer</b> simply by <b>installing the Duniter software</b> (free/libre and open source). <a href=\"{{installDocUrl}}\" target=\"_system\">Read the installation manual &gt;&gt;</a>.",
      "MENU_BTN_ACCOUNT": "<b>{{'ACCOUNT.TITLE'|translate}}</b> allows access to your account balance and transaction history.",
      "MENU_BTN_ACCOUNT_MEMBER": "Here you can consult your account status, transaction history and your certifications.",
      "WALLET_CERTIFICATIONS": "Click here to reveiw the details of your certifications (given and received).",
      "WALLET_BALANCE": "Your account <b>balance</b> is shown here.",
      "WALLET_BALANCE_RELATIVE": "{{'HELP.TIP.WALLET_BALANCE'|translate}}<br/><br/>The used unit (&ldquo;<b>{{'COMMON.UD'|translate}}<sub>{{currency|abbreviate}}</sub></b>&rdquo;) signifies that the amount in {{currency|capitalize}} has been divided by the <b>Universal Dividend</b> (UD) co-created by each member.<br/>At this moment, 1 UD equals {{currentUD}} {{currency|capitalize}}.",
      "WALLET_BALANCE_CHANGE_UNIT": "You can <b>change the unit</b> in which amounts are shown in <b><i class=\"icon ion-android-settings\"></i>&nbsp;{{'MENU.SETTINGS'|translate}}</b>.<br/><br/>For example, to display amounts <b>directly in {{currency|capitalize}}</b> instead of relative amounts.",
      "WALLET_SEND": "Issue a payment in just a few clicks.",
      "WALLET_SEND_NO_MONEY": "Issue a payment in just a few clicks.<br/>(Your balance does not allow this yet)",
      "WALLET_OPTIONS": "Please note that this button allows access to <b>other, less used actions</b>.<br/><br/>Don't forget to take a quick look, when you have a moment!",
      "WALLET_RECEIVED_CERTS": "This shows the list of persons that certified you.",
      "WALLET_CERTIFY": "The button <b>{{'WOT.BTN_SELECT_AND_CERTIFY'|translate}}</b> allows selecting an identity and certifying it.<br/><br/>Only users that are <b>already member</b> may certify others.",
      "WALLET_CERT_STOCK": "Your supply of certifications (to send) is limited to <b>{{sigStock}} certifications</b>.<br/><br/>This supply will replete itself over time, as and when earlier certifications expire.",
      "MENU_BTN_WOT": "The menu <b>{{'MENU.WOT'|translate}}</b> allows searching <b>users</b> of the currency (member or not).",
      "WOT_SEARCH_TEXT_XS": "To search in the registry, type the <b>first letters of a users pseudonym or public key</b>.<br/><br/>The search will start automatically.",
      "WOT_SEARCH_TEXT": "To search in the registry, type the <b>first letters of a users pseudonym or public key</b>.<br/><br/>Then hit <b>Enter</b> to start the search.",
      "WOT_SEARCH_RESULT": "Simply click a user row to view the details sheet.",
      "WOT_VIEW_CERTIFICATIONS": "The row <b>{{'ACCOUNT.CERTIFICATION_COUNT'|translate}}</b> shows how many members members validated this identity.<br/><br/>These certifications testify that the account belongs to <b>a living human</b> and this person has <b>no other member account</b>.",
      "WOT_VIEW_CERTIFICATIONS_COUNT": "There are at least <b>{{sigQty}} certifications</b> needed to become a member and receive the <b>Universal Dividend</b>.",
      "WOT_VIEW_CERTIFICATIONS_CLICK": "Click here to open <b>a list of all certifications</b> given to and by this identity.",
      "WOT_VIEW_CERTIFY": "The button <b>{{'WOT.BTN_CERTIFY'|translate}}</b> allows to add your certification to this identity.",
      "CERTIFY_RULES": "<b>Attention:</b> Only certify <b>real and living persons</b> that do not own any other certified account.<br/><br/>The trust carried by the currency depends on each member's vigilance!",
      "MENU_BTN_SETTINGS": "The <b>{{'MENU.SETTINGS'|translate}}</b> allow you to configure the Cesium application.<br/><br/>For example, you can <b>change the unit</b> in which the currency will be shown.",
      "HEADER_BAR_BTN_PROFILE": "Click here to access your <b>user profile</b>",
      "SETTINGS_CHANGE_UNIT": "You can <b>change the display unit</b> of amounts by clicking here.<br/><br/>- Deactivate the option to show amounts in {{currency|capitalize}}.<br/>- Activate the option for relative amounts in {{'COMMON.UD'|translate}}<sub>{{currency|abbreviate}}</sub> (<b>divided</b> by the current Universal Dividend).",
      "END_LOGIN": "This guided visit has <b>ended</b>.<br/><br/>Welcome to the <b>free economy</b>!",
      "END_NOT_LOGIN": "This guided visit has <b>ended</b>.<br/><br/>If you wish to join the currency {{currency|capitalize}}, simply click <b>{{'LOGIN.CREATE_ACCOUNT'|translate}}</b> below."
    }
  }
}
);
}]);
